(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[605],{

/***/ 46783:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* reexport */ PageBuilder; },
  "b": function() { return /* reexport */ pagebuilder_PlaceholderReact; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/hooks/useWindowDimensions.js

function useWindowDimensions() {
    var getWindowDimensions = function getWindowDimensions() {
        var width = hasWindow ? window.innerWidth : null;
        var height = hasWindow ? window.innerHeight : null;
        return {
            width: width,
            height: height
        };
    };
    var hasWindow = "object" !== 'undefined';
    var ref = (0,react.useState)(getWindowDimensions()), windowDimensions = ref[0], setWindowDimensions = ref[1];
    (0,react.useEffect)(function() {
        if (hasWindow) {
            var handleResize = function handleResize() {
                setWindowDimensions(getWindowDimensions());
            };
            window.addEventListener('resize', handleResize);
            return function() {
                return window.removeEventListener('resize', handleResize);
            };
        }
    }, [
        hasWindow
    ]);
    return windowDimensions;
};

// EXTERNAL MODULE: ../../libs/shared-ui/hooks/index.ts + 5 modules
var hooks = __webpack_require__(37162);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/services/globalContext.js




//import { useSelector } from 'react-redux'

var globalContext_GlobalContext = /*#__PURE__*/ react.createContext();
var GlobalContextProvider = function(param) {
    var contentTypeId = param.contentTypeId, objectId = param.objectId, pkey = param.pkey, manualEditMode = param.editMode, draft = param.draft, children = param.children;
    var ref = (0,react.useState)(false), showImport = ref[0], setShowImport = ref[1];
    // useSelector((state) => state.toolbar.edit_mode)
    //const [utente, setUtente] = useState(false) // useSelector((state) => state.utente)
    var ref1 = (0,react.useState)(false), previewMode = ref1[0], setPreviewMode = ref1[1];
    var ref2 = (0,react.useState)(true), wireframeMode = ref2[0], setWireframeMode = ref2[1];
    var width = useWindowDimensions().width;
    var ref3 = (0,react.useState)(), windowMode = ref3[0], setWindowMode = ref3[1];
    var ref4 = (0,react.useState)(), sidebarTab = ref4[0], setSidebarTab = ref4[1];
    var ref5 = (0,react.useState)(), leftSidebarTab = ref5[0], setLeftSidebarTab = ref5[1];
    var ref6 = (0,react.useState)(), assetId = ref6[0], setAssetId = ref6[1];
    var ref7 = (0,react.useState)(), floatingSettingsOpen = ref7[0], setFloatingSettingsOpen = ref7[1];
    var ref8 = (0,hooks/* useUtente */.yl)(), utente = ref8.utente, loading = ref8.loading;
    var ref9 = (0,react.useState)(undefined), editMode = ref9[0], setEditMode = ref9[1];
    var ref10 = {
        locale: 'it'
    }, lang = ref10.locale;
    (0,react.useEffect)(function() {
        if (!loading) {
            if (utente && utente.isStaff) {
                setEditMode(manualEditMode !== undefined && manualEditMode !== null ? manualEditMode : utente.edit);
            } else {
                setEditMode(false);
            }
        }
    }, [
        loading,
        utente,
        manualEditMode
    ]);
    (0,react.useEffect)(function() {
        if (width <= 575) {
            setWindowMode('mobile');
        } else if (width <= 991) {
            setWindowMode('tablet');
        } else {
            setWindowMode('desktop');
        }
    }, [
        width
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(globalContext_GlobalContext.Provider, {
        value: {
            contentTypeId: contentTypeId,
            objectId: objectId,
            pkey: pkey,
            lang: lang,
            showImport: showImport,
            setShowImport: setShowImport,
            editMode: editMode,
            previewMode: previewMode,
            setPreviewMode: setPreviewMode,
            utente: utente,
            windowMode: windowMode,
            wireframeMode: wireframeMode,
            setWireframeMode: setWireframeMode,
            draft: draft,
            sidebarTab: sidebarTab,
            setSidebarTab: setSidebarTab,
            leftSidebarTab: leftSidebarTab,
            setLeftSidebarTab: setLeftSidebarTab,
            assetId: assetId,
            setAssetId: setAssetId,
            floatingSettingsOpen: floatingSettingsOpen,
            setFloatingSettingsOpen: setFloatingSettingsOpen
        },
        children: children
    }));
};
/* harmony default export */ var globalContext = (GlobalContextProvider);

// EXTERNAL MODULE: ../../node_modules/axios/index.js
var axios = __webpack_require__(89644);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ../../libs/shared-ui/utils/index.ts
var utils = __webpack_require__(20741);
;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/services/api.js


var SITE = '1';
var LANG = 'it';
var baseUrl = utils/* API_HOST */.H + '/d/';
var apiBaseUrl = utils/* API_FULL_PATH */.Ke + 'react-pagebuilder/';
var axiosInstance = axios_default().create({
    baseURL: baseUrl
});
var apiAxiosInstance = axios_default().create({
    baseURL: apiBaseUrl,
    withCredentials: true
});
apiAxiosInstance.defaults.xsrfCookieName = 'csrftoken';
apiAxiosInstance.defaults.xsrfHeaderName = 'X-CSRFTOKEN';
var api_api = {
    listPagebuilder: listPagebuilder,
    getPagebuilder: getPagebuilder,
    getPagebuilderJsonFile: getPagebuilderJsonFile,
    saveDraftPagebuilder: saveDraftPagebuilder,
    publishPagebuilder: publishPagebuilder,
    unpublishPagebuilder: unpublishPagebuilder,
    getCustomBlocks: getCustomBlocks,
    createCustomBlock: createCustomBlock,
    deleteCustomBlock: deleteCustomBlock,
    getGlobalCustomBlocks: getGlobalCustomBlocks,
    createGlobalCustomBlock: createGlobalCustomBlock,
    updateGlobalCustomBlock: updateGlobalCustomBlock,
    deleteGlobalCustomBlock: deleteGlobalCustomBlock
};
function listPagebuilder(params) {
    var contentTypeId = (params === null || params === void 0 ? void 0 : params.contentTypeId) ? "content_type_id=".concat(params.contentTypeId) : '';
    var lang = (params === null || params === void 0 ? void 0 : params.lang) ? "&lang=".concat(params.lang) : '';
    var url = "pagebuilder/?".concat(contentTypeId).concat(lang);
    return apiAxiosInstance.get(url).then(function(res) {
        return res.data;
    }).catch(function(err) {
        return Promise.reject(err);
    });
}
function getPagebuilder(params) {
    var contentTypeId = "content_type_id=".concat(params.contentTypeId);
    var objectId = "&object_id=".concat(params.objectId);
    var key = "&key=".concat(params.key);
    var lang = "&lang=".concat(params.lang);
    var edit_mode = params.edit_mode ? "&edit_mode=true" : '';
    var url = "pagebuilder/?".concat(contentTypeId).concat(objectId).concat(key).concat(lang).concat(edit_mode);
    return apiAxiosInstance.get(url).then(function(res) {
        return res.data;
    }).catch(function(err) {
        return Promise.reject(err);
    });
}
function getPagebuilderJsonFile(params) {
    var id = params.id ? params.id : '';
    var url = "json-pagebuilder/".concat(id, "/");
    return axiosInstance.get(url).then(function(res) {
        return res.data;
    }).catch(function(err) {
        return Promise.reject(err);
    });
}
function saveDraftPagebuilder(pagebuilderId, json_draft) {
    var body = {
        json_draft: json_draft
    };
    return apiAxiosInstance.post("pagebuilder/".concat(pagebuilderId, "/save_draft/"), body).then(function(res) {
        return res.data;
    }).catch(function(err) {
        return Promise.reject(err);
    });
}
function publishPagebuilder(pagebuilderId) {
    return apiAxiosInstance.post("pagebuilder/".concat(pagebuilderId, "/publish/")).then(function(res) {
        return res.data;
    }).catch(function(err) {
        return Promise.reject(err);
    });
}
function unpublishPagebuilder(pagebuilderId) {
    return apiAxiosInstance.post("pagebuilder/".concat(pagebuilderId, "/unpublish/")).then(function(res) {
        return res.data;
    }).catch(function(err) {
        return Promise.reject(err);
    });
}
function getCustomBlocks(params) {
    var lang = "&lang=".concat(params.lang);
    return apiAxiosInstance.get("custom-blocks/?".concat(lang)).then(function(res) {
        return res.data;
    }).catch(function(err) {
        return Promise.reject(err);
    });
}
function createCustomBlock(params) {
    var body = {
        lang: params.lang,
        name: params.name,
        json_content: params.json_content
    };
    return apiAxiosInstance.post('custom-blocks/', body).then(function(res) {
        return res.data;
    }).catch(function(err) {
        return Promise.reject(err);
    });
}
function deleteCustomBlock(id) {
    return apiAxiosInstance.delete('custom-blocks/' + id + '/').then(function(res) {
        return res.data;
    }).catch(function(err) {
        return Promise.reject(err);
    });
}
function getGlobalCustomBlocks(params) {
    var lang = "&lang=".concat(params.lang);
    return apiAxiosInstance.get("global-custom-blocks/?".concat(lang)).then(function(res) {
        return res.data;
    }).catch(function(err) {
        return Promise.reject(err);
    });
}
function createGlobalCustomBlock(params) {
    var body = {
        lang: params.lang,
        name: params.name,
        json_content: params.json_content
    };
    return apiAxiosInstance.post('global-custom-blocks/', body).then(function(res) {
        return res.data;
    }).catch(function(err) {
        return Promise.reject(err);
    });
}
function updateGlobalCustomBlock(id, params) {
    var body = {
        lang: params.lang,
        name: params.name,
        json_content: params.json_content
    };
    return apiAxiosInstance.put('react-pagebuilder/global-custom-blocks/' + id + '/', body).then(function(res) {
        return res.data;
    }).catch(function(err) {
        return Promise.reject(err);
    });
}
function deleteGlobalCustomBlock(id) {
    return apiAxiosInstance.delete('react-pagebuilder/global-custom-blocks/' + id + '/').then(function(res) {
        return res.data;
    }).catch(function(err) {
        return Promise.reject(err);
    });
}

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/services/pagebuilderContext.js




var PagebuilderContext = /*#__PURE__*/ react.createContext();
var PagebuilderContextProvider = function(param) {
    var children = param.children;
    var ref = (0,react.useContext)(globalContext_GlobalContext), contentTypeId = ref.contentTypeId, objectId = ref.objectId, pkey = ref.pkey, lang = ref.lang, editMode = ref.editMode, utente = ref.utente;
    var ref1 = (0,react.useState)(), pagebuilder1 = ref1[0], setPagebuilder = ref1[1];
    var ref2 = (0,react.useState)(true), isLoading = ref2[0], setLoading = ref2[1];
    (0,react.useEffect)(function() {
        if (pkey && lang && editMode !== undefined && editMode !== null) {
            setLoading(true);
            api_api.getPagebuilder({
                contentTypeId: contentTypeId,
                objectId: objectId,
                key: pkey,
                lang: lang,
                edit_mode: utente && utente.isStaff ? true : false
            }).then(function(data) {
                setPagebuilder(data);
                setLoading(false);
            }).catch(function(err) {
                setLoading(false);
                console.log(err);
            });
        }
    }, [
        contentTypeId,
        objectId,
        pkey,
        lang,
        editMode,
        JSON.stringify(utente)
    ]);
    var update = function(pagebuilder) {
        setPagebuilder(pagebuilder);
    };
    var saveDraft = function(json_draft) {
        var refresh = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        if (refresh) {
            setLoading(true);
        }
        api_api.saveDraftPagebuilder(pagebuilder1.id, json_draft).then(function(data) {
            update(data);
            console.log(data);
            if (refresh) {
                setLoading(false);
            }
        }).catch(function(err) {
            console.log(err);
            if (refresh) {
                setLoading(false);
            }
        });
    };
    var publish = function() {
        var refresh = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        if (refresh) {
            setLoading(true);
        }
        api_api.publishPagebuilder(pagebuilder1.id).then(function(data) {
            update(data);
            console.log(data);
            if (refresh) {
                setLoading(false);
            }
        }).catch(function(err) {
            console.log(err);
            if (refresh) {
                setLoading(false);
            }
        });
    };
    var unpublish = function() {
        var refresh = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        if (refresh) {
            setLoading(true);
        }
        api_api.unpublishPagebuilder(pagebuilder1.id).then(function(data) {
            update(data);
            console.log(data);
            if (refresh) {
                setLoading(false);
            }
        }).catch(function(err) {
            console.log(err);
            if (refresh) {
                setLoading(false);
            }
        });
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(PagebuilderContext.Provider, {
        value: {
            pagebuilder: pagebuilder1,
            isLoading: isLoading,
            saveDraft: saveDraft,
            publish: publish,
            unpublish: unpublish
        },
        children: children
    }));
};
/* harmony default export */ var pagebuilderContext = (PagebuilderContextProvider);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/services/customBlocksContext.js




function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var customBlocksContext_CustomBlocksContext = /*#__PURE__*/ react.createContext();
var CustomBlocksContextProvider = function(param) {
    var children = param.children;
    var ref = (0,react.useContext)(globalContext_GlobalContext), lang = ref.lang, editMode = ref.editMode;
    var ref1 = (0,react.useState)(), customBlocks = ref1[0], setCustomBlocks = ref1[1];
    var ref2 = (0,react.useState)(true), isLoading = ref2[0], setLoading = ref2[1];
    (0,react.useEffect)(function() {
        if (editMode) {
            setLoading(true);
            api_api.getCustomBlocks({
                lang: lang
            }).then(function(data) {
                setCustomBlocks(data);
                setLoading(false);
            }).catch(function(err) {
                setLoading(false);
                console.log(err);
            });
        }
    }, [
        editMode
    ]);
    var addCustomBlock = function(name, json_content) {
        return api_api.createCustomBlock({
            lang: lang,
            name: name,
            json_content: json_content
        }).then(function(data) {
            setCustomBlocks(_toConsumableArray(customBlocks).concat([
                data
            ]));
            return data;
        }).catch(function(err) {
            console.log(err);
            return Promise.reject(err);
        });
    };
    var deleteCustomBlock = function(name) {
        var blockIndex = customBlocks.findIndex(function(block) {
            return block.name === name;
        });
        return api_api.deleteCustomBlock(customBlocks[blockIndex].id).then(function(data) {
            var newCustomBlocks = _toConsumableArray(customBlocks);
            newCustomBlocks.splice(blockIndex, 1);
            setCustomBlocks(newCustomBlocks);
            return data;
        }).catch(function(err) {
            console.log(err);
            return Promise.reject(err);
        });
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: editMode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(customBlocksContext_CustomBlocksContext.Provider, {
            value: {
                customBlocks: customBlocks,
                addCustomBlock: addCustomBlock,
                deleteCustomBlock: deleteCustomBlock,
                isLoading: isLoading
            },
            children: children
        }) : children
    }));
};
/* harmony default export */ var customBlocksContext = (CustomBlocksContextProvider);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/services/globalCustomBlocksContext.js




function globalCustomBlocksContext_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function globalCustomBlocksContext_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return globalCustomBlocksContext_arrayLikeToArray(arr);
}
function globalCustomBlocksContext_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function globalCustomBlocksContext_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function globalCustomBlocksContext_toConsumableArray(arr) {
    return globalCustomBlocksContext_arrayWithoutHoles(arr) || globalCustomBlocksContext_iterableToArray(arr) || globalCustomBlocksContext_unsupportedIterableToArray(arr) || globalCustomBlocksContext_nonIterableSpread();
}
function globalCustomBlocksContext_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return globalCustomBlocksContext_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return globalCustomBlocksContext_arrayLikeToArray(o, minLen);
}
var globalCustomBlocksContext_GlobalCustomBlocksContext = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.createContext()));
var GlobalCustomBlocksContextProvider = function(param) {
    var children = param.children;
    var ref = useContext(GlobalContext), lang = ref.lang, editMode = ref.editMode;
    var ref1 = useState(), globalCustomBlocks = ref1[0], setGlobalCustomBlocks = ref1[1];
    var ref2 = useState(true), isLoading = ref2[0], setLoading = ref2[1];
    useEffect(function() {
        if (editMode) {
            setLoading(true);
            api.getGlobalCustomBlocks({
                lang: lang
            }).then(function(data) {
                setGlobalCustomBlocks(data);
                setLoading(false);
            }).catch(function(err) {
                setLoading(false);
                console.log(err);
            });
        }
    }, [
        editMode
    ]);
    var addGlobalCustomBlock = function(name, json_content) {
        return api.createGlobalCustomBlock({
            lang: lang,
            name: name,
            json_content: json_content
        }).then(function(data) {
            setGlobalCustomBlocks(globalCustomBlocksContext_toConsumableArray(globalCustomBlocks).concat([
                data
            ]));
            return data;
        }).catch(function(err) {
            console.log(err);
            return Promise.reject(err);
        });
    };
    var updateGlobalCustomBlock = function(id, name, json_content) {
        var blockIndex = globalCustomBlocks.findIndex(function(block) {
            return block.id === id;
        });
        return api.updateGlobalCustomBlock(id, {
            lang: lang,
            name: name,
            json_content: json_content
        }).then(function(data) {
            var newGlobalCustomBlocks = globalCustomBlocksContext_toConsumableArray(globalCustomBlocks);
            newGlobalCustomBlocks.splice(blockIndex, 1);
            setGlobalCustomBlocks(globalCustomBlocksContext_toConsumableArray(newGlobalCustomBlocks).concat([
                data
            ]));
            return data;
        }).catch(function(err) {
            console.log(err);
            return Promise.reject(err);
        });
    };
    var deleteGlobalCustomBlock = function(name) {
        var blockIndex = globalCustomBlocks.findIndex(function(block) {
            return block.name === name;
        });
        return api.deleteGlobalCustomBlock(globalCustomBlocks[blockIndex].id).then(function(data) {
            var newGlobalCustomBlocks = globalCustomBlocksContext_toConsumableArray(globalCustomBlocks);
            newGlobalCustomBlocks.splice(blockIndex, 1);
            setGlobalCustomBlocks(newGlobalCustomBlocks);
            return data;
        }).catch(function(err) {
            console.log(err);
            return Promise.reject(err);
        });
    };
    return(/*#__PURE__*/ _jsx(_Fragment, {
        children: editMode ? /*#__PURE__*/ _jsx(globalCustomBlocksContext_GlobalCustomBlocksContext.Provider, {
            value: {
                globalCustomBlocks: globalCustomBlocks,
                addGlobalCustomBlock: addGlobalCustomBlock,
                updateGlobalCustomBlock: updateGlobalCustomBlock,
                deleteGlobalCustomBlock: deleteGlobalCustomBlock,
                isLoading: isLoading
            },
            children: children
        }) : children
    }));
};
/* harmony default export */ var globalCustomBlocksContext = ((/* unused pure expression or super */ null && (GlobalCustomBlocksContextProvider)));

// EXTERNAL MODULE: ../../node_modules/@craftjs/core/dist/esm/index.js + 1 modules
var esm = __webpack_require__(99648);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(94776);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/dom-helpers/esm/css.js + 5 modules
var css = __webpack_require__(42355);
// EXTERNAL MODULE: ../../node_modules/dom-helpers/esm/transitionEnd.js + 1 modules
var transitionEnd = __webpack_require__(19958);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react-transition-group/esm/Transition.js + 2 modules
var Transition = __webpack_require__(98005);
;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/atoms/BootstrapFade/BootstrapFade.tsx







var _excluded = [
    "className",
    "children"
];
var _fadeStyles;
var defaultProps = {
    in: false,
    timeout: 300,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false
};
var fadeStyles = (_fadeStyles = {}, _fadeStyles[Transition/* ENTERING */.d0] = 'show', _fadeStyles[Transition/* ENTERED */.cn] = 'show', _fadeStyles);
function parseDuration(node, property) {
    var str = (0,css/* default */.Z)(node, property) || '';
    var mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function transitionEndListener(element, handler) {
    var duration = parseDuration(element, 'transitionDuration');
    var delay = parseDuration(element, 'transitionDelay');
    var remove = (0,transitionEnd/* default */.Z)(element, function(e) {
        if (e.target === element) {
            remove();
            handler(e);
        }
    }, duration + delay);
}
function triggerBrowserReflow(node) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    node.offsetHeight;
}
var Fade = /*#__PURE__*/ react.forwardRef(function(_ref, ref) {
    var className = _ref.className, children = _ref.children, props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, _excluded);
    var handleEnter = (0,react.useCallback)(function(node) {
        triggerBrowserReflow(node);
        if (props.onEnter) props.onEnter(node);
    }, [
        props
    ]);
    return(/*#__PURE__*/ react.createElement(Transition/* default */.ZP, (0,esm_extends/* default */.Z)({
        ref: ref,
        addEndListener: transitionEndListener
    }, props, {
        onEnter: handleEnter
    }), function(status, innerProps) {
        return(/*#__PURE__*/ react.cloneElement(children, (0,esm_extends/* default */.Z)({}, innerProps, {
            className: classnames_default()('fade', className, children.props.className, fadeStyles[status])
        })));
    }));
});
Fade.defaultProps = defaultProps;
Fade.displayName = 'Fade';
/* harmony default export */ var BootstrapFade = (Fade);

// EXTERNAL MODULE: ../../node_modules/react-overlays/esm/Overlay.js + 61 modules
var Overlay = __webpack_require__(36705);
// EXTERNAL MODULE: ../../node_modules/react-overlays/esm/safeFindDOMNode.js
var safeFindDOMNode = __webpack_require__(40865);
// EXTERNAL MODULE: ../../node_modules/dom-helpers/esm/hasClass.js
var hasClass = __webpack_require__(82456);
;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/hooks/useBootstrapPopperMarginModifiers.tsx


function getMargins(element) {
    var styles = window.getComputedStyle(element);
    var top = parseFloat(styles.marginTop) || 0;
    var right = parseFloat(styles.marginRight) || 0;
    var bottom = parseFloat(styles.marginBottom) || 0;
    var left = parseFloat(styles.marginLeft) || 0;
    return {
        top: top,
        right: right,
        bottom: bottom,
        left: left
    };
}
function useBoostrapPopperMarginModifiers() {
    var overlayRef = (0,react.useRef)(null);
    var margins = (0,react.useRef)(null);
    var arrowMargins = (0,react.useRef)(null);
    var popoverClass = 'popover';
    var dropdownMenuClass = 'dropdown-menu';
    var callback = (0,react.useCallback)(function(overlay) {
        if (!overlay || !((0,hasClass/* default */.Z)(overlay, popoverClass) || (0,hasClass/* default */.Z)(overlay, dropdownMenuClass))) return;
        margins.current = getMargins(overlay);
        overlay.style.margin = '0';
        overlayRef.current = overlay;
    }, [
        popoverClass,
        dropdownMenuClass
    ]);
    var offset = (0,react.useMemo)(function() {
        return {
            name: 'offset',
            options: {
                offset: function offset(_ref) {
                    var placement = _ref.placement;
                    if (!margins.current) return [
                        0,
                        0
                    ];
                    var _margins$current = margins.current, top = _margins$current.top, left = _margins$current.left, bottom = _margins$current.bottom, right = _margins$current.right;
                    switch(placement.split('-')[0]){
                        case 'top':
                            return [
                                0,
                                bottom
                            ];
                        case 'left':
                            return [
                                0,
                                right
                            ];
                        case 'bottom':
                            return [
                                0,
                                top
                            ];
                        case 'right':
                            return [
                                0,
                                left
                            ];
                        default:
                            return [
                                0,
                                0
                            ];
                    }
                }
            }
        };
    }, [
        margins
    ]);
    var arrow = (0,react.useMemo)(function() {
        return {
            name: 'arrow',
            options: {
                padding: function padding() {
                    // The options here are used for Popper 2.8.4 and up.
                    // For earlier version, padding is handled in popoverArrowMargins below.
                    if (!arrowMargins.current) {
                        return 0;
                    }
                    var _arrowMargins$current = arrowMargins.current, top = _arrowMargins$current.top, right = _arrowMargins$current.right;
                    var padding = top || right;
                    return {
                        top: padding,
                        left: padding,
                        right: padding,
                        bottom: padding
                    };
                }
            }
        };
    }, [
        arrowMargins
    ]); // Converts popover arrow margin to arrow modifier padding
    var popoverArrowMargins = (0,react.useMemo)(function() {
        return {
            name: 'popoverArrowMargins',
            enabled: true,
            phase: 'main',
            requiresIfExists: [
                'arrow'
            ],
            effect: function effect(_ref2) {
                var state = _ref2.state;
                if (!overlayRef.current || !state.elements.arrow || !(0,hasClass/* default */.Z)(overlayRef.current, popoverClass)) {
                    return undefined;
                }
                if (state.modifiersData['arrow#persistent']) {
                    // @popperjs/core <= 2.8.3 uses arrow#persistent to pass padding to arrow modifier.
                    var _getMargins = getMargins(state.elements.arrow), top = _getMargins.top, right = _getMargins.right;
                    var padding = top || right;
                    state.modifiersData['arrow#persistent'].padding = {
                        top: padding,
                        left: padding,
                        right: padding,
                        bottom: padding
                    };
                } else {
                    // @popperjs/core >= 2.8.4 gets the padding from the arrow modifier options,
                    // so we'll get the margins here, and let the arrow modifier above pass
                    // it to popper.
                    arrowMargins.current = getMargins(state.elements.arrow);
                }
                state.elements.arrow.style.margin = '0';
                return function() {
                    if (state.elements.arrow) state.elements.arrow.style.margin = '';
                };
            }
        };
    }, [
        popoverClass
    ]);
    return [
        callback,
        [
            offset,
            arrow,
            popoverArrowMargins
        ]
    ];
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/atoms/BootstrapOverlay/BootstrapOverlay.tsx








var BootstrapOverlay_excluded = [
    'children',
    'transition',
    'popperConfig'
], _excluded2 = [
    'props',
    'arrowProps',
    'show',
    'update',
    'forceUpdate',
    'placement',
    'state', 
];
var BootstrapOverlay_defaultProps = {
    transition: BootstrapFade,
    rootClose: false,
    show: false,
    placement: 'top'
};
function wrapRefs(props, arrowProps) {
    var ref = props.ref;
    var aRef = arrowProps.ref;
    props.ref = ref.__wrapped || (ref.__wrapped = function(r) {
        return ref((0,safeFindDOMNode/* default */.Z)(r));
    });
    arrowProps.ref = aRef.__wrapped || (aRef.__wrapped = function(r) {
        return aRef((0,safeFindDOMNode/* default */.Z)(r));
    });
}
function BootstrapOverlay_Overlay(_ref) {
    var overlay = _ref.children, transition = _ref.transition, _ref$popperConfig = _ref.popperConfig, popperConfig = _ref$popperConfig === void 0 ? {} : _ref$popperConfig, outerProps = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, BootstrapOverlay_excluded);
    var popperRef = (0,react.useRef)({});
    var _usePopperMarginModif = useBoostrapPopperMarginModifiers(), ref = _usePopperMarginModif[0], marginModifiers = _usePopperMarginModif[1];
    var actualTransition = transition === true ? BootstrapFade : transition || null;
    return(/*#__PURE__*/ react.createElement(Overlay/* default */.Z, (0,esm_extends/* default */.Z)({}, outerProps, {
        ref: ref,
        popperConfig: (0,esm_extends/* default */.Z)({}, popperConfig, {
            modifiers: marginModifiers.concat(popperConfig.modifiers || [])
        }),
        transition: actualTransition
    }), function(_ref2) {
        var _state$modifiersData$;
        var overlayProps = _ref2.props, arrowProps = _ref2.arrowProps, show = _ref2.show, update = _ref2.update, _ = _ref2.forceUpdate, placement = _ref2.placement, state = _ref2.state, props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, _excluded2);
        wrapRefs(overlayProps, arrowProps);
        var popper = Object.assign(popperRef.current, {
            state: state,
            scheduleUpdate: update,
            placement: placement,
            outOfBoundaries: (state == null ? void 0 : (_state$modifiersData$ = state.modifiersData.hide) == null ? void 0 : _state$modifiersData$.isReferenceHidden) || false
        });
        if (typeof overlay === 'function') return overlay((0,esm_extends/* default */.Z)({}, props, overlayProps, {
            placement: placement,
            show: show
        }, !transition && show && {
            className: 'show'
        }, {
            popper: popper,
            arrowProps: arrowProps
        }));
        return(/*#__PURE__*/ react.cloneElement(overlay, (0,esm_extends/* default */.Z)({}, props, overlayProps, {
            placement: placement,
            arrowProps: arrowProps,
            popper: popper,
            className: classnames_default()(overlay.props.className, !transition && show && 'show'),
            style: (0,esm_extends/* default */.Z)({}, overlay.props.style, overlayProps.style)
        })));
    }));
}
BootstrapOverlay_Overlay.defaultProps = BootstrapOverlay_defaultProps;
/* harmony default export */ var BootstrapOverlay = (BootstrapOverlay_Overlay);

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(81665);
// EXTERNAL MODULE: ../../node_modules/dom-helpers/esm/contains.js
var contains = __webpack_require__(18786);
// EXTERNAL MODULE: ../../node_modules/@restart/hooks/esm/useTimeout.js + 2 modules
var useTimeout = __webpack_require__(29808);
// EXTERNAL MODULE: ../../node_modules/warning/warning.js
var warning = __webpack_require__(45982);
// EXTERNAL MODULE: ../../node_modules/uncontrollable/lib/esm/index.js + 4 modules
var lib_esm = __webpack_require__(93759);
;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/atoms/BootstrapOverlayTrigger/BootstrapOverlayTrigger.tsx










var BootstrapOverlayTrigger_excluded = [
    'trigger',
    'overlay',
    'children',
    'popperConfig',
    'show',
    'defaultShow',
    'onToggle',
    'delay',
    'placement',
    'flip', 
];
var RefHolder1 = /*#__PURE__*/ function(_React$Component) {
    var RefHolder = function RefHolder() {
        return _React$Component.apply(this, arguments) || this;
    };
    (0,inheritsLoose/* default */.Z)(RefHolder, _React$Component);
    var _proto = RefHolder.prototype;
    _proto.render = function render() {
        return this.props.children;
    };
    return RefHolder;
}(react.Component);
function normalizeDelay(delay) {
    return delay && typeof delay === 'object' ? delay : {
        show: delay,
        hide: delay
    };
} // Simple implementation of mouseEnter and mouseLeave.
// React's built version is broken: https://github.com/facebook/react/issues/4251
// for cases when the trigger is disabled and mouseOut/Over can cause flicker
// moving from one child element to another.
function handleMouseOverOut(handler, args, relatedNative) {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    var e = args[0];
    var target = e.currentTarget;
    var related = e.relatedTarget || e.nativeEvent[relatedNative];
    if ((!related || related !== target) && !(0,contains/* default */.Z)(target, related)) {
        handler.apply(void 0, args);
    }
}
var BootstrapOverlayTrigger_defaultProps = {
    defaultShow: false,
    trigger: [
        'hover',
        'focus'
    ]
};
function OverlayTrigger(_ref) {
    var trigger = _ref.trigger, overlay = _ref.overlay, children = _ref.children, _ref$popperConfig = _ref.popperConfig, popperConfig = _ref$popperConfig === void 0 ? {} : _ref$popperConfig, propsShow = _ref.show, _ref$defaultShow = _ref.defaultShow, defaultShow = _ref$defaultShow === void 0 ? false : _ref$defaultShow, onToggle = _ref.onToggle, propsDelay = _ref.delay, placement = _ref.placement, _ref$flip = _ref.flip, flip = _ref$flip === void 0 ? placement && placement.indexOf('auto') !== -1 : _ref$flip, props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, BootstrapOverlayTrigger_excluded);
    var triggerNodeRef = (0,react.useRef)(null);
    var timeout = (0,useTimeout/* default */.Z)();
    var hoverStateRef = (0,react.useRef)('');
    var _useUncontrolledProp = (0,lib_esm/* useUncontrolledProp */.$c)(propsShow, defaultShow, onToggle), show = _useUncontrolledProp[0], setShow = _useUncontrolledProp[1];
    var delay = normalizeDelay(propsDelay);
    var _ref2 = typeof children !== 'function' ? react.Children.only(children).props : {}, onFocus = _ref2.onFocus, onBlur = _ref2.onBlur, onClick = _ref2.onClick;
    var getTarget = (0,react.useCallback)(function() {
        return (0,safeFindDOMNode/* default */.Z)(triggerNodeRef.current);
    }, []);
    var handleShow = (0,react.useCallback)(function() {
        timeout.clear();
        hoverStateRef.current = 'show';
        if (!delay.show) {
            setShow(true);
            return;
        }
        timeout.set(function() {
            if (hoverStateRef.current === 'show') setShow(true);
        }, delay.show);
    }, [
        delay.show,
        setShow,
        timeout
    ]);
    var handleHide = (0,react.useCallback)(function() {
        timeout.clear();
        hoverStateRef.current = 'hide';
        if (!delay.hide) {
            setShow(false);
            return;
        }
        timeout.set(function() {
            if (hoverStateRef.current === 'hide') setShow(false);
        }, delay.hide);
    }, [
        delay.hide,
        setShow,
        timeout
    ]);
    var handleFocus = (0,react.useCallback)(function() {
        handleShow();
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        onFocus == null ? void 0 : onFocus.apply(void 0, args);
    }, [
        handleShow,
        onFocus
    ]);
    var handleBlur = (0,react.useCallback)(function() {
        handleHide();
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++){
            args[_key2] = arguments[_key2];
        }
        onBlur == null ? void 0 : onBlur.apply(void 0, args);
    }, [
        handleHide,
        onBlur
    ]);
    var handleClick = (0,react.useCallback)(function() {
        setShow(!show);
        if (onClick) onClick.apply(void 0, arguments);
    }, [
        onClick,
        setShow,
        show
    ]);
    var handleMouseOver = (0,react.useCallback)(function() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++){
            args[_key3] = arguments[_key3];
        }
        handleMouseOverOut(handleShow, args, 'fromElement');
    }, [
        handleShow
    ]);
    var handleMouseOut = (0,react.useCallback)(function() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++){
            args[_key4] = arguments[_key4];
        }
        handleMouseOverOut(handleHide, args, 'toElement');
    }, [
        handleHide
    ]);
    var triggers = trigger == null ? [] : [].concat(trigger);
    var triggerProps = {};
    if (triggers.indexOf('click') !== -1) {
        triggerProps.onClick = handleClick;
    }
    if (triggers.indexOf('focus') !== -1) {
        triggerProps.onFocus = handleFocus;
        triggerProps.onBlur = handleBlur;
    }
    if (triggers.indexOf('hover') !== -1) {
         false ? 0 : void 0;
        triggerProps.onMouseOver = handleMouseOver;
        triggerProps.onMouseOut = handleMouseOut;
    }
    return(/*#__PURE__*/ react.createElement(react.Fragment, null, typeof children === 'function' ? children((0,esm_extends/* default */.Z)({}, triggerProps, {
        ref: triggerNodeRef
    })) : /*#__PURE__*/ react.createElement(RefHolder1, {
        ref: triggerNodeRef
    }, /*#__PURE__*/ (0,react.cloneElement)(children, triggerProps)), /*#__PURE__*/ react.createElement(BootstrapOverlay, (0,esm_extends/* default */.Z)({}, props, {
        show: show,
        onHide: handleHide,
        flip: flip,
        placement: placement,
        popperConfig: popperConfig,
        target: getTarget
    }), overlay)));
}
OverlayTrigger.defaultProps = BootstrapOverlayTrigger_defaultProps;
/* harmony default export */ var BootstrapOverlayTrigger = (OverlayTrigger);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/atoms/BootstrapTooltip/BootstrapTooltip.tsx




var BootstrapTooltip_excluded = [
    "bsPrefix",
    "placement",
    "className",
    "style",
    "children",
    "arrowProps",
    "popper",
    "show"
];
var BootstrapTooltip_defaultProps = {
    placement: 'right'
};
var BootstrapTooltip = /*#__PURE__*/ react.forwardRef(function(_ref, ref) {
    var bsPrefix = _ref.bsPrefix, placement = _ref.placement, className = _ref.className, style = _ref.style, children = _ref.children, arrowProps = _ref.arrowProps, _ = _ref.popper, _2 = _ref.show, props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, BootstrapTooltip_excluded);
    bsPrefix = bsPrefix || 'tooltip';
    var _ref2 = (placement == null ? void 0 : placement.split('-')) || [], primaryPlacement = _ref2[0];
    return(/*#__PURE__*/ react.createElement("div", (0,esm_extends/* default */.Z)({
        ref: ref,
        style: style,
        role: "tooltip",
        "x-placement": primaryPlacement,
        className: classnames_default()(className, bsPrefix, "bs-tooltip-" + primaryPlacement)
    }, props), /*#__PURE__*/ react.createElement("div", (0,esm_extends/* default */.Z)({
        className: "arrow"
    }, arrowProps)), /*#__PURE__*/ react.createElement("div", {
        className: bsPrefix + "-inner"
    }, children)));
});
BootstrapTooltip.defaultProps = BootstrapTooltip_defaultProps;
BootstrapTooltip.displayName = 'Tooltip';
/* harmony default export */ var BootstrapTooltip_BootstrapTooltip = (BootstrapTooltip);

// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/Add.js


function Add(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--add".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M38 26h-12v12h-4v-12h-12v-4h12v-12h4v12h12v4z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 0h48v48h-48z",
                fill: "none"
            })
        ]
    }));
}
/* harmony default export */ var icons_Add = (Add);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/Bin.js


function Bin(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--bin".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12 38c0 2.21 1.79 4 4 4h16c2.21 0 4-1.79 4-4v-24h-24v24zm26-30h-7l-2-2h-10l-2 2h-7v4h28v-4z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 0h48v48h-48z",
                fill: "none"
            })
        ]
    }));
}
/* harmony default export */ var icons_Bin = (Bin);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/Blocks.js


function Blocks(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--blocks".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 0h48v48h-48z",
                fill: "none"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6 26h16v-20h-16v20zm0 16h16v-12h-16v12zm20 0h16v-20h-16v20zm0-36v12h16v-12h-16z"
            })
        ]
    }));
}
/* harmony default export */ var icons_Blocks = (Blocks);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/Button.js


function Button(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        viewBox: "0 -44 640 640",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--button ".concat(className ? className : ''),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "M592 96.5H48c-26.5 0-48 21.5-48 48v223c0 26.5 21.5 48 48 48h544c26.5 0 48-21.5 48-48v-223c0-26.5-21.5-48-48-48zm-6 271H54c-3.3 0-6-2.7-6-6v-211c0-3.3 2.7-6 6-6h532c3.3 0 6 2.7 6 6v211c0 3.3-2.7 6-6 6z"
        })
    }));
}
/* harmony default export */ var icons_Button = (Button);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/Check.js


function Check(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--check".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 0h48v48h-48z",
                fill: "none"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18 32.34l-8.34-8.34-2.83 2.83 11.17 11.17 24-24-2.83-2.83z"
            })
        ]
    }));
}
/* harmony default export */ var icons_Check = (Check);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/ChevronDown.js


function ChevronDown_ChevronDown(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--chevron-down".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.83 16.42l9.17 9.17 9.17-9.17 2.83 2.83-12 12-12-12z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0-.75h48v48h-48z",
                fill: "none"
            })
        ]
    }));
}
/* harmony default export */ var icons_ChevronDown = (ChevronDown_ChevronDown);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/ChevronLeft.js


function ChevronLeft(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--chevron-left".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M30.83 32.67l-9.17-9.17 9.17-9.17-2.83-2.83-12 12 12 12z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0-.5h48v48h-48z",
                fill: "none"
            })
        ]
    }));
}
/* harmony default export */ var icons_ChevronLeft = (ChevronLeft);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/ChevronRight.js


function ChevronRight(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--chevron-right".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.17 32.92l9.17-9.17-9.17-9.17 2.83-2.83 12 12-12 12z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0-.25h48v48h-48z",
                fill: "none"
            })
        ]
    }));
}
/* harmony default export */ var icons_ChevronRight = (ChevronRight);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/ChevronUp.js


function ChevronUp_ChevronUp(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--chevron-up".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.83 30.83l9.17-9.17 9.17 9.17 2.83-2.83-12-12-12 12z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 0h48v48h-48z",
                fill: "none"
            })
        ]
    }));
}
/* harmony default export */ var icons_ChevronUp = (ChevronUp_ChevronUp);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/Click.js


function Click(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        viewBox: "0 0 20 20",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--click".concat(className ? ' ' + className : ''),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            clipRule: "evenodd",
            d: "M6.67187 1.91147C6.52893 1.37801 5.9806 1.06142 5.44713 1.20437C4.91366 1.34731 4.59708 1.89565 4.74002 2.42911L4.99884 3.39504C5.14178 3.9285 5.69012 4.24509 6.22359 4.10214C6.75705 3.9592 7.07363 3.41086 6.93069 2.8774L6.67187 1.91147ZM2.42923 4.7399C1.89577 4.59696 1.34743 4.91354 1.20449 5.44701C1.06155 5.98047 1.37813 6.52881 1.9116 6.67175L2.87752 6.93057C3.41099 7.07351 3.95932 6.75693 4.10227 6.22346C4.24521 5.69 3.92863 5.14166 3.39516 4.99872L2.42923 4.7399ZM11.2427 4.17149C11.6332 3.78097 11.6332 3.1478 11.2427 2.75728C10.8522 2.36676 10.219 2.36676 9.82847 2.75728L9.12136 3.46439C8.73084 3.85491 8.73084 4.48808 9.12136 4.8786C9.51189 5.26912 10.1451 5.26912 10.5356 4.8786L11.2427 4.17149ZM4.17162 11.2426L4.87872 10.5355C5.26925 10.1449 5.26925 9.51177 4.87872 9.12124C4.4882 8.73072 3.85503 8.73072 3.46451 9.12124L2.7574 9.82835C2.36688 10.2189 2.36688 10.852 2.7574 11.2426C3.14793 11.6331 3.78109 11.6331 4.17162 11.2426ZM7.37154 6.07152C7.00012 5.92295 6.5759 6.01002 6.29304 6.29289C6.01018 6.57575 5.92311 6.99997 6.07167 7.37138L10.0717 17.3714C10.2179 17.737 10.5651 17.9828 10.9586 17.9991C11.352 18.0155 11.7185 17.7994 11.8946 17.4472L13.2741 14.6882L16.293 17.7071C16.6836 18.0976 17.3167 18.0976 17.7073 17.7071C18.0978 17.3166 18.0978 16.6834 17.7073 16.2929L14.6883 13.2739L17.4474 11.8944C17.7996 11.7183 18.0157 11.3519 17.9993 10.9584C17.9829 10.565 17.7372 10.2178 17.3715 10.0715L7.37154 6.07152Z",
            fillRule: "evenodd"
        })
    }));
}
/* harmony default export */ var icons_Click = (Click);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/Close.js


function Close(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--close".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M38 12.83l-2.83-2.83-11.17 11.17-11.17-11.17-2.83 2.83 11.17 11.17-11.17 11.17 2.83 2.83 11.17-11.17 11.17 11.17 2.83-2.83-11.17-11.17z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 0h48v48h-48z",
                fill: "none"
            })
        ]
    }));
}
/* harmony default export */ var icons_Close = (Close);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/Conditions.js


function Conditions(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--conditions".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M40 20h-6v-2.28c3.45-.89 6-3.99 6-7.72h-6v-2c0-1.1-.89-2-2-2h-16c-1.1 0-2 .9-2 2v2h-6c0 3.72 2.56 6.83 6 7.72v2.28h-6c0 3.72 2.56 6.83 6 7.72v2.28h-6c0 3.72 2.56 6.83 6 7.72v2.28c0 1.1.9 2 2 2h16c1.11 0 2-.9 2-2v-2.28c3.45-.89 6-3.99 6-7.72h-6v-2.28c3.45-.89 6-4 6-7.72zm-16 18c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm0-10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm0-10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 0h48v48h-48z",
                fill: "none"
            })
        ]
    }));
}
/* harmony default export */ var icons_Conditions = (Conditions);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/CustomBlocks.js


function CustomBlocks(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--custom-blocks".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6 10v28c0 2.21 1.79 4 4 4h28c2.21 0 4-1.79 4-4v-28c0-2.21-1.79-4-4-4h-28c-2.21 0-4 1.79-4 4zm24 8c0 3.32-2.69 6-6 6s-6-2.68-6-6c0-3.31 2.69-6 6-6s6 2.69 6 6zm-18 16c0-4 8-6.2 12-6.2s12 2.2 12 6.2v2h-24v-2z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 0h48v48h-48z",
                fill: "none"
            })
        ]
    }));
}
/* harmony default export */ var icons_CustomBlocks = (CustomBlocks);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/Denied.js


function Denied(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--denied".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 0h48v48H0z",
                fill: "none"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 4C12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20S35.05 4 24 4zm0 36c-8.84 0-16-7.16-16-16 0-3.7 1.27-7.09 3.37-9.8L33.8 36.63C31.09 38.73 27.7 40 24 40zm12.63-6.2L14.2 11.37C16.91 9.27 20.3 8 24 8c8.84 0 16 7.16 16 16 0 3.7-1.27 7.09-3.37 9.8z"
            })
        ]
    }));
}
/* harmony default export */ var icons_Denied = (Denied);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/Desktop.js


function Desktop(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--desktop".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 0h48v48h-48z",
                fill: "none"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M42 4h-36c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h14v4h-4v4h16v-4h-4v-4h14c2.21 0 4-1.79 4-4v-24c0-2.21-1.79-4-4-4zm0 28h-36v-24h36v24z"
            })
        ]
    }));
}
/* harmony default export */ var icons_Desktop = (Desktop);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/Edit.js


function Edit(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--edit".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6 34.5v7.5h7.5l22.13-22.13-7.5-7.5-22.13 22.13zm35.41-20.41c.78-.78.78-2.05 0-2.83l-4.67-4.67c-.78-.78-2.05-.78-2.83 0l-3.66 3.66 7.5 7.5 3.66-3.66z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 0h48v48h-48z",
                fill: "none"
            })
        ]
    }));
}
/* harmony default export */ var icons_Edit = (Edit);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/Empty.js


function Empty(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--strokes icon--empty".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z",
                fill: "none"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("polyline", {
                points: "13 2 13 9 20 9",
                fill: "none"
            })
        ]
    }));
}
/* harmony default export */ var icons_Empty = (Empty);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/Export.js


function Export(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--export".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 0h48v48h-48z",
                fill: "none"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18 32h12v-12h8l-14-14-14 14h8zm-8 4h28v4h-28z"
            })
        ]
    }));
}
/* harmony default export */ var icons_Export = (Export);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/FolderOpen.js


function FolderOpen(param) {
    var className = param.className;
    return(/*#__PURE__*/ _jsxs("svg", {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--folder-open".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M0 0h48v48h-48z",
                fill: "none"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M40 12h-16l-4-4h-12c-2.21 0-3.98 1.79-3.98 4l-.02 24c0 2.21 1.79 4 4 4h32c2.21 0 4-1.79 4-4v-20c0-2.21-1.79-4-4-4zm0 24h-32v-20h32v20z"
            })
        ]
    }));
}
/* harmony default export */ var icons_FolderOpen = ((/* unused pure expression or super */ null && (FolderOpen)));

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/Fullscreen.js


function Fullscreen(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--fullscreen".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29.92,2.62a1.15,1.15,0,0,0-.21-.33,1.15,1.15,0,0,0-.33-.21A1,1,0,0,0,29,2H21a1,1,0,0,0,0,2h5.59l-8.3,8.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L28,5.41V11a1,1,0,0,0,2,0V3A1,1,0,0,0,29.92,2.62Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.41,4H11a1,1,0,0,0,0-2H3a1,1,0,0,0-.38.08,1.15,1.15,0,0,0-.33.21,1.15,1.15,0,0,0-.21.33A1,1,0,0,0,2,3v8a1,1,0,0,0,2,0V5.41l8.29,8.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M29,20a1,1,0,0,0-1,1v5.59l-8.29-8.3a1,1,0,0,0-1.42,1.42L26.59,28H21a1,1,0,0,0,0,2h8a1,1,0,0,0,.38-.08.9.9,0,0,0,.54-.54A1,1,0,0,0,30,29V21A1,1,0,0,0,29,20Z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.29,18.29,4,26.59V21a1,1,0,0,0-2,0v8a1,1,0,0,0,.08.38,1.15,1.15,0,0,0,.21.33,1.15,1.15,0,0,0,.33.21A1,1,0,0,0,3,30h8a1,1,0,0,0,0-2H5.41l8.3-8.29a1,1,0,0,0-1.42-1.42Z"
            })
        ]
    }));
}
/* harmony default export */ var icons_Fullscreen = (Fullscreen);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/GenericBlock.js


function GenericBlock(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--strokes icon--generic-block".concat(className ? ' ' + className : ''),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M20 7L12 3L4 7M20 7L12 11M20 7V17L12 21M12 11L4 7M12 11V21M4 7V17L12 21",
            fill: "none",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2"
        })
    }));
}
/* harmony default export */ var icons_GenericBlock = (GenericBlock);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/Image.js


function Image(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        viewBox: "-32 0 512 512",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--image ".concat(className ? className : ''),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "M416 32H32A32 32 0 0 0 0 64v384a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32zm-16 400H48v-64h352zm0-112h-16l-97.07-121c-7.46-9.31-22.4-9.31-29.86 0l-63.38 79-33.05-45.78c-7.92-11-25.36-11-33.28 0L64 320H48V80h352zM144 176a32 32 0 1 0-32-32 32 32 0 0 0 32 32z"
        })
    }));
}
/* harmony default export */ var icons_Image = (Image);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/ImageCopy.js


function ImageCopy(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--image-copy".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 0h48v48h-48z",
                fill: "none"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M44 32v-24c0-2.21-1.79-4-4-4h-24c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h24c2.21 0 4-1.79 4-4zm-22-8l4.06 5.42 5.94-7.42 8 10h-24l6-8zm-18-12v28c0 2.21 1.79 4 4 4h28v-4h-28v-28h-4z"
            })
        ]
    }));
}
/* harmony default export */ var icons_ImageCopy = (ImageCopy);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/Import.js


function Import(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--import".concat(className ? ' ' + className : ''),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M24 32.5l8-8h-6v-18h-4v18h-6l8 8zm18-26h-12v3.97h12v28.06h-36v-28.06h12v-3.97h-12c-2.21 0-4 1.79-4 4v28c0 2.21 1.79 4 4 4h36c2.21 0 4-1.79 4-4v-28c0-2.21-1.79-4-4-4z"
        })
    }));
}
/* harmony default export */ var icons_Import = (Import);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/Info.js


function Info(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--info".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 0h48v48h-48z",
                fill: "none"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22 34h4v-12h-4v12zm2-30c-11.05 0-20 8.95-20 20s8.95 20 20 20 20-8.95 20-20-8.95-20-20-20zm0 36c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16zm-2-22h4v-4h-4v4z"
            })
        ]
    }));
}
/* harmony default export */ var icons_Info = (Info);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/Laptop.js


function Laptop(param) {
    var className = param.className;
    return(/*#__PURE__*/ _jsxs("svg", {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--laptop".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M0 0h48v48h-48z",
                fill: "none"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M40 36v-2c2.21 0 3.98-1.79 3.98-4l.02-20c0-2.21-1.79-4-4-4h-32c-2.21 0-4 1.79-4 4v20c0 2.21 1.79 4 4 4v2h-8v4h48v-4h-8zm-32-26h32v20h-32v-20z"
            })
        ]
    }));
}
/* harmony default export */ var icons_Laptop = ((/* unused pure expression or super */ null && (Laptop)));

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/Loader.js


function Loader(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--loader".concat(className ? ' ' + className : ''),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M16,0.5c-0.82813,0-1.5,0.67188-1.5,1.5v4c0,0.82813,0.67188,1.5,1.5,1.5s1.5-0.67188,1.5-1.5V2 C17.5,1.17188,16.82813,0.5,16,0.5z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M7.5,16c0-0.82813-0.67188-1.5-1.5-1.5H2c-0.82813,0-1.5,0.67188-1.5,1.5s0.67188,1.5,1.5,1.5h4 C6.82813,17.5,7.5,16.82813,7.5,16z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M7.86816,22.01074l-2.82813,2.82813c-0.58594,0.58594-0.58594,1.53516,0,2.12109 c0.29297,0.29297,0.67676,0.43945,1.06055,0.43945s0.76758-0.14648,1.06055-0.43945l2.82813-2.82813 c0.58594-0.58594,0.58594-1.53516,0-2.12109S8.4541,21.4248,7.86816,22.01074z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M16,24.5c-0.82813,0-1.5,0.67188-1.5,1.5v4c0,0.82813,0.67188,1.5,1.5,1.5s1.5-0.67188,1.5-1.5v-4 C17.5,25.17188,16.82813,24.5,16,24.5z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M24.13184,22.01074c-0.58594-0.58594-1.53516-0.58594-2.12109,0s-0.58594,1.53516,0,2.12109l2.82813,2.82813 c0.29297,0.29297,0.67676,0.43945,1.06055,0.43945s0.76758-0.14648,1.06055-0.43945c0.58594-0.58594,0.58594-1.53516,0-2.12109 L24.13184,22.01074z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M30,14.5h-4c-0.82813,0-1.5,0.67188-1.5,1.5s0.67188,1.5,1.5,1.5h4c0.82813,0,1.5-0.67188,1.5-1.5S30.82813,14.5,30,14.5z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M23.07129,10.42871c0.38379,0,0.76758-0.14648,1.06055-0.43945l2.82813-2.82813c0.58594-0.58594,0.58594-1.53516,0-2.12109 s-1.53516-0.58594-2.12109,0l-2.82813,2.82813c-0.58594,0.58594-0.58594,1.53516,0,2.12109 C22.30371,10.28223,22.6875,10.42871,23.07129,10.42871z"
                })
            ]
        })
    }));
}
/* harmony default export */ var icons_Loader = (Loader);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/LockClose.js


function LockClose(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--lock-close".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 0h48v48h-48z",
                fill: "none"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M36 16h-2v-4c0-5.52-4.48-10-10-10s-10 4.48-10 10v4h-2c-2.21 0-4 1.79-4 4v20c0 2.21 1.79 4 4 4h24c2.21 0 4-1.79 4-4v-20c0-2.21-1.79-4-4-4zm-12-10.2c3.42 0 6.2 2.78 6.2 6.2v4h-12.2v-4h-.2c0-3.42 2.78-6.2 6.2-6.2zm12 34.2h-24v-20h24v20zm-12-6c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4z"
            })
        ]
    }));
}
/* harmony default export */ var icons_LockClose = (LockClose);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/LockOpen.js


function LockOpen(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--lock-open".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 0h48v48h-48z",
                fill: "none"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 34c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm12-18h-2v-4c0-5.52-4.48-10-10-10s-10 4.48-10 10h3.8c0-3.42 2.78-6.2 6.2-6.2 3.42 0 6.2 2.78 6.2 6.2v4h-18.2c-2.21 0-4 1.79-4 4v20c0 2.21 1.79 4 4 4h24c2.21 0 4-1.79 4-4v-20c0-2.21-1.79-4-4-4zm0 24h-24v-20h24v20z"
            })
        ]
    }));
}
/* harmony default export */ var icons_LockOpen = (LockOpen);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/More.js


function More(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--more".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13,16c0,1.654,1.346,3,3,3s3-1.346,3-3s-1.346-3-3-3S13,14.346,13,16z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13,26c0,1.654,1.346,3,3,3s3-1.346,3-3s-1.346-3-3-3S13,24.346,13,26z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13,6c0,1.654,1.346,3,3,3s3-1.346,3-3s-1.346-3-3-3S13,4.346,13,6z"
            })
        ]
    }));
}
/* harmony default export */ var icons_More = (More);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/Navigation.js


function Navigation(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--navigation".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M36 16c0-6.63-5.37-12-12-12s-12 5.37-12 12c0 9 12 22 12 22s12-13 12-22zm-16 0c0-2.21 1.79-4 4-4s4 1.79 4 4-1.79 4-4 4-4-1.79-4-4zm-10 24v4h28v-4h-28z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 0h48v48h-48z",
                fill: "none"
            })
        ]
    }));
}
/* harmony default export */ var icons_Navigation = (Navigation);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/Options.js


function Options(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--options".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 0h48v48h-48z",
                fill: "none"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M38.86 25.95c.08-.64.14-1.29.14-1.95s-.06-1.31-.14-1.95l4.23-3.31c.38-.3.49-.84.24-1.28l-4-6.93c-.25-.43-.77-.61-1.22-.43l-4.98 2.01c-1.03-.79-2.16-1.46-3.38-1.97l-.75-5.3c-.09-.47-.5-.84-1-.84h-8c-.5 0-.91.37-.99.84l-.75 5.3c-1.22.51-2.35 1.17-3.38 1.97l-4.98-2.01c-.45-.17-.97 0-1.22.43l-4 6.93c-.25.43-.14.97.24 1.28l4.22 3.31c-.08.64-.14 1.29-.14 1.95s.06 1.31.14 1.95l-4.22 3.31c-.38.3-.49.84-.24 1.28l4 6.93c.25.43.77.61 1.22.43l4.98-2.01c1.03.79 2.16 1.46 3.38 1.97l.75 5.3c.08.47.49.84.99.84h8c.5 0 .91-.37.99-.84l.75-5.3c1.22-.51 2.35-1.17 3.38-1.97l4.98 2.01c.45.17.97 0 1.22-.43l4-6.93c.25-.43.14-.97-.24-1.28l-4.22-3.31zm-14.86 5.05c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
            })
        ]
    }));
}
/* harmony default export */ var icons_Options = (Options);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/PdfLink.js


function PdfLink_Import(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "-4 -4 40 40",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--pdflink".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                id: "pd-pdflink__mask",
                fill: "white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M23.3072 3.55472C22.935 3.1987 22.4398 3 21.9248 3H8C6.89543 3 6 3.89543 6 5V27C6 28.1046 6.89543 29 8 29H27C28.1046 29 29 28.1046 29 27V9.85458C29 9.30873 28.7769 8.7866 28.3824 8.4093L23.3072 3.55472Z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M23.3072 3.55472C22.935 3.1987 22.4398 3 21.9248 3H8C6.89543 3 6 3.89543 6 5V27C6 28.1046 6.89543 29 8 29H27C28.1046 29 29 28.1046 29 27V9.85458C29 9.30873 28.7769 8.7866 28.3824 8.4093L23.3072 3.55472Z",
                fill: "none"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.3824 8.4093L27.6912 9.13194L28.3824 8.4093ZM23.3072 3.55472L22.616 4.27736L23.3072 3.55472ZM8 4H21.9248V2H8V4ZM7 27V5H5V27H7ZM27 28H8V30H27V28ZM28 9.85458V27H30V9.85458H28ZM29.0737 7.68665L23.9984 2.83207L22.616 4.27736L27.6912 9.13194L29.0737 7.68665ZM30 9.85458C30 9.03581 29.6653 8.25261 29.0737 7.68665L27.6912 9.13194C27.8884 9.32059 28 9.58166 28 9.85458H30ZM27 30C28.6569 30 30 28.6569 30 27H28C28 27.5523 27.5523 28 27 28V30ZM5 27C5 28.6569 6.34314 30 8 30V28C7.44772 28 7 27.5523 7 27H5ZM21.9248 4C22.1823 4 22.4299 4.09935 22.616 4.27736L23.9984 2.83207C23.4401 2.29805 22.6973 2 21.9248 2V4ZM8 2C6.34315 2 5 3.34315 5 5H7C7 4.44772 7.44772 4 8 4V2Z",
                fill: "currentColor",
                mask: "url(#pd-pdflink__mask)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "3",
                y: "8",
                width: "23",
                height: "10",
                rx: "5",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.27747 12.8235H8.6978C9.09066 12.8235 9.38462 12.7469 9.57967 12.5937C9.77473 12.4378 9.87225 12.212 9.87225 11.9166C9.87225 11.6183 9.78984 11.3981 9.625 11.2558C9.46291 11.1135 9.20742 11.0424 8.85852 11.0424H8.27747V12.8235ZM11.1621 11.8714C11.1621 12.5171 10.9588 13.0109 10.5522 13.3529C10.1484 13.6949 9.5728 13.8659 8.82555 13.8659H8.27747V16H7V10H8.92445C9.65522 10 10.2102 10.1573 10.5893 10.472C10.9712 10.7839 11.1621 11.2503 11.1621 11.8714Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.2981 12.9425C17.2981 13.9302 17.0151 14.6867 16.4492 15.212C15.886 15.7373 15.0714 16 14.0055 16H12.2995V10H14.1909C15.1745 10 15.9382 10.2585 16.4821 10.7756C17.0261 11.2927 17.2981 12.015 17.2981 12.9425ZM15.9712 12.9754C15.9712 11.6867 15.3997 11.0424 14.2569 11.0424H13.5769V14.9494H14.125C15.3558 14.9494 15.9712 14.2914 15.9712 12.9754Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.8036 16H18.5467V10H22V11.0424H19.8036V12.5896H21.8475V13.6279H19.8036V16Z",
                fill: "white"
            })
        ]
    }));
}
/* harmony default export */ var PdfLink = (PdfLink_Import);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/PlusCopy.js


function PlusCopy(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--plus-copy".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 0h48v48H0z",
                fill: "none"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8 12H4v28c0 2.21 1.79 4 4 4h28v-4H8V12zm32-8H16c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h24c2.21 0 4-1.79 4-4V8c0-2.21-1.79-4-4-4zm-2 18h-8v8h-4v-8h-8v-4h8v-8h4v8h8v4z"
            })
        ]
    }));
}
/* harmony default export */ var icons_PlusCopy = (PlusCopy);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/Preview.js


function Preview_Preview(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--preview".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 0h48v48h-48z",
                fill: "none"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M38 38h-28v-28h14v-4h-14c-2.21 0-4 1.79-4 4v28c0 2.21 1.79 4 4 4h28c2.21 0 4-1.79 4-4v-14h-4v14zm-10-32v4h7.17l-19.66 19.66 2.83 2.83 19.66-19.66v7.17h4v-14h-14z"
            })
        ]
    }));
}
/* harmony default export */ var icons_Preview = (Preview_Preview);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/PreviewMode.js


function PreviewMode_PreviewMode(param) {
    var className = param.className;
    return(/*#__PURE__*/ _jsxs("svg", {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--preview-mode".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M6 6v36h36v-36h-36zm16 32h-12v-12h12v12zm0-16h-12v-12h12v12zm16 16h-12v-12h12v12zm0-16h-12v-12h12v12z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M0 0h48v48h-48z",
                fill: "none"
            })
        ]
    }));
}
/* harmony default export */ var icons_PreviewMode = ((/* unused pure expression or super */ null && (PreviewMode_PreviewMode)));

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/Publish.js


function Publish(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--publish".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 0h48v48h-48z",
                fill: "none"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M38.71 20.07c-1.36-6.88-7.43-12.07-14.71-12.07-5.78 0-10.79 3.28-13.3 8.07-6.01.65-10.7 5.74-10.7 11.93 0 6.63 5.37 12 12 12h26c5.52 0 10-4.48 10-10 0-5.28-4.11-9.56-9.29-9.93zm-10.71 5.93v8h-8v-8h-6l10-10 10 10h-6z"
            })
        ]
    }));
}
/* harmony default export */ var icons_Publish = (Publish);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/Quote.js


function Quote(param) {
    var className = param.className;
    return(/*#__PURE__*/ _jsxs("svg", {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--quote".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M12 34h6l4-8v-12h-12v12h6zm16 0h6l4-8v-12h-12v12h6z"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M0 0h48v48h-48z",
                fill: "none"
            })
        ]
    }));
}
/* harmony default export */ var icons_Quote = ((/* unused pure expression or super */ null && (Quote)));

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/Redo.js


function Redo(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--redo".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 0h48v48h-48z",
                fill: "none"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M36.79 21.2c-3.68-3.23-8.5-5.2-13.79-5.2-9.3 0-17.17 6.06-19.92 14.44l4.73 1.56c2.1-6.39 8.1-11 15.19-11 3.91 0 7.46 1.44 10.23 3.77l-7.23 7.23h18v-18l-7.21 7.2z"
            })
        ]
    }));
}
/* harmony default export */ var icons_Redo = (Redo);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/Save.js


function Save(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--save".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 0h48v48h-48z",
                fill: "none"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M34 6h-24c-2.21 0-4 1.79-4 4v28c0 2.21 1.79 4 4 4h28c2.21 0 4-1.79 4-4v-24l-8-8zm-10 32c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm6-20h-20v-8h20v8z"
            })
        ]
    }));
}
/* harmony default export */ var icons_Save = (Save);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/Smartphone.js


function Smartphone(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--smartphone".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 0h48v48h-48z",
                fill: "none"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M34 2.02l-20-.02c-2.21 0-4 1.79-4 4v36c0 2.21 1.79 4 4 4h20c2.21 0 4-1.79 4-4v-36c0-2.21-1.79-3.98-4-3.98zm0 35.98h-20v-28h20v28z"
            })
        ]
    }));
}
/* harmony default export */ var icons_Smartphone = (Smartphone);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/SmartphoneLandscape.js


function SmartphoneLandscape(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--smartphone-landscape".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 0h48v48h-48z",
                fill: "none"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.02 14l-.02 20c0 2.21 1.79 4 4 4h36c2.21 0 4-1.79 4-4v-20c0-2.21-1.79-4-4-4h-36c-2.21 0-3.98 1.79-3.98 4zm35.98 0v20h-28v-20h28z"
            })
        ]
    }));
}
/* harmony default export */ var icons_SmartphoneLandscape = (SmartphoneLandscape);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/Tablet.js


function Tablet(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--tablet".concat(className ? ' ' + className : ''),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M36 0h-24c-3.31 0-6 2.69-6 6v36c0 3.31 2.69 6 6 6h24c3.31 0 6-2.69 6-6v-36c0-3.31-2.69-6-6-6zm-8 44h-8v-2h8v2zm10.5-6h-29v-32h29v32z"
        })
    }));
}
/* harmony default export */ var icons_Tablet = (Tablet);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/TabletLandscape.js


function TabletLandscape(param) {
    var className = param.className;
    return(/*#__PURE__*/ _jsxs("svg", {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--tablet-landscape".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M0 0h48v48h-48z",
                fill: "none"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M42 8h-36c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h36c2.21 0 3.98-1.79 3.98-4l.02-24c0-2.21-1.79-4-4-4zm-4 28h-28v-24h28v24z"
            })
        ]
    }));
}
/* harmony default export */ var icons_TabletLandscape = ((/* unused pure expression or super */ null && (TabletLandscape)));

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/Tabs.js


function Tabs(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--tabs".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12,10V5H4C2.9,5,2,5.9,2,7v4v14c0,1.1,0.9,2,2,2h24c1.1,0,2-0.9,2-2V10H12z",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: 10
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M30,10H12V5h16c1.1,0,2,0.9,2,2V10z",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: 10
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                x1: "18",
                x2: "18",
                y1: "5",
                y2: "10",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: 10
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                x1: "24",
                x2: "24",
                y1: "5",
                y2: "10",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: 10
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("line", {
                x1: "6",
                x2: "8",
                y1: "8",
                y2: "8",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: 10
            })
        ]
    }));
}
/* harmony default export */ var icons_Tabs = (Tabs);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/Template.js


function Template(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--template".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 0h48v48h-48z",
                fill: "none"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6 26h16v-20h-16v20zm0 16h16v-12h-16v12zm20 0h16v-20h-16v20zm0-36v12h16v-12h-16z"
            })
        ]
    }));
}
/* harmony default export */ var icons_Template = (Template);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/Text.js


function Text(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        viewBox: "-76 -44 600 600",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--text ".concat(className ? className : ''),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "M432 32a16 16 0 0 1 16 16v80a16 16 0 0 1-16 16h-16a16 16 0 0 1-16-16V96H256v336h48a16 16 0 0 1 16 16v16a16 16 0 0 1-16 16H144a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h48V96H48v32a16 16 0 0 1-16 16H16a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16z"
        })
    }));
}
/* harmony default export */ var icons_Text = (Text);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/Undo.js


function Undo(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--undo".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 0h48v48h-48z",
                fill: "none"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25 16c-5.29 0-10.11 1.97-13.8 5.2l-7.2-7.2v18h18l-7.23-7.23c2.77-2.33 6.32-3.77 10.23-3.77 7.09 0 13.09 4.61 15.19 11l4.73-1.56c-2.75-8.38-10.62-14.44-19.92-14.44z"
            })
        ]
    }));
}
/* harmony default export */ var icons_Undo = (Undo);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/Unpublish.js


function Unpublish(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--unpublish".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 0h48v48h-48z",
                fill: "none"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M38.71 20.07c-1.36-6.88-7.43-12.07-14.71-12.07-2.95 0-5.7.87-8.02 2.34l2.92 2.92c1.53-.79 3.26-1.26 5.1-1.26 6.08 0 11 4.92 11 11v1h3c3.31 0 6 2.69 6 6 0 2.27-1.27 4.22-3.13 5.24l2.9 2.9c2.55-1.81 4.23-4.77 4.23-8.14 0-5.28-4.11-9.56-9.29-9.93zm-32.71-9.52l5.5 5.48c-6.38.27-11.5 5.52-11.5 11.97 0 6.63 5.37 12 12 12h23.45l4 4 2.55-2.54-33.45-33.46-2.55 2.55zm9.45 9.45l16 16h-19.45c-4.42 0-8-3.58-8-8s3.58-8 8-8h3.45z"
            })
        ]
    }));
}
/* harmony default export */ var icons_Unpublish = (Unpublish);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/Upload.js


function Upload(param) {
    var className = param.className;
    return(/*#__PURE__*/ _jsxs("svg", {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--upload".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M0 0h48v48h-48z",
                fill: "none"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M18 32h12v-12h8l-14-14-14 14h8zm-8 4h28v4h-28z"
            })
        ]
    }));
}
/* harmony default export */ var icons_Upload = ((/* unused pure expression or super */ null && (Upload)));

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/Video.js


function Video(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        viewBox: "-44 -44 600 600",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--video ".concat(className ? className : ''),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "currentColor",
            d: "M371.7 238l-176-107c-15.8-8.8-35.7 2.5-35.7 21v208c0 18.4 19.8 29.8 35.7 21l176-101c16.4-9.1 16.4-32.8 0-42zM504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256z"
        })
    }));
}
/* harmony default export */ var icons_Video = (Video);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/VisibilityOff.js


function VisibilityOff(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--visibility-off".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 0h48v48h-48zm0 0h48v48h-48zm0 0h48v48h-48zm0 0h48v48h-48z",
                fill: "none"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 14c5.52 0 10 4.48 10 10 0 1.29-.26 2.52-.71 3.65l5.85 5.85c3.02-2.52 5.4-5.78 6.87-9.5-3.47-8.78-12-15-22.01-15-2.8 0-5.48.5-7.97 1.4l4.32 4.31c1.13-.44 2.36-.71 3.65-.71zm-20-5.45l4.56 4.56.91.91c-3.3 2.58-5.91 6.01-7.47 9.98 3.46 8.78 12 15 22 15 3.1 0 6.06-.6 8.77-1.69l.85.85 5.83 5.84 2.55-2.54-35.45-35.46-2.55 2.55zm11.06 11.05l3.09 3.09c-.09.43-.15.86-.15 1.31 0 3.31 2.69 6 6 6 .45 0 .88-.06 1.3-.15l3.09 3.09c-1.33.66-2.81 1.06-4.39 1.06-5.52 0-10-4.48-10-10 0-1.58.4-3.06 1.06-4.4zm8.61-1.57l6.3 6.3.03-.33c0-3.31-2.69-6-6-6l-.33.03z"
            })
        ]
    }));
}
/* harmony default export */ var icons_VisibilityOff = (VisibilityOff);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/VisibilityOn.js


function VisibilityOn(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--visibility-on".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 0h48v48h-48z",
                fill: "none"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24 9c-10 0-18.54 6.22-22 15 3.46 8.78 12 15 22 15 10.01 0 18.54-6.22 22-15-3.46-8.78-11.99-15-22-15zm0 25c-5.52 0-10-4.48-10-10s4.48-10 10-10 10 4.48 10 10-4.48 10-10 10zm0-16c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6z"
            })
        ]
    }));
}
/* harmony default export */ var icons_VisibilityOn = (VisibilityOn);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/WireframeMode.js


function WireframeMode(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 48 48",
        xmlns: "http://www.w3.org/2000/svg",
        className: "icon icon--wireframe-mode".concat(className ? ' ' + className : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14 10h4v-4h-4v4zm0 16h4v-4h-4v4zm0 16h4v-4h-4v4zm8-8h4v-4h-4v4zm0 8h4v-4h-4v4zm-16 0h4v-4h-4v4zm0-8h4v-4h-4v4zm0-8h4v-4h-4v4zm0-8h4v-4h-4v4zm0-8h4v-4h-4v4zm16 16h4v-4h-4v4zm16 8h4v-4h-4v4zm0-8h4v-4h-4v4zm0 16h4v-4h-4v4zm0-24h4v-4h-4v4zm-16 0h4v-4h-4v4zm16-12v4h4v-4h-4zm-16 4h4v-4h-4v4zm8 32h4v-4h-4v4zm0-16h4v-4h-4v4zm0-16h4v-4h-4v4z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0 0h48v48h-48z",
                fill: "none"
            })
        ]
    }));
}
/* harmony default export */ var icons_WireframeMode = (WireframeMode);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/icons/index.js























































;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/atoms/Button/Button.js




var Button_Button = function(param) {
    var _label = param.label, label = _label === void 0 ? '' : _label, _type = param.type, type = _type === void 0 ? 'button' : _type, _variant = param.variant, variant = _variant === void 0 ? 'primary' : _variant, _size = param.size, size = _size === void 0 ? 'md' : _size, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _icon = param.icon, icon = _icon === void 0 ? null : _icon, _iconPos = param.iconPos, iconPos = _iconPos === void 0 ? 'left' : _iconPos, _onClick = param.onClick, onClick = _onClick === void 0 ? function() {} : _onClick, _href = param.href, href = _href === void 0 ? null : _href, _newPage = param.newPage, newPage = _newPage === void 0 ? false : _newPage, _className = param.className, className = _className === void 0 ? '' : _className, _loading = param.loading, loading = _loading === void 0 ? false : _loading, _external = param.external, external = _external === void 0 ? false : _external;
    var classeNames = "\n    pb-button \n    pb-button--".concat(variant, " \n    pb-button--").concat(size, "\n    ").concat(!label ? ' pb-button--icon' : '', "\n    ").concat(icon && iconPos === 'right' ? ' pb-button--icon-right' : '', "\n    ").concat(loading ? ' pb-button--loading' : '', "\n    ").concat(className ? " ".concat(className) : '');
    var buttonContent = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "pb-button__icon",
                children: icon
            }),
            label && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "pb-button__label",
                children: label
            }),
            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "pb-button__loader",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Loader, {})
            })
        ]
    });
    return href ? external ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        className: classeNames,
        href: href,
        target: newPage ? '_blank' : null,
        rel: "noreferrer",
        children: buttonContent
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
        href: href,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: classeNames,
            rel: "noreferrer",
            children: buttonContent
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        type: type,
        className: classeNames,
        disabled: disabled,
        onClick: onClick,
        children: buttonContent
    });
};
/* harmony default export */ var atoms_Button_Button = (Button_Button);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/atoms/FormError/FormError.js


var FormError = function(param) {
    var _message = param.message, message = _message === void 0 ? '' : _message, _visible = param.visible, visible = _visible === void 0 ? false : _visible, _className = param.className, className = _className === void 0 ? '' : _className;
    return visible && message ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: 'pb-form-error' + (className ? ' ' + className : ''),
        children: message
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var FormError_FormError = (FormError);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/atoms/FormField/FormField.js




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var FormField = function(param) {
    var _label = param.label, label = _label === void 0 ? '' : _label, _status = param.status, status = _status === void 0 ? '' : _status, _errorMessage = param.errorMessage, errorMessage = _errorMessage === void 0 ? '' : _errorMessage, _className = param.className, className = _className === void 0 ? '' : _className, _helper = param.helper, helper = _helper === void 0 ? null : _helper, _children = param.children, children = _children === void 0 ? null : _children;
    var classNames = "pb-form-field\n    ".concat(status ? " pb-form-field--".concat(status) : '', "\n    ").concat(className ? " ".concat(className) : '');
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classNames,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pb-form-field__head",
                children: [
                    label && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "pb-form-field__label",
                        children: label
                    }),
                    helper && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip_Tooltip, _objectSpread({}, helper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "pb-form-field__helper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Info, {})
                        })
                    }))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pb-form-field__children",
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormError_FormError, {
                message: errorMessage,
                visible: status === 'error'
            })
        ]
    }));
};
/* harmony default export */ var FormField_FormField = (FormField);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/atoms/FormInput/FormInput.js



var FormInput = function(param) {
    var _type = param.type, type = _type === void 0 ? 'text' : _type, _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? '' : _placeholder, _name = param.name, name = _name === void 0 ? '' : _name, _value = param.value, value = _value === void 0 ? '' : _value, _className = param.className, className = _className === void 0 ? '' : _className, _readOnly = param.readOnly, readOnly = _readOnly === void 0 ? false : _readOnly, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _status = param.status, status = _status === void 0 ? '' : _status, _errorMessage = param.errorMessage, errorMessage = _errorMessage === void 0 ? '' : _errorMessage, _onBlur = param.onBlur, onBlur = _onBlur === void 0 ? function() {} : _onBlur, _onFocus = param.onFocus, onFocus = _onFocus === void 0 ? function() {} : _onFocus, _onChange = param.onChange, onChange = _onChange === void 0 ? function() {} : _onChange;
    var classNames = "\n    pb-form-input \n    ".concat(status ? " pb-form-input--".concat(status) : '', "\n    ").concat(className ? " ".concat(className) : '');
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classNames,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: type,
                name: name,
                value: value,
                className: "pb-form-input__input",
                placeholder: placeholder,
                disabled: disabled,
                readOnly: readOnly,
                onBlur: onBlur,
                onFocus: onFocus,
                onChange: onChange
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormError_FormError, {
                className: "pb-form-input__error",
                message: errorMessage,
                visible: status === 'error'
            })
        ]
    }));
};
/* harmony default export */ var FormInput_FormInput = (FormInput);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/atoms/FormSelect/FormSelect.js



var FormSelect_FormInput = function(param) {
    var _options = param.options, options = _options === void 0 ? [] : _options, _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? '' : _placeholder, _name = param.name, name = _name === void 0 ? '' : _name, _value = param.value, value = _value === void 0 ? '' : _value, _className = param.className, className = _className === void 0 ? '' : _className, _readOnly = param.readOnly, readOnly = _readOnly === void 0 ? false : _readOnly, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _status = param.status, status = _status === void 0 ? '' : _status, _errorMessage = param.errorMessage, errorMessage = _errorMessage === void 0 ? '' : _errorMessage, _onBlur = param.onBlur, onBlur = _onBlur === void 0 ? function() {} : _onBlur, _onFocus = param.onFocus, onFocus = _onFocus === void 0 ? function() {} : _onFocus, _onChange = param.onChange, onChange = _onChange === void 0 ? function() {} : _onChange;
    var classNames = "\n    pb-form-select \n    ".concat(status ? " pb-form-select--".concat(status) : '', "\n    ").concat(className ? " ".concat(className) : '');
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classNames,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                name: name,
                defaultValue: value,
                className: "pb-form-select__input",
                placeholder: placeholder,
                disabled: disabled,
                readOnly: readOnly,
                onBlur: onBlur,
                onFocus: onFocus,
                onChange: onChange,
                children: [
                    placeholder && /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        value: "",
                        children: placeholder
                    }),
                    options.map(function(option) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("option", {
                            value: option.value,
                            children: option.label
                        }, option.value);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormError_FormError, {
                className: "pb-form-input__error",
                message: errorMessage,
                visible: status === 'error'
            })
        ]
    }));
};
/* harmony default export */ var FormSelect = (FormSelect_FormInput);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/atoms/Loader/Loader.js



var Loader_Loader = function(param) {
    var className = param.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Loader, {
        className: 'pb-loader ' + className
    }));
};
/* harmony default export */ var atoms_Loader_Loader = (Loader_Loader);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/atoms/Modal/Modal.js



var Modal = function(param) {
    var open = param.open, setOpen = param.setOpen, children = param.children;
    var close = function(e) {
        e.stopPropagation();
        if (setOpen) setOpen(false);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            open && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pb-overlay-modal",
                onClick: close
            }),
            open && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: 'pb-modal',
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "pb-modal__close",
                        onClick: close,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Close, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "pb-modal__body",
                        children: children
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var Modal_Modal = (Modal);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/atoms/NotificationBar/NotificationBar.js



var NotificationBar = function(param) {
    var children = param.children, _type = param.type, type = _type === void 0 ? 'alert' : _type;
    var ref = (0,react.useState)(false), closing = ref[0], setClosing = ref[1];
    var ref1 = (0,react.useState)(false), close = ref1[0], setClose = ref1[1];
    var closeMe = function() {
        setClosing(true);
        setTimeout(function() {
            setClose(true);
            setClosing(false);
        }, 500);
    };
    return !close ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pb-notification-bar pb-notification-bar--".concat(type).concat(closing ? ' pb-notification-bar--closing' : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                "aria-label": "Close",
                className: "pb-notification-bar__close",
                onClick: closeMe,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Close, {})
            }),
            children
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var NotificationBar_NotificationBar = (NotificationBar);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/atoms/Tooltip/Tooltip.js



function Tooltip_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Tooltip_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Tooltip_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Tooltip = function(param) {
    var _label = param.label, label = _label === void 0 ? '' : _label, _id = param.id, id = _id === void 0 ? '' : _id, _pos = param.pos, pos = _pos === void 0 ? 'top' : _pos, _className = param.className, className = _className === void 0 ? '' : _className, _children = param.children, children = _children === void 0 ? null : _children;
    var renderTooltip = function(props) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(BootstrapTooltip_BootstrapTooltip, Tooltip_objectSpread({
            id: id,
            className: "pb-tooltip ".concat(className ? " ".concat(className) : '')
        }, props, {
            children: label
        }));
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(BootstrapOverlayTrigger, {
        placement: pos,
        delay: {
            show: 50,
            hide: 50
        },
        overlay: renderTooltip,
        children: children
    }));
};
/* harmony default export */ var Tooltip_Tooltip = (Tooltip);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pb-components/atoms/index.js















;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/editor/Viewport/Sidebar/Toolbar/ToolbarSection.js



function ToolbarSection_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ToolbarSection_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ToolbarSection_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var ToolbarSection_ToolbarSection = function(param) {
    var title = param.title, description = param.description, open = param.open, onChange = param.onChange, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, children = param.children, buttonTooltip = param.buttonTooltip, _initOpen = param.initOpen, initOpen = _initOpen === void 0 ? false : _initOpen;
    var ref = (0,react.useState)(initOpen), visible = ref[0], setVisible = ref[1];
    var ref1 = (0,react.useState)(), state1 = ref1[0], setState = ref1[1];
    var changeState = function(state) {
        if (onChange) {
            onChange(state);
        } else {
            setVisible(state);
        }
    };
    (0,react.useEffect)(function() {
        if (open !== undefined) {
            setState(open);
        } else {
            setState(visible);
        }
    }, [
        open,
        visible
    ]);
    var buttonContent = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "toolbar-section__button ".concat(disabled ? 'disabled' : ''),
        onClick: function() {
            return disabled ? false : changeState(!state1);
        },
        children: title
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "toolbar-section",
        children: [
            buttonTooltip ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip_Tooltip, ToolbarSection_objectSpread({}, buttonTooltip, {
                children: buttonContent
            })) : buttonContent,
            state1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "toolbar-section__content",
                children: [
                    description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                            children: description
                        })
                    }),
                    children
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/utils/dynamic.js
var deepValue = function(obj, path) {
    var paths = path.split('.');
    for(var i = 0; i < paths.length; i++){
        try {
            obj = obj[paths[i]];
        } catch (err) {
            return undefined;
        }
    }
    return obj;
};
var getAllPaths = function(root) {
    var paths = [];
    var nodes = [
        {
            obj: root,
            path: ''
        }, 
    ];
    while(nodes.length > 0){
        var n = nodes.pop();
        Object.keys(n.obj).forEach(function(k) {
            var path = n.path;
            if (path !== '') {
                path = path.concat('.');
            }
            path = path.concat(k);
            if (typeof n.obj[k] === 'object') {
                nodes.unshift({
                    obj: n.obj[k],
                    path: path
                });
            } else {
                paths.push(path);
            }
        });
    }
    return paths;
};
var getArrayPaths = function(root) {
    var paths = [];
    if (!root) {
        return paths;
    }
    var nodes = [
        {
            obj: root,
            path: ''
        }, 
    ];
    while(nodes.length > 0){
        var n = nodes.pop();
        if (n && n.obj) {
            Object.keys(n.obj).forEach(function(k) {
                var path = n.path;
                if (path !== '') {
                    path = path.concat('.');
                }
                path = path.concat(k);
                if (typeof n.obj[k] === 'object') {
                    nodes.unshift({
                        obj: n.obj[k],
                        path: path
                    });
                }
                if (Array.isArray(n.obj[k])) {
                    paths.push(path);
                }
            });
        }
    }
    return paths;
};
var getDynamicValue = function(value) {
    try {
        return value.substring(2, value.length - 1);
    } catch (err) {
        return undefined;
    }
};
var setDynamicValue = function(value) {
    return '${' + value + '}';
};
var isDynamicValue = function(value) {
    if (typeof value === 'string') {
        return value.substring(0, 2) === '${';
    }
    return false;
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/components/DynamicDataBlock/DynamicDataBlockSettings.js






var DynamicDataBlockSettings = function() {
    var customs = (0,esm/* useNode */.Zo)(function(node) {
        return {
            customs: node.data.custom
        };
    }).customs;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ToolbarSection_ToolbarSection, {
            title: "Settings",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolbarItem, {
                    propKey: "block",
                    propSubKey: "apiUrl",
                    type: "text",
                    label: "API url",
                    description: "Paste your url"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        fontSize: '1em'
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Try:"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "https://reqres.in/api/users/2"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "https://reqres.in/api/users?page=2"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolbarItem, {
                    propKey: "block",
                    propSubKey: "repeatForEach",
                    type: "dynamic",
                    label: "Repeat for each",
                    values: getArrayPaths(customs.dynamicData),
                    defaultValue: null
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/services/dynamicDataContext.js

var DynamicDataContext = /*#__PURE__*/ react.createContext();

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/utils/block.js




function block_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function block_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            block_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var block_parseNodeTree = function(nodes, id) {
    var index1 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, global = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, disabled = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
    var type = nodes.nodes[id]['data']['name'];
    var Block = resolver[type];
    var props = JSON.parse(JSON.stringify(nodes.nodes[id]['data']['props']));
    var custom = JSON.parse(JSON.stringify(nodes.nodes[id]['data']['custom']));
    if (global) {
        custom['globalId'] = global;
    }
    if (disabled) {
        props.conditions['disabled'] = disabled;
    }
    var children = nodes.nodes[id]['data']['nodes'];
    var canvas = nodes.nodes[id]['data']['isCanvas'];
    return(/*#__PURE__*/ (0,react.createElement)(esm/* Element */.W_, block_objectSpread({
        is: Block,
        canvas: canvas,
        custom: custom
    }, props, {
        key: index1,
        children: children.map(function(childId, index) {
            return block_parseNodeTree(nodes, childId, index, null, disabled);
        })
    })));
};
var removeCustomPropsFromSerializedNodes = function(serializedNodes, query) {
    var newSerializedNodes = block_objectSpread({}, serializedNodes);
    Object.keys(serializedNodes).forEach(function(nodeId) {
        newSerializedNodes[nodeId].custom = {};
    });
    return newSerializedNodes;
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/utils/node.js




function node_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function node_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            node_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var node_isDisabled = function(nodeId) {
    var query = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, helper = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    if (!nodeId) {
        return false;
    }
    var node = null;
    if (query) {
        node = query.node(nodeId).get();
    }
    if (helper) {
        node = helper(nodeId).get();
    }
    if (!node) {
        return false;
    }
    if (node.data.props.conditions.disabled) {
        return true;
    }
    return false;
};
var node_isDeletable = function(nodeId, query) {
    if (!nodeId) {
        return false;
    }
    if (node_isDisabled(nodeId, query)) {
        return false;
    }
    var isDefaultDeletable = false;
    try {
        isDefaultDeletable = query.node(nodeId).isDeletable();
    } catch (err) {
        return isDefaultDeletable;
    }
    if (isDefaultDeletable) {
        var parentNodeId = query.node(nodeId).get().data.parent;
        var parentNode = query.node(parentNodeId).get();
        // Non si può eliminare il nodo (ROW) figlio di un DYNAMICDATABLOCK
        if (parentNode.data.type === DynamicDataBlock) {
            return false;
        } else if (parentNode.data.type === components_Button_Button) {
            return false;
        } else if (parentNode.data.type === Tabs_Tabs) {
            return false;
        } else if (parentNode.data.type === TabsMenu) {
            return false;
        } else if (parentNode.data.type === TabsContent) {
            return false;
        }
    }
    return isDefaultDeletable;
};
var isMoveable = function(nodeId, query) {
    if (!nodeId) {
        return false;
    }
    if (node_isDisabled(nodeId, query)) {
        return false;
    }
    var isDefaultMoveable = query.node(nodeId).isDraggable();
    if (isDefaultMoveable) {
        var parentNodeId = query.node(nodeId).get().data.parent;
        var parentNode = query.node(parentNodeId).get();
        // Non si può spostare il nodo (ROW) figlio di un DYNAMICDATABLOCK
        if (parentNode.data.type === DynamicDataBlock) {
            return false;
        } else if (parentNode.data.type === components_Button_Button) {
            return false;
        } else if (parentNode.data.type === Tabs_Tabs) {
            return false;
        } else if (parentNode.data.type === TabsMenu) {
            return false;
        } else if (parentNode.data.type === TabsContent) {
            return false;
        }
    }
    return isDefaultMoveable;
};
var isClonable = function(nodeId, query) {
    if (!nodeId) {
        return false;
    }
    if (node_isDisabled(nodeId, query)) {
        return false;
    }
    var isDefaultClonable = nodeId !== esm/* ROOT_NODE */.QS;
    if (isDefaultClonable) {
        var parentNodeId = query.node(nodeId).get().data.parent;
        var parentNode = query.node(parentNodeId).get();
        // Non si può clonare il nodo (ROW) figlio di un DYNAMICDATABLOCK
        if (parentNode.data.type === DynamicDataBlock) {
            return false;
        } else if (parentNode.data.type === components_Button_Button) {
            return false;
        } else if (parentNode.data.type === Tabs_Tabs) {
            return false;
        } else if (parentNode.data.type === TabsMenu) {
            return false;
        } else if (parentNode.data.type === TabsContent) {
            return false;
        }
    }
    return isDefaultClonable;
};
var isCopyable = function(nodeId, query) {
    if (!nodeId) {
        return false;
    }
    if (node_isDisabled(nodeId, query)) {
        return false;
    }
    var isDefaultCopyable = nodeId !== esm/* ROOT_NODE */.QS;
    if (isDefaultCopyable) {
        var parentNodeId = query.node(nodeId).get().data.parent;
        var parentNode = query.node(parentNodeId).get();
        // Non si può copiare il nodo (TABSMENU, TABSCONTENT) figlio di un TABS
        if (parentNode.data.type === Tabs_Tabs) {
            return false;
        } else if (parentNode.data.type === TabsMenu) {
            return false;
        } else if (parentNode.data.type === TabsContent) {
            return false;
        }
    }
    return isDefaultCopyable;
};
var isDroppable = function(nodeId, query) {
    if (!nodeId) {
        return false;
    }
    if (node_isDisabled(nodeId, query)) {
        return false;
    }
    var isDefaultDroppable = query.node(nodeId).isCanvas();
    return isDefaultDroppable;
};
var isParentSelectable = function(nodeId) {
    if (!nodeId) {
        return false;
    }
    return nodeId !== esm/* ROOT_NODE */.QS;
};
var node_getAncestors = function(nodeId, query) {
    var ancestors = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], level = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    var node = query.node(nodeId).get();
    if (!node) {
        return ancestors;
    }
    if (level !== 0) {
        ancestors.push(nodeId);
    }
    if (!node.data.parent) {
        return ancestors;
    }
    ancestors = node_getAncestors(node.data.parent, query, ancestors, level + 1);
    return ancestors;
};
var node_serializeNodeTree = function(nodeTree, query) {
    var serializedNodeTree = {};
    serializedNodeTree['rootNodeId'] = nodeTree['rootNodeId'];
    serializedNodeTree['nodes'] = {};
    Object.keys(nodeTree.nodes).forEach(function(nodeId) {
        serializedNodeTree['nodes'][nodeId] = query.node(nodeId).toSerializedNode();
    });
    return serializedNodeTree;
};
var node_deserializeNodeTree = function(serializedNodeTree, query) {
    var nodeTree = {};
    nodeTree['rootNodeId'] = serializedNodeTree['rootNodeId'];
    nodeTree['nodes'] = {};
    Object.keys(serializedNodeTree.nodes).forEach(function(nodeId) {
        nodeTree['nodes'][nodeId] = query.parseSerializedNode(serializedNodeTree['nodes'][nodeId]).toNode();
    });
    return nodeTree;
};
var cloneNodeTree = function(nodeId, query) {
    var disabled = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var nodeTreeToClone = query.node(nodeId).toNodeTree();
    var serializedNodeTree = node_serializeNodeTree(nodeTreeToClone, query);
    var nodeTree = node_deserializeNodeTree(serializedNodeTree, query);
    var elements = block_parseNodeTree(nodeTree, nodeTree['rootNodeId'], 0, null, disabled);
    var clonedNodeTree = query.parseReactElement(elements).toNodeTree();
    return clonedNodeTree;
};
var node_addNodeTree = function(nodeTree, targetId, actions) {
    var ignore = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, index = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, throttle = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
    if (ignore) {
        actions.history.ignore().addNodeTree(nodeTree, targetId, index);
    }
    if (throttle) {
        actions.history.throttle().addNodeTree(nodeTree, targetId, index);
    } else {
        actions.addNodeTree(nodeTree, targetId, index);
    }
};
var deleteNodeTree = function(nodeId, actions) {
    var ignore = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, throttle = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    if (ignore) {
        actions.history.ignore().delete(nodeId);
    }
    if (throttle) {
        actions.history.throttle().delete(nodeId);
    } else {
        actions.delete(nodeId);
    }
};
var isGlobal = function(nodeId) {
    var query = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, helper = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    return isGlobalParent(nodeId, query, helper) || isGlobalChild(nodeId, query, helper);
};
var isGlobalParent = function(nodeId) {
    var query = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, helper = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    if (!nodeId) {
        return false;
    }
    if (nodeId === esm/* ROOT_NODE */.QS) {
        return false;
    }
    var node = null;
    if (query) {
        node = query.node(nodeId).get();
    }
    if (helper) {
        node = helper(nodeId).get();
    }
    if (!node) {
        return false;
    }
    if (node.data.custom.globalId) {
        return true;
    }
    return false;
};
var isGlobalChild = function(nodeId) {
    var query = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, helper = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    if (!nodeId) {
        return false;
    }
    if (nodeId === esm/* ROOT_NODE */.QS) {
        return false;
    }
    var node = null;
    if (query) {
        node = query.node(nodeId).get();
    }
    if (helper) {
        node = helper(nodeId).get();
    }
    if (!node) {
        return false;
    }
    if (isGlobalParent(node.data.parent, query, helper)) {
        return true;
    }
    return isGlobalChild(node.data.parent, query, helper);
};
var node_getGlobalParent = function(nodeId, query) {
    if (!nodeId) {
        return null;
    }
    if (nodeId === ROOT_NODE) {
        return null;
    }
    var node = query.node(nodeId).get();
    if (node.data.custom.globalId) {
        return nodeId;
    }
    return node_getGlobalParent(node.data.parent, query);
};
var node_getGlobalId = function(nodeId) {
    var query = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, helper = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    if (!nodeId) {
        return null;
    }
    if (nodeId === ROOT_NODE) {
        return null;
    }
    var node = null;
    if (query) {
        node = query.node(nodeId).get();
    }
    if (helper) {
        node = helper(nodeId).get();
    }
    if (!node) {
        return null;
    }
    if (node.data.custom.globalId) {
        return node.data.custom.globalId;
    }
    return node_getGlobalId(node.data.parent, query, helper);
};
// @TODO Rimuovere
var insertExtNodeOnParentFromVar = function(nodes, actions, query, nodeId, parentId, indexToInsert) {
    var node = nodes.nodes[nodeId];
    // console.log({node});
    var freshNode = {
        data: node_objectSpread({}, node.data, {
            nodes: [],
            linkedNodes: {}
        })
    };
    // console.log({freshNode});
    var nodeToAdd = query.parseFreshNode(freshNode).toNode();
    // console.log({nodeToAdd});
    actions.add(nodeToAdd, parentId, indexToInsert);
    if (node.data.nodes.length !== 0) {
        node.data.nodes.forEach(function(childNodeId, index) {
            console.log({
                childNodeId: childNodeId
            });
            insertExtNodeOnParentFromVar(nodes, actions, query, childNodeId, nodeToAdd.id, index);
        });
    }
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/conditions/index.js
var defaultConditionsProps = {
    hiddenIfLoggedIn: false,
    hiddenIfNotLoggedIn: false,
    hiddenIfDesktop: false,
    hiddenIfTablet: false,
    hiddenIfMobile: false
};
var conditions = {
    'Utente': {
        hiddenIfLoggedIn: {
            description: "Nascondi se l'utente \xe8 loggato"
        },
        hiddenIfNotLoggedIn: {
            description: "Nascondi se l'utente non \xe8 loggato"
        }
    },
    'Screen Size': {
        hiddenIfDesktop: {
            description: 'Nascondi se in modalit\xe0 desktop'
        },
        hiddenIfTablet: {
            description: 'Nascondi se in modalit\xe0 tablet'
        },
        hiddenIfMobile: {
            description: 'Nascondi se in modalit\xe0 smartphone'
        }
    }
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/conditions/ConditionsSettings.js





var ConditionsSettings = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: Object.keys(conditions).map(function(category) {
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ToolbarSection_ToolbarSection, {
                title: category,
                initOpen: true,
                children: Object.keys(conditions[category]).map(function(key) {
                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ToolbarItem, {
                        inline: true,
                        propKey: "conditions",
                        propSubKey: key,
                        type: "switch",
                        label: conditions[category][key].description
                    }, key));
                })
            }, category));
        })
    }));
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/utils/rules.js


var rules_canDrag = function(currentNode, helpers, fun) {
    if (currentNode.data.props.conditions.disabled) {
        return false;
    }
    if (fun) {
        return fun(currentNode, helpers);
    } else {
        return true;
    }
};
var rules_canDrop = function(targetNode, helpers, fun) {
    if (targetNode.data.props.conditions.disabled) {
        return false;
    }
    if (fun) {
        return fun(targetNode, helpers);
    } else {
        return true;
    }
};
var rules_canMoveIn = function(incomingNode, currentNode, helpers, fun) {
    if (currentNode.data.props.conditions.disabled) {
        return false;
    }
    if (fun) {
        return fun(incomingNode, currentNode, helpers);
    } else {
        return true;
    }
};
var rules_canMoveOut = function(outgoingNode, currentNode, helpers, fun) {
    if (outgoingNode.data.props.conditions.disabled) {
        return false;
    }
    if (fun) {
        return fun(outgoingNode, currentNode, helpers);
    } else {
        return true;
    }
};
var rules_canDropBlock = function(currentNode, targetNode) {
    var Block = resolver[targetNode.data.name];
    if (Block) {
        return Block.craft.rules.canMoveIn(currentNode, targetNode);
    }
    return false;
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/components/withCraft.js



var withCraft = function(param) {
    var name = param.name, defaultProps = param.defaultProps, settings = param.settings, floatingSettings = param.floatingSettings, canDrag = param.canDrag, canDrop = param.canDrop, canMoveIn = param.canMoveIn, canMoveOut = param.canMoveOut;
    return {
        displayName: name,
        props: {
            block: defaultProps,
            conditions: defaultConditionsProps
        },
        related: {
            toolbar: settings,
            floatingToolbar: floatingSettings ? floatingSettings : settings,
            conditions: ConditionsSettings
        },
        rules: {
            canDrag: function(currentNode, helpers) {
                return rules_canDrag(currentNode, helpers, canDrag);
            },
            canDrop: function(targetNode, helpers) {
                return rules_canDrop(targetNode, helpers, canDrop);
            },
            canMoveIn: function(incomingNode, currentNode, helpers) {
                return rules_canMoveIn(incomingNode, currentNode, helpers, canMoveIn);
            },
            canMoveOut: function(outgoingNode, currentNode, helpers) {
                return rules_canMoveOut(outgoingNode, currentNode, helpers, canMoveOut);
            }
        }
    };
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/components/DynamicDataBlock/index.js









function DynamicDataBlock_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function DynamicDataBlock_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            DynamicDataBlock_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var update = function(id, query, actions) {
    var node = query.node(id).get();
    var data = node.data.custom['dynamicData'];
    var nodes = node.data.nodes;
    var repeatForEach = node.data.props.block.repeatForEach;
    if (data) {
        if (repeatForEach) {
            var repeatValue = deepValue(data, getDynamicValue(repeatForEach));
            if (repeatValue) {
                for(var i = 1; i < nodes.length; i++){
                    deleteNodeTree(nodes[i], actions, true);
                }
                var firstNodeId = nodes[0];
                for(var i1 = 1; i1 < repeatValue.length; i1++){
                    var nodeTree = cloneNodeTree(firstNodeId, query, true) // true = disabled
                    ;
                    node_addNodeTree(nodeTree, id, actions, true) // true = history ignore
                    ;
                }
            } else {
                for(var i2 = 1; i2 < nodes.length; i2++){
                    deleteNodeTree(nodes[i2], actions, true);
                }
                actions.setProp(id, function(props) {
                    props.block.repeatForEach = DynamicDataBlock_defaultProps.repeatForEach;
                });
            }
        } else {
            for(var i3 = 1; i3 < nodes.length; i3++){
                deleteNodeTree(nodes[i3], actions, true);
            }
        }
    } else {
        for(var i4 = 1; i4 < nodes.length; i4++){
            deleteNodeTree(nodes[i4], actions, true);
        }
        actions.setProp(id, function(props) {
            props.block.repeatForEach = DynamicDataBlock_defaultProps.repeatForEach;
        });
    }
};
var DynamicDataBlock_defaultProps = {
    apiUrl: 'https://reqres.in/api/users/2',
    /*
        Response

        {
            "data": {
                "id":2,
                "email":"janet.weaver@reqres.in",
                "first_name":"Janet",
                "last_name":"Weaver",
                "avatar":"https://reqres.in/img/faces/2-image.jpg"
            },
            "support": {
                "url":"https://reqres.in/#support-heading",
                "text":"To keep ReqRes free, contributions towards server costs are appreciated!"
            }
        }
    */ repeatForEach: null,
    needUpdate: false
};
var DynamicDataBlock = function(props) {
    var blockProps = DynamicDataBlock_objectSpread({}, DynamicDataBlock_defaultProps, props.block);
    var apiUrl = blockProps.apiUrl, repeatForEach = blockProps.repeatForEach;
    var children = props.children;
    var ref5 = (0,esm/* useNode */.Zo)(function(state) {
        return {
            selected: state.events.selected,
            hovered: state.events.hovered,
            nodes: state.data.nodes,
            node: state.data,
            customs: state.data.custom
        };
    }), id = ref5.id, _connectors = ref5.connectors, connect = _connectors.connect, drag = _connectors.drag, selected = ref5.selected, hovered = ref5.hovered, _actions = ref5.actions, setCustom = _actions.setCustom, setProp = _actions.setProp, nodes = ref5.nodes, node = ref5.node, customs = ref5.customs;
    var ref1 = (0,esm/* useEditor */.jE)(function(state) {
        return {
            enabled: state.options.enabled
        };
    }), query = ref1.query, actions = ref1.actions, enabled = ref1.enabled;
    var className = "".concat(id, " dynamic-data-block ");
    if (selected) {
        className += 'component-selected';
    } else if (hovered) {
        className += 'component-hovered';
    }
    var ref2 = (0,react.useState)(null), data = ref2[0], setData = ref2[1];
    var ref3 = (0,react.useState)(true), loading = ref3[0], setLoading = ref3[1];
    (0,react.useEffect)(function() {
        setLoading(true);
        axios_default().get(apiUrl).then(function(res) {
            setData(res.data);
            actions.history.ignore().setCustom(id, function(custom) {
                custom['dynamicData'] = res.data;
            });
            setLoading(false);
        }).catch(function(err) {
            console.log(err);
            setData(null);
            actions.history.ignore().setCustom(id, function(custom) {
                delete custom['dynamicData'];
            });
            setLoading(false);
        });
    }, [
        apiUrl
    ]);
    var ref4 = (0,react.useState)(), isMounting = ref4[0], setMounting = ref4[1];
    (0,react.useEffect)(function() {
        setMounting(true);
    }, []);
    (0,react.useEffect)(function() {
        if (isMounting) {
            setMounting(false);
        } else if (!loading) {
            update(id, query, actions);
        }
    }, [
        customs,
        repeatForEach
    ]);
    /* const [ needUpdate, setNeedUpdate ] = useState(false)

    useEffect(() => {
        if(needUpdate) {
            update(id, query, actions)
            setNeedUpdate(false)
        }
    }, [needUpdate]) */ /*
    const update = () => {
        console.log("DDB is updating ...")
        if(data) {
            if(repeatForEach) {
                for(let i = 1; i < nodes.length; i++){
                    deleteNode(nodes[i], query, actions)
                }
                const firstNodeId = nodes[0]
                for(let i = 1; i < deepValue(data, getDynamicValue(repeatForEach)).length; i++) {
                    const nodeTree = cloneNodeTree(firstNodeId, query, true)
                    addNodeTree(nodeTree, id, actions)
                }
            }
            else {
                for(let i = 1; i < nodes.length; i++){
                    deleteNode(nodes[i], query, actions)
                }
            }
        }
    }
    */ return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: function(ref) {
            return connect(drag(ref));
        },
        className: className,
        style: {
            position: 'relative'
        },
        children: !loading && (repeatForEach && deepValue(data, getDynamicValue(repeatForEach)) ? react.Children.map(children.props.children, function(child, i) {
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicDataContext.Provider, {
                value: deepValue(data, getDynamicValue(repeatForEach))[i],
                children: child
            }, i));
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicDataContext.Provider, {
            value: data,
            children: children
        }))
    }));
};
DynamicDataBlock.craft = withCraft({
    name: 'DynamicDataBlock',
    defaultProps: DynamicDataBlock_defaultProps,
    settings: DynamicDataBlockSettings
});

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/editor/Viewport/Sidebar/Toolbar/ToolbarItem/DynamicToolbarItem.js





var DynamicToolbarItem = function(param) {
    var propKey = param.propKey, propSubKey = param.propSubKey, value2 = param.value, values = param.values, setProp = param.setProp, onChange = param.onChange, defaultValue = param.defaultValue;
    var ref = (0,esm/* useNode */.Zo)(function(node) {
        return {
            customs: node.data.custom,
            props: node.data.props,
            parent: node.data.parent,
            nodes: node.data.nodes
        };
    }), id = ref.id, customs = ref.customs, props1 = ref.props, parent = ref.parent, nodes = ref.nodes;
    var ref1 = (0,esm/* useEditor */.jE)(), actions = ref1.actions, query = ref1.query;
    var ref2 = (0,react.useState)(), state = ref2[0], setState = ref2[1];
    (0,react.useEffect)(function() {
        setState(value2);
    }, [
        value2
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: state !== undefined && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                    value: isDynamicValue(state) ? getDynamicValue(state) : 'not_dynamic',
                    onChange: function(e) {
                        setProp(function(props) {
                            if (e.target.value === 'not_dynamic') {
                                var value = defaultValue;
                                props[propKey][propSubKey] = onChange ? onChange(value) : value;
                            } else {
                                var value1 = setDynamicValue(e.target.value);
                                props[propKey][propSubKey] = onChange ? onChange(value1) : value1;
                            }
                        }, 1000);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                            value: "not_dynamic",
                            children: "Not dynamic"
                        }),
                        values.map(function(val) {
                            return(/*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                value: val,
                                children: val
                            }, val));
                        })
                    ]
                }),
                props1.block.repeatForEach && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    onClick: function() {
                        return update(id, query, actions);
                    },
                    children: "Update"
                })
            ]
        })
    }));
};

// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
// EXTERNAL MODULE: ../../node_modules/react-quill/dist/quill.snow.css
var quill_snow = __webpack_require__(58188);
;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/plugins/RichTextEditor/index.js




var ReactQuill = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(774), __webpack_require__.e(615), __webpack_require__.e(655)]).then(__webpack_require__.t.bind(__webpack_require__, 8617, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8617)
            ];
        }
    },
    ssr: false,
    loading: function() {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)("p", {
            children: "Loading ..."
        });
    }
});
var modules = {
    clipboard: {
        matchVisual: true
    },
    toolbar: {
        container: [
            [
                {
                    header: [
                        false,
                        1
                    ]
                }
            ],
            [
                {
                    align: [
                        false,
                        'center',
                        'right',
                        'justify'
                    ]
                }
            ],
            [
                'bold',
                'italic',
                'underline',
                'strike'
            ],
            [
                {
                    script: 'sub'
                },
                {
                    script: 'super'
                }
            ],
            [
                {
                    list: 'ordered'
                },
                {
                    list: 'bullet'
                },
                {
                    indent: '-1'
                },
                {
                    indent: '+1'
                }
            ],
            [
                'link'
            ],
            [
                'clean'
            ],
            [
                {
                    background: [
                        '#ffff00',
                        '#ff00ff',
                        '#00ffff'
                    ]
                }
            ], 
        ]
    }
};
/* const modules = {
    clipboard: {
        matchVisual: false
    },
    toolbar: {
      container: "#toolbar",
    },
  }; */ var formats = [
    'header',
    'align',
    'bold',
    'italic',
    'underline',
    'align',
    'strike',
    'script',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
    'color',
    'code-block',
    'background', 
];
var CustomToolbar = function() {
    /*#__PURE__*/ return _jsxs("div", {
        id: "toolbar",
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "ql-formats",
                children: /*#__PURE__*/ _jsxs("select", {
                    className: "ql-header",
                    defaultValue: "",
                    children: [
                        /*#__PURE__*/ _jsx("option", {
                            value: "1",
                            children: "Titolo"
                        }),
                        /*#__PURE__*/ _jsx("option", {
                            value: "",
                            children: "Normal"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs("span", {
                className: "ql-formats",
                children: [
                    /*#__PURE__*/ _jsx("button", {
                        className: "ql-bold"
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        className: "ql-italic"
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        className: "ql-underline"
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        className: "ql-strike"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("span", {
                className: "ql-formats",
                children: [
                    /*#__PURE__*/ _jsx("button", {
                        className: "ql-list",
                        value: "ordered"
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        className: "ql-list",
                        value: "bullet"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("span", {
                className: "ql-formats",
                children: [
                    /*#__PURE__*/ _jsx("button", {
                        className: "ql-script",
                        value: "super"
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        className: "ql-script",
                        value: "sub"
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        className: "ql-blockquote"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "ql-formats",
                children: /*#__PURE__*/ _jsx("button", {
                    className: "ql-link"
                })
            }),
            /*#__PURE__*/ _jsxs("span", {
                className: "ql-formats",
                children: [
                    /*#__PURE__*/ _jsx("button", {
                        className: "ql-code-block"
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        className: "ql-clean"
                    })
                ]
            })
        ]
    });
};
var RichTextEditor = function(param) {
    var value1 = param.value, setValue = param.setValue, noHtml = param.noHtml;
    /**
   *  se noHtml (es.: in Text di Button) => uso value
   *  altrimenti (Text normale) => uso state
   */ var ref = (0,react.useState)(), state1 = ref[0], setState = ref[1];
    (0,react.useEffect)(function() {
        if (!noHtml) {
            if (value1.endsWith('<p><br></p>')) {
                var state = value1;
                setState(state.concat('<p><br></p>'));
            } else {
                setState(value1);
            }
        }
    }, []);
    var onChange = function(value, delta, source, editor) {
        if (source === 'user') {
            if (!noHtml) {
                setState(noHtml ? editor.getText(value) : value);
            }
            setValue(noHtml ? editor.getText(value) : value);
        }
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(ReactQuill, {
        className: "rte-fixed ".concat(noHtml && 'rte-no-toolbar'),
        theme: "snow",
        value: noHtml ? value1 : state1,
        onChange: onChange,
        modules: modules,
        formats: formats
    }));
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/editor/Viewport/Sidebar/Toolbar/ToolbarItem/TextToolbarItem.js





var TextToolbarItem = function(param) {
    var propKey = param.propKey, propSubKey = param.propSubKey, value1 = param.value, setProp = param.setProp, onChange = param.onChange, onlyDynamic = param.onlyDynamic, dynamic = param.dynamic, dynamicValues = param.dynamicValues, defaultValue = param.defaultValue, rte = param.rte;
    var ref = (0,react.useState)(), state = ref[0], setState = ref[1];
    (0,react.useEffect)(function() {
        setState(value1);
    }, []);
    (0,react.useEffect)(function() {
        setState(value1);
    }, [
        value1
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: state !== undefined && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                !onlyDynamic && (rte ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextEditor, {
                    value: state,
                    setValue: function(value) {
                        setState(value);
                        setProp(function(props) {
                            props[propKey][propSubKey] = onChange ? onChange(value) : value;
                        }, 500);
                    },
                    inline: true
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput_FormInput, {
                    value: state,
                    onChange: function(e) {
                        setState(e.target.value);
                        setProp(function(props) {
                            var value = e.target.value;
                            props[propKey][propSubKey] = onChange ? onChange(value) : value;
                        }, 1000);
                    }
                })),
                dynamic && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicToolbarItem, {
                    propKey: propKey,
                    propSubKey: propSubKey,
                    value: state,
                    values: dynamicValues,
                    setProp: setProp,
                    onChange: onChange,
                    defaultValue: defaultValue
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/editor/Viewport/Sidebar/Toolbar/ToolbarItem/FileToolbarItem.js








function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var FileToolbarItem = function(param) {
    var propKey = param.propKey, propSubKey = param.propSubKey, value = param.value, setProp = param.setProp, onChange = param.onChange;
    var ref = (0,react.useContext)(globalContext_GlobalContext), leftSidebarTab = ref.leftSidebarTab, setLeftSidebarTab = ref.setLeftSidebarTab, assetId = ref.assetId, setAssetId = ref.setAssetId;
    var ref1 = (0,react.useState)(false), waitingForFile = ref1[0], setWaitingForFile = ref1[1];
    var openFiler = function(event) {
        event.preventDefault();
        setWaitingForFile(true);
        setLeftSidebarTab('Assets');
    /* window.open(
      'http://localhost:9999/d/filer-wrapper/',
      'upload',
      'width=500,height=400'
    ) */ };
    (0,react.useEffect)(function() {
        if (leftSidebarTab !== 'Assets') {
            setWaitingForFile(false);
        }
    }, [
        leftSidebarTab
    ]);
    (0,react.useEffect)(_asyncToGenerator(runtime_default().mark(function _callee() {
        var response, data, url;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!assetId) {
                        _ctx.next = 11;
                        break;
                    }
                    if (waitingForFile) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 3:
                    _ctx.next = 5;
                    return utils/* adminApi.get */.Nq.get(//API_HOST + '/d/filebrowser_filer/url_image/' + assetId + '/'
                    'filer_files/' + assetId + '/');
                case 5:
                    response = _ctx.sent;
                    data = response.data;
                    url = utils/* API_HOST */.H + data.url;
                    setProp(function(props) {
                        props[propKey][propSubKey] = onChange ? onChange(url) : url;
                    }, 500);
                    setLeftSidebarTab(null);
                    setAssetId(null);
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        assetId
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !!value && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "toolbar-section__item__header",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "toolbar-section__item__header__description",
                    style: {
                        wordBreak: 'break-all',
                        marginBottom: '10px'
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            style: {
                                color: '#484b52'
                            },
                            children: "File selezionato:"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: value
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    display: 'flex',
                    justifyContent: 'space-between'
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_Button_Button, {
                        label: "Scegli file",
                        variant: "primary",
                        size: "sm",
                        onClick: function(e) {
                            return openFiler(e);
                        }
                    }),
                    !!value && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_Button_Button, {
                        label: "Rimuovi file",
                        variant: "secondary",
                        size: "sm",
                        onClick: function() {
                            setProp(function(props) {
                                props[propKey][propSubKey] = onChange ? onChange("") : "";
                            }, 500);
                        }
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/editor/Viewport/Sidebar/Toolbar/ToolbarItem/CodeToolbarItem.js




var CodeEditor = (0,dynamic["default"])(Promise.all(/* import() */[__webpack_require__.e(816), __webpack_require__.e(731), __webpack_require__.e(686)]).then(__webpack_require__.bind(__webpack_require__, 48967)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(48967)
            ];
        }
    },
    ssr: false
});
var CodeToolbarItem = function(param) {
    var propKey = param.propKey, propSubKey = param.propSubKey, value1 = param.value, setProp = param.setProp, onChange = param.onChange, onlyDynamic = param.onlyDynamic, dynamic1 = param.dynamic, dynamicValues = param.dynamicValues, defaultValue = param.defaultValue;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !onlyDynamic && /*#__PURE__*/ (0,jsx_runtime.jsx)(CodeEditor, {
                value: value1,
                onChange: function(value) {
                    return setProp(function(props) {
                        props[propKey][propSubKey] = onChange ? onChange(value) : value;
                    }, 1000);
                }
            }),
            dynamic1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicToolbarItem, {
                propKey: propKey,
                propSubKey: propSubKey,
                value: value1,
                values: dynamicValues,
                setProp: setProp,
                onChange: onChange,
                defaultValue: defaultValue
            })
        ]
    }));
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/editor/Viewport/Sidebar/Toolbar/ToolbarItem/SliderToolbarItem.js



var SliderToolbarItem = function(param) {
    var propKey = param.propKey, propSubKey = param.propSubKey, value1 = param.value, setProp = param.setProp, onChange = param.onChange, min = param.min, max = param.max, step = param.step, onlyDynamic = param.onlyDynamic, dynamic = param.dynamic, dynamicValues = param.dynamicValues, defaultValue = param.defaultValue;
    var ref = (0,react.useState)(), state = ref[0], setState = ref[1];
    (0,react.useEffect)(function() {
        setState(value1);
    }, [
        value1
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: state !== undefined && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                !onlyDynamic && /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    type: "range",
                    min: min,
                    max: max,
                    step: step,
                    value: state,
                    onChange: function(e) {
                        return setProp(function(props) {
                            var value = e.target.value;
                            props[propKey][propSubKey] = onChange ? onChange(value) : value;
                        }, 1000);
                    }
                }),
                dynamic && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicToolbarItem, {
                    propKey: propKey,
                    propSubKey: propSubKey,
                    value: state,
                    values: dynamicValues,
                    setProp: setProp,
                    onChange: onChange,
                    defaultValue: defaultValue
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/editor/Viewport/Sidebar/Toolbar/ToolbarItem/SelectToolbarItem.js




var SelectToolbarItem = function(param) {
    var propKey = param.propKey, propSubKey = param.propSubKey, values = param.values, value1 = param.value, setProp = param.setProp, onChange = param.onChange, onlyDynamic = param.onlyDynamic, dynamic = param.dynamic, dynamicValues = param.dynamicValues, defaultValue = param.defaultValue, nullable = param.nullable, options = param.options;
    var ref = (0,react.useState)(), state = ref[0], setState = ref[1];
    (0,react.useEffect)(function() {
        setState(value1);
    }, [
        value1
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: state !== undefined && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                !onlyDynamic && state !== undefined && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormSelect, {
                    value: state,
                    options: (nullable ? [
                        {
                            label: 'No value',
                            value: 'no_value'
                        }
                    ] : []).concat(options ? options : values.map(function(v) {
                        return {
                            label: v,
                            value: v
                        };
                    })),
                    onChange: function(e) {
                        return setProp(function(props) {
                            var value = e.target.value;
                            if (value === 'no_value') {
                                value = defaultValue;
                            }
                            props[propKey][propSubKey] = onChange ? onChange(value) : value;
                        }, 1000);
                    }
                }),
                dynamic && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicToolbarItem, {
                    propKey: propKey,
                    propSubKey: propSubKey,
                    value: state,
                    values: dynamicValues,
                    setProp: setProp,
                    onChange: onChange,
                    defaultValue: defaultValue
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/editor/Viewport/Sidebar/Toolbar/ToolbarItem/RadioToolbarItem.js


var RadioToolbarItem = function(param) {
    var propKey = param.propKey, propSubKey = param.propSubKey, values = param.values, value1 = param.value, setProp = param.setProp, onChange = param.onChange, onlyDynamic = param.onlyDynamic, dynamic = param.dynamic, dynamicValues = param.dynamicValues, defaultValue = param.defaultValue;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !onlyDynamic && values.map(function(val) {
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            type: "radio",
                            name: propSubKey,
                            value: val,
                            checked: value1 === val,
                            onChange: function(e) {
                                return setProp(function(props) {
                                    var value = e.target.value;
                                    props[propKey][propSubKey] = onChange ? onChange(value) : value;
                                }, 1000);
                            }
                        }),
                        val
                    ]
                }, val));
            }),
            dynamic && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicToolbarItem, {
                propKey: propKey,
                propSubKey: propSubKey,
                value: value1,
                values: dynamicValues,
                setProp: setProp,
                onChange: onChange,
                defaultValue: defaultValue
            })
        ]
    }));
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/editor/Viewport/Sidebar/Toolbar/ToolbarItem/SwitchToolbarItem.js


var SwitchToolbarItem = function(param) {
    var propKey = param.propKey, propSubKey = param.propSubKey, value1 = param.value, setProp = param.setProp, onChange = param.onChange, onlyDynamic = param.onlyDynamic, dynamic = param.dynamic, dynamicValues = param.dynamicValues, defaultValue = param.defaultValue;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !onlyDynamic && /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "checkbox",
                name: propSubKey,
                defaultChecked: value1,
                onChange: function(e) {
                    return setProp(function(props) {
                        var value = e.target.checked;
                        props[propKey][propSubKey] = onChange ? onChange(value) : value;
                    }, 1000);
                }
            }),
            dynamic && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicToolbarItem, {
                propKey: propKey,
                propSubKey: propSubKey,
                value: value1,
                values: dynamicValues,
                setProp: setProp,
                onChange: onChange,
                defaultValue: defaultValue
            })
        ]
    }));
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/editor/Viewport/Sidebar/Toolbar/ToolbarItem/ColorToolbarItem.js


var ColorToolbarItem = function(param) {
    var propKey = param.propKey, propSubKey = param.propSubKey, value1 = param.value, setProp = param.setProp, onChange = param.onChange, onlyDynamic = param.onlyDynamic, dynamic = param.dynamic, dynamicValues = param.dynamicValues, defaultValue = param.defaultValue;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !onlyDynamic && /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "color",
                value: value1 === 'transparent' || value1 === 'inherit' ? '#000000' : value1,
                onChange: function(e) {
                    return setProp(function(props) {
                        var value = e.target.value;
                        props[propKey][propSubKey] = onChange ? onChange(value) : value;
                    }, 1000);
                }
            }),
            dynamic && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicToolbarItem, {
                propKey: propKey,
                propSubKey: propSubKey,
                value: value1,
                values: dynamicValues,
                setProp: setProp,
                onChange: onChange,
                defaultValue: defaultValue
            })
        ]
    }));
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/editor/Viewport/Sidebar/Toolbar/ToolbarItem/index.js












function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var ToolbarItem = function(_param) {
    var inline = _param.inline, propKey = _param.propKey, propSubKey = _param.propSubKey, type = _param.type, onChange = _param.onChange, values = _param.values, options = _param.options, onlyDynamic = _param.onlyDynamic, dynamic = _param.dynamic, dynamicValues = _param.dynamicValues, defaultValue = _param.defaultValue, nullable = _param.nullable, rte = _param.rte, children = _param.children, props = _objectWithoutProperties(_param, [
        "inline",
        "propKey",
        "propSubKey",
        "type",
        "onChange",
        "values",
        "options",
        "onlyDynamic",
        "dynamic",
        "dynamicValues",
        "defaultValue",
        "nullable",
        "rte",
        "children"
    ]);
    var ref = (0,esm/* useNode */.Zo)(function(node) {
        return {
            ps: node.data.props
        };
    }), setProp = ref.actions.setProp, ps = ref.ps;
    var ref1 = (0,react.useState)(), value = ref1[0], setValue = ref1[1];
    (0,react.useEffect)(function() {
        if (propKey && propSubKey) {
            setValue(ps[propKey][propSubKey]);
        }
    }, [
        ps
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "toolbar-section__item ".concat(inline ? 'toolbar-section__item--inline' : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "toolbar-section__item__header",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "toolbar-section__item__header__label",
                        children: props.label
                    }),
                    props.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "toolbar-section__item__header__description",
                        children: props.description
                    })
                ]
            }),
            value !== undefined && (type === 'text' ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TextToolbarItem, {
                propKey: propKey,
                propSubKey: propSubKey,
                value: value,
                setProp: setProp,
                onChange: onChange,
                onlyDynamic: onlyDynamic,
                dynamic: dynamic,
                dynamicValues: dynamicValues,
                defaultValue: defaultValue,
                rte: rte
            }) : type === 'file' ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FileToolbarItem, {
                propKey: propKey,
                propSubKey: propSubKey,
                value: value,
                setProp: setProp,
                onChange: onChange
            }) : type === 'code' ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CodeToolbarItem, {
                propKey: propKey,
                propSubKey: propSubKey,
                value: value,
                setProp: setProp,
                onChange: onChange,
                onlyDynamic: onlyDynamic,
                dynamic: dynamic,
                dynamicValues: dynamicValues,
                defaultValue: defaultValue
            }) : type === 'slider' ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderToolbarItem, {
                propKey: propKey,
                propSubKey: propSubKey,
                value: value,
                setProp: setProp,
                onChange: onChange,
                max: props.max,
                min: props.min,
                step: props.step,
                onlyDynamic: onlyDynamic,
                dynamic: dynamic,
                dynamicValues: dynamicValues,
                defaultValue: defaultValue
            }) : type === 'select' ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectToolbarItem, {
                propKey: propKey,
                propSubKey: propSubKey,
                options: options,
                values: values,
                value: value,
                setProp: setProp,
                onChange: onChange,
                onlyDynamic: onlyDynamic,
                dynamic: dynamic,
                dynamicValues: dynamicValues,
                defaultValue: defaultValue,
                nullable: nullable
            }) : type === 'radio' ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioToolbarItem, {
                propKey: propKey,
                propSubKey: propSubKey,
                values: values,
                value: value,
                setProp: setProp,
                onChange: onChange,
                onlyDynamic: onlyDynamic,
                dynamic: dynamic,
                dynamicValues: dynamicValues,
                defaultValue: defaultValue
            }) : type === 'switch' ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchToolbarItem, {
                propKey: propKey,
                propSubKey: propSubKey,
                value: value,
                setProp: setProp,
                onChange: onChange,
                onlyDynamic: onlyDynamic,
                dynamic: dynamic,
                dynamicValues: dynamicValues,
                defaultValue: defaultValue
            }) : type === 'color' ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorToolbarItem, {
                propKey: propKey,
                propSubKey: propSubKey,
                value: value,
                setProp: setProp,
                onChange: onChange,
                onlyDynamic: onlyDynamic,
                dynamic: dynamic,
                dynamicValues: dynamicValues,
                defaultValue: defaultValue
            }) : type === 'dynamic' ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicToolbarItem, {
                propKey: propKey,
                propSubKey: propSubKey,
                value: value,
                values: values,
                setProp: setProp,
                onChange: onChange,
                defaultValue: defaultValue
            }) : null),
            type === 'other' ? children : null
        ]
    }));
};


;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/components/Button/ButtonSettings.js








function ButtonSettings_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function ButtonSettings_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                ButtonSettings_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                ButtonSettings_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
//import { useQuery, gql } from '@apollo/client'
//import { initializeApollo } from 'utils/apollo'
//import { PAGINE } from 'utils/queries'
var variantOpts = [
    {
        label: 'Primary',
        value: 'primary'
    },
    {
        label: 'Secondary',
        value: 'secondary'
    },
    {
        label: 'Tertiary',
        value: 'tertiary'
    },
    {
        label: 'Tertiary 2',
        value: 'tertiary2'
    },
    {
        label: 'Ghost',
        value: 'ghost'
    }, 
];
var sizeOptions = [
    {
        label: 'Small',
        value: 'sm'
    },
    {
        label: 'Medium',
        value: 'md'
    },
    {
        label: 'Large',
        value: 'lg'
    }
];
var ButtonSettings = function(props) {
    var customs = (0,esm/* useNode */.Zo)(function(node) {
        return {
            customs: node.data.custom
        };
    }).customs;
    // const client = initializeApollo()
    var ref = (0,react.useState)([]), urlOpts = ref[0], setUrlOpts = ref[1];
    (0,react.useEffect)(ButtonSettings_asyncToGenerator(runtime_default().mark(function _callee() {
        var data, pagine, onlyDetailPagine, finalUrlOpts;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    data = null;
                    if (data) {
                        pagine = data.pagine.edges;
                        onlyDetailPagine = pagine.filter(function(paginaNode) {
                            return paginaNode.node.tipologia === 'PAGE_APP';
                        });
                        finalUrlOpts = onlyDetailPagine.map(function(paginaNode) {
                            return paginaNode.node.path === '' ? '/' : paginaNode.node.path;
                        });
                        setUrlOpts(finalUrlOpts);
                    }
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), []);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ToolbarSection_ToolbarSection, {
                title: "Style",
                initOpen: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolbarItem, {
                        propKey: "block",
                        propSubKey: "variant",
                        type: "select",
                        label: "Variante",
                        options: variantOpts,
                        dynamic: dynamicProps.includes('variant') && customs.dynamicData,
                        dynamicValues: customs.dynamicData ? getAllPaths(customs.dynamicData) : [],
                        defaultValue: Button_defaultProps.variant
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolbarItem, {
                        propKey: "block",
                        propSubKey: "size",
                        type: "select",
                        label: "Size",
                        options: sizeOptions,
                        dynamic: dynamicProps.includes('size') && customs.dynamicData,
                        dynamicValues: customs.dynamicData ? getAllPaths(customs.dynamicData) : [],
                        defaultValue: Button_defaultProps.size
                    })
                ]
            }),
            !props.floating && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ToolbarSection_ToolbarSection, {
                title: "Settings",
                initOpen: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolbarItem, {
                        propKey: "block",
                        propSubKey: "url",
                        type: "text",
                        label: "URL",
                        dynamic: dynamicProps.includes('url') && customs.dynamicData,
                        dynamicValues: customs.dynamicData ? getAllPaths(customs.dynamicData) : [],
                        defaultValue: Button_defaultProps.url
                    }),
                    urlOpts && /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolbarItem, {
                        propKey: "block",
                        propSubKey: "url",
                        type: "select",
                        label: "URL",
                        values: urlOpts,
                        nullable: true,
                        defaultValue: Button_defaultProps.url
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolbarItem, {
                        propKey: "block",
                        propSubKey: "openNewTab",
                        type: "switch",
                        label: "Open in new tab",
                        dynamic: dynamicProps.includes('openNewTab') && customs.dynamicData,
                        dynamicValues: customs.dynamicData ? getAllPaths(customs.dynamicData) : [],
                        defaultValue: Button_defaultProps.openNewTab
                    })
                ]
            })
        ]
    }));
};
var ButtonFloatingSettings = function() {
    /*#__PURE__*/ return react.createElement(ButtonSettings, {
        floating: true
    });
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/components/withBlock.js







function withBlock_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function withBlock_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            withBlock_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var withBlock = function(Component, defaultProps, dynamicProps) {
    return function(props1) {
        var ref4 = (0,esm/* useNode */.Zo)(function(state) {
            return {
                selected: state.events.selected,
                hovered: state.events.hovered,
                customs: state.data.custom,
                blockProps: state.data.props.block,
                conditionsProps: state.data.props.conditions
            };
        }), id = ref4.id, _connectors = ref4.connectors, connect = _connectors.connect, drag = _connectors.drag, _actions = ref4.actions, setCustom = _actions.setCustom, setProp = _actions.setProp, customs = ref4.customs, blockProps = ref4.blockProps, conditionsProps = ref4.conditionsProps, selected = ref4.selected, hovered = ref4.hovered;
        var ref1 = (0,esm/* useEditor */.jE)(function(state) {
            return {
                enabled: state.options.enabled
            };
        }), query = ref1.query, actions = ref1.actions, enabled = ref1.enabled;
        var ref2 = (0,react.useContext)(globalContext_GlobalContext), previewMode = ref2.previewMode, wireframeMode = ref2.wireframeMode, floatingSettingsOpen = ref2.floatingSettingsOpen, setFloatingSettingsOpen = ref2.setFloatingSettingsOpen;
        var value = (0,react.useContext)(DynamicDataContext);
        (0,react.useEffect)(function() {
            // seleziona nodo quando droppato (ma anche al render iniziale del pagebuilder)
            /* actions.selectNode(id)
    if(id === ROOT_NODE) {
      actions.selectNode(null)
    } */ // imposta le defaultProps alle props non specificate
            Object.keys(defaultProps).forEach(function(propKey) {
                if (blockProps[propKey] === undefined) {
                    actions.history.ignore().setProp(id, function(props) {
                        props.block[propKey] = defaultProps[propKey];
                    });
                }
            });
            // imposta le defaultConditionsProps alle props non specificate
            Object.keys(defaultConditionsProps).forEach(function(propKey) {
                if (conditionsProps[propKey] === undefined) {
                    actions.history.ignore().setProp(id, function(props) {
                        props.conditions[propKey] = defaultConditionsProps[propKey];
                    });
                }
            });
        }, []);
        (0,react.useEffect)(function() {
            if (value) {
                actions.history.ignore().setCustom(id, function(custom) {
                    custom['dynamicData'] = value;
                });
            } else {
                actions.history.ignore().setCustom(id, function(custom) {
                    delete custom['dynamicData'];
                });
            }
        }, [
            value
        ]);
        /*  
        1)
        se cambiano i dati dinamici ed era settato un valore dinamico che non ha più
        un corrispondente, allora ripristiniamo il valore di default
        2)
        se non ci sono più i dati dinamici ed era settato un valore dinamico, 
        allora ripristiniamo il valore di default
    */ (0,react.useEffect)(function() {
            if (value) {
                dynamicProps === null || dynamicProps === void 0 ? void 0 : dynamicProps.forEach(function(dprop) {
                    if (isDynamicValue(props1.block[dprop]) && !deepValue(value, getDynamicValue(props1.block[dprop]))) {
                        //setProp((props) => {
                        actions.history.ignore().setProp(id, function(props) {
                            props.block[dprop] = defaultProps[dprop];
                        });
                    }
                });
            } else {
                dynamicProps === null || dynamicProps === void 0 ? void 0 : dynamicProps.forEach(function(dprop) {
                    if (isDynamicValue(props1.block[dprop])) {
                        //setProp((props) => {
                        actions.history.ignore().setProp(id, function(props) {
                            props.block[dprop] = defaultProps[dprop];
                        });
                    }
                });
            }
        }, [
            value
        ]);
        // funzione che ritorna il valore effettivo a seconda che sia dinamico oppure no
        var renderValue = function(val) {
            if (value && isDynamicValue(val)) {
                return deepValue(value, getDynamicValue(val));
            } else {
                return val;
            }
        };
        var renderText = function(text) {
            if (value) {
                var index = text.indexOf('${');
                if (index === -1) {
                    return text;
                } else {
                    var lastIndex = text.indexOf('}');
                    if (lastIndex !== -1) {
                        var val = text.substring(index, lastIndex + 1);
                        var renderedVal = renderValue(val);
                        var newT = '';
                        if (renderedVal) {
                            newT = text.substring(0, index).concat(renderedVal).concat(text.substr(lastIndex + 1));
                        } else {
                            newT = text.substring(0, index).concat(text.substr(lastIndex + 1));
                        }
                        return renderText(newT);
                    } else {
                        return text;
                    }
                }
            } else {
                return text;
            }
        };
        var retRef = function(ref) {
            var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'drag';
            if (!enabled) {
                return null;
            } else if (props1.conditions && props1.conditions.disabled) {
                return null;
            } else {
                if (type === 'drag') {
                    return connect(drag(ref));
                } else if (type === 'connect') {
                    return connect(ref);
                } else {
                    return connect(null);
                }
            }
        };
        var ref3 = (0,react.useState)(''), className1 = ref3[0], setClassName = ref3[1];
        (0,react.useEffect)(function() {
            var className = "".concat(id, " ").concat(enabled && !previewMode && wireframeMode ? 'with-wireframe' : '');
            if (selected) {
                if (!customs.editing) {
                    className += ' component-selected';
                }
            } else if (hovered) {
                className += ' component-hovered';
            }
            setClassName(className);
        }, [
            selected,
            hovered,
            enabled,
            previewMode,
            wireframeMode,
            customs.editing
        ]);
        var onDoubleClick = function(event, fun) {
            event.stopPropagation();
            if (fun) {
                fun();
            } else {
                setFloatingSettingsOpen(true);
            }
        };
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, withBlock_objectSpread({}, props1, {
                className: className1,
                renderValue: renderValue,
                renderText: renderText,
                retRef: retRef,
                onDoubleClick: onDoubleClick
            }))
        }));
    };
};

// EXTERNAL MODULE: ../../libs/shared-ui/src/atoms/index.ts + 76 modules
var atoms = __webpack_require__(28518);
;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/components/Button/index.js







function Button_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Button_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Button_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Button_defaultProps = {
    url: '',
    openNewTab: false,
    variant: 'primary',
    size: 'md'
};
var dynamicProps = [
    'url'
];
var components_Button_Button = withBlock(function(props) {
    var blockProps = Button_objectSpread({}, Button_defaultProps, props.block);
    var url = blockProps.url, openNewTab = blockProps.openNewTab, variant = blockProps.variant, size = blockProps.size;
    var children = props.children;
    var _ = props.renderValue;
    var ref1 = (0,esm/* useNode */.Zo)(function(state) {
        return {
            selected: state.events.selected,
            dragged: state.events.dragged,
            hovered: state.events.hovered,
            customs: state.data.custom
        };
    }), id = ref1.id, connect = ref1.connectors.connect, selected = ref1.selected, hovered = ref1.hovered, _actions = ref1.actions, setProp = _actions.setProp, setCustom = _actions.setCustom, customs = ref1.customs;
    var enabled = (0,esm/* useEditor */.jE)(function(state) {
        return {
            enabled: state.options.enabled
        };
    }).enabled;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: function(ref) {
            return props.retRef(ref);
        },
        className: 'block-button ' + props.className,
        children: enabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
            variant: variant,
            label: children.props.children[0],
            size: size
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
            href: _(url),
            newPage: openNewTab,
            variant: variant,
            label: children.props.children[0],
            size: size
        })
    }));
}, Button_defaultProps, dynamicProps);
components_Button_Button.craft = withCraft({
    name: 'Button',
    defaultProps: Button_defaultProps,
    settings: ButtonSettings,
    floatingSettings: ButtonFloatingSettings
});

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/components/Image/ImageSettings.js






var alignOpts = [
    'left',
    'center',
    'right'
];
var ImageSettings = function() {
    var customs = (0,esm/* useNode */.Zo)(function(node) {
        return {
            customs: node.data.custom
        };
    }).customs;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ToolbarSection_ToolbarSection, {
                title: "Settings",
                initOpen: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolbarItem, {
                        propKey: "block",
                        propSubKey: "src",
                        type: "text",
                        label: "Src",
                        description: "Paste your url or upload a file",
                        dynamic: Image_dynamicProps.includes('src') && customs.dynamicData,
                        dynamicValues: customs.dynamicData ? getAllPaths(customs.dynamicData) : [],
                        defaultValue: Image_defaultProps.src
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolbarItem, {
                        propKey: "block",
                        propSubKey: "src",
                        type: "file"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolbarItem, {
                        propKey: "block",
                        propSubKey: "alt",
                        type: "text",
                        label: "Alt Text",
                        dynamic: Image_dynamicProps.includes('alt') && customs.dynamicData,
                        dynamicValues: customs.dynamicData ? getAllPaths(customs.dynamicData) : [],
                        defaultValue: Image_defaultProps.alt
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ToolbarSection_ToolbarSection, {
                title: "Style",
                initOpen: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolbarItem, {
                        propKey: "block",
                        propSubKey: "align",
                        type: "select",
                        label: "Alignment",
                        values: alignOpts,
                        dynamic: Image_dynamicProps.includes('align') && customs.dynamicData,
                        dynamicValues: customs.dynamicData ? getAllPaths(customs.dynamicData) : [],
                        defaultValue: Image_defaultProps.align
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolbarItem, {
                        propKey: "block",
                        propSubKey: "fullWidth",
                        type: "switch",
                        label: "Full Width",
                        dynamic: Image_dynamicProps.includes('fullWidth') && customs.dynamicData,
                        dynamicValues: customs.dynamicData ? getAllPaths(customs.dynamicData) : [],
                        defaultValue: Image_defaultProps.fullWidth
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/components/Image/index.js








function Image_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Image_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Image_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Image_defaultProps = {
    // src: "https://d3e54v103j8qbb.cloudfront.net/plugins/Basic/assets/placeholder.60f9b1840c.svg",
    src: 'https://dummyimage.com/300x200/737173/ffffff.png',
    alt: 'Image',
    align: 'left',
    fullWidth: false
};
var Image_dynamicProps = [
    'src'
];
var Image_Image = withBlock(function(props) {
    var blockProps = Image_objectSpread({}, Image_defaultProps, props.block);
    var src = blockProps.src, alt = blockProps.alt, align = blockProps.align, fullWidth = blockProps.fullWidth;
    var _ = props.renderValue;
    var ref1 = (0,esm/* useNode */.Zo)(function(state) {
        return {
            selected: state.events.selected,
            dragged: state.events.dragged,
            hovered: state.events.hovered,
            customs: state.data.custom
        };
    }), id = ref1.id, _connectors = ref1.connectors, connect = _connectors.connect, drag = _connectors.drag, _actions = ref1.actions, setProp = _actions.setProp, setCustom = _actions.setCustom, selected = ref1.selected, hovered = ref1.hovered, customs = ref1.customs;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div" // img non supporta :after
    , {
        ref: function(ref) {
            return props.retRef(ref);
        },
        className: 'block-image ' + (fullWidth ? 'block-image--full ' : '') + props.className,
        style: {
            position: 'relative',
            textAlign: align
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WImage */.Tg, {
            src: _(src),
            title: _(src),
            alt: alt
        })
    }));
}, Image_defaultProps, Image_dynamicProps);
Image_Image.craft = withCraft({
    name: 'Image',
    defaultProps: Image_defaultProps,
    settings: ImageSettings
});

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/components/PdfLink/PdfLinkSettings.js






var PdfLinkSettings = function() {
    var customs = (0,esm/* useNode */.Zo)(function(node) {
        return {
            customs: node.data.custom
        };
    }).customs;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(ToolbarSection_ToolbarSection, {
        title: "Settings",
        initOpen: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolbarItem, {
                propKey: "block",
                propSubKey: "name",
                type: "text",
                label: "Nome",
                dynamic: PdfLink_dynamicProps.includes('name') && customs.dynamicData,
                dynamicValues: customs.dynamicData ? getAllPaths(customs.dynamicData) : [],
                defaultValue: PdfLink_defaultProps.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolbarItem, {
                propKey: "block",
                propSubKey: "url",
                type: "text",
                label: "URL",
                dynamic: PdfLink_dynamicProps.includes('url') && customs.dynamicData,
                dynamicValues: customs.dynamicData ? getAllPaths(customs.dynamicData) : [],
                defaultValue: PdfLink_defaultProps.url
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolbarItem, {
                propKey: "block",
                propSubKey: "url",
                type: "file"
            })
        ]
    }));
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/components/PdfLink/index.js







function PdfLink_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function PdfLink_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            PdfLink_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var PdfLink_defaultProps = {
    name: 'Nome del file',
    url: '#'
};
var PdfLink_dynamicProps = [];
var PdfLink_PdfLink = withBlock(function(props) {
    var blockProps = PdfLink_objectSpread({}, PdfLink_defaultProps, props.block);
    var name = blockProps.name, url = blockProps.url;
    var _ = props.renderValue;
    var enabled = (0,esm/* useEditor */.jE)(function(state) {
        return {
            enabled: state.options.enabled
        };
    }).enabled;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: function(ref) {
            return props.retRef(ref);
        },
        className: 'block-pdflink ' + (enabled ? 'block-pdflink--editing ' : '') + props.className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* PdfLink */.lQ, {
            name: name,
            url: url
        })
    }));
}, PdfLink_defaultProps, PdfLink_dynamicProps);
PdfLink_PdfLink.craft = withCraft({
    name: 'PdfLink',
    defaultProps: PdfLink_defaultProps,
    settings: PdfLinkSettings
});

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/components/ROOT/index.js





var ROOT_defaultProps = {};
var ROOT_dynamicProps = [];
var ROOT = withBlock(function(props) {
    var children = props.children;
    var enabled = (0,esm/* useEditor */.jE)(function(state) {
        return {
            enabled: state.options.enabled
        };
    }).enabled;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: function(ref) {
            return props.retRef(ref, 'connect');
        },
        className: (enabled ? 'ROOT--editing ' : '') + props.className,
        onDoubleClick: props.onDoubleClick,
        style: {
            position: 'relative',
            display: 'block',
            width: '100%',
            backgroundColor: 'white',
            padding: enabled ? '10px' : '0px',
            minHeight: '75px'
        },
        children: children
    }));
}, ROOT_defaultProps, ROOT_dynamicProps);
ROOT.craft = withCraft({
    name: 'ROOT',
    defaultProps: ROOT_defaultProps,
    settings: null
});

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/components/Tabs/TabsSettings.js








var TabsSettings = function() {
    var ref3 = (0,esm/* useNode */.Zo)(function(node) {
        return {
            props: node.data.props,
            active: node.data.custom.active,
            nodes: node.data.nodes
        };
    }), id = ref3.id, props1 = ref3.props, active = ref3.active, nodes = ref3.nodes, _actions = ref3.actions, setProp = _actions.setProp, setCustom = _actions.setCustom;
    var ref1 = (0,esm/* useEditor */.jE)(function(state, query) {
        var ref, ref2;
        return {
            tabsMenuNode: (nodes === null || nodes === void 0 ? void 0 : nodes.length) ? query.node(nodes[0]).get() : null,
            tabsMenuList: (nodes === null || nodes === void 0 ? void 0 : nodes.length) ? (ref = query.node(nodes[0]).get()) === null || ref === void 0 ? void 0 : ref.data.nodes : [],
            tabsContentNode: (nodes === null || nodes === void 0 ? void 0 : nodes.length) ? query.node(nodes[1]).get() : null,
            tabsContentList: (nodes === null || nodes === void 0 ? void 0 : nodes.length) ? (ref2 = query.node(nodes[1]).get()) === null || ref2 === void 0 ? void 0 : ref2.data.nodes : []
        };
    }), actions = ref1.actions, query1 = ref1.query, tabsMenuNode = ref1.tabsMenuNode, tabsMenuList = ref1.tabsMenuList, tabsContentNode = ref1.tabsContentNode, tabsContentList = ref1.tabsContentList;
    var addSlide = function() {
        var tabsMenuId = tabsMenuNode.id;
        var newTabsMenuElement = /*#__PURE__*/ (0,jsx_runtime.jsx)(TextEditor, {
            block: {
                text: "Tab ".concat((tabsMenuList === null || tabsMenuList === void 0 ? void 0 : tabsMenuList.length) + 1, " \n"),
                noHtml: true
            }
        });
        var newTabsMenuElementNodeTree = query1.parseReactElement(newTabsMenuElement).toNodeTree();
        node_addNodeTree(newTabsMenuElementNodeTree, tabsMenuId, actions, false, null, true) // true = throttle
        ;
        var tabsContentId = tabsContentNode.id;
        var newTabsContentElement = /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Element */.W_, {
            is: TabPane,
            canvas: true
        });
        var newTabsContentElementNodeTree = query1.parseReactElement(newTabsContentElement).toNodeTree();
        node_addNodeTree(newTabsContentElementNodeTree, tabsContentId, actions, false, null, true) // true = throttle
        ;
    };
    var deleteSlide = function(index) {
        if (tabsMenuList.length > 2) {
            if (index < active) {
                setCustom(function(props) {
                    props.active = active - 1;
                });
            } else if (active >= tabsMenuList.length - 1) {
                setCustom(function(props) {
                    props.active = active - 1;
                });
            }
            var tabMenuId = tabsMenuList[index];
            deleteNodeTree(tabMenuId, actions, false, true) // true = throttle
            ;
            var tabContentId = tabsContentList[index];
            deleteNodeTree(tabContentId, actions, false, true) // true = throttle
            ;
        }
    };
    var selectSlide = function(index) {
        setCustom(function(props) {
            props.active = index;
        });
        actions.selectNode(tabsMenuList[index]);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolbarSection_ToolbarSection, {
            title: "Tabs",
            initOpen: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ToolbarItem, {
                type: "other",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "tabs-settings__tabs-num",
                        children: [
                            "# Tabs: ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: tabsMenuList.length
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_Button_Button, {
                        onClick: function() {
                            return addSlide();
                        },
                        label: "Add Tab",
                        size: "sm"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "tabs-settings__list__title",
                        children: "Tabs list"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tabs-settings__tabs",
                        children: Array.from(Array(tabsMenuList.length).keys()).map(function(tab, index) {
                            return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "tabs-settings__tabs-item ".concat(index === active ? 'active' : ''),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_Button_Button, {
                                        variant: "ghost",
                                        label: 'Tab ' + (index + 1),
                                        onClick: function() {
                                            return selectSlide(index);
                                        },
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Edit, {}),
                                        iconPos: "right"
                                    }),
                                    tabsMenuList.length > 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_Button_Button, {
                                        variant: "ghost",
                                        onClick: function() {
                                            return deleteSlide(index);
                                        },
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Bin, {})
                                    })
                                ]
                            }, index));
                        })
                    })
                ]
            })
        })
    }));
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/components/Tabs/index.js






function Tabs_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Tabs_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Tabs_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Tabs_defaultProps = {};
var Tabs_dynamicProps = [];
var Tabs_Tabs = withBlock(function(props) {
    var blockProps = Tabs_objectSpread({}, Tabs_defaultProps, props.block);
    var current = blockProps.current;
    var children = props.children;
    var _ = props.renderValue;
    var id = (0,esm/* useNode */.Zo)().id;
    var ref1 = (0,esm/* useEditor */.jE)(function(state) {
        return {
            enabled: state.options.enabled
        };
    }), enabled = ref1.enabled, actions = ref1.actions;
    var tabsMenuComponent = children.props.children[0];
    var tabsContentComponent = children.props.children[1];
    (0,react.useEffect)(function() {
        actions.history.ignore().setCustom(id, function(customs) {
            customs.active = 0;
        });
    }, []);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: function(ref) {
            return props.retRef(ref);
        },
        className: 'block-tabs ' + props.className,
        children: [
            tabsMenuComponent,
            tabsContentComponent
        ]
    }));
}, Tabs_defaultProps, Tabs_dynamicProps);
Tabs_Tabs.craft = withCraft({
    name: 'Tabs',
    defaultProps: Tabs_defaultProps,
    settings: TabsSettings
});

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/components/TabsContent/TabsContentSettings.js



var TabsContentSettings = function(props) {
    var customs = (0,esm/* useNode */.Zo)(function(node) {
        return {
            customs: node.data.custom
        };
    }).customs;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "empty-message",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: "No options available"
        })
    }));
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/components/TabsContent/index.js






function TabsContent_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function TabsContent_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            TabsContent_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var TabsContent_defaultProps = {};
var TabsContent_dynamicProps = [];
var TabsContent = withBlock(function(props) {
    var blockProps = TabsContent_objectSpread({}, TabsContent_defaultProps, props.block);
    var children = props.children;
    var _ = props.renderValue;
    var ref1 = (0,esm/* useNode */.Zo)(function(state) {
        return {
            parent: state.data.parent
        };
    }), id = ref1.id, parent = ref1.parent;
    var parentNode = (0,esm/* useEditor */.jE)(function(state, query) {
        return {
            parentNode: parent ? query.node(parent).get() : null
        };
    }).parentNode;
    var active = parentNode === null || parentNode === void 0 ? void 0 : parentNode.data.custom.active;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: function(ref) {
            return props.retRef(ref);
        },
        className: 'block-tabs-content ' + props.className,
        children: children.props.children.map(function(tab, index) {
            return active === index && tab;
        })
    }));
}, TabsContent_defaultProps, TabsContent_dynamicProps);
TabsContent.craft = withCraft({
    name: 'TabsContent',
    defaultProps: TabsContent_defaultProps,
    settings: TabsContentSettings
});

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/components/TabsMenu/TabsMenuSettings.js



var TabsMenuSettings = function(props) {
    var customs = (0,esm/* useNode */.Zo)(function(node) {
        return {
            customs: node.data.custom
        };
    }).customs;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "empty-message",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: "No options available"
        })
    }));
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/components/TabsMenu/index.js







function TabsMenu_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function TabsMenu_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            TabsMenu_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var TabsMenu_defaultProps = {};
var TabsMenu_dynamicProps = [];
var TabsMenu = withBlock(function(props) {
    var blockProps = TabsMenu_objectSpread({}, TabsMenu_defaultProps, props.block);
    var children = props.children;
    var _ = props.renderValue;
    var ref2 = (0,esm/* useNode */.Zo)(function(state) {
        return {
            parent: state.data.parent,
            nodes: state.data.nodes
        };
    }), id = ref2.id, parent = ref2.parent, nodes = ref2.nodes;
    var ref1 = (0,esm/* useEditor */.jE)(function(state, query) {
        return {
            parentNode: parent ? query.node(parent).get() : null
        };
    }), parentNode = ref1.parentNode, actions = ref1.actions;
    var active = parentNode === null || parentNode === void 0 ? void 0 : parentNode.data.custom.active;
    var setActive = function(index) {
        actions.history.ignore().setCustom(parentNode.id, function(customs) {
            customs.active = index;
        });
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: function(ref) {
            return props.retRef(ref);
        },
        className: 'block-tabs-menu ' + props.className,
        children: children.props.children.map(function(tab, index) {
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "block-tabs-menu__item",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Chip */.Af, {
                    label: tab,
                    onClick: function() {
                        return setActive(index);
                    },
                    active: active === index
                })
            }, index));
        })
    }));
}, TabsMenu_defaultProps, TabsMenu_dynamicProps);
TabsMenu.craft = withCraft({
    name: 'TabsMenu',
    defaultProps: TabsMenu_defaultProps,
    settings: TabsMenuSettings
});

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/components/TabPane/TabPaneSettings.js



var TabPaneSettings = function(props) {
    var customs = (0,esm/* useNode */.Zo)(function(node) {
        return {
            customs: node.data.custom
        };
    }).customs;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "empty-message",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: "No options available"
        })
    }));
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/components/TabPane/index.js





function TabPane_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function TabPane_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            TabPane_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var TabPane_defaultProps = {};
var TabPane_dynamicProps = [];
var TabPane = withBlock(function(props) {
    var blockProps = TabPane_objectSpread({}, TabPane_defaultProps, props.block);
    var children = props.children;
    var _ = props.renderValue;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: function(ref) {
            return props.retRef(ref);
        },
        className: 'block-tab-pane ' + props.className,
        children: children
    }));
}, TabPane_defaultProps, TabPane_dynamicProps);
TabPane.craft = withCraft({
    name: 'TabPane',
    defaultProps: TabPane_defaultProps,
    settings: TabPaneSettings
});

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/components/Text/TextSettings.js






var TextSettings = function() {
    var customs = (0,esm/* useNode */.Zo)(function(node) {
        return {
            customs: node.data.custom
        };
    }).customs;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: customs.dynamicData ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolbarSection_ToolbarSection, {
            title: "Dynamic Data",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolbarItem, {
                propKey: "block",
                propSubKey: "text",
                type: "text",
                label: "Text",
                onlyDynamic: true,
                dynamic: Text_dynamicProps.includes('text'),
                dynamicValues: getAllPaths(customs.dynamicData),
                defaultValue: Text_defaultProps.text
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "empty-message",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "No options available"
            })
        })
    }));
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/components/Text/index.js






function Text_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Text_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Text_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Text_defaultProps = {
    text: '<p>Enter your text!</p>',
    noHtml: false
};
var Text_dynamicProps = [
    'text'
];
var Text_Text = withBlock(function(props) {
    var blockProps = Text_objectSpread({}, Text_defaultProps, props.block);
    var text = blockProps.text, noHtml = blockProps.noHtml;
    var children = props.children;
    var _ = props.renderValue;
    var ref1 = (0,esm/* useNode */.Zo)(function(state) {
        return {
            selected: state.events.selected,
            dragged: state.events.dragged,
            hovered: state.events.hovered,
            customs: state.data.custom
        };
    }), id = ref1.id, _connectors = ref1.connectors, connect = _connectors.connect, drag = _connectors.drag, selected = ref1.selected, hovered = ref1.hovered, _actions = ref1.actions, setProp = _actions.setProp, setCustom = _actions.setCustom, customs = ref1.customs;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: function(ref) {
            return props.retRef(ref);
        },
        className: 'block-text ' + props.className,
        children: children.props.children[0]
    }));
}, Text_defaultProps, Text_dynamicProps);
Text_Text.craft = withCraft({
    name: 'Text',
    defaultProps: Text_defaultProps,
    settings: TextSettings
});

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/components/TextEditor/TextEditorSettings.js






var TextEditorSettings = function() {
    var customs = (0,esm/* useNode */.Zo)(function(node) {
        return {
            customs: node.data.custom
        };
    }).customs;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: customs.dynamicData ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolbarSection_ToolbarSection, {
            title: "Dynamic Data",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolbarItem, {
                propKey: "block",
                propSubKey: "texteditor",
                type: "texteditor",
                label: "Text Editor",
                onlyDynamic: true,
                dynamic: TextEditor_dynamicProps.includes('texteditor'),
                dynamicValues: getAllPaths(customs.dynamicData),
                defaultValue: TextEditor_defaultProps.texteditor
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "empty-message",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "No options available"
            })
        })
    }));
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/components/TextEditor/index.js









function TextEditor_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function TextEditor_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            TextEditor_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var TextEditor_defaultProps = {
    text: '<p>Enter your text!</p>',
    noHtml: false
};
var TextEditor_dynamicProps = [
    'text'
];
var TextEditor = withBlock(function(props1) {
    var ref4, ref1;
    var blockProps = TextEditor_objectSpread({}, TextEditor_defaultProps, props1.block);
    var text = blockProps.text, noHtml = blockProps.noHtml;
    var _ = props1.renderValue;
    var __ = props1.renderText;
    var ref2 = (0,esm/* useNode */.Zo)(function(state) {
        return {
            selected: state.events.selected,
            dragged: state.events.dragged,
            hovered: state.events.hovered,
            customs: state.data.custom
        };
    }), id = ref2.id, _connectors = ref2.connectors, connect = _connectors.connect, drag = _connectors.drag, selected = ref2.selected, hovered = ref2.hovered, _actions = ref2.actions, setProp = _actions.setProp, setCustom = _actions.setCustom, customs1 = ref2.customs;
    var ref3 = (0,esm/* useEditor */.jE)(function(state) {
        return {
            enabled: state.options.enabled
        };
    }), actions = ref3.actions, query = ref3.query, enabled = ref3.enabled;
    (0,react.useEffect)(function() {
        if (selected) {
            return;
        }
        actions.history.ignore().setCustom(id, function(customs) {
            customs.editing = false;
        });
    }, [
        selected
    ]);
    var enableEditable = function() {
        if (selected && (!props1.conditions || !props1.conditions.disabled)) {
            actions.history.ignore().setCustom(id, function(customs) {
                customs.editing = true;
            });
        }
    };
    (0,react.useEffect)(function() {
        if (enabled) {
            var nodes = node_getAncestors(id, query);
            nodes.pop(esm/* ROOT_NODE */.QS);
            nodes.push(id);
            nodes.forEach(function(nodeId) {
                var isDraggable = query.node(nodeId).isDraggable();
                if (isDraggable) {
                    var element = document.getElementsByClassName(nodeId)[0];
                    if (element) {
                        if (customs1.editing) {
                            element.removeAttribute('draggable');
                        } else {
                            element.setAttribute('draggable', true);
                        }
                    }
                }
            });
        }
    }, [
        customs1.editing
    ]);
    var className = 'text-editor ' + (customs1.editing ? '' : ((ref4 = props1.block) === null || ref4 === void 0 ? void 0 : ref4.className) === 'quote__content' ? '' : 'ql-editor ') + (((ref1 = props1.block) === null || ref1 === void 0 ? void 0 : ref1.className) ? props1.block.className + ' ' : '') + props1.className;
    return customs1.editing ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: id,
        ref: function(ref) {
            return props1.retRef(ref);
        },
        onDoubleClick: function(e) {
            return props1.onDoubleClick(e, enableEditable);
        },
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextEditor, {
            value: text,
            setValue: function(value) {
                return setProp(function(props) {
                    return props.block.text = value;
                }, 500);
            },
            noHtml: noHtml
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: id,
        ref: function(ref) {
            return props1.retRef(ref);
        },
        onDoubleClick: function(e) {
            return props1.onDoubleClick(e, enableEditable);
        },
        className: className,
        dangerouslySetInnerHTML: {
            __html: __(text)
        }
    });
}, TextEditor_defaultProps, TextEditor_dynamicProps);
TextEditor.craft = withCraft({
    name: 'Text',
    defaultProps: TextEditor_defaultProps,
    settings: TextEditorSettings
});

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/components/Video/VideoSettings.js






var VideoSettings = function() {
    var ref = (0,esm/* useNode */.Zo)(function(node) {
        return {
            customs: node.data.custom,
            props: node.data.props
        };
    }), customs = ref.customs, props = ref.props;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ToolbarSection_ToolbarSection, {
            title: "Settings",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolbarSection_ToolbarSection, {
                    title: "Con url",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolbarItem, {
                        propKey: "block",
                        propSubKey: "src",
                        type: "text",
                        label: "URL",
                        description: "Paste your url",
                        dynamic: Video_dynamicProps.includes('src') && customs.dynamicData,
                        dynamicValues: customs.dynamicData ? getAllPaths(customs.dynamicData) : [],
                        defaultValue: Video_defaultProps.src
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ToolbarSection_ToolbarSection, {
                    title: "Con provider",
                    description: "*Nota: per utilizzare il provider \xe8 necessario lasciare vuoto il campo url",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolbarItem, {
                            propKey: "block",
                            propSubKey: "provider",
                            type: "select",
                            label: "Provider",
                            values: Object.keys(providers),
                            dynamic: Video_dynamicProps.includes('provider') && customs.dynamicData,
                            dynamicValues: customs.dynamicData ? getAllPaths(customs.dynamicData) : [],
                            defaultValue: Video_defaultProps.provider
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolbarItem, {
                            propKey: "block",
                            propSubKey: "videoId",
                            type: "text",
                            label: "Video ID",
                            dynamic: Video_dynamicProps.includes('videoId') && customs.dynamicData,
                            dynamicValues: customs.dynamicData ? getAllPaths(customs.dynamicData) : [],
                            defaultValue: Video_defaultProps.videoId
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolbarItem, {
                            propKey: "block",
                            propSubKey: "autoplay",
                            type: "switch",
                            label: "Autoplay",
                            dynamic: Video_dynamicProps.includes('autoplay') && customs.dynamicData,
                            dynamicValues: customs.dynamicData ? getAllPaths(customs.dynamicData) : [],
                            defaultValue: Video_defaultProps.autoplay
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolbarItem, {
                            propKey: "block",
                            propSubKey: "loop",
                            type: "switch",
                            label: "Loop",
                            dynamic: Video_dynamicProps.includes('loop') && customs.dynamicData,
                            dynamicValues: customs.dynamicData ? getAllPaths(customs.dynamicData) : [],
                            defaultValue: Video_defaultProps.loop
                        }),
                        props.block.provider !== 'vimeo' && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolbarItem, {
                                    propKey: "block",
                                    propSubKey: "controls",
                                    type: "switch",
                                    label: "Controls",
                                    dynamic: Video_dynamicProps.includes('controls') && customs.dynamicData,
                                    dynamicValues: customs.dynamicData ? getAllPaths(customs.dynamicData) : [],
                                    defaultValue: Video_defaultProps.controls
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolbarItem, {
                                    propKey: "block",
                                    propSubKey: "related",
                                    type: "switch",
                                    label: "Related",
                                    dynamic: Video_dynamicProps.includes('related') && customs.dynamicData,
                                    dynamicValues: customs.dynamicData ? getAllPaths(customs.dynamicData) : [],
                                    defaultValue: Video_defaultProps.related
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolbarItem, {
                                    propKey: "block",
                                    propSubKey: "modest",
                                    type: "switch",
                                    label: "Modest",
                                    dynamic: Video_dynamicProps.includes('modest') && customs.dynamicData,
                                    dynamicValues: customs.dynamicData ? getAllPaths(customs.dynamicData) : [],
                                    defaultValue: Video_defaultProps.modest
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/components/Video/index.js







function Video_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Video_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Video_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var providers = {
    youtube: {
        url: 'https://www.youtube.com/embed/'
    },
    youtube_nocookie: {
        url: 'https://www.youtube-nocookie.com/embed/'
    },
    vimeo: {
        url: 'https://player.vimeo.com/video/'
    }
};
var Video_defaultProps = {
    src: '',
    provider: 'youtube',
    videoId: '',
    autoplay: false,
    loop: false,
    controls: true,
    related: true,
    modest: false
};
var Video_dynamicProps = [
    'src'
];
var Video_Video = withBlock(function(props) {
    var blockProps = Video_objectSpread({}, Video_defaultProps, props.block);
    var src = blockProps.src, provider = blockProps.provider, videoId = blockProps.videoId, autoplay = blockProps.autoplay, loop = blockProps.loop, controls = blockProps.controls, related = blockProps.related, modest = blockProps.modest;
    var _ = props.renderValue;
    var enabled = (0,esm/* useEditor */.jE)(function(state) {
        return {
            enabled: state.options.enabled
        };
    }).enabled;
    var ref1 = (0,esm/* useNode */.Zo)(function(state) {
        return {
            selected: state.events.selected,
            dragged: state.events.dragged,
            hovered: state.events.hovered,
            customs: state.data.custom
        };
    }), id = ref1.id, _connectors = ref1.connectors, connect = _connectors.connect, drag = _connectors.drag, selected = ref1.selected, hovered = ref1.hovered, _actions = ref1.actions, setProp = _actions.setProp, setCustom = _actions.setCustom, customs = ref1.customs;
    var getSrc = function() {
        if (src) {
            return _(src);
        }
        if (provider) {
            var url = providers[provider].url + videoId + '?';
            if (autoplay) {
                url += '&autoplay=1';
            }
            if (loop) {
                url += "&loop=1&playlist=".concat(videoId);
            }
            if (provider !== 'vimeo') {
                if (!controls) {
                    url += '&controls=0&showinfo=0';
                }
                if (!related) {
                    url += '&rel=0';
                }
                if (modest) {
                    url += '&modestbranding=1';
                }
            }
            return url;
        }
        return _(src);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: function(ref) {
            return props.retRef(ref);
        },
        className: 'block-video ' + props.className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
            src: getSrc(),
            frameBorder: "0",
            allowFullScreen: "1",
            allow: enabled ? '' : 'autoplay',
            style: {
                pointerEvents: enabled ? 'none' : 'auto',
                width: '100%',
                height: '100%'
            }
        })
    }));
}, Video_defaultProps, Video_dynamicProps);
Video_Video.craft = withCraft({
    name: 'Video',
    defaultProps: Video_defaultProps,
    settings: VideoSettings
});

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/components/index.js













// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
// EXTERNAL MODULE: ../../libs/shared-ui/src/atoms/Icons/index.ts + 104 modules
var Icons = __webpack_require__(10196);
;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/editor/FloatingSettings.js





var FloatingSettings = function(param) {
    var parentPos = param.parentPos;
    var ref = (0,esm/* useEditor */.jE)(function(state) {
        return {
            selected: state.events.selected
        };
    }), selected = ref.selected, query = ref.query, actions = ref.actions;
    var ref1 = (0,react.useContext)(globalContext_GlobalContext), floatingSettingsOpen = ref1.floatingSettingsOpen, setFloatingSettingsOpen = ref1.setFloatingSettingsOpen, setSidebarTab = ref1.setSidebarTab;
    var ref2 = (0,react.useState)(), pos1 = ref2[0], setPos = ref2[1];
    (0,react.useEffect)(function() {
        if (parentPos) {
            var left = parentPos.left;
            var top = parentPos.top;
            var screenW = window.innerWidth;
            var screenH = window.innerHeight;
            var pos = {};
            if (left > screenW / 2) {
                pos['right'] = '0';
            } else {
                pos['left'] = '2px';
            }
            if (top > screenH / 2) {
                pos['bottom'] = 'calc(100% + 10px)';
            } else {
                pos['top'] = 'calc(100% + 10px)';
            }
            setPos(pos);
            setVisible(true);
        }
    }, [
        parentPos
    ]);
    var ref3 = (0,react.useState)(), visible = ref3[0], setVisible = ref3[1];
    var ref4 = (0,react.useState)(), node1 = ref4[0], setNode = ref4[1];
    (0,react.useEffect)(function() {
        if (selected) {
            var node = query.node(selected).get();
            setNode(node);
        }
    }, [
        selected
    ]);
    var onShowAllSettings = function() {
        setSidebarTab('tab-options');
        setFloatingSettingsOpen(false);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: floatingSettingsOpen && visible && node1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "floating-settings-menu",
            style: pos1,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "floating-settings-menu-header",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "floating-settings-menu-header-title",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                children: [
                                    node1.data.name,
                                    " Options"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "floating-settings-menu-header-close",
                            onClick: function() {
                                return setFloatingSettingsOpen(false);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.Close, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "floating-settings-menu-content",
                    children: /*#__PURE__*/ react.createElement(node1.related.floatingToolbar)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "floating-settings-menu-footer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        onClick: function() {
                            return onShowAllSettings();
                        },
                        children: [
                            "Show All Options ",
                            '>'
                        ]
                    })
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/editor/RenderNode.js



//import { FaArrowUp, FaTrash, FaArrowsAlt, FaClone, FaSyncAlt, FaCog } from 'react-icons/fa'








var RenderNode = function(param) {
    var render = param.render;
    var ref3 = (0,esm/* useEditor */.jE)(), actions = ref3.actions, query = ref3.query;
    var ref1 = (0,esm/* useNode */.Zo)(function(node) {
        return {
            isActive: node.events.selected,
            isHover: node.events.hovered,
            dom: node.dom,
            name: node.data.name,
            parent: node.data.parent,
            type: node.data.type
        };
    }), id = ref1.id, isActive = ref1.isActive, isHover = ref1.isHover, dom1 = ref1.dom, name = ref1.name, drag = ref1.connectors.drag, parent = ref1.parent, type = ref1.type;
    var ref2 = (0,react.useContext)(globalContext_GlobalContext), floatingSettingsOpen = ref2.floatingSettingsOpen, setFloatingSettingsOpen = ref2.setFloatingSettingsOpen;
    (0,react.useEffect)(function() {
        if (!isActive) {
            setFloatingSettingsOpen(false);
        }
    }, [
        isActive
    ]);
    var currentRef = (0,react.useRef)();
    var deletable = node_isDeletable(id, query);
    var moveable = isMoveable(id, query);
    var clonable = isClonable(id, query);
    var parentSelectable = isParentSelectable(id);
    var global = isGlobal(id, query);
    var disabled = node_isDisabled(id, query);
    var getPos = (0,react.useCallback)(function(dom) {
        var ref = dom ? dom.getBoundingClientRect() : {
            top: 0,
            left: 0,
            bottom: 0
        }, top = ref.top, left = ref.left, bottom = ref.bottom;
        return {
            top: top > 0 ? top : bottom,
            left: left,
            bottom: bottom
        };
    }, [
        dom1
    ]);
    var scroll = (0,react.useCallback)(function() {
        var currentDOM = currentRef.current;
        if (!currentDOM) return;
        var ref = getPos(dom1), top = ref.top, left = ref.left;
        currentDOM.style.top = "".concat(top, "px");
        currentDOM.style.left = "".concat(left, "px");
    }, [
        dom1
    ]);
    (0,react.useEffect)(function() {
        var dom2 = document.querySelector('.craftjs-renderer');
        if (dom2) {
            dom2.addEventListener('scroll', scroll);
        }
        return function() {
            var dom = document.querySelector('.craftjs-renderer');
            if (dom) {
                dom.removeEventListener('scroll', scroll);
            }
        };
    }, [
        scroll
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !disabled && (isHover || isActive) && /*#__PURE__*/ react_dom.createPortal(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                ref: currentRef,
                className: "component-menu component-menu-".concat(global ? 'global' : isActive ? 'selected' : 'hovered'),
                style: {
                    left: "".concat(getPos(dom1).left, "px"),
                    top: "".concat(getPos(dom1).top, "px")
                },
                children: [
                    global && /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        children: "Global -  "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "component-menu__name",
                        children: name
                    }),
                    isActive && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "component-menu__actions",
                        children: [
                            moveable && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "cursor-move",
                                ref: drag,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_WireframeMode, {})
                            }),
                            parentSelectable && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "cursor-pointer",
                                onClick: function() {
                                    actions.selectNode(parent);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_ChevronUp, {})
                            }),
                            clonable && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "cursor-pointer",
                                onClick: function() {
                                    var idToClone = id;
                                    var parentToClone = parent;
                                    var parentType = query.node(parent).get().data.type;
                                    if (parentType === Text_Text) {
                                        idToClone = parent;
                                        parentToClone = query.node(parent).get().data.parent;
                                    }
                                    var nodeTree = cloneNodeTree(idToClone, query);
                                    var index = query.node(parentToClone).get().data.nodes.indexOf(idToClone);
                                    node_addNodeTree(nodeTree, parentToClone, actions, false, index + 1);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_PlusCopy, {})
                            }),
                            deletable && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "cursor-pointer",
                                onClick: function(e) {
                                    e.stopPropagation();
                                    var parentType = query.node(parent).get().data.type;
                                    if (parentType === Text_Text) {
                                        deleteNodeTree(parent, actions);
                                    } else {
                                        deleteNodeTree(id, actions);
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Bin, {})
                            }),
                            name === 'DynamicDataBlock' && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "cursor-pointer",
                                onClick: function() {
                                    update(id, query, actions);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_ChevronDown, {})
                            }),
                            id !== esm/* ROOT_NODE */.QS && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "cursor-pointer",
                                        onClick: function() {
                                            setFloatingSettingsOpen(!floatingSettingsOpen);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Options, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FloatingSettings, {
                                        parentPos: {
                                            left: getPos(dom1).left,
                                            top: getPos(dom1).top
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }), document.body),
            render
        ]
    }));
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/hooks/useInterval.js

/*

Vedi 2° risposta a https://stackoverflow.com/questions/57476683/setinterval-is-not-showing-updated-state

spiegazione completa: https://overreacted.io/making-setinterval-declarative-with-react-hooks/

*/ var useInterval = function(callback, delay) {
    var savedCallback = useRef();
    useEffect(function() {
        savedCallback.current = callback;
    });
    useEffect(function() {
        var tick = function tick() {
            savedCallback.current();
        };
        var id = setInterval(tick, delay);
        return function() {
            return clearInterval(id);
        };
    }, [
        delay
    ]);
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/hooks/useTimeout.js

/*

https://medium.com/javascript-in-plain-english/usetimeout-react-hook-3cc58b94af1f

*/ /* export const useTimeout = (callback, timeout = 0) => {
      const timeoutIdRef = useRef();
      const cancel = useCallback(
          () => {
              const timeoutId = timeoutIdRef.current;
              if (timeoutId) {
                  timeoutIdRef.current = undefined;
                  clearTimeout(timeoutId);
              }
          },
          [timeoutIdRef],
      );
  
      useEffect(
          () => {
              timeoutIdRef.current = setTimeout(callback, timeout);
              return cancel;
          },
          [callback, timeout, cancel],
      );
  
      return cancel;
  } */ /*
    https://github.com/rally25rs/react-use-timeout
*/ function useTimeout_useTimeout(callback) {
    var timeout = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var timeoutId = (0,react.useRef)();
    var handler = (0,react.useMemo)(function() {
        return {
            start: function start(overrideTimeout) {
                handler.stop();
                timeoutId.current = setTimeout(callback, overrideTimeout === undefined ? timeout : overrideTimeout);
            },
            stop: function stop() {
                if (timeoutId.current) {
                    clearTimeout(timeoutId.current);
                }
            },
            restart: function restart() {
                handler.stop();
                handler.start();
            }
        };
    }, [
        callback,
        timeout
    ]);
    (0,react.useEffect)(function() {
        return function() {
            handler.stop();
        };
    }, []);
    return handler;
}

// EXTERNAL MODULE: ../../node_modules/file-saver/dist/FileSaver.min.js
var FileSaver_min = __webpack_require__(46782);
;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/editor/Viewport/Topbar/index.js












function Topbar_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Topbar_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Topbar_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var TopbarButton = function(param) {
    var id = param.id, label = param.label, icon = param.icon, tooltip = param.tooltip, onClick = param.onClick, disabled = param.disabled, href = param.href, blank = param.blank, status = param.status;
    var clickHandle = function(event) {
        if (disabled) {
            return;
        } else {
            onClick();
        }
    };
    var content = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            label && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: label
            }),
            icon && icon
        ]
    });
    var wrappedContent = href ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        className: "topbar__item".concat(status ? " topbar__item--".concat(status) : '', " topbar__item--").concat(id).concat(disabled ? ' disabled' : ''),
        href: href,
        target: blank ? '_blank' : '',
        children: content
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "topbar__item".concat(status ? " topbar__item--".concat(status) : '', " topbar__item--").concat(id).concat(disabled ? ' disabled' : ''),
        onClick: clickHandle,
        children: content
    });
    return tooltip ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip_Tooltip, {
        id: id,
        pos: "bottom",
        label: tooltip,
        children: wrappedContent
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: wrappedContent
    });
};
var Topbar = function() {
    var ref = (0,esm/* useEditor */.jE)(function(state, query) {
        return {
            selectedNodeId: state.events.selected,
            enabled: state.options.enabled,
            canUndo: query.history.canUndo(),
            canRedo: query.history.canRedo()
        };
    }), query1 = ref.query, actions = ref.actions, selectedNodeId = ref.selectedNodeId, enabled = ref.enabled, canUndo = ref.canUndo, canRedo = ref.canRedo;
    var ref1 = (0,react.useContext)(globalContext_GlobalContext), contentTypeId = ref1.contentTypeId, objectId = ref1.objectId, pkey = ref1.pkey, setShowImport = ref1.setShowImport, previewMode = ref1.previewMode, setPreviewMode = ref1.setPreviewMode, wireframeMode = ref1.wireframeMode, setWireframeMode = ref1.setWireframeMode;
    var ref2 = (0,react.useContext)(PagebuilderContext), pagebuilder = ref2.pagebuilder, isLoading = ref2.isLoading, saveDraft = ref2.saveDraft, publish = ref2.publish, unpublish = ref2.unpublish;
    var ref3 = (0,react.useState)(false), viewMore = ref3[0], setViewMore = ref3[1];
    var printInfo = function() {
        console.log(query1.getSerializedNodes());
        console.log(query1.serialize());
        if (selectedNodeId) {
            console.log(query1.node(selectedNodeId));
            console.log(query1.node(selectedNodeId).get());
        }
    };
    var clearCanvas = function() {
        var nodesToDelete = query1.node(esm/* ROOT_NODE */.QS).get().data.nodes;
        nodesToDelete.forEach(function(nodeId) {
            actions.history.throttle(100).delete(nodeId);
        });
    };
    var ref4 = (0,react.useState)(false), draftsDifferent = ref4[0], setDraftsDifferent = ref4[1];
    var removeCustoms = function(data) {
        var json = JSON.parse(data);
        var obj = {};
        Object.keys(json).forEach(function(nodeId) {
            obj[nodeId] = json[nodeId];
            obj[nodeId]['custom'] = {};
        });
        return JSON.stringify(obj);
    };
    // auto-save
    var ref5 = (0,react.useState)(false), autoSaveEnabled = ref5[0], setAutoSaveEnabled = ref5[1];
    var ref6 = (0,react.useState)(false), needToSave = ref6[0], setNeedToSave = ref6[1];
    var save = function() {
        saveToDb();
        setNeedToSave(false);
    };
    var timeout = useTimeout_useTimeout(save, 4000); // ogni 4 secondi prova a salvare
    var saveToDb = function() {
        var data = query1.serialize();
        saveDraft(data);
    // setDraftsDifferent(false)
    };
    var sendMessage = function(data) {
        if (window.parent) {
            window.parent.postMessage(Topbar_objectSpread({
                source: 'pagebuilder'
            }, data), '*');
        }
    };
    // fix setOptions problem
    var changeEdit = function() {
        var toPreviewMode = !previewMode;
        actions.setOptions(function(options) {
            options.enabled = !toPreviewMode;
        });
        setPreviewMode(toPreviewMode);
    };
    (0,react.useEffect)(function() {
        if (previewMode) {
            sendMessage({
                preview: true
            });
        } else {
            sendMessage({
                preview: false
            });
        }
    }, [
        previewMode
    ]);
    var onNodesChange = function(query) {
        if (autoSaveEnabled) {
            setNeedToSave(true);
            timeout.restart();
        }
        if (removeCustoms(query.serialize()) === pagebuilder.json_draft) {
            setDraftsDifferent(false);
        } else {
            setDraftsDifferent(true);
        }
    };
    (0,react.useEffect)(function() {
        if (pagebuilder) {
            if (removeCustoms(query1.serialize()) === pagebuilder.json_draft) {
                setDraftsDifferent(false);
            } else {
                setDraftsDifferent(true);
            }
        }
    }, [
        pagebuilder
    ]);
    (0,react.useEffect)(function() {
        actions.setOptions(function(options) {
            return options.onNodesChange = onNodesChange;
        });
    }, [
        autoSaveEnabled,
        pagebuilder
    ]);
    var exportPagebuilder = function() {
        api_api.getPagebuilderJsonFile({
            id: pagebuilder.id
        }).then(function(data) {
            var file = new File([
                JSON.stringify(data)
            ], "pagebuilder-".concat(pagebuilder.id, ".json"), {
                type: 'application/json'
            });
            (0,FileSaver_min.saveAs)(file);
        }).catch(function(err) {
            console.log(err);
        });
    };
    var ref7 = (0,react.useState)(false), fullscreen = ref7[0], setFullscreen = ref7[1];
    var openFullScreen = function() {
        if (fullscreen) return;
        var element = parent.document.documentElement;
        if (!element) return;
        if (element.requestFullscreen) {
            element.requestFullscreen();
        } else if (element.webkitRequestFullscreen) {
            /* Safari */ element.webkitRequestFullscreen();
        } else if (element.msRequestFullscreen) {
            /* IE11 */ element.msRequestFullscreen();
        }
        setFullscreen(true);
    };
    var closeFullScreen = function() {
        if (!fullscreen) return;
        if (!parent.document) return;
        if (parent.document.exitFullscreen) {
            parent.document.exitFullscreen();
        } else if (parent.document.webkitExitFullscreen) {
            /* Safari */ parent.document.webkitExitFullscreen();
        } else if (parent.document.msExitFullscreen) {
            /* IE11 */ parent.document.msExitFullscreen();
        }
        setFullscreen(false);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "topbar",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "topbar__items topbar__items--previews",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Previews:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TopbarButton, {
                        id: "preview-mode",
                        onClick: changeEdit,
                        icon: !previewMode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_VisibilityOff, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_VisibilityOn, {}),
                        tooltip: previewMode ? 'Preview ON' : 'Preview OFF'
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TopbarButton, {
                        id: "draft-preview",
                        href: "/pagebuilder?contentTypeId=".concat(contentTypeId, "&objectId=").concat(objectId, "&key=").concat(pkey, "&editMode=false&draft=true"),
                        blank: true,
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Preview, {}),
                        tooltip: "Open draft preview"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TopbarButton, {
                        id: "preview",
                        href: "/pagebuilder?contentTypeId=".concat(contentTypeId, "&objectId=").concat(objectId, "&key=").concat(pkey, "&editMode=false"),
                        blank: true,
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Preview, {}),
                        tooltip: "Open preview"
                    })
                ]
            }),
            !previewMode ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "topbar__items topbar__items--main",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TopbarButton, {
                                id: "save-status",
                                status: draftsDifferent ? autoSaveEnabled ? 'warning' : 'error' : 'success',
                                label: draftsDifferent ? autoSaveEnabled ? 'Modified...' : 'Unsaved changes' : 'Saved',
                                icon: draftsDifferent ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Edit, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Check, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TopbarButton, {
                                id: "fullscreen",
                                onClick: fullscreen ? closeFullScreen : openFullScreen,
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Fullscreen, {}),
                                tooltip: 'Fullscreen'
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TopbarButton, {
                                id: "undo",
                                onClick: function() {
                                    return actions.history.undo();
                                },
                                disabled: !canUndo,
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Undo, {}),
                                tooltip: canUndo ? 'Undo' : 'Nothing to undo'
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TopbarButton, {
                                id: "redo",
                                onClick: function() {
                                    return actions.history.redo();
                                },
                                disabled: !canRedo,
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Redo, {}),
                                tooltip: canRedo ? 'Redo' : 'Nothing to redo'
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TopbarButton, {
                                id: "delete",
                                onClick: clearCanvas,
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Bin, {}),
                                tooltip: "Delete all"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TopbarButton, {
                                id: "save-draft",
                                onClick: saveToDb,
                                disabled: !draftsDifferent,
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Save, {}),
                                tooltip: "Save draft"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TopbarButton, {
                                id: "publish",
                                onClick: publish,
                                disabled: pagebuilder.json_draft === pagebuilder.json_published,
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Publish, {}),
                                tooltip: "Publish"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TopbarButton, {
                                id: "unpublish",
                                onClick: unpublish,
                                disabled: pagebuilder.draft,
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Unpublish, {}),
                                tooltip: "Unpublish"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "topbar__items topbar__items--advanced ".concat(viewMore ? 'visible' : ''),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TopbarButton, {
                                id: "export",
                                onClick: exportPagebuilder,
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Export, {}),
                                tooltip: "Export"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TopbarButton, {
                                id: "import",
                                onClick: function() {
                                    return setShowImport(true);
                                },
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Import, {}),
                                tooltip: "Import from pagebuilder"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TopbarButton, {
                                id: "autosave",
                                onClick: function() {
                                    return setAutoSaveEnabled(!autoSaveEnabled);
                                },
                                icon: autoSaveEnabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_LockClose, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_LockOpen, {}),
                                tooltip: autoSaveEnabled ? 'Autosave ENABLED' : 'Autosave DISABLED'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "topbar__items topbar__items--more",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TopbarButton, {
                            id: "more",
                            onClick: function() {
                                return setViewMore(!viewMore);
                            },
                            tooltip: viewMore ? 'Hide advanced options' : 'Show advanced actions',
                            icon: viewMore ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Close, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_More, {})
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "topbar__items topbar__items__center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TopbarButton, {
                        id: "device-desktop",
                        onClick: function() {
                            return sendMessage({
                                format: 'desktop'
                            });
                        },
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Desktop, {}),
                        tooltip: "Desktop"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TopbarButton, {
                        id: "device-tablet",
                        onClick: function() {
                            return sendMessage({
                                format: 'tablet'
                            });
                        },
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Tablet, {}),
                        tooltip: "Tablet"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TopbarButton, {
                        id: "device-mobile-landscape",
                        onClick: function() {
                            return sendMessage({
                                format: 'mobile-landscape'
                            });
                        },
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_SmartphoneLandscape, {}),
                        tooltip: "Mobile Landscape"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TopbarButton, {
                        id: "device-mobile-portrait",
                        onClick: function() {
                            return sendMessage({
                                format: 'mobile-portrait'
                            });
                        },
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Smartphone, {}),
                        tooltip: "Mobile"
                    })
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/editor/Viewport/Sidebar/Toolbar/index.js





var Toolbar = function() {
    var ref = (0,esm/* useEditor */.jE)(function(state) {
        return {
            selected: state.events.selected,
            related: state.events.selected && state.nodes[state.events.selected].related
        };
    }), selected = ref.selected, related = ref.related, query = ref.query;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: selected && selected !== esm/* ROOT_NODE */.QS && !node_isDisabled(selected, query) && related.toolbar ? /*#__PURE__*/ react.createElement(related.toolbar) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "empty-message",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Click on a component to start editing."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Click, {})
            ]
        })
    }));
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/editor/Viewport/Sidebar/Layers/index.js



//import { FaChevronUp, FaChevronDown, FaEye, FaEyeSlash } from 'react-icons/fa'


function Layers_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function Layers_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return Layers_arrayLikeToArray(arr);
}
function Layers_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function Layers_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Layers_toConsumableArray(arr) {
    return Layers_arrayWithoutHoles(arr) || Layers_iterableToArray(arr) || Layers_unsupportedIterableToArray(arr) || Layers_nonIterableSpread();
}
function Layers_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return Layers_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Layers_arrayLikeToArray(o, minLen);
}
var TreeNode = function(param) {
    var id = param.id, level = param.level, defaultOpen = param.open;
    var ref3 = useEditor(function(state) {
        return {
            selected: state.events.selected,
            nodes: state.nodes
        };
    }), selected = ref3.selected, query = ref3.query, actions = ref3.actions, nodes = ref3.nodes, connectors = ref3.connectors;
    var ref1 = useState(defaultOpen), open = ref1[0], setOpen = ref1[1];
    var ref2 = useState(), nodeDetail = ref2[0], setNodeDetail = ref2[1];
    useEffect(function() {
        if (id && !isDisabled(id, query)) {
            setNodeDetail(query.node(id).get());
        }
    }, [
        id,
        nodes
    ]);
    var onSelectNode = function() {
        actions.selectNode(id);
        document.getElementsByClassName(id)[0].scrollIntoView({
            behaviour: 'smooth'
        });
    };
    var onOpenTree = function(event) {
        event.stopPropagation();
        setOpen(!open);
    };
    var onHide = function() {
        var hidden = nodeDetail.data.hidden;
        actions.history.ignore().setHidden(id, !hidden);
    };
    return(/*#__PURE__*/ _jsx(_Fragment, {
        children: nodeDetail && /*#__PURE__*/ _jsxs("div", {
            className: "tree-node-container",
            ref: function(ref) {
                return connectors.hover(ref, id);
            },
            onDoubleClick: function(e) {
                return onOpenTree(e);
            },
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "tree-node-header ".concat(selected === id ? 'tree-node-header__active' : ''),
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            onClick: function() {
                                return onSelectNode();
                            },
                            children: [
                                Layers_toConsumableArray(Array(level)).map(function(e, i) {
                                    /*#__PURE__*/ return _jsx("span", {
                                        children: "--"
                                    }, i);
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    children: " "
                                }),
                                /*#__PURE__*/ _jsxs("span", {
                                    children: [
                                        nodeDetail.data.displayName,
                                        ' ',
                                        nodeDetail.data.nodes.length !== 0 && "(".concat(nodeDetail.data.nodes.length, ")")
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "tree-node-header-end",
                            children: [
                                isDeletable(id, query) && /*#__PURE__*/ _jsx("div", {
                                    onClick: function() {
                                        return onHide();
                                    },
                                    children: nodeDetail.data.hidden ? /*#__PURE__*/ _jsx(Preview, {}) : /*#__PURE__*/ _jsx(PreviewMode, {})
                                }),
                                nodeDetail.data.nodes.length !== 0 && /*#__PURE__*/ _jsx("div", {
                                    onClick: function(e) {
                                        return onOpenTree(e);
                                    },
                                    children: open ? /*#__PURE__*/ _jsx(ChevronUp, {}) : /*#__PURE__*/ _jsx(ChevronDown, {})
                                })
                            ]
                        })
                    ]
                }),
                open && nodeDetail.data.nodes.map(function(nodeId) {
                    return(/*#__PURE__*/ _jsx(TreeNode, {
                        id: nodeId,
                        level: level + 1,
                        open: defaultOpen
                    }, nodeId));
                })
            ]
        })
    }));
};
var Layers = function(param) {
    var open = param.open;
    var ref = useEditor(function(state) {
        return {
            selected: state.events.selected,
            nodes: state.nodes
        };
    }), selected = ref.selected, nodes = ref.nodes, query = ref.query, actions = ref.actions;
    return(/*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx(TreeNode, {
            id: ROOT_NODE,
            level: 0,
            open: open
        })
    }));
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/editor/Viewport/Sidebar/Toolbox/conf.js




var TEXT = /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Element */.W_, {
    is: Text_Text,
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextEditor, {
        block: {
            text: '<p>Hello world!</p>',
            className: 'text__content'
        }
    })
});
var BUTTON = /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Element */.W_, {
    is: components_Button_Button,
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextEditor, {
        block: {
            text: 'Click me\n',
            noHtml: true
        }
    })
});
var IMAGE = /*#__PURE__*/ (0,jsx_runtime.jsx)(Image_Image, {
    block: {
        src: 'https://www.w3schools.com/css/paris.jpg'
    }
});
var PDF_LINK = /*#__PURE__*/ (0,jsx_runtime.jsx)(PdfLink_PdfLink, {
    block: {
        src: 'https://www.w3schools.com/css/paris.jpg'
    }
});
var VIDEO = /*#__PURE__*/ (0,jsx_runtime.jsx)(Video_Video, {
    block: {
        src: ''
    }
});
var TABS = /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Element */.W_, {
    is: Tabs_Tabs,
    children: [
        /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Element */.W_, {
            is: TabsMenu,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextEditor, {
                    block: {
                        text: 'Tab 1\n',
                        noHtml: true
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextEditor, {
                    block: {
                        text: 'Tab 2\n',
                        noHtml: true
                    }
                })
            ]
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Element */.W_, {
            is: TabsContent,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Element */.W_, {
                    is: TabPane,
                    canvas: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Element */.W_, {
                    is: TabPane,
                    canvas: true
                })
            ]
        })
    ]
});
// possibilità di inserire icona per il block
var conf_conf = [
    {
        title: 'Basic',
        blocks: {
            text: {
                name: 'Text',
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Text, {}),
                block: TEXT
            },
            button: {
                name: 'Button',
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Button, {}),
                block: BUTTON
            },
            pdf_link: {
                name: 'PdfLink',
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(PdfLink, {}),
                block: PDF_LINK
            },
            image: {
                name: 'Image',
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Image, {}),
                block: IMAGE
            },
            video: {
                name: 'Video',
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Video, {}),
                block: VIDEO
            },
            tabs: {
                name: 'Tabs',
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Tabs, {}),
                block: TABS
            }
        }
    }, 
];

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/editor/Viewport/Sidebar/Toolbox/index.js









var Toolbox = function() {
    var ref3 = useEditor(function(state) {
        return {
            selectedNodeId: state.events.selected
        };
    }), create = ref3.connectors.create, query = ref3.query, actions = ref3.actions, selectedNodeId = ref3.selectedNodeId;
    var ref1 = useContext(CustomBlocksContext), customBlocksObject = ref1.customBlocks, deleteCustomBlock = ref1.deleteCustomBlock;
    var ref2 = useState(), customBlocks = ref2[0], setCustomBlocks = ref2[1];
    useEffect(function() {
        if (customBlocksObject) {
            var tmp = [];
            customBlocksObject.forEach(function(block) {
                var newBlock = JSON.parse(JSON.stringify(block));
                var serializedNodeTree = JSON.parse(block.json_content);
                var nodeTree = deserializeNodeTree(serializedNodeTree, query);
                newBlock['nodeTree'] = nodeTree;
                var element = parseNodeTree(nodeTree, nodeTree['rootNodeId']);
                newBlock['element'] = element;
                tmp.push(newBlock);
            });
            setCustomBlocks(tmp);
        }
    }, [
        customBlocksObject
    ]);
    var onDeleteCustomBlock = function(name) {
        deleteCustomBlock(name);
    };
    var addBlock = function(element) {
        var nodeTree = query.parseReactElement(element).toNodeTree();
        var currentNode = nodeTree['nodes'][nodeTree['rootNodeId']];
        var targetNode = null;
        if (selectedNodeId) {
            targetNode = query.node(selectedNodeId).get();
        } else {
            targetNode = query.node(ROOT_NODE).get();
        }
        if (canDropBlock(currentNode, targetNode)) {
            addNodeTree(nodeTree, targetNode.id, actions);
        } else {
            console.log("Can not drop ".concat(currentNode.data.name, " in ").concat(targetNode.data.name));
        }
    };
    var renderBlock = function(element, name) {
        return(/*#__PURE__*/ _jsx("div", {
            className: "toolbox__tools__item",
            ref: function(ref) {
                return create(ref, element);
            },
            onClick: function() {
                return addBlock(element);
            },
            children: /*#__PURE__*/ _jsx("p", {
                children: name
            })
        }, name));
    };
    return(/*#__PURE__*/ _jsxs("div", {
        className: "toolbox",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "toolbox__tools",
                children: conf.map(function(conf1) {
                    /*#__PURE__*/ return _jsx(ToolbarSection, {
                        title: conf1.title,
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "toolbox__tools__wrapper",
                            children: Object.keys(conf1.blocks).map(function(key) {
                                return renderBlock(conf1.blocks[key].block, conf1.blocks[key].name);
                            })
                        })
                    }, conf1.title);
                })
            }),
            /*#__PURE__*/ _jsx("br", {}),
            /*#__PURE__*/ _jsx(ToolbarSection, {
                title: "Saved",
                children: customBlocks && /*#__PURE__*/ _jsx("div", {
                    className: "toolbox__custom-blocks",
                    children: customBlocks.map(function(block) {
                        return(/*#__PURE__*/ _jsxs("div", {
                            className: "toolbox__custom-blocks__item",
                            children: [
                                renderBlock(block.element, block.name),
                                /*#__PURE__*/ _jsx("div", {
                                    children: /*#__PURE__*/ _jsx("a", {
                                        onClick: function() {
                                            return onDeleteCustomBlock(block.name);
                                        },
                                        children: "delete"
                                    })
                                })
                            ]
                        }, block.name));
                    })
                })
            })
        ]
    }));
};

// EXTERNAL MODULE: ../../node_modules/@craftjs/utils/dist/esm/index.js + 2 modules
var dist_esm = __webpack_require__(82785);
;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/editor/Viewport/Sidebar/AdvancedSettings/CreateCustomBlock/index.js





var CreateCustomBlock_CreateCustomBlock = function(param) {
    var selected = param.selected, onChange = param.onChange;
    var query = useEditor().query;
    var ref = useState(''), name = ref[0], setName = ref[1];
    var ref1 = useState(''), successMessage = ref1[0], setSuccessMessage = ref1[1];
    var ref2 = useState(''), errorMessage = ref2[0], setErrorMessagee = ref2[1];
    var addCustomBlock = useContext(CustomBlocksContext).addCustomBlock;
    var onCreateCustomBlock = function() {
        var nodes = query.node(selected).toNodeTree();
        var serializedNodes = serializeNodeTree(nodes, query);
        var json_content = JSON.stringify(serializedNodes);
        addCustomBlock(name, json_content).then(function(data) {
            setErrorMessagee('');
            setSuccessMessage('Custom Block creato con successo');
        }).catch(function(err) {
            setSuccessMessage('');
            setErrorMessagee('Impossibile creare il Custom Block');
        });
    };
    return(/*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("p", {
                children: "Name"
            }),
            successMessage && /*#__PURE__*/ _jsx("p", {
                style: {
                    color: 'green'
                },
                children: successMessage
            }),
            errorMessage && /*#__PURE__*/ _jsx("p", {
                style: {
                    color: 'red'
                },
                children: errorMessage
            }),
            /*#__PURE__*/ _jsx("input", {
                type: "text",
                onChange: function(e) {
                    return setName(e.target.value);
                }
            }),
            /*#__PURE__*/ _jsx("button", {
                onClick: function() {
                    return onCreateCustomBlock();
                },
                children: "Create"
            }),
            /*#__PURE__*/ _jsx("button", {
                onClick: function() {
                    return onChange(false);
                },
                children: "Cancel"
            })
        ]
    }));
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/editor/Viewport/Sidebar/AdvancedSettings/CreateGlobalCustomBlock/index.js





var CreateGlobalCustomBlock = function(param) {
    var selected = param.selected, onChange = param.onChange;
    var ref = useEditor(), query = ref.query, actions = ref.actions;
    var ref1 = useState(''), name = ref1[0], setName = ref1[1];
    var ref2 = useState(''), successMessage = ref2[0], setSuccessMessage = ref2[1];
    var ref3 = useState(''), errorMessage = ref3[0], setErrorMessagee = ref3[1];
    var addGlobalCustomBlock = useContext(GlobalCustomBlocksContext).addGlobalCustomBlock;
    var onCreateGlobalCustomBlock = function() {
        var nodes = query.node(selected).toNodeTree();
        var serializedNodes = serializeNodeTree(nodes, query);
        var json_content = JSON.stringify(serializedNodes);
        // lo aggiungo al DB e allo store
        addGlobalCustomBlock(name, json_content).then(function(data) {
            var globalId = data.id;
            // Aggiungo la custom prop al nodo selezionato (già piazzato => che è diventato GCB)
            actions.setCustom(selected, function(custom) {
                custom['globalId'] = globalId;
            });
            setErrorMessagee('');
            setSuccessMessage('Global Custom Block creato con successo');
        }).catch(function(err) {
            setSuccessMessage('');
            setErrorMessagee('Impossibile creare il Global Custom Block');
        });
    };
    return(/*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("p", {
                children: "Name"
            }),
            successMessage && /*#__PURE__*/ _jsx("p", {
                style: {
                    color: 'green'
                },
                children: successMessage
            }),
            errorMessage && /*#__PURE__*/ _jsx("p", {
                style: {
                    color: 'red'
                },
                children: errorMessage
            }),
            /*#__PURE__*/ _jsx("input", {
                type: "text",
                onChange: function(e) {
                    return setName(e.target.value);
                }
            }),
            /*#__PURE__*/ _jsx("button", {
                onClick: function() {
                    return onCreateGlobalCustomBlock();
                },
                children: "Create"
            }),
            /*#__PURE__*/ _jsx("button", {
                onClick: function() {
                    return onChange(false);
                },
                children: "Cancel"
            })
        ]
    }));
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/editor/Viewport/Sidebar/AdvancedSettings/index.js










var AdvancedSettings = function() {
    var ref = useEditor(function(state) {
        return {
            selected: state.events.selected
        };
    }), selected = ref.selected, query = ref.query;
    var isGlobal = getGlobalId(selected, query) !== null;
    var ref1 = useContext(GlobalCustomBlocksContext), globalCustomBlocks = ref1.globalCustomBlocks, updateGlobalCustomBlock = ref1.updateGlobalCustomBlock;
    var onSaveGlobalCustomBlock = function(nodeId) {
        var globalParentId = getGlobalParent(nodeId, query);
        var nodes = query.node(globalParentId).toNodeTree();
        var serializedNodes = serializeNodeTree(nodes, query);
        var json_content = JSON.stringify(serializedNodes);
        var id = getGlobalId(globalParentId, query);
        var name = globalCustomBlocks.find(function(block) {
            return block.id === id;
        }).name;
        // lo modifico sul DB e nello store
        updateGlobalCustomBlock(id, name, json_content).then(function(data) {
            console.log(data);
        }).catch(function(err) {
            console.log(err);
        });
    };
    var isAdvancedSettingsAllowed = function() {
        if (!selected) {
            return false;
        }
        if (selected === ROOT_NODE) {
            return false;
        }
        if (isDisabled(selected, query)) {
            return false;
        }
        var parent = query.node(selected).get().data.parent;
        var parentNode = query.node(parent).get();
        var ancestors = getAncestors(selected, query);
        var ddb = ancestors.find(function(nodeId) {
            return query.node(nodeId).get().data.name === 'DynamicDataBlock';
        });
        if (ddb) {
            return false;
        }
        return true;
    };
    return(/*#__PURE__*/ _jsx(_Fragment, {
        children: isAdvancedSettingsAllowed() ? /*#__PURE__*/ _jsx(_Fragment, {
            children: /*#__PURE__*/ _jsx(ToolbarSection, {
                title: "Create custom block",
                children: /*#__PURE__*/ _jsx(CreateCustomBlock, {
                    selected: selected
                })
            })
        }) : /*#__PURE__*/ _jsx("div", {
            children: /*#__PURE__*/ _jsx("p", {
                children: "Click on a component to start editing."
            })
        })
    }));
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/editor/Viewport/Sidebar/Conditions/index.js





var Conditions_Conditions = function() {
    var ref = (0,esm/* useEditor */.jE)(function(state) {
        return {
            selected: state.events.selected,
            related: state.events.selected && state.nodes[state.events.selected].related
        };
    }), selected = ref.selected, related = ref.related, query = ref.query;
    var isConditionsAllowed = function() {
        if (!selected) {
            return false;
        }
        if (selected === esm/* ROOT_NODE */.QS) {
            return true;
        }
        if (node_isDisabled(selected, query)) {
            return false;
        }
        var ancestors = node_getAncestors(selected, query);
        var ddb = ancestors.find(function(nodeId) {
            return query.node(nodeId).get().data.name === 'DynamicDataBlock';
        });
        if (ddb) {
            return false;
        }
        return true;
    };
    return isConditionsAllowed() && related.conditions ? /*#__PURE__*/ react.createElement(related.conditions) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "empty-message",
        children: selected ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Conditions for the selected component are not allowed."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Denied, {})
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Click on a component to start editing."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Click, {})
            ]
        })
    });
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/editor/Viewport/Sidebar/index.js










var Sidebar = function() {
    var selectedNodeId = (0,esm/* useEditor */.jE)(function(state) {
        return {
            selectedNodeId: state.events.selected
        };
    }).selectedNodeId;
    var ref = (0,react.useContext)(globalContext_GlobalContext), sidebarTab = ref.sidebarTab, setSidebarTab = ref.setSidebarTab;
    (0,react.useEffect)(function() {
        setSidebarTab('tab-options');
    }, []);
    (0,react.useEffect)(function() {
        if (selectedNodeId) {
            if (sidebarTab === 'tab-blocks') {
                setSidebarTab('tab-options');
            }
        }
    }, [
        selectedNodeId
    ]);
    /* useEffect(() => {
        // By default, react-hotkeys will match hotkey sequences on the keydown event
        // In questo modo, disabilitiamo KeyboardShortcuts nella sidebar
        document.getElementById("sidebar").addEventListener("keydown", (e) => {
            e.stopPropagation()
        })
    }, []) */ return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "sidebar",
        className: "sidebar",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "sidebar__tabs",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "sidebar__tab-item ".concat(sidebarTab === 'tab-options' ? 'sidebar__tab-item--active' : ''),
                        onClick: function() {
                            return setSidebarTab('tab-options');
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Options, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Options"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "sidebar__tab-item ".concat(sidebarTab === 'tab-conditions' ? 'sidebar__tab-item--active' : ''),
                        onClick: function() {
                            return setSidebarTab('tab-conditions');
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Conditions, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "Conditions"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: 'sidebar__tab-content',
                children: [
                    sidebarTab === 'tab-options' && /*#__PURE__*/ (0,jsx_runtime.jsx)(Toolbar, {}),
                    sidebarTab === 'tab-conditions' && /*#__PURE__*/ (0,jsx_runtime.jsx)(Conditions_Conditions, {})
                ]
            })
        ]
    }));
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/editor/Viewport/Bottombar/index.js




var BreadcrumbStep = function(param) {
    var nodeId = param.nodeId, last = param.last;
    var ref2 = (0,esm/* useEditor */.jE)(), query = ref2.query, actions = ref2.actions, connectors = ref2.connectors;
    var ref1 = (0,react.useState)(), node1 = ref1[0], setNode = ref1[1];
    (0,react.useEffect)(function() {
        if (nodeId) {
            var node = query.node(nodeId).get();
            if (node) {
                setNode(node);
            }
        }
    }, [
        nodeId
    ]);
    var onSelectNode = function() {
        actions.selectNode(nodeId);
        document.getElementsByClassName(nodeId)[0].scrollIntoView({
            behaviour: 'smooth'
        });
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: node1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "block-breadcrumbs-step",
            onClick: function() {
                return onSelectNode();
            },
            ref: function(ref) {
                return connectors.hover(ref, nodeId);
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "block-breadcrumbs-step__title",
                    children: node1.data.name
                }),
                !last && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "block-breadcrumbs-step__arrow"
                })
            ]
        }, nodeId)
    }));
};
var Bottombar = function() {
    var ref4 = (0,esm/* useEditor */.jE)(function(state) {
        var ref;
        return {
            selectedNodeId: state.events.selected,
            parent: (ref = state.nodes[state.events.selected]) === null || ref === void 0 ? void 0 : ref.data.parent
        };
    }), query = ref4.query, selectedNodeId = ref4.selectedNodeId, parent = ref4.parent;
    var ref3 = (0,react.useState)(), hierarchy1 = ref3[0], setHierarchy = ref3[1];
    (0,react.useEffect)(function() {
        if (selectedNodeId) {
            var ancestors = node_getAncestors(selectedNodeId, query);
            var hierarchy = ancestors.reverse();
            hierarchy.push(selectedNodeId);
            setHierarchy(hierarchy);
        } else {
            setHierarchy([]);
        }
    }, [
        selectedNodeId,
        parent
    ]); // devo aggiornare anche quando cambia il parent
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bottombar",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "bottombar-main",
            children: hierarchy1 && (hierarchy1.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bottombar-placeholder",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "No Component Selected"
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "block-breadcrumbs",
                children: hierarchy1.map(function(nodeId, index) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(BreadcrumbStep, {
                        nodeId: nodeId,
                        last: index === hierarchy1.length - 1
                    }, index);
                })
            }))
        })
    }));
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/editor/ContextMenu.js







function ContextMenu_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function ContextMenu_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                ContextMenu_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                ContextMenu_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function ContextMenu_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ContextMenu_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ContextMenu_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var ContextMenuItem = function(param) {
    var label = param.label, onClick = param.onClick, disabled = param.disabled;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: disabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "context-menu-item disabled",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: label
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "context-menu-item",
            onClick: onClick,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: label
            })
        })
    }));
};
var ContextMenu = function() {
    var ref = (0,esm/* useEditor */.jE)(function(state) {
        return {
            selected: state.events.selected
        };
    }), selected = ref.selected, query = ref.query, actions = ref.actions;
    // mantiene il node selected anche quando viene cliccato il contextmenu-item
    // dove selected diventerebbe null
    var ref1 = (0,react.useState)(), nodeSelected = ref1[0], setNodeSelected = ref1[1];
    var ref2 = (0,react.useState)(), deletable = ref2[0], setDeletable = ref2[1];
    var ref3 = (0,react.useState)(), clonable = ref3[0], setClonable = ref3[1];
    var ref4 = (0,react.useState)(), copyable = ref4[0], setCopyable = ref4[1];
    var ref5 = (0,react.useState)(), cuttable = ref5[0], setCuttable = ref5[1];
    var ref6 = (0,react.useState)(), disabled = ref6[0], setDisabled = ref6[1];
    var ref7 = (0,react.useState)(), droppable = ref7[0], setDroppable = ref7[1];
    (0,react.useEffect)(function() {
        if (selected) {
            setNodeSelected(selected);
            setDeletable(node_isDeletable(selected, query));
            setClonable(isClonable(selected, query));
            setCopyable(isCopyable(selected, query));
            setCuttable(node_isDeletable(selected, query) && isCopyable(selected, query));
            setDisabled(node_isDisabled(selected, query));
            setDroppable(isDroppable(selected, query));
        }
    }, [
        selected
    ]);
    var ref8 = (0,react.useState)(), style1 = ref8[0], setStyle = ref8[1];
    var ref9 = (0,react.useState)(false), visible = ref9[0], setVisible = ref9[1];
    var onRightClick = function(event) {
        if (selected && !query.node(selected).get().data.custom.editing) {
            event.preventDefault();
            var clickX = event.pageX;
            var clickY = event.pageY;
            var screenW = window.innerWidth;
            var screenH = window.innerHeight;
            var style = {};
            if (clickX > screenW / 2) {
                style['right'] = screenW - clickX;
            } else {
                style['left'] = clickX;
            }
            if (clickY > screenH / 2) {
                style['bottom'] = screenH - clickY;
            } else {
                style['top'] = clickY;
            }
            setStyle(style);
            setVisible(true);
        } else {
            onLeftClick();
        }
    };
    var onLeftClick = function() {
        setVisible(false);
    };
    var onScroll = function() {
        setVisible(false);
    };
    (0,react.useEffect)(function() {
        var dom1 = document.querySelector('.craftjs-renderer');
        if (dom1) {
            document.addEventListener('click', onLeftClick);
            dom1.addEventListener('scroll', onScroll);
            dom1.addEventListener('contextmenu', onRightClick);
        }
        return function() {
            var dom = document.querySelector('.craftjs-renderer');
            if (dom) {
                document.removeEventListener('click', onLeftClick);
                dom.removeEventListener('scroll', onScroll);
                dom.removeEventListener('contextmenu', onRightClick);
            }
        };
    }, [
        selected
    ]);
    var copy = function() {
        var _ref = ContextMenu_asyncToGenerator(runtime_default().mark(function _callee() {
            var parent, parentType, idToCopy, nodeTree, serializedNodeTree;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!isCopyable(nodeSelected, query)) {
                            _ctx.next = 9;
                            break;
                        }
                        parent = query.node(nodeSelected).get().data.parent;
                        parentType = query.node(parent).get().data.type;
                        idToCopy = nodeSelected;
                        if (parentType === Text_Text) {
                            idToCopy = parent;
                        }
                        nodeTree = query.node(idToCopy).toNodeTree();
                        serializedNodeTree = node_serializeNodeTree(nodeTree, query);
                        _ctx.next = 9;
                        return navigator.clipboard.writeText(JSON.stringify(serializedNodeTree));
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function copy() {
            return _ref.apply(this, arguments);
        };
    }();
    var cut = function() {
        var _ref = ContextMenu_asyncToGenerator(runtime_default().mark(function _callee() {
            var parent, parentType, idToClone, nodeTree, serializedNodeTree;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!isClonable(nodeSelected, query)) {
                            _ctx.next = 10;
                            break;
                        }
                        parent = query.node(nodeSelected).get().data.parent;
                        parentType = query.node(parent).get().data.type;
                        idToClone = nodeSelected;
                        if (parentType === Text_Text) {
                            idToClone = parent;
                        }
                        nodeTree = query.node(idToClone).toNodeTree();
                        serializedNodeTree = node_serializeNodeTree(nodeTree, query);
                        _ctx.next = 9;
                        return navigator.clipboard.writeText(JSON.stringify(serializedNodeTree));
                    case 9:
                        deleteNodeTree(idToClone, actions);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function cut() {
            return _ref.apply(this, arguments);
        };
    }();
    var paste = function() {
        var _ref = ContextMenu_asyncToGenerator(runtime_default().mark(function _callee() {
            var clipboard, nodeTree, currentNode, targetNode;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return navigator.clipboard.readText();
                    case 2:
                        clipboard = _ctx.sent;
                        try {
                            nodeTree = node_deserializeNodeTree(JSON.parse(clipboard), query);
                            currentNode = nodeTree['nodes'][nodeTree['rootNodeId']];
                            targetNode = query.node(nodeSelected).get();
                            if (rules_canDropBlock(currentNode, targetNode)) {
                                node_addNodeTree(nodeTree, nodeSelected, actions);
                            }
                        } catch (err) {
                            console.log(err);
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function paste() {
            return _ref.apply(this, arguments);
        };
    }();
    var clone = function() {
        if (isClonable(nodeSelected, query)) {
            var parent = query.node(nodeSelected).get().data.parent;
            var idToClone = nodeSelected;
            var parentToClone = parent;
            var parentType = query.node(parent).get().data.type;
            if (parentType === Text_Text) {
                idToClone = parent;
                parentToClone = query.node(parent).get().data.parent;
            }
            var nodeTree = cloneNodeTree(idToClone, query);
            var index = query.node(parentToClone).get().data.nodes.indexOf(idToClone);
            node_addNodeTree(nodeTree, parentToClone, actions, false, index + 1);
        }
    };
    var cancel = function() {
        if (node_isDeletable(nodeSelected, query)) {
            var parent = query.node(nodeSelected).get().data.parent;
            var parentType = query.node(parent).get().data.type;
            if (parentType === Text_Text) {
                deleteNodeTree(parent, actions);
            } else {
                deleteNodeTree(nodeSelected, actions);
            }
        }
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: visible && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "context-menu",
            style: ContextMenu_objectSpread({}, style1),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "context-menu-items",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContextMenuItem, {
                        label: "Copy",
                        onClick: copy,
                        disabled: !copyable
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContextMenuItem, {
                        label: "Cut",
                        onClick: cut,
                        disabled: !cuttable
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContextMenuItem, {
                        label: "Paste",
                        onClick: paste,
                        disabled: !droppable
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContextMenuItem, {
                        label: "Clone",
                        onClick: clone,
                        disabled: !clonable
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ContextMenuItem, {
                        label: "Cancel",
                        onClick: cancel,
                        disabled: !deletable
                    })
                ]
            })
        })
    }));
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/editor/Viewport/LeftSidebar/Toolbox/index.js










var Toolbox_Toolbox = function() {
    var ref4 = (0,esm/* useEditor */.jE)(function(state) {
        return {
            selectedNodeId: state.events.selected
        };
    }), create = ref4.connectors.create, query = ref4.query, actions = ref4.actions, selectedNodeId = ref4.selectedNodeId;
    var ref1 = (0,react.useContext)(customBlocksContext_CustomBlocksContext), customBlocksObject = ref1.customBlocks;
    var ref2 = (0,react.useState)(), prebuiltCustomBlocks = ref2[0], setPrebuiltCustomBlocks = ref2[1];
    (0,react.useEffect)(function() {
        if (customBlocksObject) {
            var prebuiltTmp = [];
            customBlocksObject.forEach(function(block) {
                var newBlock = JSON.parse(JSON.stringify(block));
                var serializedNodeTree = JSON.parse(block.json_content);
                var nodeTree = node_deserializeNodeTree(serializedNodeTree, query);
                newBlock['nodeTree'] = nodeTree;
                var element = block_parseNodeTree(nodeTree, nodeTree['rootNodeId']);
                newBlock['element'] = element;
                if (block.prebuilt) {
                    prebuiltTmp.push(newBlock);
                }
            });
            setPrebuiltCustomBlocks(prebuiltTmp);
        }
    }, [
        customBlocksObject
    ]);
    var addBlock = function(element) {
        var nodeTree = query.parseReactElement(element).toNodeTree();
        var currentNode = nodeTree['nodes'][nodeTree['rootNodeId']];
        var targetNode = null;
        if (selectedNodeId) {
            targetNode = query.node(selectedNodeId).get();
        } else {
            targetNode = query.node(esm/* ROOT_NODE */.QS).get();
        }
        if (rules_canDropBlock(currentNode, targetNode)) {
            node_addNodeTree(nodeTree, targetNode.id, actions);
        } else {
            console.log("Can not drop ".concat(currentNode.data.name, " in ").concat(targetNode.data.name));
        }
    };
    var ref3 = (0,react.useState)('Blocks'), activeTab = ref3[0], setActiveTab = ref3[1];
    var renderBlock = function(element, name, icon) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "toolbox__tools__item",
            ref: function(ref) {
                return create(ref, element);
            },
            onClick: function() {
                return addBlock(element);
            },
            children: [
                icon ? icon : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_GenericBlock, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: name
                })
            ]
        }, name));
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "toolbox",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "toolbox__tools",
            children: activeTab === 'Blocks' && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: conf_conf.map(function(conf1) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(ToolbarSection_ToolbarSection, {
                        title: conf1.title,
                        open: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "toolbox__tools__wrapper",
                            children: Object.keys(conf1.blocks).map(function(key) {
                                return renderBlock(conf1.blocks[key].block, conf1.blocks[key].name, conf1.blocks[key].icon);
                            })
                        })
                    }, conf1.title);
                })
            })
        })
    }));
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/editor/Viewport/LeftSidebar/CustomToolbox/FormCustomBlock.js










var FormCustomBlock = function(param) {
    var nodeId1 = param.nodeId;
    var query = (0,esm/* useEditor */.jE)().query;
    var ref = (0,react.useState)(''), name = ref[0], setName = ref[1];
    var ref1 = (0,react.useState)(''), successMessage = ref1[0], setSuccessMessage = ref1[1];
    var ref2 = (0,react.useState)(''), errorMessage = ref2[0], setErrorMessagee = ref2[1];
    var ref3 = (0,react.useState)(false), open = ref3[0], setOpen = ref3[1];
    var addCustomBlock = (0,react.useContext)(customBlocksContext_CustomBlocksContext).addCustomBlock;
    var onCreateCustomBlock = function() {
        var nodes = query.node(nodeId1).toNodeTree();
        var serializedNodes = node_serializeNodeTree(nodes, query);
        var json_content = JSON.stringify(serializedNodes);
        addCustomBlock(name, json_content).then(function(data) {
            setErrorMessagee('');
            setSuccessMessage('Custom Block creato con successo');
            setTimeout(function() {
                setSuccessMessage('');
            }, 5000);
        }).catch(function(err) {
            setSuccessMessage('');
            setErrorMessagee('Impossibile creare il Custom Block');
        });
    };
    var isFormDisabled = function() {
        if (!nodeId1) {
            return true;
        }
        if (nodeId1 === esm/* ROOT_NODE */.QS) {
            return true;
        }
        if (node_isDisabled(nodeId1, query)) {
            return true;
        }
        var ancestors = node_getAncestors(nodeId1, query);
        var ddb = ancestors.find(function(nodeId) {
            return query.node(nodeId).get().data.type === DynamicDataBlock;
        });
        if (ddb) {
            return true;
        }
        var nodeType = query.node(nodeId1).get().data.type;
        if (nodeType === TabsMenu || nodeType === TabsContent || nodeType === TabPane) {
            return true;
        }
        return false;
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolbarSection_ToolbarSection, {
            title: "Create new Custom Block",
            disabled: isFormDisabled(),
            buttonTooltip: isFormDisabled() ? {
                id: 'create-custom-block-button',
                label: 'Click on a component in your page',
                pos: 'right'
            } : null,
            open: open,
            onChange: setOpen,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    successMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationBar_NotificationBar, {
                        type: "success",
                        children: successMessage
                    }),
                    errorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationBar_NotificationBar, {
                        type: "alert",
                        children: errorMessage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormField_FormField, {
                        label: "Name",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInput_FormInput, {
                            value: name,
                            onChange: function(e) {
                                return setName(e.target.value);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "form-buttons",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_Button_Button, {
                                variant: "ghost",
                                size: "sm",
                                label: "Cancel",
                                onClick: function() {
                                    return setOpen(false);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_Button_Button, {
                                variant: "primary",
                                size: "sm",
                                label: "Create",
                                onClick: function() {
                                    return onCreateCustomBlock();
                                },
                                disabled: name.trim() === ''
                            })
                        ]
                    })
                ]
            })
        })
    }));
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/editor/Viewport/LeftSidebar/CustomToolbox/index.js










var CustomToolbox = function() {
    var ref3 = (0,esm/* useEditor */.jE)(function(state) {
        return {
            selectedNodeId: state.events.selected
        };
    }), create = ref3.connectors.create, query = ref3.query, actions = ref3.actions, selectedNodeId = ref3.selectedNodeId;
    var ref1 = (0,react.useContext)(customBlocksContext_CustomBlocksContext), customBlocksObject = ref1.customBlocks, deleteCustomBlock = ref1.deleteCustomBlock;
    var ref2 = (0,react.useState)(), customBlocks = ref2[0], setCustomBlocks = ref2[1];
    (0,react.useEffect)(function() {
        if (customBlocksObject) {
            var tmp = [];
            customBlocksObject.forEach(function(block) {
                var newBlock = JSON.parse(JSON.stringify(block));
                var serializedNodeTree = JSON.parse(block.json_content);
                var nodeTree = node_deserializeNodeTree(serializedNodeTree, query);
                newBlock['nodeTree'] = nodeTree;
                var element = block_parseNodeTree(nodeTree, nodeTree['rootNodeId']);
                newBlock['element'] = element;
                if (!block.prebuilt) {
                    tmp.push(newBlock);
                }
            });
            setCustomBlocks(tmp);
        }
    }, [
        customBlocksObject
    ]);
    var onDeleteCustomBlock = function(name) {
        deleteCustomBlock(name);
    };
    var addBlock = function(element) {
        var nodeTree = query.parseReactElement(element).toNodeTree();
        var currentNode = nodeTree['nodes'][nodeTree['rootNodeId']];
        var targetNode = null;
        if (selectedNodeId) {
            targetNode = query.node(selectedNodeId).get();
        } else {
            targetNode = query.node(esm/* ROOT_NODE */.QS).get();
        }
        if (rules_canDropBlock(currentNode, targetNode)) {
            node_addNodeTree(nodeTree, targetNode.id, actions);
        } else {
            console.log("Can not drop ".concat(currentNode.data.name, " in ").concat(targetNode.data.name));
        }
    };
    var renderBlock = function(element, name) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "custom-toolbox__tools__item",
            ref: function(ref) {
                return create(ref, element);
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_GenericBlock, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: name
                })
            ]
        }));
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "custom-toolbox",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "custom-toolbox__create",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormCustomBlock, {
                    nodeId: selectedNodeId
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "custom-toolbox__tools",
                children: (customBlocks === null || customBlocks === void 0 ? void 0 : customBlocks.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "custom-toolbox__custom-blocks",
                    children: customBlocks.map(function(block) {
                        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "custom-toolbox__custom-blocks__item",
                            children: [
                                renderBlock(block.element, block.name),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_Button_Button, {
                                    variant: "ghost",
                                    size: "sm",
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Add, {}),
                                    onClick: function() {
                                        return addBlock(block.element);
                                    },
                                    className: "custom-toolbox__tools__item__add"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_Button_Button, {
                                    variant: "ghost",
                                    size: "sm",
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Bin, {}),
                                    onClick: function() {
                                        return onDeleteCustomBlock(block.name);
                                    },
                                    className: "custom-toolbox__tools__item__delete"
                                })
                            ]
                        }, block.name));
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "empty-message",
                    children: "No elements yet"
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/editor/Viewport/LeftSidebar/Asset/index.js









function Asset_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function Asset_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                Asset_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                Asset_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var Asset = function() {
    var ref = (0,esm/* useEditor */.jE)(function(state) {
        return {
            selectedNodeId: state.events.selected
        };
    }), query = ref.query, actions = ref.actions, selectedNodeId = ref.selectedNodeId;
    var ref1 = (0,react.useContext)(globalContext_GlobalContext), assetId = ref1.assetId, setAssetId = ref1.setAssetId;
    var handler = function() {
        var _ref = Asset_asyncToGenerator(runtime_default().mark(function _callee(event) {
            var data, id, name;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        data = event.data;
                        if (data.source === 'filer-wrapper') {
                            data = data.data;
                            id = data.id;
                            name = data.name;
                            setAssetId(id);
                        }
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handler(event) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        window.addEventListener('message', handler);
        return function() {
            window.removeEventListener('message', handler);
        };
    }, []);
    /* useEffect(async () => {
        if(assetId) {
            if(selectedNodeId) {
                const response = await axios.get("http://localhost:9999/d/filebrowser_filer/url_image/" + assetId +"/")
                const data = response.data
                const url = "http://localhost:9999" + data.url

                const elements =  (
                    <Image block={{ src: url }} />
                )
                const nodeTree = query.parseReactElement(elements).toNodeTree()
                const currentNode = nodeTree['nodes'][nodeTree['rootNodeId']]

                const targetNode = query.node(selectedNodeId).get()
                if (canDropBlock(currentNode, targetNode)) {
                    addNodeTree(nodeTree, selectedNodeId, actions)
                    setAssetId(null)
                }
            }
            else {
                const response = await axios.get("http://localhost:9999/d/filebrowser_filer/url_image/" + assetId +"/")
                const data = response.data
                const url = "http://localhost:9999" + data.url

                const elements =  (
                    <Image block={{ src: url }} />
                )
                const nodeTree = query.parseReactElement(elements).toNodeTree()
                addNodeTree(nodeTree, ROOT_NODE, actions)
                setAssetId(null)
            }
            
        }
  }, [selectedNodeId, assetId]) */ return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: 'asset',
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
            style: {
                width: '100%',
                height: '100%',
                border: 'none'
            },
            src: "".concat(utils/* API_HOST */.H, "/d/filer-wrapper/")
        })
    }));
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/editor/Viewport/LeftSidebar/Navigator/index.js







var getBlockConfByName = function(name) {
    for(var key in conf_conf){
        var blockConf = Object.values(conf_conf[key].blocks).find(function(el) {
            return el.name === name;
        });
        if (blockConf) return blockConf;
    }
    return null;
};
var Navigator_TreeNode = function(param) {
    var id = param.id, level = param.level, defaultOpen = param.open;
    var ref3 = (0,esm/* useEditor */.jE)(function(state) {
        return {
            selected: state.events.selected,
            nodes: state.nodes
        };
    }), selected = ref3.selected, query = ref3.query, actions = ref3.actions, nodes = ref3.nodes, connectors = ref3.connectors;
    var ref1 = (0,react.useState)(defaultOpen), open = ref1[0], setOpen = ref1[1];
    var ref2 = (0,react.useState)(), nodeDetail = ref2[0], setNodeDetail = ref2[1];
    (0,react.useEffect)(function() {
        if (id && !node_isDisabled(id, query)) {
            setNodeDetail(query.node(id).get());
        }
    }, [
        id,
        nodes
    ]);
    var onSelectNode = function() {
        actions.selectNode(id);
        document.getElementsByClassName(id)[0].scrollIntoView({
            behaviour: 'smooth'
        });
    };
    var onOpenTree = function(event) {
        event.stopPropagation();
        setOpen(!open);
    };
    var onHide = function() {
        var hidden = nodeDetail.data.hidden;
        actions.history.ignore().setHidden(id, !hidden);
    };
    var blockConf = nodeDetail && getBlockConfByName(nodeDetail.data.name);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: nodeDetail && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tree-node-container",
            ref: function(ref) {
                return connectors.hover(ref, id);
            },
            onDoubleClick: function(e) {
                return onOpenTree(e);
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tree-node".concat(nodeDetail.data.nodes.length === 0 ? ' tree-node--leaf' : '', " ").concat(selected === id ? 'tree-node--active' : ''),
                    children: [
                        nodeDetail.data.nodes.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tree-node__dropdown-trigger",
                            onClick: function(e) {
                                return onOpenTree(e);
                            },
                            children: open ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_ChevronDown, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_ChevronRight, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "tree-node__selection-scope",
                            onClick: function() {
                                return onSelectNode();
                            },
                            children: [
                                (blockConf === null || blockConf === void 0 ? void 0 : blockConf.icon) ? blockConf === null || blockConf === void 0 ? void 0 : blockConf.icon : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_GenericBlock, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        nodeDetail.data.displayName,
                                        ' ',
                                        nodeDetail.data.nodes.length !== 0 && "(".concat(nodeDetail.data.nodes.length, ")")
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "tree-node__actions",
                            children: node_isDeletable(id, query) && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                onClick: function() {
                                    return onHide();
                                },
                                children: nodeDetail.data.hidden ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_VisibilityOff, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_VisibilityOn, {})
                            })
                        })
                    ]
                }),
                open && nodeDetail.data.nodes.map(function(nodeId) {
                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Navigator_TreeNode, {
                        id: nodeId,
                        level: level + 1,
                        open: defaultOpen
                    }, nodeId));
                })
            ]
        })
    }));
};
var Navigator = function(param) {
    var open = param.open;
    var ref = (0,esm/* useEditor */.jE)(function(state) {
        return {
            selected: state.events.selected,
            nodes: state.nodes
        };
    }), selected = ref.selected, nodes = ref.nodes, query = ref.query, actions = ref.actions;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "navigator",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigator_TreeNode, {
            id: esm/* ROOT_NODE */.QS,
            level: 0,
            open: open
        })
    }));
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/editor/Viewport/LeftSidebar/index.js










function _throw(e) {
    throw e;
}
var LeftSidebarPanel = function(param) {
    var tab = param.tab, onClose = param.onClose;
    var onDrag = function() {
        onClose();
    };
    (0,react.useEffect)(function() {
        var panel1 = document.querySelector('.left-sidebar__panel');
        if (panel1) {
            panel1.addEventListener('dragover', onDrag);
        }
        return function() {
            var panel = document.querySelector('.left-sidebar__panel');
            if (panel) {
                panel.removeEventListener('dragover', onDrag);
            }
        };
    }, []);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "left-sidebar__panel",
        style: {
            width: tab === 'Assets' ? '80%' : '250px',
            minWidth: tab === 'Assets' ? '600px' : 'auto'
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "left-sidebar__panel__header",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "left-sidebar__panel__header__title",
                        children: tab
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "left-sidebar__panel__header__close",
                        onClick: onClose,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.Close, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "left-sidebar__panel__content",
                children: [
                    tab === 'Blocks' && /*#__PURE__*/ (0,jsx_runtime.jsx)(Toolbox_Toolbox, {}),
                    tab === 'CustomBlocks' && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomToolbox, {}),
                    tab === 'Assets' && /*#__PURE__*/ (0,jsx_runtime.jsx)(Asset, {}),
                    tab === 'Navigator' && /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigator, {
                        open: true
                    })
                ]
            })
        ]
    }));
};
var LeftSidebar = function(param) {
    var param = param !== null ? param : _throw(new TypeError("Cannot destructure undefined"));
    var ref = (0,react.useContext)(globalContext_GlobalContext), leftSidebarTab = ref.leftSidebarTab, setLeftSidebarTab = ref.setLeftSidebarTab, setAssetId = ref.setAssetId;
    var currentRef = (0,react.useRef)();
    var onClickOutside = function(event) {
        if (currentRef && !currentRef.current.contains(event.target)) {
            closePanel();
        }
    };
    (0,react.useEffect)(function() {
        document.addEventListener('mousedown', onClickOutside);
        return function() {
            document.removeEventListener('mousedown', onClickOutside);
        };
    }, []);
    var openTab = function(name) {
        if (leftSidebarTab === name) {
            closePanel();
        } else {
            setLeftSidebarTab(name);
        }
    };
    var closePanel = function() {
        setLeftSidebarTab(null);
        setAssetId(null);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "left-sidebar",
        ref: currentRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "left-sidebar__tabs",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "left-sidebar__tab-item ".concat(leftSidebarTab === 'Blocks' ? 'left-sidebar__tab-item--active' : ''),
                        onClick: function() {
                            return openTab('Blocks');
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Blocks, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "left-sidebar__tab-item ".concat(leftSidebarTab === 'CustomBlocks' ? 'left-sidebar__tab-item--active' : ''),
                        onClick: function() {
                            return openTab('CustomBlocks');
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_CustomBlocks, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "left-sidebar__tab-item ".concat(leftSidebarTab === 'Navigator' ? 'left-sidebar__tab-item--active' : ''),
                        onClick: function() {
                            return openTab('Navigator');
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Navigation, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "left-sidebar__tab-item ".concat(leftSidebarTab === 'Assets' ? 'left-sidebar__tab-item--active' : ''),
                        onClick: function() {
                            return openTab('Assets');
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Image, {})
                    })
                ]
            }),
            leftSidebarTab && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "left-sidebar__panel__overlay",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftSidebarPanel, {
                    tab: leftSidebarTab,
                    onClose: closePanel
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/editor/Viewport/index.js






//import { KeyboardShortcutsProvider } from '../../services/keyboardShortcuts'



var Viewport = function(param) {
    var children = param.children;
    var connectors = (0,esm/* useEditor */.jE)().connectors;
    var previewMode = (0,react.useContext)(globalContext_GlobalContext).previewMode;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "viewport",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Topbar, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "content-wrapper",
                    children: [
                        !previewMode && /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftSidebar, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "content ".concat(previewMode ? 'content__preview' : ''),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "craftjs-renderer ".concat(previewMode ? 'craftjs-renderer__preview' : ''),
                                    ref: function(ref) {
                                        return connectors.select(connectors.hover(ref, null), null);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "canvas",
                                            children: children
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContextMenu, {})
                                    ]
                                }),
                                !previewMode && /*#__PURE__*/ (0,jsx_runtime.jsx)(Bottombar, {})
                            ]
                        }),
                        !previewMode && /*#__PURE__*/ (0,jsx_runtime.jsx)(Sidebar, {})
                    ]
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pagebuilder/ConditionsWrapper.js



var ConditionsWrapper = function(param) {
    var children = param.children;
    var ref = (0,esm/* useEditor */.jE)(function(state) {
        return {
            nodes: state.nodes
        };
    }), actions = ref.actions, query = ref.query, nodes = ref.nodes;
    var ref1 = (0,react.useContext)(globalContext_GlobalContext), utente = ref1.utente, windowMode = ref1.windowMode;
    (0,react.useEffect)(function() {
        // Nascondi tutto al primo render
        actions.setHidden(esm/* ROOT_NODE */.QS, true);
    }, []);
    (0,react.useEffect)(function() {
        if (nodes && Object.keys(nodes).length > 0) {
            Object.keys(nodes).forEach(function(id) {
                var conditionsProps = query.node(id).get().data.props.conditions;
                var toHide = false;
                if (utente && conditionsProps.hiddenIfLoggedIn || !utente && conditionsProps.hiddenIfNotLoggedIn || windowMode === 'desktop' && conditionsProps.hiddenIfDesktop || windowMode === 'tablet' && conditionsProps.hiddenIfTablet || windowMode === 'mobile' && conditionsProps.hiddenIfMobile) {
                    toHide = true;
                }
                actions.setHidden(id, toHide);
            });
        // Finito di valutare le condizioni, rendi di nuovo visibile la ROOT
        // actions.setHidden(ROOT_NODE, false)
        }
    }, [
        windowMode,
        nodes
    ]);
    return children;
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/editor/index.js







var resolver = {
    ROOT: ROOT,
    Tabs: Tabs_Tabs,
    TabsContent: TabsContent,
    TabsMenu: TabsMenu,
    TabPane: TabPane,
    TextEditor: TextEditor,
    Text: Text_Text,
    Button: components_Button_Button,
    Image: Image_Image,
    PdfLink: PdfLink_PdfLink,
    Video: Video_Video
};
var Editor = function(param) {
    var json = param.json, editMode = param.editMode, withConditions = param.withConditions;
    var Wrapper = withConditions ? ConditionsWrapper : react.Fragment;
    return editMode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Editor */.ML, {
        resolver: resolver,
        enabled: true,
        onRender: RenderNode,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Viewport, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Frame */.RQ, {
                data: json,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Element */.W_, {
                    is: ROOT,
                    canvas: true
                })
            })
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Editor */.ML, {
        resolver: resolver,
        enabled: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Frame */.RQ, {
                data: json
            })
        })
    });
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/utils/constants.js
var PREVIOUSblankPlaceholder = '{"ROOT":{"type":{"resolvedName":"Column"},"isCanvas":true,"props":{"block":{"flexDirection":"column","alignItems":"stretch","justifyContent":"flex-start","backgroundColor":"#ffffff","color":"#131518","shadow":0,"borderRadius":0,"width":"800px","height":"auto","backgroundImage":"","marginTop":0,"marginRight":0,"marginBottom":0,"marginLeft":0,"paddingTop":20,"paddingRight":20,"paddingBottom":20,"paddingLeft":20},"conditions":{"hiddenIfLoggedIn":false,"hiddenIfNotLoggedIn":false,"hiddenIfDesktop":false,"hiddenIfTablet":false,"hiddenIfMobile":false}},"displayName":"Column","custom":{},"hidden":false,"nodes":[],"linkedNodes":{}}}';
var blankPlaceholder = '{"ROOT":{"type":{"resolvedName":"ROOT"},"isCanvas":true,"props":{"block":{},"conditions":{"hiddenIfLoggedIn":false,"hiddenIfNotLoggedIn":false,"hiddenIfDesktop":false,"hiddenIfTablet":false,"hiddenIfMobile":false}},"displayName":"ROOT","custom":{},"hidden":false,"nodes":[],"linkedNodes":{}}}';

// EXTERNAL MODULE: ../../node_modules/react-error-boundary/dist/react-error-boundary.umd.js
var react_error_boundary_umd = __webpack_require__(80589);
;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pagebuilder/PlaceholderImport/index.js










var PlaceholderImport = function() {
    var ref = (0,react.useContext)(globalContext_GlobalContext), contentTypeId = ref.contentTypeId, lang = ref.lang, setShowImport = ref.setShowImport;
    var ref1 = (0,react.useContext)(PagebuilderContext), pagebuilder = ref1.pagebuilder, saveDraft = ref1.saveDraft;
    var ref2 = (0,react.useState)([]), placeholders = ref2[0], setPlaceholders = ref2[1];
    (0,react.useEffect)(function() {
        api_api.listPagebuilder({
            contentTypeId: contentTypeId,
            lang: lang
        }).then(function(data) {
            setPlaceholders(data.filter(function(p) {
                return p.id !== pagebuilder.id;
            }));
        }).catch(function(err) {
            console.log(err);
        });
    }, []);
    var update = function(placeholderId) {
        var placeholder = placeholders.find(function(p) {
            return p.id === placeholderId;
        });
        if (placeholder) {
            saveDraft(placeholder.json_draft, true);
            setShowImport(false);
        }
    };
    var updateBlank = function() {
        saveDraft(blankPlaceholder, true);
        setShowImport(false);
    };
    // file upload
    var ref3 = (0,react.useState)(false), loading = ref3[0], setLoading = ref3[1];
    var ref4 = (0,react.useState)(null), jsonUploaded = ref4[0], setJsonUploaded = ref4[1];
    var ref5 = (0,react.useState)(''), importType = ref5[0], setImportType = ref5[1];
    var uploadFile = function() {
        saveDraft(jsonUploaded, true);
        setShowImport(false);
    };
    var renderListing = function(listing) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "placeholder-listing",
            children: listing.filter(function(item) {
                return item.json_draft;
            }).map(function(item) {
                var json_draft = item.json_draft ? JSON.parse(item.json_draft) : '';
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "placeholder-listing-item",
                    onClick: function() {
                        return update(item.id);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "placeholder-listing-item__title",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: item.object_name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        item.object_id,
                                        " - ",
                                        item.key
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "placeholder-listing-item__editor",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Editor, {
                                json: json_draft,
                                editMode: false,
                                withConditions: false
                            })
                        })
                    ]
                }, item.id));
            })
        }));
    };
    var importTypes = [
        {
            key: 'stesso_oggetto',
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_PlusCopy, {}),
            label: 'Stesso oggetto',
            active: placeholders.filter(function(p) {
                return p.content_type_id === pagebuilder.content_type_id && p.object_id === pagebuilder.object_id && p.json_draft;
            }).length > 0
        },
        {
            key: 'stesso_contenttype',
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_ImageCopy, {}),
            label: 'Altra pagina dello stesso tipo',
            active: placeholders.filter(function(p) {
                return p.content_type_id === pagebuilder.content_type_id && p.object_id !== pagebuilder.object_id && p.json_draft;
            }).length > 0
        },
        {
            key: 'file',
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Template, {}),
            label: 'Importa un template (file .json)',
            active: true
        },
        {
            key: 'vuoto',
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Empty, {}),
            label: 'Inizia con un template vuoto',
            active: true,
            onClick: function() {
                return updateBlank();
            }
        }, 
    ];
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "pagebuilder-import-page",
        children: importType === '' ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "pagebuilder-import-page__title",
                    children: "Scegli la modalit\xe0 di import"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "pagebuilder-import-page__options",
                    children: importTypes.filter(function(t) {
                        return t.active;
                    }).map(function(t) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("button", {
                            type: "button",
                            className: "pagebuilder-import-page__option",
                            onClick: function() {
                                return t.onClick ? t.onClick() : setImportType(t.key);
                            },
                            children: [
                                t.icon,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: t.label
                                })
                            ]
                        }, "pagebuilder-import-page-option__".concat(t.key));
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pagebuilder-import-page__step2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_Button_Button, {
                        label: "Indietro",
                        variant: "ghost",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_ChevronLeft, {}),
                        iconPos: "left",
                        onClick: function() {
                            return setImportType('');
                        },
                        className: "pagebuilder-import-page__step2__back"
                    }),
                    importType === 'stesso_oggetto' && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "pagebuilder-import-page__title",
                                children: "Seleziona"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "pagebuilder-import-page__stesso-oggetto",
                                children: renderListing(placeholders.filter(function(p) {
                                    return p.content_type_id === pagebuilder.content_type_id && p.object_id === pagebuilder.object_id;
                                }))
                            })
                        ]
                    }),
                    importType === 'stesso_contenttype' && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "pagebuilder-import-page__title",
                                children: "Seleziona"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "pagebuilder-import-page__stesso-contenttype",
                                children: renderListing(placeholders.filter(function(p) {
                                    return p.content_type_id === pagebuilder.content_type_id && p.object_id !== pagebuilder.object_id;
                                }))
                            })
                        ]
                    }),
                    importType === 'file' && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "pagebuilder-import-page__title",
                                children: "Carica il file .json"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "pagebuilder-import-page__file",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "file",
                                        accept: ".json",
                                        onChange: function(e1) {
                                            setLoading(true);
                                            var fileReader = new FileReader();
                                            fileReader.readAsText(e1.target.files[0], 'utf-8');
                                            fileReader.onload = function(e) {
                                                var data = e.target.result;
                                                setJsonUploaded(data);
                                                setLoading(false);
                                            };
                                        }
                                    }),
                                    jsonUploaded && !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "pagebuilder-import-page__file__import-result",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_error_boundary_umd.ErrorBoundary, {
                                            fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "pagebuilder-import-page__file__import-result__error",
                                                children: "Il file caricato non \xe8 valido"
                                            }),
                                            onError: function(error, info) {},
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "pagebuilder-import-page__file__import-result__title",
                                                    children: "Anteprima"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "pagebuilder-import-page__file__import-result__preview",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "pagebuilder-import-page__file__import-result__preview__editor",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Editor, {
                                                            json: jsonUploaded,
                                                            editMode: false,
                                                            withConditions: false
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "pagebuilder-import-page__file__import-result__cta-box",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_Button_Button, {
                                                        label: "Conferma",
                                                        onClick: function() {
                                                            return uploadFile();
                                                        }
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    }));
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pagebuilder/Placeholder.js







var Placeholder = function() {
    var ref = (0,react.useContext)(globalContext_GlobalContext), utente = ref.utente, editMode = ref.editMode, draft = ref.draft, showImport = ref.showImport, setShowImport = ref.setShowImport;
    var ref1 = (0,react.useContext)(PagebuilderContext), pagebuilder = ref1.pagebuilder, isLoading = ref1.isLoading;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_Loader_Loader, {}) : pagebuilder && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "pagebuilder-wrapper",
            style: {
                width: '100%',
                height: '100%'
            },
            children: [
                (editMode || !editMode && (pagebuilder.json_published || draft && utente && utente.isStaff && pagebuilder.json_draft)) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Editor, {
                    json: editMode ? pagebuilder.json_draft : draft !== undefined && draft !== null && utente && utente.isStaff ? draft ? pagebuilder.json_draft : pagebuilder.json_published : pagebuilder.json_published,
                    editMode: editMode,
                    withConditions: true
                }),
                editMode && showImport && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_Modal, {
                    open: true,
                    setOpen: setShowImport,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlaceholderImport, {})
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pagebuilder/PageBuilder.js







var PageBuilder = function(param) {
    var contentTypeId = param.contentTypeId, objectId = param.objectId, pkey = param.pkey, _editMode = param.editMode, editMode = _editMode === void 0 ? false : _editMode, _draft = param.draft, draft = _draft === void 0 ? false : _draft;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(globalContext, {
        contentTypeId: contentTypeId,
        objectId: objectId,
        pkey: pkey,
        editMode: editMode,
        draft: draft,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(pagebuilderContext, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(customBlocksContext, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Placeholder, {})
            })
        })
    }));
};

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pagebuilder/PlaceholderReact.tsx




var PlaceholderReact = function(props) {
    var _contentTypeId = props.contentTypeId, contentTypeId = _contentTypeId === void 0 ? 0 : _contentTypeId, _objectId = props.objectId, objectId = _objectId === void 0 ? 0 : _objectId, _pkey = props.pkey, pkey = _pkey === void 0 ? '' : _pkey;
    var utente = (0,hooks/* useUtente */.yl)().utente;
    var ref = (0,react.useState)(null), content1 = ref[0], setContent = ref[1];
    (0,react.useEffect)(function() {
        var content = null;
        if (utente && utente.edit) {
            content = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pb-content active",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                    className: "pagebuilder-placeholder",
                    src: "/pagebuilder/?contentTypeId=".concat(contentTypeId, "&objectId=").concat(objectId, "&key=").concat(pkey),
                    title: "Pagebuilder"
                })
            });
        } else {
            content = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pb-content",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageBuilder, {
                    contentTypeId: contentTypeId,
                    objectId: objectId,
                    pkey: pkey
                })
            });
        }
        setContent(content);
    }, [
        JSON.stringify(utente),
        contentTypeId,
        objectId,
        pkey
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !!content1 && content1
    }));
};
/* harmony default export */ var pagebuilder_PlaceholderReact = (PlaceholderReact);

;// CONCATENATED MODULE: ../../libs/pagebuilder/src/lib/pagebuilder/index.ts




;// CONCATENATED MODULE: ../../libs/pagebuilder/src/index.ts




/***/ }),

/***/ 72605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ke": function() { return /* reexport */ ArchivioFascicoliTemplate_ArchivioFascicoliTemplate; },
  "OX": function() { return /* reexport */ AreaClientiTemplate_AreaClientiTemplate; },
  "Pq": function() { return /* reexport */ ArticoloTemplate_ArticoloTemplate; },
  "$I": function() { return /* reexport */ CatchAllTemplate_CatchAllTemplate; },
  "Qm": function() { return /* reexport */ CategoriaProdottoTemplate_CategoriaProdottoTemplate; },
  "Bj": function() { return /* reexport */ ChiSiamoTemplate_ChiSiamoTemplate; },
  "jI": function() { return /* reexport */ ContattaciTemplate_ContattaciTemplate; },
  "k1": function() { return /* reexport */ ContattaciThankYouTemplate_ContattaciThankYouTemplate; },
  "x1": function() { return /* reexport */ Custom404Template_Custom404Template; },
  "pl": function() { return /* reexport */ FaqDetailTemplate_FaqDetailTemplate; },
  "$8": function() { return /* reexport */ FaqListingTemplate_FaqListingTemplate; },
  "kS": function() { return /* reexport */ HomeTemplate_HomeTemplate; },
  "sN": function() { return /* reexport */ LayoutEmpty_LayoutEmpty; },
  "nn": function() { return /* reexport */ MagazineTemplate_MagazineTemplate; },
  "BU": function() { return /* reexport */ PortaleValorizzazioniTemplate_PortaleValorizzazioniTemplate; },
  "xb": function() { return /* reexport */ PreventivatoreThankYouTemplate_PreventivatoreThankYouTemplate; },
  "Yo": function() { return /* reexport */ ProdottoTemplate_ProdottoTemplate; },
  "u6": function() { return /* reexport */ ReclamiTemplate_ReclamiTemplate; },
  "p7": function() { return /* reexport */ SearchResultsTemplate_SearchResultsTemplate; }
});

// UNUSED EXPORTS: SinistroTemplate

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/shared-ui/src/atoms/index.ts + 76 modules
var atoms = __webpack_require__(28518);
// EXTERNAL MODULE: ../../libs/shared-ui/hooks/index.ts + 5 modules
var hooks = __webpack_require__(37162);
// EXTERNAL MODULE: ../../libs/shared-ui/src/organisms/AppModal/AppModal.module.sass
var AppModal_module = __webpack_require__(43204);
var AppModal_module_default = /*#__PURE__*/__webpack_require__.n(AppModal_module);
// EXTERNAL MODULE: ../../libs/shared-ui/src/atoms/Icons/index.ts + 104 modules
var Icons = __webpack_require__(10196);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/organisms/AppModal/AppModal.tsx






function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var AppModal = function(props) {
    var ref;
    var _app = props.app, app = _app === void 0 ? undefined : _app, _open = props.open, open = _open === void 0 ? false : _open, _setOpen = props.setOpen, setOpen = _setOpen === void 0 ? function() {
        return undefined;
    } : _setOpen, _className = props.className, className = _className === void 0 ? '' : _className;
    var t = (0,hooks/* useTrans */.IA)();
    var getAppLogo = function(key) {
        if (!key) return null;
        switch(key){
            case "apple":
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.AppStore, {}));
            case "android":
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.GooglePlay, {}));
        }
        return null;
    };
    return app ? /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Modal */.u_, {
        open: open,
        setOpen: setOpen,
        closeButton: true,
        className: "".concat((AppModal_module_default()).appModal, " ").concat(className ? " ".concat(className) : ''),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (AppModal_module_default()).content,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: (AppModal_module_default()).title,
                    dangerouslySetInnerHTML: {
                        __html: t("Scarica l'app") + " <strong>".concat(app.name, "</strong>")
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: (AppModal_module_default()).description,
                    children: t("Seleziona lo store di riferimento")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (AppModal_module_default()).links,
                    children: ((ref = app.children) === null || ref === void 0 ? void 0 : ref.edges) && app.children.edges.map(function(child) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                            className: (AppModal_module_default()).logo,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", _objectSpread({
                                href: child.node.url || '',
                                className: (AppModal_module_default()).appButton
                            }, child.node.blank && {
                                target: '_blank'
                            }, {
                                children: getAppLogo(child.node.style)
                            }))
                        }, child.node.pk);
                    })
                })
            ]
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var AppModal_AppModal = (AppModal);

// EXTERNAL MODULE: ../../node_modules/swiper/esm/react/swiper.js + 8 modules
var swiper = __webpack_require__(43952);
// EXTERNAL MODULE: ../../node_modules/swiper/esm/react/swiper-slide.js
var swiper_slide = __webpack_require__(98395);
// EXTERNAL MODULE: ../../libs/shared-ui/src/molecules/AllegatiBox/AllegatiBox.module.sass
var AllegatiBox_module = __webpack_require__(19663);
var AllegatiBox_module_default = /*#__PURE__*/__webpack_require__.n(AllegatiBox_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/molecules/AllegatiBox/AllegatiBox.tsx




var AllegatiBox = function(props) {
    var ref, ref1;
    var _item = props.item, item = _item === void 0 ? null : _item, _sidebar = props.sidebar, sidebar = _sidebar === void 0 ? false : _sidebar, _className = props.className, className = _className === void 0 ? '' : _className;
    return item ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((AllegatiBox_module_default()).allegatiBox, " ").concat(sidebar ? (AllegatiBox_module_default())["allegatiBox--sidebar"] : '', " ").concat(className ? " ".concat(className) : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (AllegatiBox_module_default()).titleBox,
                children: [
                    item.name && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (AllegatiBox_module_default()).title,
                        dangerouslySetInnerHTML: {
                            __html: item.name
                        }
                    }),
                    item.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (AllegatiBox_module_default()).description,
                        dangerouslySetInnerHTML: {
                            __html: item.description
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (AllegatiBox_module_default()).content,
                children: !!item.children && ((ref = item.children) === null || ref === void 0 ? void 0 : (ref1 = ref.edges) === null || ref1 === void 0 ? void 0 : ref1.map(function(child) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(atoms/* PdfLink */.lQ, {
                        name: child.node.name,
                        url: child.node.url
                    }, child.node.pk);
                }))
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var AllegatiBox_AllegatiBox = (AllegatiBox);

// EXTERNAL MODULE: ../../libs/shared-ui/src/molecules/AppBox/AppBox.module.sass
var AppBox_module = __webpack_require__(89808);
var AppBox_module_default = /*#__PURE__*/__webpack_require__.n(AppBox_module);
// EXTERNAL MODULE: ../../libs/shared-ui/utils/gtm.js
var gtm = __webpack_require__(43705);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/molecules/AppBox/AppBox.tsx








var AppBox = function(props) {
    var ref3;
    var _item = props.item, item = _item === void 0 ? undefined : _item, _className = props.className, className = _className === void 0 ? '' : _className, _controlled = props.controlled, controlled = _controlled === void 0 ? false : _controlled, _defaultAppModal = props.defaultAppModal, defaultAppModal = _defaultAppModal === void 0 ? null : _defaultAppModal, _setDefaultAppModal = props.setDefaultAppModal, setDefaultAppModal = _setDefaultAppModal === void 0 ? function() {} : _setDefaultAppModal, _defaultOpenAppModal = props.defaultOpenAppModal, defaultOpenAppModal = _defaultOpenAppModal === void 0 ? false : _defaultOpenAppModal, _setDefaultOpenAppModal = props.setDefaultOpenAppModal, setDefaultOpenAppModal = _setDefaultOpenAppModal === void 0 ? function() {} : _setDefaultOpenAppModal;
    var isMobile = (0,hooks/* useIsMobile */.dD)();
    var ref1 = (0,react.useState)(false), appModalOpen = ref1[0], setAppModalOpen = ref1[1];
    var ref2 = (0,react.useState)(undefined), appModal = ref2[0], setAppModal = ref2[1];
    (0,react.useEffect)(function() {
        if (appModal) {
            setAppModalOpen(true);
        }
        if (controlled && defaultAppModal) {
            setDefaultOpenAppModal(true);
        }
    }, [
        appModal,
        defaultAppModal
    ]);
    (0,react.useEffect)(function() {
        if (!appModalOpen) {
            setAppModal(undefined);
        }
        if (controlled && !defaultOpenAppModal) {
            setDefaultAppModal(undefined);
        }
    }, [
        appModalOpen,
        defaultOpenAppModal
    ]);
    return item ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((AppBox_module_default()).appBox, " ").concat(className ? " ".concat(className) : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (AppBox_module_default()).imageBox,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WImage */.Tg, {
                    maxWidth: 400,
                    maxHeight: 480,
                    src: isMobile ? item.mainImageResponsive : item.mainImage,
                    className: (AppBox_module_default()).image,
                    layout: "intrinsic",
                    objectFit: "contain"
                }, "app-box-".concat(item.pk, "-main-image").concat(isMobile ? '-mobile' : ''))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (AppBox_module_default()).main,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (AppBox_module_default()).content,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (AppBox_module_default()).title,
                                children: item.name
                            }),
                            !!item.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (AppBox_module_default()).description,
                                dangerouslySetInnerHTML: {
                                    __html: item.description
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (AppBox_module_default()).list,
                        children: ((ref3 = item.children) === null || ref3 === void 0 ? void 0 : ref3.edges) && item.children.edges.map(function(child) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(atoms/* AssistenzaButton */.zm, {
                                label: child.node.description || '',
                                url: child.node.url,
                                newPage: child.node.blank,
                                onClick: function() {
                                    var ref;
                                    setAppModal(child.node);
                                    setDefaultAppModal(child.node);
                                    (0,gtm/* sendGTMData */.S3)({
                                        event: "GAevent",
                                        eventCategory: 'app',
                                        eventAction: ((ref = child.node.name) === null || ref === void 0 ? void 0 : ref.toGTMFormat()) || '',
                                        eventLabel: 'download'
                                    });
                                }
                            }, child.node.pk);
                        })
                    })
                ]
            }),
            !controlled && /*#__PURE__*/ (0,jsx_runtime.jsx)(AppModal_AppModal, {
                app: appModal,
                open: appModalOpen,
                setOpen: setAppModalOpen
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var AppBox_AppBox = (AppBox);

// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
// EXTERNAL MODULE: ../../libs/shared-ui/src/molecules/ArticoloCard/ArticoloCard.module.sass
var ArticoloCard_module = __webpack_require__(8573);
var ArticoloCard_module_default = /*#__PURE__*/__webpack_require__.n(ArticoloCard_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/molecules/ArticoloCard/ArticoloCard.tsx





var ArticoloCard = function(props) {
    var ref;
    var _articolo = props.articolo, articolo = _articolo === void 0 ? undefined : _articolo, _className = props.className, className = _className === void 0 ? '' : _className, _onClick = props.onClick, onClick = _onClick === void 0 ? function() {
        return undefined;
    } : _onClick;
    return articolo ? /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
        href: articolo.url,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            className: "".concat((ArticoloCard_module_default()).articoloCard, " ").concat(className),
            onClick: onClick,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ArticoloCard_module_default()).imageBox,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WImage */.Tg, {
                        src: articolo.mainImage,
                        maxWidth: 350,
                        maxHeight: 124,
                        layout: "intrinsic",
                        objectFit: "cover"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ArticoloCard_module_default()).content,
                    children: [
                        !!((ref = articolo.categoria) === null || ref === void 0 ? void 0 : ref.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ArticoloCard_module_default()).chips,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Chip */.Af, {
                                label: articolo.categoria.title,
                                variant: "light",
                                size: "sm",
                                weight: "regular"
                            })
                        }),
                        !!articolo.publicationDate && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (ArticoloCard_module_default()).date,
                            children: articolo.publicationDate
                        }),
                        !!articolo.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (ArticoloCard_module_default()).title,
                            children: articolo.title
                        })
                    ]
                })
            ]
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var ArticoloCard_ArticoloCard = (ArticoloCard);

// EXTERNAL MODULE: ../../libs/shared-ui/src/molecules/ContentBox/ContentBox.module.sass
var ContentBox_module = __webpack_require__(38570);
var ContentBox_module_default = /*#__PURE__*/__webpack_require__.n(ContentBox_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/molecules/ContentBox/ContentBox.tsx





var ContentBox = function(props) {
    var _item = props.item, item = _item === void 0 ? null : _item, _titlePos = props.titlePos, titlePos = _titlePos === void 0 ? 'left' : _titlePos, _className = props.className, className = _className === void 0 ? '' : _className;
    var isMobile = (0,hooks/* useIsMobile */.dD)();
    return item ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((ContentBox_module_default()).contentBox, " ").concat((ContentBox_module_default())["contentBox--title-".concat(titlePos)], " ").concat(className ? " ".concat(className) : ''),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ContentBox_module_default()).layout,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((ContentBox_module_default()).titleBox, " ").concat(item.mainImage ? (ContentBox_module_default())["titleBox--image"] : ''),
                        children: !!item.name && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (ContentBox_module_default()).title,
                            dangerouslySetInnerHTML: {
                                __html: item.name
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ContentBox_module_default()).main,
                        children: [
                            !!item.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((ContentBox_module_default()).content, " custom-content"),
                                dangerouslySetInnerHTML: {
                                    __html: item.description
                                }
                            }),
                            !!item.children && item.children.edges.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ContentBox_module_default()).links,
                                children: item.children.edges.map(function(x) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(atoms/* PdfLink */.lQ, {
                                        name: x.node.name,
                                        url: x.node.url
                                    }, x.node.pk);
                                })
                            })
                        ]
                    }),
                    !!item.mainImage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ContentBox_module_default()).imageCompositionBox,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ContentBox_module_default()).imageBox,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WImage */.Tg, {
                                src: isMobile ? item.mainImageResponsive : item.mainImage,
                                maxWidth: 610,
                                maxHeight: 367,
                                layout: "intrinsic",
                                objectFit: "cover"
                            }, "content-box-".concat(item.pk, "-main-image").concat(isMobile ? '-mobile' : ''))
                        })
                    })
                ]
            })
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var ContentBox_ContentBox = (ContentBox);

;// CONCATENATED MODULE: ../../libs/shared-ui/utils/icons.tsx


var getIcon = function(key) {
    if (!key) return null;
    var keyToComponentName = key.split("_").map(function(v) {
        return v.charAt(0).toUpperCase() + v.slice(1);
    }).join("");
    //@ts-ignore
    var Icon = Icons["".concat(keyToComponentName)];
    if (Icon) return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {}));
    return null;
};

// EXTERNAL MODULE: ../../libs/shared-ui/src/molecules/FaqCategoryCard/FaqCategoryCard.module.sass
var FaqCategoryCard_module = __webpack_require__(66497);
var FaqCategoryCard_module_default = /*#__PURE__*/__webpack_require__.n(FaqCategoryCard_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/molecules/FaqCategoryCard/FaqCategoryCard.tsx





var FaqCategoryCard = function(props) {
    var _item = props.item, item = _item === void 0 ? undefined : _item, _className = props.className, className = _className === void 0 ? '' : _className, _onClick = props.onClick, onClick = _onClick === void 0 ? function() {
        return undefined;
    } : _onClick;
    return item ? /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
        href: (item === null || item === void 0 ? void 0 : item.url) || '',
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            className: "".concat((FaqCategoryCard_module_default()).faqCategoryCard, " ").concat(className ? " ".concat(className) : ''),
            onClick: onClick,
            children: [
                !!item.style && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (FaqCategoryCard_module_default()).icon,
                    children: getIcon(item.style)
                }),
                !!item.titolo && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: (FaqCategoryCard_module_default()).title,
                    children: item.titolo
                }),
                !!item.descrizione && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (FaqCategoryCard_module_default()).description,
                    dangerouslySetInnerHTML: {
                        __html: item.descrizione
                    }
                })
            ]
        })
    }, item.pk) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var FaqCategoryCard_FaqCategoryCard = (FaqCategoryCard);

// EXTERNAL MODULE: ../../libs/shared-ui/src/molecules/FaqSidebarMenu/FaqSidebarMenu.module.sass
var FaqSidebarMenu_module = __webpack_require__(14456);
var FaqSidebarMenu_module_default = /*#__PURE__*/__webpack_require__.n(FaqSidebarMenu_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/molecules/FaqSidebarMenu/FaqSidebarMenu.tsx






var FaqSidebarMenu = function(props) {
    var _items = props.items, items = _items === void 0 ? [] : _items, _className = props.className, className = _className === void 0 ? '' : _className, _isSearchFaq = props.isSearchFaq, isSearchFaq = _isSearchFaq === void 0 ? false : _isSearchFaq, _handleSelectCategory = props.handleSelectCategory, handleSelectCategory = _handleSelectCategory === void 0 ? function() {
        return undefined;
    } : _handleSelectCategory, _pkCategoriaSelected = props.pkCategoriaSelected, pkCategoriaSelected = _pkCategoriaSelected === void 0 ? null : _pkCategoriaSelected;
    var ref = (0,react.useState)(false), mobileOpen = ref[0], setMobileOpen = ref[1];
    var innerListingRef = (0,react.useRef)(null);
    var t = (0,hooks/* useTrans */.IA)();
    return items.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((FaqSidebarMenu_module_default()).faqSidebarMenu, " ").concat(mobileOpen ? (FaqSidebarMenu_module_default())["faqSidebarMenu--mobileOpen"] : '', " ").concat(className ? " ".concat(className) : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                type: "button",
                className: (FaqSidebarMenu_module_default()).mobileAction,
                onClick: function() {
                    return setMobileOpen(!mobileOpen);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (FaqSidebarMenu_module_default()).actionLabel,
                        children: t("Categorie")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (FaqSidebarMenu_module_default()).actionIcon,
                        children: mobileOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.Close, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.ChevronDown, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (FaqSidebarMenu_module_default()).listing,
                style: {
                    maxHeight: (innerListingRef === null || innerListingRef === void 0 ? void 0 : innerListingRef.current) && mobileOpen ? innerListingRef.current.clientHeight : 0
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (FaqSidebarMenu_module_default()).innerListing,
                    ref: innerListingRef,
                    children: items.map(function(item) {
                        return isSearchFaq ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            className: "".concat((FaqSidebarMenu_module_default()).item, " ").concat(item.pk === pkCategoriaSelected ? (FaqSidebarMenu_module_default())["item--active"] : ''),
                            onClick: function() {
                                return handleSelectCategory(item.pk);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (FaqSidebarMenu_module_default()).itemTitle,
                                    children: item.titolo
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (FaqSidebarMenu_module_default()).itemIcon,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.ArrowRight, {})
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                            href: item === null || item === void 0 ? void 0 : item.url,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: "".concat((FaqSidebarMenu_module_default()).item, " ").concat(item.active ? (FaqSidebarMenu_module_default())["item--active"] : ''),
                                onClick: function() {
                                    return handleSelectCategory(item.pk);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (FaqSidebarMenu_module_default()).itemTitle,
                                        children: item.titolo
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (FaqSidebarMenu_module_default()).itemIcon,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.ArrowRight, {})
                                    })
                                ]
                            })
                        }, item.pk);
                    })
                })
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var FaqSidebarMenu_FaqSidebarMenu = (FaqSidebarMenu);

// EXTERNAL MODULE: ../../libs/shared-ui/utils/safe.ts
var safe = __webpack_require__(78775);
// EXTERNAL MODULE: ../../libs/shared-ui/src/molecules/FascicoloCard/FascicoloCard.module.sass
var FascicoloCard_module = __webpack_require__(6654);
var FascicoloCard_module_default = /*#__PURE__*/__webpack_require__.n(FascicoloCard_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/molecules/FascicoloCard/FascicoloCard.tsx








var FascicoloCard = function(props) {
    var ref2, ref1;
    var _fascicolo = props.fascicolo, fascicolo = _fascicolo === void 0 ? undefined : _fascicolo, _className = props.className, className = _className === void 0 ? '' : _className, _isCatalogoFondi = props.isCatalogoFondi, isCatalogoFondi = _isCatalogoFondi === void 0 ? false : _isCatalogoFondi;
    var t = (0,hooks/* useTrans */.IA)();
    return fascicolo ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((FascicoloCard_module_default()).fascicoloCard, " ").concat(className ? " ".concat(className) : ''),
        children: [
            fascicolo.edizione && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: (FascicoloCard_module_default()).edizione,
                children: [
                    t('Edizione'),
                    ": ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (FascicoloCard_module_default()).value,
                        children: (0,safe/* monthYearFormat */.EK)(fascicolo.edizione)
                    })
                ]
            }),
            !!((ref2 = fascicolo.tags) === null || ref2 === void 0 ? void 0 : ref2.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (FascicoloCard_module_default()).chips,
                children: fascicolo.tags.map(function(tag) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(atoms/* Chip */.Af, {
                        label: tag.titolo,
                        variant: "blue",
                        size: "sm",
                        weight: "regular"
                    }, tag.pk);
                })
            }),
            fascicolo.titolo && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (FascicoloCard_module_default()).title,
                children: fascicolo.titolo
            }),
            fascicolo.descrizione && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (FascicoloCard_module_default()).description,
                dangerouslySetInnerHTML: {
                    __html: fascicolo.descrizione || ''
                }
            }),
            !!((ref1 = fascicolo.files) === null || ref1 === void 0 ? void 0 : ref1.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (FascicoloCard_module_default()).ctaBox,
                children: fascicolo.files.map(function(file) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                            label: file.titolo,
                            rightIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.ArrowRight, {}),
                            variant: "ghost",
                            newPage: true,
                            href: file.url,
                            onClick: function() {
                                var ref;
                                return (0,gtm/* sendGTMData */.S3)({
                                    event: "GAevent",
                                    eventCategory: isCatalogoFondi ? "catalogo_fondi" : "fascicolo",
                                    eventAction: (ref = fascicolo.titolo) === null || ref === void 0 ? void 0 : ref.toGTMFormat(),
                                    eventLabel: file.url
                                });
                            }
                        })
                    }, file.pk);
                })
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var FascicoloCard_FascicoloCard = (FascicoloCard);

// EXTERNAL MODULE: ../../libs/shared-ui/src/molecules/FilledTextBox/FilledTextBox.module.sass
var FilledTextBox_module = __webpack_require__(54150);
var FilledTextBox_module_default = /*#__PURE__*/__webpack_require__.n(FilledTextBox_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/molecules/FilledTextBox/FilledTextBox.tsx




var FilledTextBox = function(props) {
    var _item = props.item, item = _item === void 0 ? undefined : _item, _className = props.className, className = _className === void 0 ? '' : _className;
    var icon = getIcon(item === null || item === void 0 ? void 0 : item.style);
    return item ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((FilledTextBox_module_default()).filledTextBox, " ").concat(className ? " ".concat(className) : ''),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (FilledTextBox_module_default()).content,
            children: [
                !!item.name && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: (FilledTextBox_module_default()).title,
                    children: [
                        !!icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (FilledTextBox_module_default()).icon,
                            children: icon
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: item.name
                        })
                    ]
                }),
                !!item.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (FilledTextBox_module_default()).description,
                    dangerouslySetInnerHTML: {
                        __html: item.description
                    }
                })
            ]
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var FilledTextBox_FilledTextBox = (FilledTextBox);

// EXTERNAL MODULE: ../../libs/shared-ui/src/molecules/ImageTextBox/ImageTextBox.module.sass
var ImageTextBox_module = __webpack_require__(25009);
var ImageTextBox_module_default = /*#__PURE__*/__webpack_require__.n(ImageTextBox_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/molecules/ImageTextBox/ImageTextBox.tsx






var ImageTextBox = function(props) {
    var _item = props.item, item = _item === void 0 ? undefined : _item, _textPos = props.textPos, textPos = _textPos === void 0 ? 'right' : _textPos, _className = props.className, className = _className === void 0 ? '' : _className;
    var isMobile = (0,hooks/* useIsMobile */.dD)();
    return item ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((ImageTextBox_module_default()).imageTextBox, " ").concat((ImageTextBox_module_default())["imageTextBox--text-".concat(textPos)], " ").concat(className ? " ".concat(className) : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ImageTextBox_module_default()).imageBox,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WImage */.Tg, {
                    maxWidth: 966,
                    maxHeight: 474,
                    src: isMobile ? item.mainImageResponsive : item.mainImage,
                    layout: "intrinsic",
                    objectFit: "cover"
                }, "image-text-box-".concat(item.pk, "-main-image").concat(isMobile ? '-mobile' : ''))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ImageTextBox_module_default()).content,
                children: [
                    !!item.name && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (ImageTextBox_module_default()).title,
                        children: item.name
                    }),
                    !!item.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ImageTextBox_module_default()).description,
                        dangerouslySetInnerHTML: {
                            __html: item.description
                        }
                    }),
                    !!item.ctaLabel && !!item.url && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ImageTextBox_module_default()).ctaBox,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                            label: item.ctaLabel,
                            variant: "tertiary2",
                            href: item.url,
                            onClick: function() {
                                var ref;
                                return (0,gtm/* sendGTMData */.S3)({
                                    event: "GAevent",
                                    eventCategory: "banner_promo",
                                    eventAction: ((ref = item.name) === null || ref === void 0 ? void 0 : ref.toGTMFormat()) || '',
                                    eventLabel: "homepage"
                                });
                            }
                        })
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var ImageTextBox_ImageTextBox = (ImageTextBox);

// EXTERNAL MODULE: ../../libs/shared-ui/src/molecules/LineaBox/LineaBox.module.sass
var LineaBox_module = __webpack_require__(83254);
var LineaBox_module_default = /*#__PURE__*/__webpack_require__.n(LineaBox_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/molecules/LineaBox/LineaBox.tsx







var GaranzieBlock = function(props) {
    var _title = props.title, title = _title === void 0 ? '' : _title, _garanzie = props.garanzie, garanzie = _garanzie === void 0 ? [] : _garanzie, _collapsable = props.collapsable, collapsable = _collapsable === void 0 ? false : _collapsable, _listHeight = props.listHeight, listHeight = _listHeight === void 0 ? 0 : _listHeight, _onChangeListHeight = props.onChangeListHeight, onChangeListHeight = _onChangeListHeight === void 0 ? undefined : _onChangeListHeight, _open = props.open, open = _open === void 0 ? false : _open, _setOpen = props.setOpen, setOpen = _setOpen === void 0 ? function(v) {
        return undefined;
    } : _setOpen;
    var innerContentRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (innerContentRef.current && onChangeListHeight) onChangeListHeight(innerContentRef.current.clientHeight);
    }, [
        innerContentRef,
        onChangeListHeight
    ]);
    return garanzie.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((LineaBox_module_default()).garanzieBlock, " ").concat(collapsable ? "".concat((LineaBox_module_default())["garanzieBlock--collapsable"], " ").concat(open ? (LineaBox_module_default())["garanzieBlock--collapsable--open"] : '') : ''),
        children: [
            collapsable ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: (LineaBox_module_default()).garanzieButton,
                onClick: function() {
                    return setOpen(!open);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (LineaBox_module_default()).garanzieTitle,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (LineaBox_module_default()).garanzieArrow,
                        children: open ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.ChevronUp, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.ChevronDown, {})
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (LineaBox_module_default()).garanzieTitle,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (LineaBox_module_default()).garanzieList,
                style: collapsable ? {
                    maxHeight: (innerContentRef === null || innerContentRef === void 0 ? void 0 : innerContentRef.current) && open ? innerContentRef.current.clientHeight : 0
                } : {
                    minHeight: listHeight
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (LineaBox_module_default()).garanzieListContent,
                    ref: innerContentRef,
                    children: garanzie.map(function(garanzia) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("p", {
                            className: "".concat((LineaBox_module_default()).garanzieItem, " ").concat((LineaBox_module_default())["garanzieItem--".concat(garanzia.style)]),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (LineaBox_module_default()).garanzieItemIcon,
                                    children: getIcon(garanzia.style)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: garanzia.info ? (LineaBox_module_default()).garanzieItemLabel : '',
                                    children: garanzia.titolo
                                }),
                                !!garanzia.info && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Tooltip */.u, {
                                    id: "tooltip-garanzia-".concat(garanzia.pk),
                                    label: garanzia.info,
                                    size: "sm",
                                    pos: "bottom",
                                    autoWidth: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (LineaBox_module_default()).garanzieItemInfo,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.Info, {})
                                    })
                                })
                            ]
                        }, garanzia.pk);
                    })
                })
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
var LineaBox = function(props) {
    var _linea = props.linea, linea = _linea === void 0 ? undefined : _linea, _garanzieIncluseListHeight = props.garanzieIncluseListHeight, garanzieIncluseListHeight = _garanzieIncluseListHeight === void 0 ? 0 : _garanzieIncluseListHeight, _onChangeGaranzieIncluseListHeight = props.onChangeGaranzieIncluseListHeight, onChangeGaranzieIncluseListHeight = _onChangeGaranzieIncluseListHeight === void 0 ? function(h) {
        return undefined;
    } : _onChangeGaranzieIncluseListHeight, _garanzieOpzionaliOpen = props.garanzieOpzionaliOpen, garanzieOpzionaliOpen = _garanzieOpzionaliOpen === void 0 ? false : _garanzieOpzionaliOpen, _setGaranzieOpzionaliOpen = props.setGaranzieOpzionaliOpen, setGaranzieOpzionaliOpen = _setGaranzieOpzionaliOpen === void 0 ? function(v) {
        return undefined;
    } : _setGaranzieOpzionaliOpen, _className = props.className, className = _className === void 0 ? '' : _className;
    var t = (0,hooks/* useTrans */.IA)();
    var ref = (0,react.useState)(false), showFullTextMobile = ref[0], setShowFullTextMobile = ref[1];
    return linea ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((LineaBox_module_default()).lineaBox, " ").concat(linea.prezzo ? (LineaBox_module_default())["lineaBox--footer"] : '', " ").concat(className ? " ".concat(className) : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (LineaBox_module_default()).head,
                children: [
                    linea.label && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Chip */.Af, {
                        className: (LineaBox_module_default()).chip,
                        label: linea.label,
                        variant: "light",
                        weight: "regular",
                        size: "sm"
                    }),
                    linea.titolo && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "".concat((LineaBox_module_default()).title, " ").concat((LineaBox_module_default())["title--".concat(linea.style)]),
                        dangerouslySetInnerHTML: {
                            __html: linea.titolo
                        }
                    })
                ]
            }),
            linea.description ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((LineaBox_module_default()).description, " ").concat(showFullTextMobile ? (LineaBox_module_default())["description--mobile-full"] : '', " custom-content"),
                        dangerouslySetInnerHTML: {
                            __html: linea.description
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                        label: t(showFullTextMobile ? "Leggi meno" : "Leggi di pi\xf9"),
                        variant: "ghost",
                        className: (LineaBox_module_default()).readMore,
                        onClick: function() {
                            return setShowFullTextMobile(!showFullTextMobile);
                        }
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GaranzieBlock, {
                        title: t("Garanzie incluse"),
                        garanzie: linea.garanzieIncluse,
                        listHeight: garanzieIncluseListHeight,
                        onChangeListHeight: onChangeGaranzieIncluseListHeight
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GaranzieBlock, {
                        title: t("Garanzie opzionali"),
                        garanzie: linea.garanzieOpzionali,
                        open: garanzieOpzionaliOpen,
                        setOpen: setGaranzieOpzionaliOpen,
                        collapsable: true
                    })
                ]
            }),
            !!linea.prezzo && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (LineaBox_module_default()).footer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (LineaBox_module_default()).priceLabel,
                        children: t("Prezzo (€/mese)")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: (LineaBox_module_default()).priceValue,
                        children: [
                            "€ ",
                            linea.prezzo
                        ]
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var LineaBox_LineaBox = (LineaBox);

// EXTERNAL MODULE: ../../libs/shared-ui/src/molecules/LineaCheckbox/LineaCheckbox.module.sass
var LineaCheckbox_module = __webpack_require__(10585);
var LineaCheckbox_module_default = /*#__PURE__*/__webpack_require__.n(LineaCheckbox_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/molecules/LineaCheckbox/LineaCheckbox.tsx






var LineaCheckbox = function(props) {
    var _linea = props.linea, linea = _linea === void 0 ? null : _linea, _selected = props.selected, selected = _selected === void 0 ? false : _selected, _setSelected = props.setSelected, setSelected = _setSelected === void 0 ? function() {
        return undefined;
    } : _setSelected, _collapsable = props.collapsable, collapsable = _collapsable === void 0 ? false : _collapsable, _className = props.className, className = _className === void 0 ? '' : _className;
    var t = (0,hooks/* useTrans */.IA)();
    var ref // Se è collassabile inizialmente è chiuso, altrimenti è aperto
     = (0,react.useState)(!collapsable), open = ref[0], setOpen = ref[1];
    var ref1 = (0,react.useState)(false), hover = ref1[0], setHover = ref1[1];
    var innerContentRef = (0,react.useRef)(null);
    return linea ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        onClick: collapsable ? undefined : function() {
            return setSelected(!selected);
        },
        onMouseEnter: function() {
            return setHover(true);
        },
        onMouseLeave: function() {
            return setHover(false);
        },
        className: "".concat((LineaCheckbox_module_default()).lineaCheckbox, " ").concat(selected ? (LineaCheckbox_module_default())["lineaCheckbox--selected"] : '', " ").concat(hover ? (LineaCheckbox_module_default())["lineaCheckbox--hovered"] : '', " ").concat(collapsable ? (LineaCheckbox_module_default())["lineaCheckbox--collapsable"] : '', " ").concat(className ? " ".concat(className) : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (LineaCheckbox_module_default()).head,
                onClick: collapsable ? function() {
                    return setSelected(!selected);
                } : undefined,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (LineaCheckbox_module_default()).checkbox,
                        children: selected ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.CheckboxMarked, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.CheckboxUnmarked, {
                            className: "".concat(hover && (!collapsable || collapsable && open) ? (LineaCheckbox_module_default())["checkbox--hovered"] : '')
                        })
                    }),
                    (linea === null || linea === void 0 ? void 0 : linea.icon) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (LineaCheckbox_module_default()).icon,
                        children: getIcon(linea.icon)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (LineaCheckbox_module_default()).title,
                        children: linea.titolo
                    }),
                    linea.prezzo && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: (LineaCheckbox_module_default()).price,
                        children: [
                            "€",
                            linea.prezzo,
                            "/mese"
                        ]
                    })
                ]
            }),
            linea.descrizioneBreve && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (LineaCheckbox_module_default()).accordion,
                children: [
                    collapsable && /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        type: "button",
                        className: (LineaCheckbox_module_default()).accordionTrigger,
                        onClick: function() {
                            return setOpen(!open);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t(open ? "Chiudi dettagli" : "Vedi dettagli")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (LineaCheckbox_module_default()).accordionArrow,
                                children: open ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.ChevronUp, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.ChevronDown, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (LineaCheckbox_module_default()).descriptionWrap,
                        style: collapsable && (innerContentRef === null || innerContentRef === void 0 ? void 0 : innerContentRef.current) && open ? {
                            maxHeight: innerContentRef.current.clientHeight
                        } : {},
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (LineaCheckbox_module_default()).description,
                            ref: innerContentRef,
                            dangerouslySetInnerHTML: {
                                __html: linea.descrizioneBreve
                            }
                        })
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var LineaCheckbox_LineaCheckbox = (LineaCheckbox);

// EXTERNAL MODULE: ../../libs/shared-ui/src/molecules/OutlineTextCtaBox/OutlineTextCtaBox.module.sass
var OutlineTextCtaBox_module = __webpack_require__(23320);
var OutlineTextCtaBox_module_default = /*#__PURE__*/__webpack_require__.n(OutlineTextCtaBox_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/molecules/OutlineTextCtaBox/OutlineTextCtaBox.tsx




var OutlineTextCtaBox = function(props) {
    var ref1;
    var _item = props.item, item = _item === void 0 ? undefined : _item, _className = props.className, className = _className === void 0 ? '' : _className, _onClick = props.onClick, onClick = _onClick === void 0 ? function() {
        return undefined;
    } : _onClick, _onChildrenClick = props.onChildrenClick, onChildrenClick = _onChildrenClick === void 0 ? [] : _onChildrenClick;
    return item ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((OutlineTextCtaBox_module_default()).outlineTextCtaBox, " ").concat(className ? " ".concat(className) : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (OutlineTextCtaBox_module_default()).content,
                children: [
                    !!item.name && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (OutlineTextCtaBox_module_default()).title,
                        children: item.name
                    }),
                    !!item.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (OutlineTextCtaBox_module_default()).description,
                        dangerouslySetInnerHTML: {
                            __html: item.description
                        }
                    })
                ]
            }),
            !!item.ctaLabel && !!item.url ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (OutlineTextCtaBox_module_default()).ctaBox,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                    label: item.ctaLabel,
                    variant: "secondary",
                    href: item.url,
                    onClick: onClick
                })
            }) : !!item.children && ((ref1 = item.children) === null || ref1 === void 0 ? void 0 : ref1.edges.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (OutlineTextCtaBox_module_default()).ctaBox,
                children: item.children.edges.map(function(child) {
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                        label: child.node.ctaLabel,
                        newPage: child.node.blank,
                        variant: "secondary",
                        href: child.node.url,
                        onClick: ((ref = onChildrenClick.find(function(i) {
                            return i.pk === child.node.pk;
                        })) === null || ref === void 0 ? void 0 : ref.onClick) || onClick
                    }, child.node.pk);
                })
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var OutlineTextCtaBox_OutlineTextCtaBox = (OutlineTextCtaBox);

// EXTERNAL MODULE: ../../libs/pagebuilder/src/index.ts + 152 modules
var src = __webpack_require__(46783);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/molecules/PlaceholderReact/PlaceholderReact.tsx




var PlaceholderReact_PlaceholderReact = function(props) {
    var _contentTypeId = props.contentTypeId, contentTypeId = _contentTypeId === void 0 ? 0 : _contentTypeId, _objectId = props.objectId, objectId = _objectId === void 0 ? 0 : _objectId, _pkey = props.pkey, pkey = _pkey === void 0 ? '' : _pkey;
    var utente = useUtente().utente;
    var ref = useState(null), content1 = ref[0], setContent = ref[1];
    useEffect(function() {
        var content = null;
        if (utente && utente.edit) {
            content = /*#__PURE__*/ _jsx("div", {
                className: "pb-content active",
                children: /*#__PURE__*/ _jsx("iframe", {
                    className: "pagebuilder-placeholder",
                    src: "/pagebuilder/?contentTypeId=".concat(contentTypeId, "&objectId=").concat(objectId, "&key=").concat(pkey),
                    title: "Pagebuilder"
                })
            });
        } else {
            content = /*#__PURE__*/ _jsx("div", {
                className: "pb-content",
                children: /*#__PURE__*/ _jsx(PageBuilder, {
                    contentTypeId: contentTypeId,
                    objectId: objectId,
                    pkey: pkey
                })
            });
        }
        setContent(content);
    }, [
        utente
    ]);
    return(/*#__PURE__*/ _jsx(_Fragment, {
        children: !!content1 && content1
    }));
};
/* harmony default export */ var molecules_PlaceholderReact_PlaceholderReact = ((/* unused pure expression or super */ null && (PlaceholderReact_PlaceholderReact)));

// EXTERNAL MODULE: ../../libs/shared-ui/src/molecules/ProdottoCard/ProdottoCard.module.sass
var ProdottoCard_module = __webpack_require__(60397);
var ProdottoCard_module_default = /*#__PURE__*/__webpack_require__.n(ProdottoCard_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/molecules/ProdottoCard/ProdottoCard.tsx





var ProdottoCard = function(props) {
    var ref;
    var _prodotto = props.prodotto, prodotto = _prodotto === void 0 ? undefined : _prodotto, _variant = props.variant, variant = _variant === void 0 ? '' : _variant, _className = props.className, className = _className === void 0 ? '' : _className, _onClick = props.onClick, onClick = _onClick === void 0 ? function() {
        return undefined;
    } : _onClick;
    return prodotto ? /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
        href: prodotto.url,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            className: "".concat((ProdottoCard_module_default()).prodottoCard, " ").concat(variant ? (ProdottoCard_module_default())["prodottoCard--".concat(variant)] : '', " ").concat(className),
            onClick: onClick,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ProdottoCard_module_default()).imageBox,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WImage */.Tg, {
                        src: prodotto.previewImage,
                        maxWidth: 318,
                        maxHeight: 140,
                        layout: "intrinsic",
                        objectFit: "cover"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ProdottoCard_module_default()).content,
                    children: [
                        !!((ref = prodotto.tags) === null || ref === void 0 ? void 0 : ref.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ProdottoCard_module_default()).chips,
                            children: prodotto.tags.slice(0, 4).map(function(tag) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(atoms/* Chip */.Af, {
                                    label: tag.titolo,
                                    variant: "blue",
                                    size: "sm",
                                    weight: "regular"
                                }, tag.pk);
                            })
                        }),
                        !!prodotto.titolo && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (ProdottoCard_module_default()).title,
                            children: prodotto.titolo
                        }),
                        !!prodotto.descrizioneBreve && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ProdottoCard_module_default()).description,
                            dangerouslySetInnerHTML: {
                                __html: prodotto.descrizioneBreve
                            }
                        })
                    ]
                })
            ]
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var ProdottoCard_ProdottoCard = (ProdottoCard);

// EXTERNAL MODULE: ../../libs/shared-ui/src/molecules/TabTriggerCard/TabTriggerCard.module.sass
var TabTriggerCard_module = __webpack_require__(11010);
var TabTriggerCard_module_default = /*#__PURE__*/__webpack_require__.n(TabTriggerCard_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/molecules/TabTriggerCard/TabTriggerCard.tsx



var TabTriggerCard = function(props) {
    var _icon = props.icon, icon = _icon === void 0 ? undefined : _icon, _label = props.label, label = _label === void 0 ? '' : _label, _onClick = props.onClick, onClick = _onClick === void 0 ? function() {
        return undefined;
    } : _onClick, _className = props.className, className = _className === void 0 ? '' : _className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        onClick: onClick,
        className: "".concat((TabTriggerCard_module_default()).tabTriggerCard, " ").concat(className ? " ".concat(className) : ''),
        children: [
            !!icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (TabTriggerCard_module_default()).icon,
                children: icon
            }),
            !!label && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (TabTriggerCard_module_default()).label,
                children: label
            })
        ]
    }));
};
/* harmony default export */ var TabTriggerCard_TabTriggerCard = (TabTriggerCard);

// EXTERNAL MODULE: ../../libs/shared-ui/src/molecules/TextCtaBox/TextCtaBox.module.sass
var TextCtaBox_module = __webpack_require__(67055);
var TextCtaBox_module_default = /*#__PURE__*/__webpack_require__.n(TextCtaBox_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/molecules/TextCtaBox/TextCtaBox.tsx




var TextCtaBox = function(props) {
    var _item = props.item, item = _item === void 0 ? undefined : _item, _size = props.size, size = _size === void 0 ? 'lg' : _size, _className = props.className, className = _className === void 0 ? '' : _className, _onClick = props.onClick, onClick = _onClick === void 0 ? function() {
        return undefined;
    } : _onClick;
    return item ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((TextCtaBox_module_default()).textCtaBox, " ").concat((TextCtaBox_module_default())["textCtaBox--".concat(size)], " ").concat(className ? " ".concat(className) : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (TextCtaBox_module_default()).content,
                children: [
                    !!item.name && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (TextCtaBox_module_default()).title,
                        children: item.name
                    }),
                    !!item.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (TextCtaBox_module_default()).description,
                        dangerouslySetInnerHTML: {
                            __html: item.description
                        }
                    })
                ]
            }),
            !!item.ctaLabel && !!item.url && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (TextCtaBox_module_default()).ctaBox,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                    label: item.ctaLabel,
                    variant: "tertiary2",
                    href: item.url,
                    onClick: onClick
                })
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var TextCtaBox_TextCtaBox = (TextCtaBox);

// EXTERNAL MODULE: ../../libs/shared-ui/src/molecules/UseCaseCard/UseCaseCard.module.sass
var UseCaseCard_module = __webpack_require__(84605);
var UseCaseCard_module_default = /*#__PURE__*/__webpack_require__.n(UseCaseCard_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/molecules/UseCaseCard/UseCaseCard.tsx





var UseCaseCard = function(props) {
    var _item = props.item, item = _item === void 0 ? undefined : _item, _className = props.className, className = _className === void 0 ? '' : _className, _onClick = props.onClick, onClick = _onClick === void 0 ? function() {
        return undefined;
    } : _onClick;
    var isMobile = (0,hooks/* useIsMobile */.dD)();
    return item ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((UseCaseCard_module_default()).useCaseCard, " ").concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (UseCaseCard_module_default()).imageBox,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WImage */.Tg, {
                    src: isMobile ? item.mainImageResponsive : item.mainImage,
                    maxWidth: 350,
                    maxHeight: 266,
                    layout: "intrinsic",
                    objectFit: "cover"
                }, "use-case-card-".concat(item.pk, "-main-image").concat(isMobile ? '-mobile' : ''))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (UseCaseCard_module_default()).content,
                children: [
                    !!item.name && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (UseCaseCard_module_default()).title,
                        children: item.name
                    }),
                    !!item.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (UseCaseCard_module_default()).description,
                        dangerouslySetInnerHTML: {
                            __html: item.description
                        }
                    }),
                    !!item.ctaLabel && !!item.url && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (UseCaseCard_module_default()).ctaBox,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                            label: item.ctaLabel,
                            href: item.url,
                            variant: "ghost",
                            onClick: onClick
                        })
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var UseCaseCard_UseCaseCard = (UseCaseCard);

// EXTERNAL MODULE: ../../libs/shared-ui/src/molecules/ValorizzazioneCard/ValorizzazioneCard.module.sass
var ValorizzazioneCard_module = __webpack_require__(18057);
var ValorizzazioneCard_module_default = /*#__PURE__*/__webpack_require__.n(ValorizzazioneCard_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/molecules/ValorizzazioneCard/ValorizzazioneCard.tsx








var ValorizzazioneCard = function(props) {
    var ref5, ref1, ref2, ref3, ref4;
    var _valorizzazione = props.valorizzazione, valorizzazione = _valorizzazione === void 0 ? undefined : _valorizzazione, _className = props.className, className = _className === void 0 ? '' : _className;
    var t = (0,hooks/* useTrans */.IA)();
    var getLastItem = function(thePath) {
        return thePath.substring(thePath.lastIndexOf('/') + 1);
    };
    return valorizzazione ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((ValorizzazioneCard_module_default()).valorizzazioneCard, " ").concat(className ? " ".concat(className) : ''),
        children: [
            ((ref5 = valorizzazione.valoreQuota) === null || ref5 === void 0 ? void 0 : ref5.data) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: (ValorizzazioneCard_module_default()).data,
                children: [
                    t('Data'),
                    ": ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (ValorizzazioneCard_module_default()).value,
                        children: (0,safe/* dateFormat */.vc)((ref1 = valorizzazione.valoreQuota) === null || ref1 === void 0 ? void 0 : ref1.data)
                    })
                ]
            }),
            valorizzazione.descrizioneCompleta && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (ValorizzazioneCard_module_default()).title,
                children: valorizzazione.descrizioneCompleta
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ValorizzazioneCard_module_default()).attrs,
                children: [
                    valorizzazione.codiceFondo && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: (ValorizzazioneCard_module_default()).attr,
                        children: [
                            t('Codice Sicav'),
                            ": ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (ValorizzazioneCard_module_default()).value,
                                children: valorizzazione.codiceFondo
                            })
                        ]
                    }),
                    valorizzazione.codiceIsin && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: (ValorizzazioneCard_module_default()).attr,
                        children: [
                            t('Codice ISIN'),
                            ": ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (ValorizzazioneCard_module_default()).value,
                                children: valorizzazione.codiceIsin
                            })
                        ]
                    })
                ]
            }),
            ((ref2 = valorizzazione.valoreQuota) === null || ref2 === void 0 ? void 0 : ref2.valore) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: (ValorizzazioneCard_module_default()).valore,
                children: [
                    t('Valore quota'),
                    " (",
                    (ref3 = valorizzazione.valoreQuota) === null || ref3 === void 0 ? void 0 : ref3.divisa,
                    "): ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (ValorizzazioneCard_module_default()).value,
                        children: (ref4 = valorizzazione.valoreQuota) === null || ref4 === void 0 ? void 0 : ref4.valore
                    })
                ]
            }),
            valorizzazione.prospettoUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ValorizzazioneCard_module_default()).ctaBox,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                    label: t("Vai al PDF"),
                    rightIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.ArrowRight, {}),
                    variant: "ghost",
                    href: valorizzazione.prospettoUrl,
                    onClick: function() {
                        var ref;
                        return (0,gtm/* sendGTMData */.S3)({
                            event: "GAevent",
                            eventCategory: "valorizzazione",
                            eventAction: (ref = valorizzazione.descrizioneCompleta) === null || ref === void 0 ? void 0 : ref.toGTMFormat(),
                            eventLabel: getLastItem(valorizzazione.prospettoUrl)
                        });
                    }
                })
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var ValorizzazioneCard_ValorizzazioneCard = (ValorizzazioneCard);

;// CONCATENATED MODULE: ../../libs/shared-ui/src/molecules/index.ts




















// EXTERNAL MODULE: ../../libs/shared-ui/src/organisms/ArchivioFascicoliListing/ArchivioFascicoliListing.module.sass
var ArchivioFascicoliListing_module = __webpack_require__(46101);
var ArchivioFascicoliListing_module_default = /*#__PURE__*/__webpack_require__.n(ArchivioFascicoliListing_module);
// EXTERNAL MODULE: ../../libs/shared-graphql/src/lib/generated-assicurazioni/index.ts + 1 modules
var generated_assicurazioni = __webpack_require__(25246);
// EXTERNAL MODULE: ../../libs/shared-graphql/src/lib/generated-vita/index.ts + 1 modules
var generated_vita = __webpack_require__(93652);
// EXTERNAL MODULE: ../../libs/shared-ui/utils/settings.ts
var settings = __webpack_require__(29274);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/organisms/ArchivioFascicoliListing/ArchivioFascicoliListing.tsx
















function ArchivioFascicoliListing_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ArchivioFascicoliListing_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ArchivioFascicoliListing_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var ArchivioFascicoliListing = function(props) {
    var ref10, ref1, ref2;
    var _className = props.className, className = _className === void 0 ? '' : _className, _isCatalogoFondi = props.isCatalogoFondi, isCatalogoFondi = _isCatalogoFondi === void 0 ? false : _isCatalogoFondi;
    var t = (0,hooks/* useTrans */.IA)();
    var site = (0,hooks/* useSite */.W4)();
    var useCategorieFascicoliQuery = site === settings/* ASSICURAZIONI */.Cu ? generated_assicurazioni/* useCategorieFascicoliQuery */.fT : generated_vita/* useCategorieFascicoliQuery */.fT;
    var useFascioliQuery = isCatalogoFondi ? site === settings/* ASSICURAZIONI */.Cu ? generated_assicurazioni/* useCatalogoFondiQuery */.kI : generated_vita/* useCatalogoFondiQuery */.kI : site === settings/* ASSICURAZIONI */.Cu ? generated_assicurazioni/* useFascicoliQuery */.zN : generated_vita/* useFascicoliQuery */.zN;
    var ref3 = (0,react.useState)(1), page1 = ref3[0], setPage = ref3[1];
    var ref4 = (0,react.useState)([]), filtriAttivi = ref4[0], setFiltriAttivi = ref4[1];
    var toggleFiltro = function(slug) {
        var newFiltriAttivi = [];
        if (slug) {
            if (filtriAttivi.indexOf(slug) > -1) newFiltriAttivi = filtriAttivi.filter(function(x) {
                return x !== slug;
            });
            else newFiltriAttivi = filtriAttivi.concat([
                slug
            ]);
        }
        setFiltriAttivi(newFiltriAttivi);
        setPage(1);
        refetch(ArchivioFascicoliListing_objectSpread({
            offset: 0,
            first: settings/* FASCICOLI_LISTING_ITEMS_PER_PAGE */.Sj
        }, isCatalogoFondi ? {} : {
            categoria_Slug_In: newFiltriAttivi
        }));
    };
    var handleChangePage = function(value) {
        setPage(value);
        refetch(ArchivioFascicoliListing_objectSpread({
            offset: (value - 1) * settings/* FASCICOLI_LISTING_ITEMS_PER_PAGE */.Sj,
            first: settings/* FASCICOLI_LISTING_ITEMS_PER_PAGE */.Sj
        }, isCatalogoFondi ? {} : {
            categoria_Slug_In: filtriAttivi
        }));
    };
    var ref5 = (0,react.useState)(), searchInput = ref5[0], setSearchInput = ref5[1];
    var handleSearchSubmit = function(value) {
        setPage(1);
        refetch({
            offset: 0,
            first: settings/* FASCICOLI_LISTING_ITEMS_PER_PAGE */.Sj,
            titolo_Icontains: value ? value : undefined
        });
    };
    var ref6 = useCategorieFascicoliQuery(), categorieFascicoliData = ref6.data;
    var ref7 = useFascioliQuery({
        variables: {
            offset: 0,
            first: settings/* FASCICOLI_LISTING_ITEMS_PER_PAGE */.Sj
        }
    }), data = ref7.data, loading = ref7.loading, error = ref7.error, refetch = ref7.refetch;
    var totalCount = isCatalogoFondi ? data === null || data === void 0 ? void 0 : (ref10 = data.catalogoFondi) === null || ref10 === void 0 ? void 0 : ref10.totalCount : data === null || data === void 0 ? void 0 : (ref1 = data.fascicoli) === null || ref1 === void 0 ? void 0 : ref1.totalCount;
    var listingData = isCatalogoFondi ? data === null || data === void 0 ? void 0 : data.catalogoFondi : data === null || data === void 0 ? void 0 : data.fascicoli;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((ArchivioFascicoliListing_module_default()).magazineListing, " ").concat(className ? " ".concat(className) : ''),
        children: [
            !isCatalogoFondi && !!(categorieFascicoliData === null || categorieFascicoliData === void 0 ? void 0 : (ref2 = categorieFascicoliData.categorieFascicoli) === null || ref2 === void 0 ? void 0 : ref2.edges.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ArchivioFascicoliListing_module_default()).filtersList,
                        children: categorieFascicoliData.categorieFascicoli.edges.map(function(filtro) {
                            return (filtro === null || filtro === void 0 ? void 0 : filtro.node) && filtro.node.numFascicoli ? /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Chip */.Af, {
                                label: filtro.node.nome,
                                onClick: function() {
                                    var ref, ref8, ref9;
                                    toggleFiltro((ref = filtro.node) === null || ref === void 0 ? void 0 : ref.slug);
                                    (0,gtm/* sendGTMData */.S3)({
                                        event: "GAevent",
                                        eventCategory: 'filtri',
                                        eventAction: filtro === null || filtro === void 0 ? void 0 : (ref8 = filtro.node) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.nome) === null || ref9 === void 0 ? void 0 : ref9.toGTMFormat(),
                                        eventLabel: isCatalogoFondi ? 'catalogo_fondi' : 'fascicoli'
                                    });
                                },
                                active: filtro.node.slug ? filtriAttivi.indexOf(filtro.node.slug) > -1 : false
                            }, filtro.node.pk) : null;
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ArchivioFascicoliListing_module_default()).filtersSlider,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper/* Swiper */.t, {
                            spaceBetween: 16,
                            slidesPerView: "auto",
                            watchOverflow: true,
                            children: categorieFascicoliData.categorieFascicoli.edges.map(function(filtro) {
                                return (filtro === null || filtro === void 0 ? void 0 : filtro.node) && filtro.node.numFascicoli ? /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Chip */.Af, {
                                        label: filtro.node.nome,
                                        onClick: function() {
                                            var ref, ref11, ref12;
                                            toggleFiltro((ref = filtro.node) === null || ref === void 0 ? void 0 : ref.slug);
                                            (0,gtm/* sendGTMData */.S3)({
                                                event: "GAevent",
                                                eventCategory: 'filtri',
                                                eventAction: filtro === null || filtro === void 0 ? void 0 : (ref11 = filtro.node) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.nome) === null || ref12 === void 0 ? void 0 : ref12.toGTMFormat(),
                                                eventLabel: isCatalogoFondi ? 'catalogo_fondi' : 'fascicoli'
                                            });
                                        },
                                        active: filtro.node.slug ? filtriAttivi.indexOf(filtro.node.slug) > -1 : false
                                    })
                                }, filtro.node.pk) : null;
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ArchivioFascicoliListing_module_default()).advanced,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: (ArchivioFascicoliListing_module_default()).title,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: t("Risultati")
                            }),
                            " (",
                            totalCount,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ArchivioFascicoliListing_module_default()).search,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "text",
                                placeholder: isCatalogoFondi ? t("Cerca un fondo...") : t("Cerca un fascicolo..."),
                                onChange: function(e) {
                                    var value = e.target.value;
                                    setSearchInput(value);
                                    if (!value) {
                                        handleSearchSubmit(value);
                                    }
                                },
                                className: (ArchivioFascicoliListing_module_default()).input,
                                autoComplete: "off"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "submit",
                                onClick: function() {
                                    handleSearchSubmit(searchInput);
                                    (0,gtm/* sendGTMData */.S3)({
                                        event: "GAevent",
                                        eventCategory: isCatalogoFondi ? "search_catalogo_fondi" : "search_fascicoli",
                                        eventAction: searchInput === null || searchInput === void 0 ? void 0 : searchInput.toGTMFormat(),
                                        eventLabel: isCatalogoFondi ? "catalogo_fondi" : "fascicoli"
                                    });
                                },
                                className: (ArchivioFascicoliListing_module_default()).submit,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.Search, {})
                            })
                        ]
                    })
                ]
            }),
            loading && !data ? /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Loader */.aN, {
                className: (ArchivioFascicoliListing_module_default()).loader
            }) : error ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ArchivioFascicoliListing_module_default()).error,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* NotificationBar */.o4, {
                    variant: "alert",
                    label: error.message,
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.Alert, {})
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ArchivioFascicoliListing_module_default()).list,
                        children: listingData === null || listingData === void 0 ? void 0 : listingData.edges.map(function(fascicolo) {
                            return (fascicolo === null || fascicolo === void 0 ? void 0 : fascicolo.node) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ArchivioFascicoliListing_module_default()).item,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FascicoloCard_FascicoloCard, {
                                    fascicolo: fascicolo.node,
                                    isCatalogoFondi: isCatalogoFondi
                                })
                            }, fascicolo.node.pk);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Pagination */.tl, {
                        currentPage: page1,
                        totalCount: totalCount ? totalCount : 0,
                        pageSize: settings/* FASCICOLI_LISTING_ITEMS_PER_PAGE */.Sj,
                        onPageChange: function(page) {
                            return handleChangePage(page);
                        },
                        className: (ArchivioFascicoliListing_module_default()).pagination
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var ArchivioFascicoliListing_ArchivioFascicoliListing = (ArchivioFascicoliListing);

// EXTERNAL MODULE: ../../libs/shared-ui/src/organisms/ArticoloPrimoPiano/ArticoloPrimoPiano.module.sass
var ArticoloPrimoPiano_module = __webpack_require__(86309);
var ArticoloPrimoPiano_module_default = /*#__PURE__*/__webpack_require__.n(ArticoloPrimoPiano_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/organisms/ArticoloPrimoPiano/ArticoloPrimoPiano.tsx







var ArticoloPrimoPiano = function(props) {
    var _title = props.title, title = _title === void 0 ? '' : _title, _articolo = props.articolo, articolo = _articolo === void 0 ? null : _articolo, _className = props.className, className = _className === void 0 ? '' : _className;
    var t = (0,hooks/* useTrans */.IA)();
    return articolo ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((ArticoloPrimoPiano_module_default()).articoloPrimoPiano, " ").concat(className ? " ".concat(className) : ''),
        children: [
            !!title && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (ArticoloPrimoPiano_module_default()).mainTitle,
                dangerouslySetInnerHTML: {
                    __html: title
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ArticoloPrimoPiano_module_default()).layout,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ArticoloPrimoPiano_module_default()).imageBox,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WImage */.Tg, {
                            src: articolo.mainImage,
                            maxWidth: 542,
                            maxHeight: 309,
                            alt: articolo.title,
                            title: articolo.title,
                            layout: "intrinsic",
                            objectFit: "cover",
                            priority: true,
                            loading: "eager"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ArticoloPrimoPiano_module_default()).content,
                        children: [
                            !!articolo.publicationDate && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (ArticoloPrimoPiano_module_default()).date,
                                children: articolo.publicationDate
                            }),
                            !!articolo.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (ArticoloPrimoPiano_module_default()).title,
                                children: articolo.title
                            }),
                            !!articolo.abstract && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ArticoloPrimoPiano_module_default()).abstract,
                                dangerouslySetInnerHTML: {
                                    __html: articolo.abstract
                                }
                            }),
                            !!articolo.url && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ArticoloPrimoPiano_module_default()).ctaBox,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: articolo.url,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: (ArticoloPrimoPiano_module_default()).cta,
                                        onClick: function() {
                                            var ref;
                                            return (0,gtm/* sendGTMData */.S3)({
                                                event: "GAevent",
                                                eventCategory: 'articolo',
                                                eventAction: articolo === null || articolo === void 0 ? void 0 : (ref = articolo.title) === null || ref === void 0 ? void 0 : ref.toGTMFormat(),
                                                eventLabel: 'magazine'
                                            });
                                        },
                                        children: t("Leggi di pi\xf9")
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var ArticoloPrimoPiano_ArticoloPrimoPiano = (ArticoloPrimoPiano);

// EXTERNAL MODULE: ../../libs/shared-ui/contexts/chatBotContext.tsx
var chatBotContext = __webpack_require__(72056);
// EXTERNAL MODULE: ../../libs/shared-ui/src/organisms/AssistenzaSection/AssistenzaSection.module.sass
var AssistenzaSection_module = __webpack_require__(18859);
var AssistenzaSection_module_default = /*#__PURE__*/__webpack_require__.n(AssistenzaSection_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/organisms/AssistenzaSection/AssistenzaSection.tsx








function AssistenzaSection_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function AssistenzaSection_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            AssistenzaSection_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var AssistenzaSection = function(props) {
    var ref2, ref1;
    var _item = props.item, item = _item === void 0 ? undefined : _item, _className = props.className, className = _className === void 0 ? '' : _className;
    var chatbotCtx = (0,react.useContext)(chatBotContext/* ChatBotContext */.i);
    return item ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((AssistenzaSection_module_default()).assistenzaSection, " ").concat(className ? " ".concat(className) : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (AssistenzaSection_module_default()).content,
                children: [
                    !!item.name && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* IntroTitle */.Om, {
                        label: item.name,
                        className: (AssistenzaSection_module_default()).intro
                    }),
                    !!item.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (AssistenzaSection_module_default()).title,
                        dangerouslySetInnerHTML: {
                            __html: item.description
                        }
                    }),
                    !!((ref2 = item.children) === null || ref2 === void 0 ? void 0 : (ref1 = ref2.edges) === null || ref1 === void 0 ? void 0 : ref1.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (AssistenzaSection_module_default()).list,
                        children: item.children.edges.map(function(child) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(atoms/* AssistenzaButton */.zm, AssistenzaSection_objectSpread({
                                label: child.node.description || '',
                                icon: getIcon(child.node.style),
                                newPage: child.node.blank
                            }, child.node.url ? {
                                url: child.node.url,
                                onClick: function() {
                                    var ref;
                                    (0,gtm/* sendGTMData */.S3)({
                                        event: "GAevent",
                                        eventCategory: 'box_info',
                                        eventAction: 'chiedi_aiuto',
                                        eventLabel: ((ref = child.node.description) === null || ref === void 0 ? void 0 : ref.toGTMFormat()) || ''
                                    });
                                }
                            } : {
                                onClick: function() {
                                    var ref;
                                    chatbotCtx.openChatBot(child.node);
                                    (0,gtm/* sendGTMData */.S3)({
                                        event: "GAevent",
                                        eventCategory: 'box_info',
                                        eventAction: 'chiedi_aiuto',
                                        eventLabel: ((ref = child.node.description) === null || ref === void 0 ? void 0 : ref.toGTMFormat()) || ''
                                    });
                                }
                            }), child.node.pk);
                        })
                    }),
                    !!item.ctaLabel && !!item.chatbotUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (AssistenzaSection_module_default()).ctaBox,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                            label: item.ctaLabel,
                            rightIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.ArrowRight, {}),
                            variant: "ghost",
                            onClick: function() {
                                var ref;
                                return (0,gtm/* sendGTMData */.S3)({
                                    event: "GAevent",
                                    eventCategory: 'box_info',
                                    eventAction: 'chiedi_aiuto',
                                    eventLabel: (ref = item.ctaLabel) === null || ref === void 0 ? void 0 : ref.toGTMFormat()
                                });
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (AssistenzaSection_module_default()).images,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (AssistenzaSection_module_default()).imageBox,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WImage */.Tg, {
                            src: item.secondaryImage,
                            maxWidth: 380,
                            maxHeight: 440,
                            layout: "intrinsic",
                            objectFit: "cover"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (AssistenzaSection_module_default()).imageBox,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WImage */.Tg, {
                            src: item.mainImage,
                            maxWidth: 380,
                            maxHeight: 440,
                            layout: "intrinsic",
                            objectFit: "cover"
                        })
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var AssistenzaSection_AssistenzaSection = (AssistenzaSection);

// EXTERNAL MODULE: ../../libs/shared-ui/src/organisms/ChatBotOverlay/ChatBotOverlay.module.sass
var ChatBotOverlay_module = __webpack_require__(8753);
var ChatBotOverlay_module_default = /*#__PURE__*/__webpack_require__.n(ChatBotOverlay_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/organisms/ChatBotOverlay/ChatBotOverlay.tsx








function _throw(e) {
    throw e;
}
var ChatBotOverlay = function(props) {
    var props = props !== null ? props : _throw(new TypeError("Cannot destructure undefined"));
    var t = (0,hooks/* useTrans */.IA)();
    var site = (0,hooks/* useSite */.W4)();
    var chatbotCtx = (0,react.useContext)(chatBotContext/* ChatBotContext */.i);
    (0,react.useEffect)(function() {
        if (chatbotCtx.chatBotVisible) document.body.classList.add('w-noscroll');
        else document.body.classList.remove('w-noscroll');
    }, [
        chatbotCtx.chatBotVisible
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((ChatBotOverlay_module_default()).chatBotOverlay, " ").concat(chatbotCtx.chatBotVisible ? (ChatBotOverlay_module_default())["chatBotOverlay--visible"] : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ChatBotOverlay_module_default()).head,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ChatBotOverlay_module_default()).headContent,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ChatBotOverlay_module_default()).logo,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                href: "/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: site === settings/* ASSICURAZIONI */.Cu ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.LogoAssicurazioni, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.LogoVita, {})
                                })
                            })
                        }),
                        !!chatbotCtx.setChatBotVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            "aria-label": t("Chiudi"),
                            onClick: function() {
                                return chatbotCtx.setChatBotVisible(false);
                            },
                            className: (ChatBotOverlay_module_default()).close,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.Close, {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "xenioowebchat",
                className: (ChatBotOverlay_module_default()).content
            })
        ]
    }));
};
/* harmony default export */ var ChatBotOverlay_ChatBotOverlay = (ChatBotOverlay);

// EXTERNAL MODULE: ../../node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(63397);
// EXTERNAL MODULE: ../../node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(24511);
// EXTERNAL MODULE: ../../libs/shared-ui/src/organisms/ContattaciForm/ContattaciForm.module.sass
var ContattaciForm_module = __webpack_require__(29718);
var ContattaciForm_module_default = /*#__PURE__*/__webpack_require__.n(ContattaciForm_module);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react-google-recaptcha-v3/dist/react-google-recaptcha-v3.esm.js
var react_google_recaptcha_v3_esm = __webpack_require__(17473);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/organisms/ContattaciForm/ContattaciForm.tsx















function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function ContattaciForm_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ContattaciForm_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ContattaciForm_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var ContattaciForm = function(props) {
    var ref4;
    var _id = props.id, id = _id === void 0 ? '' : _id, _className = props.className, className = _className === void 0 ? '' : _className, _formContattiRef = props.formContattiRef, formContattiRef = _formContattiRef === void 0 ? null : _formContattiRef;
    var t = (0,hooks/* useTrans */.IA)();
    var site = (0,hooks/* useSite */.W4)();
    var router = (0,next_router.useRouter)();
    var executeRecaptcha = (0,react_google_recaptcha_v3_esm/* useGoogleReCaptcha */.xX)().executeRecaptcha;
    var useCreateRichiestaContattoMutation = site === settings/* ASSICURAZIONI */.Cu ? generated_assicurazioni/* useCreateRichiestaContattoMutation */.Fu : generated_vita/* useCreateRichiestaContattoMutation */.Fu;
    var ref1 = _slicedToArray(useCreateRichiestaContattoMutation(), 1), createRichiestaContattoMutation = ref1[0];
    var useTipologieContattoQuery = site === settings/* ASSICURAZIONI */.Cu ? generated_assicurazioni/* useTipologieContattoQuery */.AV : generated_vita/* useTipologieContattoQuery */.AV;
    var data = useTipologieContattoQuery().data;
    var campiVariabili = [
        {
            pk: 1,
            key: 'nome',
            yupType: es/* string */.Z_()
        },
        {
            pk: 2,
            key: 'cognome',
            yupType: es/* string */.Z_()
        },
        {
            pk: 3,
            key: 'email',
            yupType: es/* string */.Z_().email(t('Inserire un\'email valida'))
        },
        {
            pk: 4,
            key: 'numero_polizza',
            yupType: es/* string */.Z_()
        },
        {
            pk: 5,
            key: 'allegati',
            yupType: es/* mixed */.nK()
        },
        {
            pk: 6,
            key: 'messaggio',
            yupType: es/* string */.Z_()
        },
        {
            pk: 7,
            key: 'cf',
            yupType: es/* string */.Z_()
        },
        {
            pk: 8,
            key: 'telefono',
            yupType: es/* string */.Z_()
        },
        {
            pk: 9,
            key: 'documento',
            yupType: es/* mixed */.nK()
        }, 
    ];
    var formData = (data === null || data === void 0 ? void 0 : (ref4 = data.tipologieContatto) === null || ref4 === void 0 ? void 0 : ref4.reduce(function(a, v) {
        return v ? ContattaciForm_objectSpread({}, a, ContattaciForm_defineProperty({}, v['key'], v)) : a;
    }, {})) || {};
    var ref2 = (0,react.useState)(null), error = ref2[0], setError = ref2[1];
    var ref3 = (0,react.useState)(undefined), tipoContatto = ref3[0], setTipoContatto = ref3[1];
    var formHasField = function(key) {
        return tipoContatto ? formData[tipoContatto].campiObbligatori.concat(formData[tipoContatto].campiFacoltativi).indexOf(key) > -1 : false;
    };
    var validationSchemaShape = {
        tipo_contatto: es/* string */.Z_().required(t('Campo obbligatorio')),
        privacy: es/* bool */.Xg().oneOf([
            true
        ], t("Campo obbligatorio"))
    };
    if (tipoContatto) {
        for(var index in campiVariabili)if (formHasField(campiVariabili[index].key)) validationSchemaShape[campiVariabili[index].key] = formData[tipoContatto].campiObbligatori.indexOf(campiVariabili[index].key) > -1 ? campiVariabili[index].yupType.required(t('Campo obbligatorio')) : campiVariabili[index].yupType;
    }
    var validationSchema = es/* object */.Ry().shape(validationSchemaShape);
    var initialValues = {
        nome: '',
        cognome: '',
        email: '',
        tipo_contatto: undefined,
        numero_polizza: '',
        cf: '',
        telefono: '',
        allegati: null,
        documento: null,
        messaggio: '',
        privacy: true
    };
    var setFormError = function(actions) {
        actions.setSubmitting(false);
        setError(t("Errore nell'invio dei dati, riprova pi\xf9 tardi"));
        (formContattiRef === null || formContattiRef === void 0 ? void 0 : formContattiRef.current) && (formContattiRef.current.scrollTop = 0);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((ContattaciForm_module_default()).contattaciForm, " ").concat(className ? " ".concat(className) : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (ContattaciForm_module_default()).title,
                dangerouslySetInnerHTML: {
                    __html: t("<strong>Hai bisogno di assistenza?</strong> Contattaci")
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                validationSchema: validationSchema,
                initialValues: initialValues,
                onSubmit: function(values, actions) {
                    if (!executeRecaptcha) {
                        setFormError(actions);
                        return;
                    }
                    executeRecaptcha('richiesta_contatto_submit').then(function(token) {
                        createRichiestaContattoMutation({
                            variables: {
                                input: {
                                    tipologia: values.tipo_contatto,
                                    nome: values.nome,
                                    cognome: values.cognome,
                                    email: values.email,
                                    numeroPolizza: values.numero_polizza,
                                    cf: values.cf,
                                    telefono: values.telefono,
                                    documento: values.documento,
                                    allegati: values.allegati,
                                    messaggio: values.messaggio,
                                    privacy: values.privacy,
                                    captcha: token
                                }
                            }
                        }).then(function(res) {
                            var ref;
                            setError(null);
                            (0,gtm/* sendGTMData */.S3)({
                                event: "GAevent",
                                eventCategory: 'form_contatto',
                                eventAction: (ref = values.tipo_contatto) === null || ref === void 0 ? void 0 : ref.toString().toGTMFormat(),
                                eventLabel: 'ok'
                            });
                            router.push('/contattaci/thank-you');
                        }).catch(function(err) {
                            setFormError(actions);
                        });
                    }).catch(function(err) {
                        setFormError(actions);
                    });
                },
                children: function(param) {
                    var values = param.values, errors = param.errors, touched = param.touched, isValid = param.isValid, handleChange = param.handleChange, handleBlur = param.handleBlur, setFieldValue = param.setFieldValue, isSubmitting = param.isSubmitting;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                        children: [
                            error && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ContattaciForm_module_default()).error,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* NotificationBar */.o4, {
                                    variant: "alert",
                                    label: error,
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.Alert, {})
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(atoms/* FormLayout */.lt, {
                                children: [
                                    (formHasField('nome') || !values.tipo_contatto) && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* FormField */.Wi, ContattaciForm_objectSpread({
                                        label: t("Nome")
                                    }, (0,safe/* getFormFieldArgs */.MG)('nome', values, errors, touched), {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* FormInput */.yt, {
                                            name: "nome",
                                            placeholder: t("Inserisci il tuo nome"),
                                            value: values.nome,
                                            onChange: handleChange,
                                            onBlur: handleBlur
                                        })
                                    })),
                                    (formHasField('cognome') || !values.tipo_contatto) && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* FormField */.Wi, ContattaciForm_objectSpread({
                                        label: t("Cognome")
                                    }, (0,safe/* getFormFieldArgs */.MG)('cognome', values, errors, touched), {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* FormInput */.yt, {
                                            name: "cognome",
                                            placeholder: t("Inserisci il tuo cognome"),
                                            value: values.cognome,
                                            onChange: handleChange,
                                            onBlur: handleBlur
                                        })
                                    })),
                                    (formHasField('email') || !values.tipo_contatto) && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* FormField */.Wi, ContattaciForm_objectSpread({
                                        label: t("E-mail")
                                    }, (0,safe/* getFormFieldArgs */.MG)('email', values, errors, touched), {
                                        layout: "full",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* FormInput */.yt, {
                                            name: "email",
                                            placeholder: t("Inserisci la tua e-mail"),
                                            type: "email",
                                            value: values.email,
                                            onChange: handleChange,
                                            onBlur: handleBlur
                                        })
                                    })),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* FormField */.Wi, ContattaciForm_objectSpread({
                                        label: t("Tipologia di richiesta")
                                    }, (0,safe/* getFormFieldArgs */.MG)('tipo_contatto', values, errors, touched), {
                                        layout: "full",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* FormSelect */.ih, {
                                            name: "tipo_contatto",
                                            value: values.tipo_contatto,
                                            placeholder: t("Seleziona la richiesta"),
                                            options: Object.keys(formData).map(function(key) {
                                                return {
                                                    label: formData[key].titolo,
                                                    value: key
                                                };
                                            }),
                                            onChange: function(e) {
                                                handleChange(e);
                                                var newTipoContatto = e.target.value || undefined;
                                                // elimina tutti i valori dei campi non presenti per il nuovo tipo_contatto
                                                if (newTipoContatto && tipoContatto) {
                                                    var newCampi = _toConsumableArray(formData[newTipoContatto]["campiObbligatori"]).concat(_toConsumableArray(formData[newTipoContatto]["campiFacoltativi"]));
                                                    var campi = _toConsumableArray(formData[tipoContatto]["campiObbligatori"]).concat(_toConsumableArray(formData[tipoContatto]["campiFacoltativi"]));
                                                    campi.forEach(function(c) {
                                                        if (!newCampi.includes(c)) {
                                                            setFieldValue(c, initialValues[c]);
                                                        }
                                                    });
                                                }
                                                setTipoContatto(newTipoContatto);
                                            },
                                            onBlur: handleBlur
                                        })
                                    })),
                                    formHasField('numero_polizza') && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* FormField */.Wi, ContattaciForm_objectSpread({
                                        label: t("Numero di polizza")
                                    }, (0,safe/* getFormFieldArgs */.MG)('numero_polizza', values, errors, touched), {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* FormInput */.yt, {
                                            name: "numero_polizza",
                                            placeholder: t("Inserisci il numero di polizza"),
                                            value: values.numero_polizza,
                                            onChange: handleChange,
                                            onBlur: handleBlur
                                        })
                                    }))
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(atoms/* FormLayout */.lt, {
                                children: [
                                    formHasField('cf') && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* FormField */.Wi, ContattaciForm_objectSpread({
                                        label: t("Codice Fiscale / P.IVA")
                                    }, (0,safe/* getFormFieldArgs */.MG)('cf', values, errors, touched), {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* FormInput */.yt, {
                                            name: "cf",
                                            placeholder: t("Inserisci il codice fiscale o P.IVA"),
                                            value: values.cf,
                                            onChange: handleChange,
                                            onBlur: handleBlur
                                        })
                                    })),
                                    formHasField('telefono') && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* FormField */.Wi, ContattaciForm_objectSpread({
                                        label: t("Telefono cellulare")
                                    }, (0,safe/* getFormFieldArgs */.MG)('telefono', values, errors, touched), {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* FormInput */.yt, {
                                            name: "telefono",
                                            placeholder: t("Inserisci il tuo numero"),
                                            value: values.telefono,
                                            onChange: handleChange,
                                            onBlur: handleBlur
                                        })
                                    })),
                                    formHasField('documento') && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* FormField */.Wi, ContattaciForm_objectSpread({
                                        label: t("Documento di identit\xe0")
                                    }, (0,safe/* getFormFieldArgs */.MG)('documento', values, errors, touched), {
                                        layout: "full",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* FormFile */.pO, {
                                            label: values.documento ? values.documento.name : t("Carica il tuo documento d’identit\xe0"),
                                            id: id ? "documento-".concat(id) : "documento",
                                            name: "documento",
                                            onChange: function(e) {
                                                return setFieldValue("documento", e.target.files[0]);
                                            },
                                            onBlur: handleBlur
                                        })
                                    })),
                                    formHasField('allegati') && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* FormField */.Wi, ContattaciForm_objectSpread({
                                        label: t("Allega qui eventuali documenti a supporto della tua richiesta")
                                    }, (0,safe/* getFormFieldArgs */.MG)('allegati', values, errors, touched), {
                                        layout: "full",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* FormFile */.pO, {
                                            label: values.allegati ? values.allegati.map(function(file) {
                                                return file.name;
                                            }).join(", ") : t("Aggiungi un allegato"),
                                            id: id ? "allegati-".concat(id) : "allegati",
                                            name: "allegati",
                                            multiple: true,
                                            onChange: function(e) {
                                                var files = Array.from(e.target.files).map(function(file) {
                                                    return file;
                                                });
                                                setFieldValue("allegati", files);
                                            },
                                            onBlur: handleBlur
                                        })
                                    })),
                                    (formHasField('messaggio') || !values.tipo_contatto) && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* FormField */.Wi, ContattaciForm_objectSpread({
                                        label: t("Testo della richiesta")
                                    }, (0,safe/* getFormFieldArgs */.MG)('messaggio', values, errors, touched), {
                                        layout: "full",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* FormTextarea */.B1, {
                                            name: "messaggio",
                                            placeholder: t("Inserisci qui il testo della richiesta"),
                                            value: values.messaggio,
                                            onChange: handleChange,
                                            onBlur: handleBlur
                                        })
                                    })),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* FormField */.Wi, {
                                        layout: "full",
                                        space: "lg",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (ContattaciForm_module_default()).privacyDisclaimer,
                                            dangerouslySetInnerHTML: {
                                                __html: t('La Compagnia tratter\xe0 i tuoi dati nel rispetto del Regolamento Europeo sulla protezione dei dati  2016/679 (“GDPR”), per maggiori dettagli prendi visione dell’informativa sul trattamento disponibile al seguente {0}link{1}', [
                                                    '<a href="/privacy">',
                                                    '</a>'
                                                ])
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ContattaciForm_module_default()).submitBox,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                                    type: "submit",
                                    label: t("Invia messaggio"),
                                    className: (ContattaciForm_module_default()).submit,
                                    disabled: !Object.keys(touched).length || !isValid || isSubmitting
                                })
                            })
                        ]
                    });
                }
            })
        ]
    }));
};
/* harmony default export */ var ContattaciForm_ContattaciForm = (ContattaciForm);

// EXTERNAL MODULE: ../../libs/shared-ui/src/organisms/FaqCategoriesListing/FaqCategoriesListing.module.sass
var FaqCategoriesListing_module = __webpack_require__(66612);
var FaqCategoriesListing_module_default = /*#__PURE__*/__webpack_require__.n(FaqCategoriesListing_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/organisms/FaqCategoriesListing/FaqCategoriesListing.tsx





var FaqCategoriesListing = function(props) {
    var _className = props.className, className = _className === void 0 ? '' : _className, _categorieFaq = props.categorieFaq, categorieFaq = _categorieFaq === void 0 ? [] : _categorieFaq;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((FaqCategoriesListing_module_default()).faqCategoriesListing, " ").concat(className ? " ".concat(className) : ''),
        children: categorieFaq.map(function(item) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(FaqCategoryCard_FaqCategoryCard, {
                item: item,
                onClick: function() {
                    var ref;
                    return (0,gtm/* sendGTMData */.S3)({
                        event: "GAevent",
                        eventCategory: 'faq_category',
                        eventAction: item === null || item === void 0 ? void 0 : (ref = item.titolo) === null || ref === void 0 ? void 0 : ref.toGTMFormat()
                    });
                }
            }, item.pk);
        })
    }));
};
/* harmony default export */ var FaqCategoriesListing_FaqCategoriesListing = (FaqCategoriesListing);

// EXTERNAL MODULE: ../../libs/shared-ui/src/organisms/FaqSearchForm/FaqSearchForm.module.sass
var FaqSearchForm_module = __webpack_require__(17845);
var FaqSearchForm_module_default = /*#__PURE__*/__webpack_require__.n(FaqSearchForm_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/organisms/FaqSearchForm/FaqSearchForm.tsx






var FaqSearchForm = function(props) {
    var _className = props.className, className = _className === void 0 ? '' : _className;
    var t = (0,hooks/* useTrans */.IA)();
    var router = (0,next_router.useRouter)();
    var submit = function(e) {
        e.preventDefault();
        var query = e.target.q.value;
        router.push('/faq?q=' + query);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
        className: "".concat((FaqSearchForm_module_default()).faqSearchForm, " ").concat(className ? " ".concat(className) : ''),
        onSubmit: submit,
        autoComplete: "off",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (FaqSearchForm_module_default()).inputWrap,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                    type: "text",
                    name: "q",
                    placeholder: t("Ho bisogno di..."),
                    className: (FaqSearchForm_module_default()).input,
                    autoComplete: "off"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "submit",
                    className: (FaqSearchForm_module_default()).submit,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.Search, {})
                })
            ]
        })
    }));
};
/* harmony default export */ var FaqSearchForm_FaqSearchForm = (FaqSearchForm);

// EXTERNAL MODULE: ../../libs/shared-ui/src/organisms/FaqSection/FaqSection.module.sass
var FaqSection_module = __webpack_require__(22017);
var FaqSection_module_default = /*#__PURE__*/__webpack_require__.n(FaqSection_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/organisms/FaqSection/FaqSection.tsx








var FaqSection = function(props) {
    var ref3, ref1;
    var _faqs = props.faqs, faqs = _faqs === void 0 ? [] : _faqs, _faqMenu = props.faqMenu, faqMenu = _faqMenu === void 0 ? null : _faqMenu, _className = props.className, className = _className === void 0 ? '' : _className;
    var t = (0,hooks/* useTrans */.IA)();
    var maxVisible = 8;
    var ref2 = (0,react.useState)(false), showAll = ref2[0], setShowAll = ref2[1];
    var contacts = (ref1 = faqMenu === null || faqMenu === void 0 ? void 0 : (ref3 = faqMenu.children) === null || ref3 === void 0 ? void 0 : ref3.edges.find(function(child) {
        return child.node.key === "contacts";
    })) === null || ref1 === void 0 ? void 0 : ref1.node;
    return faqMenu && (faqs === null || faqs === void 0 ? void 0 : faqs.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((FaqSection_module_default()).faqSection, " ").concat(className ? " ".concat(className) : ''),
        children: [
            (faqMenu === null || faqMenu === void 0 ? void 0 : faqMenu.name) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (FaqSection_module_default()).title,
                dangerouslySetInnerHTML: {
                    __html: faqMenu.name
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (FaqSection_module_default()).list,
                children: [
                    (showAll ? faqs : faqs.slice(0, maxVisible)).map(function(faq) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(atoms/* Accordion */.UQ, {
                            label: faq.domanda,
                            content: faq.risposta,
                            onClick: function() {
                                var ref;
                                return (0,gtm/* sendGTMData */.S3)({
                                    event: "GAevent",
                                    eventCategory: "faq",
                                    eventAction: (ref = faq.domanda) === null || ref === void 0 ? void 0 : ref.toGTMFormat(),
                                    eventLabel: "pdp"
                                });
                            }
                        }, faq.pk);
                    }),
                    !showAll && faqs.length > maxVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (FaqSection_module_default()).showAll,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                            label: t(faqs.length - maxVisible === 1 ? "Mostra {0} altra domanda" : "Mostra altre {0} domande", [
                                (faqs.length - maxVisible).toString()
                            ]),
                            rightIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.ArrowRight, {}),
                            variant: "ghost",
                            onClick: function() {
                                return setShowAll(true);
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (FaqSection_module_default()).actions,
                children: [
                    (faqMenu === null || faqMenu === void 0 ? void 0 : faqMenu.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (FaqSection_module_default()).allLink,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                            href: faqMenu.url,
                            label: faqMenu.ctaLabel,
                            rightIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.ArrowRight, {}),
                            variant: "ghost",
                            onClick: function() {
                                return (0,gtm/* sendGTMData */.S3)({
                                    event: "GAevent",
                                    eventCategory: "faq",
                                    eventAction: "vai_a_tutte",
                                    eventLabel: "pdp"
                                });
                            }
                        })
                    }),
                    !!contacts && /*#__PURE__*/ (0,jsx_runtime.jsx)(OutlineTextCtaBox_OutlineTextCtaBox, {
                        item: {
                            name: contacts.name,
                            description: contacts.description,
                            ctaLabel: contacts.ctaLabel,
                            url: contacts.url
                        },
                        className: (FaqSection_module_default()).contacts,
                        onClick: function() {
                            var ref;
                            return (0,gtm/* sendGTMData */.S3)({
                                event: "GAevent",
                                eventCategory: 'faq',
                                eventAction: ((ref = contacts.ctaLabel) === null || ref === void 0 ? void 0 : ref.toGTMFormat()) || '',
                                eventLabel: 'contact_us'
                            });
                        }
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var FaqSection_FaqSection = (FaqSection);

// EXTERNAL MODULE: ../../libs/shared-ui/src/organisms/Footer/Footer.module.sass
var Footer_module = __webpack_require__(79962);
var Footer_module_default = /*#__PURE__*/__webpack_require__.n(Footer_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/organisms/Footer/Footer.tsx









function Footer_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Footer_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Footer_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Footer = function() {
    var ref5, ref1, ref2;
    var t = (0,hooks/* useTrans */.IA)();
    var site = (0,hooks/* useSite */.W4)();
    var footerMenu = (0,hooks/* useFindMenu */.Pb)("footer");
    /**
   * @TODO
   *
   * ASSICURAZIONI: style = big
   * VITA: style ? big-mobile
   */ var footerAppMenu = (0,hooks/* useFindMenu */.Pb)("footer_app");
    var ref3 = (0,react.useState)(false), appModalOpen = ref3[0], setAppModalOpen = ref3[1];
    var ref4 = (0,react.useState)(undefined), appModal = ref4[0], setAppModal = ref4[1];
    (0,react.useEffect)(function() {
        if (appModal) {
            setAppModalOpen(true);
        }
    }, [
        appModal
    ]);
    (0,react.useEffect)(function() {
        if (!appModalOpen) {
            setAppModal(undefined);
        }
    }, [
        appModalOpen
    ]);
    var footerSocialMenu = (0,hooks/* useFindMenu */.Pb)("footer_social");
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Footer_module_default()).footer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                variant: "lg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Footer_module_default()).head,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "/",
                        className: (Footer_module_default()).logo,
                        children: site === settings/* ASSICURAZIONI */.Cu ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.LogoAssicurazioniMono, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.LogoVitaMono, {})
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(atoms/* WContainer */.$t, {
                variant: "md",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Footer_module_default()).menus,
                        children: [
                            footerMenu && ((ref5 = footerMenu.children) === null || ref5 === void 0 ? void 0 : ref5.edges) && footerMenu.children.edges.map(function(item1) {
                                var ref6;
                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((Footer_module_default()).col, " ").concat(item1.node.style ? (Footer_module_default())["col--".concat(item1.node.style)] : ''),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (Footer_module_default()).menuTitle,
                                            children: item1.node.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (Footer_module_default()).menuChildren,
                                            children: (ref6 = item1.node.children) === null || ref6 === void 0 ? void 0 : ref6.edges.map(function(item) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("a", Footer_objectSpread({
                                                    href: item.node.url,
                                                    className: (Footer_module_default()).menuItem,
                                                    onClick: function() {
                                                        var ref;
                                                        return (0,gtm/* sendGTMData */.S3)({
                                                            event: "GAevent",
                                                            eventCategory: "footer",
                                                            eventAction: ((ref = item.node.name) === null || ref === void 0 ? void 0 : ref.toGTMFormat()) || ''
                                                        });
                                                    }
                                                }, item.node.blank && {
                                                    target: "_blank",
                                                    rel: "noopener noreferrer"
                                                }, {
                                                    children: item.node.name
                                                }), item.node.pk);
                                            })
                                        })
                                    ]
                                }, item1.node.pk);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Footer_module_default()).col,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Footer_module_default()).socials,
                                        children: footerSocialMenu && ((ref1 = footerSocialMenu.children) === null || ref1 === void 0 ? void 0 : ref1.edges) && footerSocialMenu.children.edges.map(function(item) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("a", {
                                                href: item.node.url,
                                                className: (Footer_module_default()).socialItem,
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                onClick: function() {
                                                    return (0,gtm/* sendGTMData */.S3)({
                                                        event: "GAevent",
                                                        eventCategory: "social",
                                                        eventAction: item.node.key,
                                                        eventLabel: "footer"
                                                    });
                                                },
                                                children: [
                                                    item.node.key === 'facebook' && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.SocialFacebook, {}),
                                                    item.node.key === 'linkedin' && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.SocialLinkedin, {})
                                                ]
                                            }, item.node.pk);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Footer_module_default()).apps,
                                        children: [
                                            footerAppMenu && ((ref2 = footerAppMenu.children) === null || ref2 === void 0 ? void 0 : ref2.edges) && footerAppMenu.children.edges.map(function(item) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                                                    label: item.node.ctaLabel,
                                                    rightIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.ArrowRight, {}),
                                                    href: item.node.url,
                                                    variant: "ghost",
                                                    color: "white",
                                                    onClick: function() {
                                                        var ref;
                                                        setAppModal(item.node);
                                                        (0,gtm/* sendGTMData */.S3)({
                                                            event: "GAevent",
                                                            eventCategory: "app",
                                                            eventAction: (ref = item.node.name) === null || ref === void 0 ? void 0 : ref.toGTMFormat(),
                                                            eventLabel: "download"
                                                        });
                                                    }
                                                }, item.node.pk);
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppModal_AppModal, {
                                                app: appModal,
                                                open: appModalOpen,
                                                setOpen: setAppModalOpen
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Footer_module_default()).copyright,
                        children: site === settings/* ASSICURAZIONI */.Cu ? t("footer_copyright_assicurazioni") : t("footer_copyright_vita")
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var Footer_Footer = (Footer);

;// CONCATENATED MODULE: ../../libs/shared-ui/src/organisms/GoogleReCaptchaWrapper/GoogleReCaptchaWrapper.tsx


var GoogleReCaptchaWrapper = function(props) {
    var _recaptchaRequired = props.recaptchaRequired, recaptchaRequired = _recaptchaRequired === void 0 ? false : _recaptchaRequired, _children = props.children, children = _children === void 0 ? null : _children;
    return recaptchaRequired ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_google_recaptcha_v3_esm/* GoogleReCaptchaProvider */.pm, {
        reCaptchaKey: "6LdgPykeAAAAAABpabLKjbxjED4tFGX-kEZ93rmm",
        children: children
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};
/* harmony default export */ var GoogleReCaptchaWrapper_GoogleReCaptchaWrapper = (GoogleReCaptchaWrapper);

// EXTERNAL MODULE: ../../libs/shared-ui/src/organisms/Header/Header.module.sass
var Header_module = __webpack_require__(56177);
var Header_module_default = /*#__PURE__*/__webpack_require__.n(Header_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/organisms/Header/Header.tsx










var Header = function(props) {
    var ref;
    var _className = props.className, className = _className === void 0 ? '' : _className;
    var t = (0,hooks/* useTrans */.IA)();
    var site = (0,hooks/* useSite */.W4)();
    var ref1 = (0,react.useState)(false), searchOpen = ref1[0], setSearchOpen = ref1[1];
    var ref2 = (0,react.useState)(false), navMobileOpen = ref2[0], setNavMobileOpen = ref2[1];
    var menuTop = (0,hooks/* useFindMenu */.Pb)("top_header");
    var menuAreaClienti = (0,hooks/* useFindMenu */.Pb)("header_area_clienti");
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((Header_module_default()).header, " ").concat(className ? " ".concat(className) : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Header_module_default()).top,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                    variant: "lg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Header_module_default()).topMenu,
                        children: menuTop && ((ref = menuTop.children) === null || ref === void 0 ? void 0 : ref.edges) && menuTop.children.edges.map(function(item) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("a", {
                                href: item.node.url,
                                children: item.node.name
                            }, item.node.pk);
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Header_module_default()).main,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                    variant: "lg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Header_module_default()).mainContent,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Header_module_default()).logo,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: "/",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        onClick: function() {
                                            return (0,gtm/* sendGTMData */.S3)({
                                                event: "GAevent",
                                                eventCategory: "header",
                                                eventAction: "logo"
                                            });
                                        },
                                        children: site === settings/* ASSICURAZIONI */.Cu ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.LogoAssicurazioni, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.LogoVita, {})
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Header_module_default()).navigation,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav_Nav, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Header_module_default()).search,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                                    label: t("Cerca"),
                                    leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.Search, {}),
                                    variant: "ghost",
                                    onClick: function() {
                                        return setSearchOpen(!searchOpen);
                                    }
                                })
                            }),
                            !!menuAreaClienti && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Header_module_default()).areaClienti,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                                    label: menuAreaClienti.ctaLabel,
                                    href: menuAreaClienti.url,
                                    external: true,
                                    newPage: true,
                                    onClick: function() {
                                        (0,gtm/* sendGTMData */.S3)({
                                            event: "GAevent",
                                            eventCategory: "header",
                                            eventAction: "area_clienti"
                                        });
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Header_module_default()).mobileButtons,
                                children: [
                                    !!menuAreaClienti && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: menuAreaClienti.url,
                                        className: (Header_module_default()).mobileButton,
                                        style: navMobileOpen ? {
                                            visibility: 'hidden'
                                        } : {},
                                        onClick: function() {
                                            (0,gtm/* sendGTMData */.S3)({
                                                event: "GAevent",
                                                eventCategory: 'header',
                                                eventAction: 'area_clienti'
                                            });
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.Profile, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        type: "button",
                                        className: (Header_module_default()).mobileButton,
                                        onClick: function() {
                                            return setSearchOpen(!searchOpen);
                                        },
                                        style: navMobileOpen ? {
                                            visibility: 'hidden'
                                        } : {},
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.Search, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        type: "button",
                                        className: (Header_module_default()).mobileButton,
                                        onClick: function() {
                                            return setNavMobileOpen(!navMobileOpen);
                                        },
                                        children: navMobileOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.Close, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.MenuRight, {})
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchOverlay_SearchOverlay, {
                visible: searchOpen,
                setVisible: setSearchOpen
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavMobile_NavMobile, {
                open: navMobileOpen,
                setOpen: setNavMobileOpen
            })
        ]
    }));
};
/* harmony default export */ var Header_Header = (Header);

// EXTERNAL MODULE: ../../libs/shared-ui/src/organisms/HeroSlider/HeroSlider.module.sass
var HeroSlider_module = __webpack_require__(22722);
var HeroSlider_module_default = /*#__PURE__*/__webpack_require__.n(HeroSlider_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/organisms/HeroSlider/HeroSlider.tsx








function HeroSlider_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function HeroSlider_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            HeroSlider_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var HeroSlider = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var _item = props.item, item = _item === void 0 ? undefined : _item, _className = props.className, className = _className === void 0 ? '' : _className;
    var isMobile = (0,hooks/* useIsMobile */.dD)();
    var imagesSwiperSettings = {
        navigation: {
            nextEl: '.hero-custom-button-next',
            prevEl: '.hero-custom-button-prev'
        },
        loop: true
    };
    var contentSwiperSettings = {
        pagination: (item === null || item === void 0 ? void 0 : (ref = item.children) === null || ref === void 0 ? void 0 : (ref1 = ref.edges) === null || ref1 === void 0 ? void 0 : ref1.length) === 1 ? false : {
            clickable: true
        },
        navigation: {
            nextEl: '.hero-custom-button-next',
            prevEl: '.hero-custom-button-prev'
        },
        loop: true,
        className: "".concat((HeroSlider_module_default()).slider, " swiper-container--pagination swiper-container--pagination--white")
    };
    return item && !!((ref2 = item.children) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.edges) === null || ref3 === void 0 ? void 0 : ref3.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((HeroSlider_module_default()).heroSlider, " ").concat(className ? " ".concat(className) : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (HeroSlider_module_default()).imagesSlider,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper/* Swiper */.t, HeroSlider_objectSpread({}, imagesSwiperSettings, {
                    children: item.children.edges.map(function(child, i) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (HeroSlider_module_default()).imageBox,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WImage */.Tg, {
                                    src: isMobile ? child.node.mainImageResponsive : child.node.mainImage,
                                    maxWidth: 1920,
                                    maxHeight: 575,
                                    layout: "intrinsic",
                                    objectFit: "cover",
                                    priority: i === 0 ? true : false,
                                    loading: i === 0 ? 'eager' : 'lazy'
                                }, "hero-slide-".concat(i).concat(isMobile ? '-mobile' : ''))
                            })
                        }, child.node.pk);
                    })
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (HeroSlider_module_default()).contentSlider,
                children: [
                    (item === null || item === void 0 ? void 0 : (ref4 = item.children) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.edges) === null || ref5 === void 0 ? void 0 : ref5.length) > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                className: "hero-custom-button-prev custom-button-prev custom-button-prev--white",
                                onClick: function() {
                                    return (0,gtm/* sendGTMData */.S3)({
                                        event: "GAevent",
                                        eventCategory: "slider",
                                        eventAction: "previous",
                                        eventLabel: "homepage"
                                    });
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.ArrowLeft, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                className: "hero-custom-button-next custom-button-next custom-button-prev--white",
                                onClick: function() {
                                    return (0,gtm/* sendGTMData */.S3)({
                                        event: "GAevent",
                                        eventCategory: "slider",
                                        eventAction: "next",
                                        eventLabel: "homepage"
                                    });
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.ArrowRight, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper/* Swiper */.t, HeroSlider_objectSpread({}, contentSwiperSettings, {
                        children: item.children.edges.map(function(child) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (HeroSlider_module_default()).content,
                                    children: [
                                        !!child.node.name && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (HeroSlider_module_default()).title,
                                            children: child.node.name
                                        }),
                                        !!child.node.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (HeroSlider_module_default()).description,
                                            dangerouslySetInnerHTML: {
                                                __html: child.node.description
                                            }
                                        }),
                                        !!child.node.ctaLabel && !!child.node.url && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (HeroSlider_module_default()).ctaBox,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                                                label: child.node.ctaLabel,
                                                variant: "tertiary2",
                                                href: child.node.url,
                                                onClick: function() {
                                                    return (0,gtm/* sendGTMData */.S3)({
                                                        event: "GAevent",
                                                        eventCategory: "slider",
                                                        eventAction: "scopri_offerta",
                                                        eventLabel: "homepage"
                                                    });
                                                }
                                            })
                                        })
                                    ]
                                })
                            }, child.node.pk);
                        })
                    }))
                ]
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var HeroSlider_HeroSlider = (HeroSlider);

// EXTERNAL MODULE: ../../libs/shared-ui/src/organisms/LineeSection/LineeSection.module.sass
var LineeSection_module = __webpack_require__(77362);
var LineeSection_module_default = /*#__PURE__*/__webpack_require__.n(LineeSection_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/organisms/LineeSection/LineeSection.tsx






var LineeSection = function(props) {
    var _title = props.title, title = _title === void 0 ? '' : _title, _linee = props.linee, linee = _linee === void 0 ? [] : _linee, _note = props.note, note = _note === void 0 ? '' : _note, _className = props.className, className = _className === void 0 ? '' : _className;
    var ref = (0,react.useState)(false), garanzieOpzionaliOpen = ref[0], setGaranzieOpzionaliOpen = ref[1];
    var ref1 = (0,react.useState)(0), garanzieIncluseListHeight = ref1[0], setGaranzieIncluseListHeight = ref1[1];
    var onChangeGaranzieIncluseListHeight = function(h) {
        if (h > garanzieIncluseListHeight) setGaranzieIncluseListHeight(h);
    };
    return (linee === null || linee === void 0 ? void 0 : linee.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((LineeSection_module_default()).section, " ").concat(className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(atoms/* WContainer */.$t, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: (LineeSection_module_default()).title,
                    dangerouslySetInnerHTML: {
                        __html: title
                    }
                }),
                linee.length === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (LineeSection_module_default()).lineaSingola,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LineaBox_LineaBox, {
                        linea: linee[0],
                        garanzieIncluseListHeight: garanzieIncluseListHeight,
                        onChangeGaranzieIncluseListHeight: onChangeGaranzieIncluseListHeight,
                        garanzieOpzionaliOpen: garanzieOpzionaliOpen,
                        setGaranzieOpzionaliOpen: setGaranzieOpzionaliOpen
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (LineeSection_module_default()).slider,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper/* Swiper */.t, {
                        slidesPerView: 1,
                        watchOverflow: true,
                        pagination: {
                            clickable: true
                        },
                        spaceBetween: 30,
                        breakpoints: {
                            768: {
                                slidesPerView: 2
                            },
                            1100: {
                                slidesPerView: 3
                            }
                        },
                        children: linee.map(function(linea) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LineaBox_LineaBox, {
                                    linea: linea,
                                    garanzieIncluseListHeight: garanzieIncluseListHeight,
                                    onChangeGaranzieIncluseListHeight: onChangeGaranzieIncluseListHeight,
                                    garanzieOpzionaliOpen: garanzieOpzionaliOpen,
                                    setGaranzieOpzionaliOpen: setGaranzieOpzionaliOpen
                                })
                            }, linea.pk);
                        })
                    })
                }),
                !!note && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                    variant: "sm",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((LineeSection_module_default()).note, " ").concat(linee.length === 1 ? (LineeSection_module_default())["note--lineaSingola"] : ''),
                        dangerouslySetInnerHTML: {
                            __html: note
                        }
                    })
                })
            ]
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var LineeSection_LineeSection = (LineeSection);

// EXTERNAL MODULE: ../../libs/shared-ui/src/organisms/MagazineListing/MagazineListing.module.sass
var MagazineListing_module = __webpack_require__(23468);
var MagazineListing_module_default = /*#__PURE__*/__webpack_require__.n(MagazineListing_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/organisms/MagazineListing/MagazineListing.tsx














var MagazineListing = function(props) {
    var ref10, ref1, ref2, ref3;
    var _className = props.className, className = _className === void 0 ? '' : _className;
    var site = (0,hooks/* useSite */.W4)();
    var useArticoliMagazineQuery = site === settings/* ASSICURAZIONI */.Cu ? generated_assicurazioni/* useArticoliMagazineQuery */.kM : generated_vita/* useArticoliMagazineQuery */.kM;
    var useCategorieArticoliQuery = site === settings/* ASSICURAZIONI */.Cu ? generated_assicurazioni/* useCategorieArticoliQuery */.lh : generated_vita/* useCategorieArticoliQuery */.lh;
    var t = (0,hooks/* useTrans */.IA)();
    var orderOptions = [
        {
            label: t('Dal pi\xf9 recente'),
            value: '-publication_date'
        },
        {
            label: t('Dal meno recente'),
            value: 'publication_date'
        }, 
    ];
    var ref4 = (0,react.useState)(1), page1 = ref4[0], setPage = ref4[1];
    var ref5 = (0,react.useState)([]), filtriAttivi = ref5[0], setFiltriAttivi = ref5[1];
    var ref6 = (0,react.useState)(orderOptions[0].value), order = ref6[0], setOrder = ref6[1];
    var handleChangeFiltri = function(slug) {
        var newFiltriAttivi = [];
        if (slug) {
            if (filtriAttivi.indexOf(slug) > -1) newFiltriAttivi = filtriAttivi.filter(function(x) {
                return x !== slug;
            });
            else newFiltriAttivi = filtriAttivi.concat([
                slug
            ]);
        }
        setFiltriAttivi(newFiltriAttivi);
        setPage(1);
        refetch({
            offset: 0,
            first: settings/* MAGAZINE_LISTING_ITEMS_PER_PAGE */.b3,
            categoria_Slug_In: newFiltriAttivi,
            orderBy: order
        });
    };
    var handleChangeOrder = function(value) {
        setOrder(value);
        setPage(1);
        refetch({
            offset: 0,
            first: settings/* MAGAZINE_LISTING_ITEMS_PER_PAGE */.b3,
            categoria_Slug_In: filtriAttivi,
            orderBy: value
        });
    };
    var handleChangePage = function(value) {
        setPage(value);
        refetch({
            offset: (value - 1) * settings/* MAGAZINE_LISTING_ITEMS_PER_PAGE */.b3,
            first: settings/* MAGAZINE_LISTING_ITEMS_PER_PAGE */.b3,
            categoria_Slug_In: filtriAttivi,
            orderBy: order
        });
    };
    var ref7 = useCategorieArticoliQuery(), categorieArticoliData = ref7.data;
    var ref8 = (0,react.useState)(0), totaleArticoli = ref8[0], setTotaleArticoli = ref8[1];
    (0,react.useEffect)(function() {
        if (categorieArticoliData) {
            var ref12;
            var tmp = 0;
            categorieArticoliData === null || categorieArticoliData === void 0 ? void 0 : (ref12 = categorieArticoliData.categorieArticoli) === null || ref12 === void 0 ? void 0 : ref12.edges.forEach(function(item) {
                var ref;
                var ref11;
                tmp += (ref11 = item === null || item === void 0 ? void 0 : (ref = item.node) === null || ref === void 0 ? void 0 : ref.numArticoli) !== null && ref11 !== void 0 ? ref11 : 0;
            });
            setTotaleArticoli(tmp);
        }
    }, [
        categorieArticoliData
    ]);
    var ref9 = useArticoliMagazineQuery({
        variables: {
            offset: 0,
            first: settings/* MAGAZINE_LISTING_ITEMS_PER_PAGE */.b3
        }
    }), data = ref9.data, loading = ref9.loading, error = ref9.error, refetch = ref9.refetch;
    var totalCount = data === null || data === void 0 ? void 0 : (ref10 = data.articoliMagazine) === null || ref10 === void 0 ? void 0 : ref10.totalCount;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((MagazineListing_module_default()).magazineListing, " ").concat(className ? " ".concat(className) : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (MagazineListing_module_default()).title,
                dangerouslySetInnerHTML: {
                    __html: "".concat(t("<strong>Tutte</strong> le news"), " (").concat(totaleArticoli, ")")
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (MagazineListing_module_default()).options,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (MagazineListing_module_default()).filters,
                        children: !!(categorieArticoliData === null || categorieArticoliData === void 0 ? void 0 : (ref1 = categorieArticoliData.categorieArticoli) === null || ref1 === void 0 ? void 0 : ref1.edges.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper/* Swiper */.t, {
                            spaceBetween: 16,
                            slidesPerView: "auto",
                            watchOverflow: true,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Chip */.Af, {
                                        label: "".concat(t('Tutti'), " (").concat(totaleArticoli, ")"),
                                        onClick: function() {
                                            handleChangeFiltri(null);
                                            (0,gtm/* sendGTMData */.S3)({
                                                event: "GAevent",
                                                eventCategory: 'filtri',
                                                eventAction: 'tutti',
                                                eventLabel: 'magazine'
                                            });
                                        },
                                        active: filtriAttivi.length === 0
                                    })
                                }),
                                categorieArticoliData === null || categorieArticoliData === void 0 ? void 0 : (ref2 = categorieArticoliData.categorieArticoli) === null || ref2 === void 0 ? void 0 : ref2.edges.map(function(cat) {
                                    var ref17, ref14;
                                    return (cat === null || cat === void 0 ? void 0 : cat.node) && cat.node.numArticoli ? /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Chip */.Af, {
                                            label: "".concat(cat === null || cat === void 0 ? void 0 : (ref17 = cat.node) === null || ref17 === void 0 ? void 0 : ref17.title, " (").concat(cat === null || cat === void 0 ? void 0 : (ref14 = cat.node) === null || ref14 === void 0 ? void 0 : ref14.numArticoli, ")"),
                                            onClick: function() {
                                                var ref, ref15, ref16;
                                                handleChangeFiltri((ref = cat.node) === null || ref === void 0 ? void 0 : ref.slug);
                                                (0,gtm/* sendGTMData */.S3)({
                                                    event: "GAevent",
                                                    eventCategory: 'filtri',
                                                    eventAction: (cat === null || cat === void 0 ? void 0 : (ref15 = cat.node) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.title) === null || ref16 === void 0 ? void 0 : ref16.toGTMFormat()) || '',
                                                    eventLabel: 'magazine'
                                                });
                                            },
                                            active: cat.node.slug ? filtriAttivi.indexOf(cat.node.slug) > -1 : false
                                        })
                                    }, cat.node.pk) : null;
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (MagazineListing_module_default()).order,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: (MagazineListing_module_default()).orderLabel,
                                children: [
                                    t("Ordina per"),
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* FormSelect */.ih, {
                                value: order,
                                onChange: function(e) {
                                    var ref;
                                    handleChangeOrder(typeof e.target.value === "string" ? e.target.value : '-publication_date');
                                    (0,gtm/* sendGTMData */.S3)({
                                        event: "GAevent",
                                        eventCategory: 'filtri',
                                        eventAction: "ordina_per_".concat(typeof e.target.value === "string" && ((ref = orderOptions.find(function(o) {
                                            return o.value === e.target.value;
                                        })) === null || ref === void 0 ? void 0 : ref.label.toGTMFormat())),
                                        eventLabel: 'magazine'
                                    });
                                },
                                options: orderOptions,
                                className: (MagazineListing_module_default()).orderField,
                                variant: "dropdown"
                            })
                        ]
                    })
                ]
            }),
            loading && !data ? /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Loader */.aN, {
                className: (MagazineListing_module_default()).loader
            }) : error ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (MagazineListing_module_default()).error,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* NotificationBar */.o4, {
                    variant: "alert",
                    label: error.message,
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.Alert, {})
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (MagazineListing_module_default()).list,
                        children: data === null || data === void 0 ? void 0 : (ref3 = data.articoliMagazine) === null || ref3 === void 0 ? void 0 : ref3.edges.map(function(articolo) {
                            var ref19;
                            return (articolo === null || articolo === void 0 ? void 0 : articolo.node) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (MagazineListing_module_default()).item,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticoloCard_ArticoloCard, {
                                    articolo: articolo.node,
                                    onClick: function() {
                                        var ref, ref18;
                                        return (0,gtm/* sendGTMData */.S3)({
                                            event: "GAevent",
                                            eventCategory: 'articolo',
                                            eventAction: ((ref = articolo.node) === null || ref === void 0 ? void 0 : (ref18 = ref.title) === null || ref18 === void 0 ? void 0 : ref18.toGTMFormat()) || '',
                                            eventLabel: 'magazine'
                                        });
                                    }
                                })
                            }, articolo === null || articolo === void 0 ? void 0 : (ref19 = articolo.node) === null || ref19 === void 0 ? void 0 : ref19.pk);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Pagination */.tl, {
                        currentPage: page1,
                        totalCount: totalCount ? totalCount : 0,
                        pageSize: settings/* MAGAZINE_LISTING_ITEMS_PER_PAGE */.b3,
                        onPageChange: function(page) {
                            return handleChangePage(page);
                        },
                        className: (MagazineListing_module_default()).pagination
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var MagazineListing_MagazineListing = (MagazineListing);

// EXTERNAL MODULE: ../../libs/shared-ui/src/organisms/MotiviSection/MotiviSection.module.sass
var MotiviSection_module = __webpack_require__(45870);
var MotiviSection_module_default = /*#__PURE__*/__webpack_require__.n(MotiviSection_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/organisms/MotiviSection/MotiviSection.tsx






var MotiviSection = function(props) {
    var ref;
    var item = props.item, _className = props.className, className = _className === void 0 ? '' : _className;
    return item ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((MotiviSection_module_default()).motiviSection, " ").concat(className ? " ".concat(className) : ''),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(atoms/* WContainer */.$t, {
            variant: "lg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (MotiviSection_module_default()).main,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (MotiviSection_module_default()).content,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (MotiviSection_module_default()).title,
                                children: item.name
                            }),
                            !!item.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (MotiviSection_module_default()).description,
                                dangerouslySetInnerHTML: {
                                    __html: item.description
                                }
                            })
                        ]
                    })
                }),
                ((ref = item.children) === null || ref === void 0 ? void 0 : ref.edges.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (MotiviSection_module_default()).slider,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper/* Swiper */.t, {
                        spaceBetween: 30,
                        slidesPerView: 1,
                        pagination: {
                            clickable: true
                        },
                        watchOverflow: true,
                        breakpoints: {
                            768: {
                                slidesPerView: 2
                            },
                            1100: {
                                slidesPerView: 4
                            }
                        },
                        children: item.children.edges.map(function(child) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (MotiviSection_module_default()).item,
                                    children: [
                                        !!child.node.style && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (MotiviSection_module_default()).itemIcon,
                                            children: getIcon(child.node.style)
                                        }),
                                        !!child.node.name && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (MotiviSection_module_default()).itemTitle,
                                            children: child.node.name
                                        }),
                                        !!child.node.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (MotiviSection_module_default()).itemDescription,
                                            dangerouslySetInnerHTML: {
                                                __html: child.node.description
                                            }
                                        })
                                    ]
                                })
                            }, child.node.pk);
                        })
                    })
                })
            ]
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var MotiviSection_MotiviSection = (MotiviSection);

// EXTERNAL MODULE: ../../libs/shared-ui/src/organisms/Nav/Nav.module.sass
var Nav_module = __webpack_require__(63499);
var Nav_module_default = /*#__PURE__*/__webpack_require__.n(Nav_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/organisms/Nav/Nav.tsx








var Nav = function(props) {
    var ref8, ref1, ref2, ref3, ref4, ref5, ref6;
    var _className = props.className, className = _className === void 0 ? '' : _className;
    var ref7 = (0,react.useState)(null), activeItem = ref7[0], setActiveItem = ref7[1];
    var mainMenu = (0,hooks/* useFindMenu */.Pb)("main");
    // Se il livello massimo è 2, non c'è lo stile dei titoletti (vita = 2, assicurazioni = 3)
    var maxLevelMenu = mainMenu && ((ref8 = mainMenu.children) === null || ref8 === void 0 ? void 0 : ref8.edges) && mainMenu.children.edges.filter(function(x) {
        var ref9;
        return ((ref9 = x.node.children) === null || ref9 === void 0 ? void 0 : ref9.edges.length) && x.node.children.edges.filter(function(y) {
            var ref;
            return (ref = y.node.children) === null || ref === void 0 ? void 0 : ref.edges.length;
        }).length > 0;
    }).length > 0 ? 3 : 2;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((Nav_module_default()).nav, " ").concat(className ? " ".concat(className) : ''),
        onMouseLeave: function() {
            return setActiveItem(null);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Nav_module_default()).main,
                children: mainMenu && ((ref1 = mainMenu.children) === null || ref1 === void 0 ? void 0 : ref1.edges) && mainMenu.children.edges.map(function(item) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                        className: (Nav_module_default()).mainItem,
                        onMouseEnter: function() {
                            return setActiveItem(item.node);
                        },
                        children: item.node.url ? /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                            href: item.node.url,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "".concat((Nav_module_default()).mainItemLabel, " ").concat((Nav_module_default()).link, " ").concat((activeItem === null || activeItem === void 0 ? void 0 : activeItem.pk) === item.node.pk ? (Nav_module_default())["mainItemLabel--open"] : ''),
                                onClick: function() {
                                    var ref;
                                    return (0,gtm/* sendGTMData */.S3)({
                                        event: "GAevent",
                                        eventCategory: "menu",
                                        eventAction: "first_level_menu",
                                        eventLabel: (ref = item.node.name) === null || ref === void 0 ? void 0 : ref.toGTMFormat()
                                    });
                                },
                                children: item.node.name
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "".concat((Nav_module_default()).mainItemLabel, " ").concat((Nav_module_default()).noLink, " ").concat((activeItem === null || activeItem === void 0 ? void 0 : activeItem.pk) === item.node.pk ? (Nav_module_default())["mainItemLabel--open"] : ''),
                            children: item.node.name
                        })
                    }, item.node.pk);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((Nav_module_default()).dropdown, " ").concat(activeItem ? (Nav_module_default())["dropdown--open"] : ''),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                    children: !!(activeItem === null || activeItem === void 0 ? void 0 : (ref2 = activeItem.children) === null || ref2 === void 0 ? void 0 : ref2.edges) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Nav_module_default()).dropdownContent,
                        children: maxLevelMenu === 3 ? activeItem.children.edges.map(function(item) {
                            var ref12, ref10;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                className: "".concat((Nav_module_default()).dropdownCol, " ").concat(item.node.style === 'box' ? (Nav_module_default())["dropdownCol--auto"] : ''),
                                children: item.node.style === 'box' ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TextCtaBox_TextCtaBox, {
                                    item: item.node,
                                    size: "sm",
                                    onClick: function() {
                                        var ref, ref11;
                                        return (0,gtm/* sendGTMData */.S3)({
                                            event: "GAevent",
                                            eventCategory: 'menu',
                                            eventAction: 'banner',
                                            eventLabel: item === null || item === void 0 ? void 0 : (ref = item.node) === null || ref === void 0 ? void 0 : (ref11 = ref.name) === null || ref11 === void 0 ? void 0 : ref11.toGTMFormat()
                                        });
                                    }
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (Nav_module_default()).dropdownItem,
                                    children: [
                                        item.node.url ? /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                            href: item.node.url,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "".concat((Nav_module_default()).dropdownItemLabel, " ").concat((Nav_module_default()).link),
                                                onClick: function() {
                                                    var ref, ref13;
                                                    return (0,gtm/* sendGTMData */.S3)({
                                                        event: "GAevent",
                                                        eventCategory: "menu",
                                                        eventAction: "second_level_menu",
                                                        eventLabel: "".concat((ref = activeItem.name) === null || ref === void 0 ? void 0 : ref.toGTMFormat(), " | ").concat((ref13 = item.node.name) === null || ref13 === void 0 ? void 0 : ref13.toGTMFormat())
                                                    });
                                                },
                                                children: item.node.name
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "".concat((Nav_module_default()).dropdownItemLabel, " ").concat((Nav_module_default()).noLink),
                                            children: item.node.name
                                        }),
                                        (item === null || item === void 0 ? void 0 : (ref12 = item.node) === null || ref12 === void 0 ? void 0 : (ref10 = ref12.children) === null || ref10 === void 0 ? void 0 : ref10.edges) && item.node.children.edges.filter(function(child) {
                                            return !!child.node.url;
                                        }).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (Nav_module_default()).dropdownItemChildren,
                                            children: item.node.children.edges.filter(function(child) {
                                                return !!child.node.url;
                                            }).map(function(child) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                        href: child.node.url || '#',
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: (Nav_module_default()).dropdownItemChild,
                                                            onClick: function() {
                                                                var ref, ref14, ref15;
                                                                return (0,gtm/* sendGTMData */.S3)({
                                                                    event: "GAevent",
                                                                    eventCategory: "menu",
                                                                    eventAction: "third_level_menu",
                                                                    eventLabel: "".concat((ref = activeItem.name) === null || ref === void 0 ? void 0 : ref.toGTMFormat(), " | ").concat((ref14 = item.node.name) === null || ref14 === void 0 ? void 0 : ref14.toGTMFormat(), " | ").concat((ref15 = child.node.name) === null || ref15 === void 0 ? void 0 : ref15.toGTMFormat())
                                                                });
                                                            },
                                                            children: child.node.name
                                                        })
                                                    })
                                                }, child.node.pk);
                                            })
                                        })
                                    ]
                                })
                            }, item.node.pk);
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "".concat((Nav_module_default()).dropdownCol, " ").concat((Nav_module_default())["dropdownCol--".concat(Math.ceil(activeItem.children.edges.filter(function(child) {
                                        return !!child.node.url && child.node.style !== 'box';
                                    }).length / 6), "-cols")]),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Nav_module_default()).dropdownItem,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat((Nav_module_default()).dropdownItemChildren, " ").concat((Nav_module_default())["dropdownItemChildren--".concat(Math.ceil(activeItem.children.edges.filter(function(child) {
                                                return !!child.node.url && child.node.style !== 'box';
                                            }).length / 6), "-cols")]),
                                            children: activeItem === null || activeItem === void 0 ? void 0 : (ref3 = activeItem.children) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.edges) === null || ref4 === void 0 ? void 0 : ref4.filter(function(child) {
                                                return !!child.node.url && child.node.style !== 'box';
                                            }).map(function(child) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                        href: child.node.url || '#',
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: (Nav_module_default()).dropdownItemChild,
                                                            onClick: function() {
                                                                var ref, ref16;
                                                                return (0,gtm/* sendGTMData */.S3)({
                                                                    event: "GAevent",
                                                                    eventCategory: "menu",
                                                                    eventAction: "second_level_menu",
                                                                    eventLabel: "".concat((ref = activeItem.name) === null || ref === void 0 ? void 0 : ref.toGTMFormat(), " | ").concat((ref16 = child.node.name) === null || ref16 === void 0 ? void 0 : ref16.toGTMFormat())
                                                                });
                                                            },
                                                            children: child.node.name
                                                        })
                                                    })
                                                }, child.node.pk);
                                            })
                                        })
                                    })
                                }),
                                activeItem === null || activeItem === void 0 ? void 0 : (ref5 = activeItem.children) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.edges) === null || ref6 === void 0 ? void 0 : ref6.filter(function(child) {
                                    return child.node.style === 'box';
                                }).map(function(child) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                        className: "".concat((Nav_module_default()).dropdownCol, " ").concat((Nav_module_default())["dropdownCol--auto"]),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextCtaBox_TextCtaBox, {
                                            item: child.node,
                                            size: "sm",
                                            onClick: function() {
                                                var ref, ref17;
                                                return (0,gtm/* sendGTMData */.S3)({
                                                    event: "GAevent",
                                                    eventCategory: 'menu',
                                                    eventAction: 'banner',
                                                    eventLabel: child === null || child === void 0 ? void 0 : (ref = child.node) === null || ref === void 0 ? void 0 : (ref17 = ref.name) === null || ref17 === void 0 ? void 0 : ref17.toGTMFormat()
                                                });
                                            }
                                        })
                                    });
                                })
                            ]
                        })
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var Nav_Nav = (Nav);

// EXTERNAL MODULE: ../../libs/shared-ui/src/organisms/NavMobile/NavMobile.module.sass
var NavMobile_module = __webpack_require__(85185);
var NavMobile_module_default = /*#__PURE__*/__webpack_require__.n(NavMobile_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/organisms/NavMobile/NavMobile.tsx









var NavMobileItem = function(props) {
    var ref6, ref1, ref2, ref3, ref4, ref5;
    var _item = props.item, item = _item === void 0 ? undefined : _item, _variant = props.variant, variant = _variant === void 0 ? 'primary' : _variant, _open = props.open, open = _open === void 0 ? false : _open, _setOpen = props.setOpen, setOpen = _setOpen === void 0 ? function(v) {
        return undefined;
    } : _setOpen, _setNavOpen = props.setNavOpen, setNavOpen = _setNavOpen === void 0 ? function(v) {
        return undefined;
    } : _setNavOpen, _levelMenu = props.levelMenu, levelMenu = _levelMenu === void 0 ? 0 : _levelMenu;
    return item ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((NavMobile_module_default()).item, " ").concat(variant ? (NavMobile_module_default())["item--".concat(variant)] : '', " ").concat(open ? (NavMobile_module_default())["item--open"] : ''),
                children: item.url ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((NavMobile_module_default()).itemHead, " ").concat((NavMobile_module_default())["itemHead--link"]),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                            href: item.url,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: (NavMobile_module_default()).itemLink,
                                onClick: function() {
                                    var ref;
                                    setNavOpen(false);
                                    (0,gtm/* sendGTMData */.S3)({
                                        event: "GAevent",
                                        eventCategory: 'menu',
                                        eventAction: levelMenu === 1 ? 'first_level_menu' : levelMenu === 2 ? 'second_level_menu' : levelMenu === 3 ? 'third_level_menu' : levelMenu === 0 ? 'top_menu' : '',
                                        eventLabel: (ref = item.name) === null || ref === void 0 ? void 0 : ref.toGTMFormat()
                                    });
                                },
                                children: [
                                    !!item.style && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (NavMobile_module_default()).itemIcon,
                                        children: getIcon(item.style)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (NavMobile_module_default()).itemLabel,
                                        children: item.name
                                    })
                                ]
                            })
                        }),
                        !!((ref6 = item.children) === null || ref6 === void 0 ? void 0 : (ref1 = ref6.edges) === null || ref1 === void 0 ? void 0 : ref1.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            onClick: function() {
                                return setOpen(true);
                            },
                            className: (NavMobile_module_default()).itemArrow,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.ArrowRight, {})
                        })
                    ]
                }) : ((ref2 = item.children) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.edges) === null || ref3 === void 0 ? void 0 : ref3.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((NavMobile_module_default()).itemHead, " ").concat((NavMobile_module_default())["itemHead--noLink"]),
                    onClick: function() {
                        return setOpen(true);
                    },
                    children: [
                        !!item.style && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (NavMobile_module_default()).itemIcon,
                            children: getIcon(item.style)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (NavMobile_module_default()).itemLabel,
                            children: item.name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (NavMobile_module_default()).itemArrow,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.ArrowRight, {})
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
            }),
            !!((ref4 = item.children) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.edges) === null || ref5 === void 0 ? void 0 : ref5.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavMobilePanel, {
                parent: item,
                open: open,
                setOpen: setOpen,
                setNavOpen: setNavOpen,
                levelMenu: levelMenu + 1
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
var NavMobilePanel = function(props) {
    var ref, ref7, ref8, ref9;
    var _parent = props.parent, parent = _parent === void 0 ? undefined : _parent, _open = props.open, open = _open === void 0 ? false : _open, _setOpen = props.setOpen, setOpen = _setOpen === void 0 ? function(v) {
        return undefined;
    } : _setOpen, _setNavOpen = props.setNavOpen, setNavOpen = _setNavOpen === void 0 ? function() {
        return undefined;
    } : _setNavOpen, _levelMenu = props.levelMenu, levelMenu = _levelMenu === void 0 ? 0 : _levelMenu;
    var ref10 = (0,react.useState)(null), openChild = ref10[0], setOpenChild = ref10[1];
    return parent ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((NavMobile_module_default()).panel, " ").concat(open ? (NavMobile_module_default())["panel--open"] : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                type: "button",
                className: (NavMobile_module_default()).back,
                onClick: function() {
                    return setOpen(false);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (NavMobile_module_default()).backArrow,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.ArrowLeft, {})
                    }),
                    !!parent.style && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (NavMobile_module_default()).backIcon,
                        children: getIcon(parent.style)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (NavMobile_module_default()).backLabel,
                        children: parent.name
                    })
                ]
            }),
            !!((ref = parent.children) === null || ref === void 0 ? void 0 : (ref7 = ref.edges) === null || ref7 === void 0 ? void 0 : ref7.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (NavMobile_module_default()).panelMenu,
                children: (ref8 = parent.children) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.edges) === null || ref9 === void 0 ? void 0 : ref9.filter(function(item) {
                    return item.node.style !== 'box';
                }).map(function(item) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(NavMobileItem, {
                        item: item.node,
                        variant: "secondary",
                        open: openChild === item.node.pk,
                        setOpen: function(v) {
                            return setOpenChild(v ? item.node.pk : null);
                        },
                        setNavOpen: function(v) {
                            return setOpen(v);
                        },
                        levelMenu: levelMenu
                    }, item.node.pk);
                })
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
var NavMobile = function(props) {
    var ref, ref11, ref12;
    var _open = props.open, open = _open === void 0 ? false : _open, _setOpen = props.setOpen, setOpen = _setOpen === void 0 ? function() {
        return undefined;
    } : _setOpen, _className = props.className, className = _className === void 0 ? '' : _className;
    var t = (0,hooks/* useTrans */.IA)();
    var ref13 = (0,react.useState)(null), openChild = ref13[0], setOpenChild = ref13[1];
    (0,react.useEffect)(function() {
        if (!open) setOpenChild(null);
        if (open) document.body.classList.add('w-noscroll');
        else document.body.classList.remove('w-noscroll');
    }, [
        open
    ]);
    var mainMenu = (0,hooks/* useFindMenu */.Pb)("main");
    var menuAreaClienti = (0,hooks/* useFindMenu */.Pb)("header_area_clienti");
    var mainExtraMobileMenu = (0,hooks/* useFindMenu */.Pb)("main_extra_mobile");
    var menuTop = (0,hooks/* useFindMenu */.Pb)("top_header");
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((NavMobile_module_default()).navMobile, " ").concat(open ? (NavMobile_module_default())["navMobile--open"] : '', " ").concat(className ? " ".concat(className) : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((NavMobile_module_default()).menu, " ").concat(openChild ? (NavMobile_module_default())["menu--openChild"] : ''),
                children: [
                    mainMenu && ((ref = mainMenu.children) === null || ref === void 0 ? void 0 : ref.edges) && mainMenu.children.edges.map(function(item) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(NavMobileItem, {
                            item: item.node,
                            open: openChild === item.node.pk,
                            setOpen: function(v) {
                                return setOpenChild(v ? item.node.pk : null);
                            },
                            setNavOpen: function(v) {
                                return setOpen(v);
                            },
                            levelMenu: 1
                        }, item.node.pk);
                    }),
                    menuTop && ((ref11 = menuTop.children) === null || ref11 === void 0 ? void 0 : ref11.edges) && menuTop.children.edges.map(function(item) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(NavMobileItem, {
                            item: item.node,
                            variant: "secondary",
                            open: openChild === item.node.pk,
                            setOpen: function(v) {
                                return !!setOpenChild && setOpenChild(v ? item.node.pk : null);
                            },
                            setNavOpen: function(v) {
                                return setOpen(v);
                            },
                            levelMenu: 0
                        }, item.node.pk);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (NavMobile_module_default()).actions,
                children: [
                    !!menuAreaClienti && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                        className: (NavMobile_module_default()).action,
                        label: menuAreaClienti.ctaLabel,
                        href: menuAreaClienti.url,
                        external: true,
                        onClick: function() {
                            (0,gtm/* sendGTMData */.S3)({
                                event: "GAevent",
                                eventCategory: "header",
                                eventAction: "area_clienti"
                            });
                        }
                    }),
                    mainExtraMobileMenu && ((ref12 = mainExtraMobileMenu.children) === null || ref12 === void 0 ? void 0 : ref12.edges) && mainExtraMobileMenu.children.edges.map(function(item) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                            label: item.node.ctaLabel,
                            href: item.node.url,
                            leftIcon: getIcon(item.node.style),
                            variant: "ghost",
                            className: (NavMobile_module_default()).action
                        }, item.node.pk);
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var NavMobile_NavMobile = (NavMobile);

// EXTERNAL MODULE: ../../node_modules/swiper/esm/components/core/core-class.js + 66 modules
var core_class = __webpack_require__(21284);
// EXTERNAL MODULE: ../../node_modules/swiper/esm/components/pagination/pagination.js
var pagination = __webpack_require__(92718);
// EXTERNAL MODULE: ../../node_modules/swiper/esm/components/navigation/navigation.js
var navigation = __webpack_require__(13701);
// EXTERNAL MODULE: ../../libs/shared-ui/src/organisms/NewsSection/NewsSection.module.sass
var NewsSection_module = __webpack_require__(51850);
var NewsSection_module_default = /*#__PURE__*/__webpack_require__.n(NewsSection_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/organisms/NewsSection/NewsSection.tsx









function NewsSection_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function NewsSection_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            NewsSection_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
core_class/* default.use */.Z.use([
    pagination/* default */.Z,
    navigation/* default */.Z
]);
var NewsSection = function(props) {
    var _intro = props.intro, intro = _intro === void 0 ? '' : _intro, _title = props.title, title = _title === void 0 ? '' : _title, _ctaLabel = props.ctaLabel, ctaLabel = _ctaLabel === void 0 ? '' : _ctaLabel, _url = props.url, url = _url === void 0 ? '' : _url, _news = props.news, news = _news === void 0 ? [] : _news, _className = props.className, className = _className === void 0 ? '' : _className;
    var swiperSettings = {
        slidesPerView: 1.25,
        spaceBetween: 16,
        pagination: {
            clickable: true
        },
        navigation: {
            nextEl: '.news-button-next',
            prevEl: '.news-button-prev'
        },
        watchOverflow: true,
        centeredSlides: false,
        className: 'swiper-container--pagination',
        breakpoints: {
            1100: {
                slidesPerView: 3,
                spaceBetween: 30
            },
            768: {
                slidesPerView: 2.5,
                centeredSlides: false
            },
            576: {
                slidesPerView: 1.5
            },
            0: {
                centeredSlides: true
            }
        }
    };
    return news.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((NewsSection_module_default()).newsSection, " ").concat(className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(atoms/* WContainer */.$t, {
            variant: "md",
            children: [
                !!intro && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* IntroTitle */.Om, {
                    label: intro,
                    className: (NewsSection_module_default()).intro
                }),
                !!title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (NewsSection_module_default()).title,
                    dangerouslySetInnerHTML: {
                        __html: title
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (NewsSection_module_default()).list,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: "custom-button-prev news-button-prev",
                            onClick: function() {
                                return (0,gtm/* sendGTMData */.S3)({
                                    event: "GAevent",
                                    eventCategory: "box_info",
                                    eventAction: "informati",
                                    eventLabel: "prev"
                                });
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.ArrowLeft, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: "custom-button-next news-button-next",
                            onClick: function() {
                                return (0,gtm/* sendGTMData */.S3)({
                                    event: "GAevent",
                                    eventCategory: "box_info",
                                    eventAction: "informati",
                                    eventLabel: "next"
                                });
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.ArrowRight, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper/* Swiper */.t, NewsSection_objectSpread({}, swiperSettings, {
                            children: news.map(function(child) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (NewsSection_module_default()).item,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticoloCard_ArticoloCard, {
                                            articolo: child.node,
                                            onClick: function() {
                                                var ref, ref1;
                                                return (0,gtm/* sendGTMData */.S3)({
                                                    event: "GAevent",
                                                    eventCategory: "box_info",
                                                    eventAction: "informati",
                                                    eventLabel: ((ref = child.node) === null || ref === void 0 ? void 0 : (ref1 = ref.title) === null || ref1 === void 0 ? void 0 : ref1.toGTMFormat()) || ''
                                                });
                                            }
                                        })
                                    })
                                }, child.node.pk);
                            })
                        })),
                        !!ctaLabel && !!url && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (NewsSection_module_default()).ctaBox,
                            onClick: function() {
                                return (0,gtm/* sendGTMData */.S3)({
                                    event: "GAevent",
                                    eventCategory: "box_info",
                                    eventAction: "informati",
                                    eventLabel: "leggi tutte le news"
                                });
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                                label: ctaLabel,
                                rightIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.ArrowRight, {}),
                                href: url,
                                variant: "ghost"
                            })
                        })
                    ]
                })
            ]
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var NewsSection_NewsSection = (NewsSection);

// EXTERNAL MODULE: ../../libs/shared-ui/src/organisms/Page/Page.module.sass
var Page_module = __webpack_require__(47330);
var Page_module_default = /*#__PURE__*/__webpack_require__.n(Page_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/organisms/Page/Page.tsx







var Page_Page = function(props) {
    var _pagina = props.pagina, pagina = _pagina === void 0 ? {} : _pagina, _item = props.item, item = _item === void 0 ? {} : _item, _children = props.children, children = _children === void 0 ? null : _children, _className = props.className, className = _className === void 0 ? '' : _className, _contentClassName = props.contentClassName, contentClassName = _contentClassName === void 0 ? '' : _contentClassName, _recaptchaRequired = props.recaptchaRequired, recaptchaRequired = _recaptchaRequired === void 0 ? false : _recaptchaRequired;
    var router = (0,next_router.useRouter)();
    var handleScroll = function() {
        if (window.scrollY > 0) document.body.classList.add('w-scrolled');
        else document.body.classList.remove('w-scrolled');
    };
    (0,react.useEffect)(function() {
        window.addEventListener('scroll', handleScroll, {
            passive: true
        });
        return function() {
            return window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    var chatbotCtx = (0,react.useContext)(chatBotContext/* ChatBotContext */.i);
    (0,react.useEffect)(function() {
        if (router.query && router.query.from_chatbot == "1") {
            setTimeout(function() {
                chatbotCtx.openChatBot({
                    chatbotUrl: "lp-feedback.html"
                });
            }, 20000);
        }
    }, []);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleReCaptchaWrapper_GoogleReCaptchaWrapper, {
        recaptchaRequired: recaptchaRequired,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Page_module_default()).pageWrap,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Toolbar_Toolbar, {
                    page: pagina,
                    item: item
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((Page_module_default()).page, " page ").concat(className || ''),
                    children: [
                        (pagina === null || pagina === void 0 ? void 0 : pagina.seo) && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* MetaSeo */.sf, {
                            seo: pagina.seo
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_Header, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((Page_module_default()).content, " ").concat(contentClassName),
                            children: children
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_Footer, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ChatBotOverlay_ChatBotOverlay, {})
            ]
        })
    }));
};
/* harmony default export */ var organisms_Page_Page = (Page_Page);

;// CONCATENATED MODULE: ../../libs/shared-ui/src/organisms/Preventivatore/Preventivatore.tsx








function Preventivatore_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Preventivatore_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Preventivatore_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Preventivatore = function(props) {
    var _title = props.title, title = _title === void 0 ? '' : _title, _className = props.className, className = _className === void 0 ? '' : _className;
    var t = useTrans();
    // FAKE
    var tipoVeicoloOptions = [
        {
            label: 'Tipo 1',
            value: 1
        }
    ];
    var numLinee = 3;
    var linee = [
        {
            pk: 1,
            style: 'beni',
            nome: 'Sharing',
            prezzo: 4,
            descrizione: '<p>Tutela in <strong>caso di infortunio</strong> personale quali sinistri occorsi durante la guida di mezzi di sharing e noleggio (bici, auto, moto) con copertura per il contraente.</p>'
        },
        {
            pk: 2,
            style: 'beni',
            nome: 'Bike',
            prezzo: 4,
            descrizione: '<p>Offre copertura in caso di danni a terzi occorsi con utilizzo di biciclette con copertura estesa a tutta la famiglia.</p>'
        },
        {
            pk: 3,
            style: 'beni',
            nome: 'Cyber Risk',
            prezzo: 7,
            descrizione: '<p>Offre supporto legale per alcuni eventi come lesione reputazione online, furto d’identit\xe0 digitale, controversie su acquisti online, con copertura estesa a tutta la famiglia.</p>'
        }, 
    ].slice(0, numLinee);
    var validationSchema = yup.object().shape({
        tipo_veicolo: yup.number().required(t("Campo obbligatorio")),
        targa: yup.string().required(t("Campo obbligatorio")),
        data_nascita: yup.string().required(t("Campo obbligatorio")).matches(/[0-9]{2}\/[0-9]{2}\/[0-9]{4}/, t("Utilizzare il formato GG/MM/AAAA")).test('validDate', t("Inserire una data valida"), function(item) {
            return !item || isDateValid(item, 'DD/MM/YYYY');
        }),
        email: yup.string().required(t("Campo obbligatorio")).email('Inserire un\'email valida'),
        privacy: yup.bool().oneOf([
            true
        ], t("Campo obbligatorio"))
    });
    var initialValues = {
        tipo_veicolo: undefined,
        targa: '',
        data_nascita: undefined,
        email: '',
        privacy: false
    };
    return(/*#__PURE__*/ _jsxs("div", {
        className: "".concat(styles.preventivatore, " ").concat(className ? " ".concat(className) : ''),
        children: [
            !!title && /*#__PURE__*/ _jsx("div", {
                className: styles.title,
                dangerouslySetInnerHTML: {
                    __html: title
                }
            }),
            /*#__PURE__*/ _jsx(Formik, {
                validationSchema: validationSchema,
                initialValues: initialValues,
                onSubmit: function(values, errors) {
                    // TODO: implementare logica qui
                    console.log('Submin preventivatore', values, errors);
                },
                children: function(param) {
                    var values = param.values, errors = param.errors, touched = param.touched, setFieldValue = param.setFieldValue;
                    /*#__PURE__*/ return _jsx(Form, {
                        children: /*#__PURE__*/ _jsxs(FormLayout, {
                            children: [
                                /*#__PURE__*/ _jsx(FormField, Preventivatore_objectSpread({
                                    label: t("Tipo veicolo")
                                }, getFormFieldArgs('tipo_veicolo', values, errors, touched), {
                                    children: /*#__PURE__*/ _jsx(FormSelect, {
                                        name: "tipo_veicolo",
                                        options: tipoVeicoloOptions,
                                        value: values.tipo_veicolo,
                                        onChange: function(e) {
                                            return setFieldValue(e.target.name, e.target.value);
                                        }
                                    })
                                })),
                                /*#__PURE__*/ _jsx(FormField, Preventivatore_objectSpread({
                                    label: t("Targa da assicurare")
                                }, getFormFieldArgs('targa', values, errors, touched), {
                                    children: /*#__PURE__*/ _jsx(FormInput, {
                                        name: "targa",
                                        value: values.targa,
                                        onChange: function(e) {
                                            return setFieldValue(e.target.name, e.target.value);
                                        }
                                    })
                                })),
                                /*#__PURE__*/ _jsxs(FormField, Preventivatore_objectSpread({
                                    label: t("Data di nascita del proprietario")
                                }, getFormFieldArgs('data_nascita', values, errors, touched), {
                                    children: [
                                        /*#__PURE__*/ _jsx(FormInput, {
                                            name: "data_nascita",
                                            value: values.data_nascita,
                                            onChange: function(e) {
                                                return setFieldValue(e.target.name, e.target.value);
                                            }
                                        }),
                                        /*#__PURE__*/ _jsx(ErrorMessage, {
                                            name: "data_nascita",
                                            render: function(msg) {
                                                /*#__PURE__*/ return _jsx(FormError, {
                                                    message: msg
                                                });
                                            }
                                        })
                                    ]
                                })),
                                /*#__PURE__*/ _jsxs(FormField, Preventivatore_objectSpread({
                                    label: t("La tua e-mail")
                                }, getFormFieldArgs('email', values, errors, touched), {
                                    children: [
                                        /*#__PURE__*/ _jsx(FormInput, {
                                            name: "email",
                                            type: "email",
                                            value: values.email,
                                            onChange: function(e) {
                                                return setFieldValue(e.target.name, e.target.value);
                                            }
                                        }),
                                        /*#__PURE__*/ _jsx(ErrorMessage, {
                                            name: "email",
                                            render: function(msg) {
                                                /*#__PURE__*/ return _jsx(FormError, {
                                                    message: msg
                                                });
                                            }
                                        })
                                    ]
                                })),
                                /*#__PURE__*/ _jsxs(FormField, Preventivatore_objectSpread({}, getFormFieldArgs('privacy', values, errors, touched), {
                                    children: [
                                        /*#__PURE__*/ _jsx(FormCheckbox, {
                                            id: "privacy",
                                            name: "privacy",
                                            checked: values.privacy,
                                            label: t("Ho letto e accetto l'informativa {0}Privacy{1}", [
                                                '<a href="#">',
                                                '</a>'
                                            ]),
                                            onChange: function(e) {
                                                return setFieldValue(e.target.name, e.target.checked);
                                            }
                                        }),
                                        /*#__PURE__*/ _jsx(ErrorMessage, {
                                            name: "privacy",
                                            render: function(msg) {
                                                /*#__PURE__*/ return _jsx(FormError, {
                                                    message: msg
                                                });
                                            }
                                        })
                                    ]
                                })),
                                /*#__PURE__*/ _jsx("div", {
                                    className: styles.submit,
                                    children: /*#__PURE__*/ _jsx(Button, {
                                        type: "submit",
                                        label: t("Richiedi un preventivo")
                                    })
                                })
                            ]
                        })
                    });
                }
            })
        ]
    }));
};
/* harmony default export */ var Preventivatore_Preventivatore = ((/* unused pure expression or super */ null && (Preventivatore)));

// EXTERNAL MODULE: ../../libs/shared-ui/src/organisms/PreventivatoreHomeSection/PreventivatoreHomeSection.module.sass
var PreventivatoreHomeSection_module = __webpack_require__(84449);
var PreventivatoreHomeSection_module_default = /*#__PURE__*/__webpack_require__.n(PreventivatoreHomeSection_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/organisms/PreventivatoreHomeSection/PreventivatoreHomeSection.tsx









var PreventivatoreHomeSection = function(props) {
    var _prodotti = props.prodotti, prodotti = _prodotti === void 0 ? [] : _prodotti, _setProdottoPreventivatoreModal = props.setProdottoPreventivatoreModal, setProdottoPreventivatoreModal = _setProdottoPreventivatoreModal === void 0 ? function() {
        return undefined;
    } : _setProdottoPreventivatoreModal, _selectedLineePreventivatore = props.selectedLineePreventivatore, selectedLineePreventivatore = _selectedLineePreventivatore === void 0 ? [] : _selectedLineePreventivatore, _setSelectedLineePreventivatore = props.setSelectedLineePreventivatore, setSelectedLineePreventivatore = _setSelectedLineePreventivatore === void 0 ? function() {
        return undefined;
    } : _setSelectedLineePreventivatore, _className = props.className, className = _className === void 0 ? '' : _className;
    var t = (0,hooks/* useTrans */.IA)();
    var tabs = prodotti.map(function(p) {
        return {
            key: "prodotto_".concat(p.pk),
            label: p.titolo,
            icon: getIcon(p.icon),
            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(PreventivatoreIntro_PreventivatoreIntro, {
                title: t("Consulta il nostro <strong>preventivatore</strong>"),
                ctaLabel: t("Richiedi un preventivo personalizzato"),
                prodotto: p,
                setFormModalOpen: function() {
                    return setProdottoPreventivatoreModal(p);
                },
                selectedLinee: selectedLineePreventivatore,
                setSelectedLinee: function(linee_ids) {
                    return setSelectedLineePreventivatore(linee_ids);
                },
                className: (PreventivatoreHomeSection_module_default()).tabContent
            })
        };
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((PreventivatoreHomeSection_module_default()).preventivatoreHomeSection, " ").concat(className ? " ".concat(className) : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (PreventivatoreHomeSection_module_default()).tabs,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* TabGroup */.v0, {
                    tabs: tabs,
                    clearSelectedLineePreventivatore: function() {
                        return setSelectedLineePreventivatore([]);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (PreventivatoreHomeSection_module_default()).slider,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (PreventivatoreHomeSection_module_default()).titleMobile,
                        dangerouslySetInnerHTML: {
                            __html: t('Consulta il nostro <strong>preventivatore</strong>')
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper/* Swiper */.t, {
                        spaceBetween: 16,
                        slidesPerView: 1.5,
                        pagination: {
                            clickable: true
                        },
                        watchOverflow: true,
                        children: prodotti.map(function(p) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (PreventivatoreHomeSection_module_default()).sliderItem,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TabTriggerCard_TabTriggerCard, {
                                        label: p.titolo,
                                        icon: getIcon(p.icon),
                                        onClick: function() {
                                            return setProdottoPreventivatoreModal(p);
                                        }
                                    })
                                })
                            }, p.pk);
                        })
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var PreventivatoreHomeSection_PreventivatoreHomeSection = (PreventivatoreHomeSection);

// EXTERNAL MODULE: ../../libs/shared-ui/src/organisms/PreventivatoreIntro/PreventivatoreIntro.module.sass
var PreventivatoreIntro_module = __webpack_require__(38352);
var PreventivatoreIntro_module_default = /*#__PURE__*/__webpack_require__.n(PreventivatoreIntro_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/organisms/PreventivatoreIntro/PreventivatoreIntro.tsx







var PreventivatoreIntro = function(props) {
    var getLineeNames = function(linee_ids) {
        return linee_ids.map(function(ids) {
            var ref;
            return (ref = prodotto === null || prodotto === void 0 ? void 0 : prodotto.linee.find(function(l) {
                return l.pk === ids;
            })) === null || ref === void 0 ? void 0 : ref.titolo.toGTMFormat();
        }).join(' | ');
    };
    var _title = props.title, title = _title === void 0 ? '' : _title, _ctaLabel = props.ctaLabel, ctaLabel = _ctaLabel === void 0 ? '' : _ctaLabel, _prodotto = props.prodotto, prodotto = _prodotto === void 0 ? undefined : _prodotto, _productPage = props.productPage, productPage = _productPage === void 0 ? false : _productPage, _setFormModalOpen = props.setFormModalOpen, setFormModalOpen = _setFormModalOpen === void 0 ? function() {
        return undefined;
    } : _setFormModalOpen, _selectedLinee = props.selectedLinee, selectedLinee = _selectedLinee === void 0 ? [] : _selectedLinee, _setSelectedLinee = props.setSelectedLinee, setSelectedLinee = _setSelectedLinee === void 0 ? function() {
        return undefined;
    } : _setSelectedLinee, _className = props.className, className = _className === void 0 ? '' : _className;
    var t = (0,hooks/* useTrans */.IA)();
    return prodotto ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((PreventivatoreIntro_module_default()).preventivatoreIntro, " ").concat(productPage ? (PreventivatoreIntro_module_default())["preventivatoreIntro--productPage"] : '', " ").concat(className ? " ".concat(className) : ''),
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (PreventivatoreIntro_module_default()).title,
                dangerouslySetInnerHTML: {
                    __html: title
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PreventivatoreLinee_PreventivatoreLinee, {
                linee: prodotto.linee.filter(function(linea) {
                    return linea.inPreventivatore;
                }),
                productPage: productPage,
                selectedLinee: selectedLinee,
                setSelectedLinee: setSelectedLinee,
                sconto: prodotto.sconto
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (PreventivatoreIntro_module_default()).ctaBox,
                children: !selectedLinee.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Tooltip */.u, {
                    id: "preventivatore-tooltip",
                    label: t("\xc9 necessario selezionare almeno una linea per richiedere un preventivo"),
                    className: "preventivatore-tooltip",
                    fullWidth: productPage ? true : false,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                        label: ctaLabel,
                        onClick: function() {
                            return setFormModalOpen(true);
                        },
                        className: (PreventivatoreIntro_module_default()).cta,
                        disabled: !selectedLinee.length
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                    label: ctaLabel,
                    onClick: function() {
                        var ref;
                        (0,gtm/* sendGTMData */.S3)({
                            event: "GAevent",
                            eventCategory: 'preventivatore',
                            eventAction: ((ref = prodotto.titolo) === null || ref === void 0 ? void 0 : ref.toGTMFormat()) || '',
                            eventLabel: 'step1',
                            linea_preventivatore: getLineeNames(selectedLinee)
                        });
                        setFormModalOpen(true);
                    },
                    className: (PreventivatoreIntro_module_default()).cta,
                    disabled: !selectedLinee.length
                })
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var PreventivatoreIntro_PreventivatoreIntro = (PreventivatoreIntro);

// EXTERNAL MODULE: ../../libs/shared-ui/src/organisms/PreventivatoreLinee/PreventivatoreLinee.module.sass
var PreventivatoreLinee_module = __webpack_require__(56915);
var PreventivatoreLinee_module_default = /*#__PURE__*/__webpack_require__.n(PreventivatoreLinee_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/organisms/PreventivatoreLinee/PreventivatoreLinee.tsx







var PreventivatoreLinee = function(props) {
    var _linee = props.linee, linee = _linee === void 0 ? [] : _linee, _selectedLinee = props.selectedLinee, selectedLinee = _selectedLinee === void 0 ? [] : _selectedLinee, _setSelectedLinee = props.setSelectedLinee, setSelectedLinee = _setSelectedLinee === void 0 ? function() {
        return undefined;
    } : _setSelectedLinee, _sconto = props.sconto, sconto = _sconto === void 0 ? '' : _sconto, _collapsable = props.collapsable, collapsable = _collapsable === void 0 ? false : _collapsable, _productPage = props.productPage, productPage = _productPage === void 0 ? false : _productPage, _errorMessage = props.errorMessage, errorMessage = _errorMessage === void 0 ? undefined : _errorMessage, _className = props.className, className = _className === void 0 ? '' : _className;
    var t = (0,hooks/* useTrans */.IA)();
    return linee && linee.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((PreventivatoreLinee_module_default()).preventivatoreLinee, " ").concat(productPage ? (PreventivatoreLinee_module_default())["preventivatoreLinee--productPage"] : '', " ").concat(className ? " ".concat(className) : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (PreventivatoreLinee_module_default()).title,
                dangerouslySetInnerHTML: {
                    __html: linee.length === 1 ? t('Seleziona la <strong>linea</strong> a cui sei interessato') : t('Seleziona le <strong>linee</strong> a cui sei interessato')
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((PreventivatoreLinee_module_default()).linee, " ").concat(collapsable ? (PreventivatoreLinee_module_default())["linee--collapsable"] : ''),
                children: [
                    productPage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (PreventivatoreLinee_module_default()).list,
                        children: linee.map(function(linea) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                className: (PreventivatoreLinee_module_default()).listItem,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LineaCheckbox_LineaCheckbox, {
                                    linea: linea,
                                    selected: selectedLinee.indexOf(linea.pk) > -1,
                                    setSelected: function(v) {
                                        return setSelectedLinee(v ? selectedLinee.concat(linea.pk) : selectedLinee.filter(function(x) {
                                            return x !== linea.pk;
                                        }));
                                    },
                                    collapsable: collapsable
                                })
                            }, linea.pk);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (PreventivatoreLinee_module_default()).slider,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper/* Swiper */.t, {
                            spaceBetween: 16,
                            slidesPerView: linee.length > 1 ? 1.2 : 1,
                            pagination: {
                                clickable: true
                            },
                            watchOverflow: true,
                            breakpoints: {
                                768: {
                                    slidesPerView: linee.length > 2 ? 2.5 : linee.length
                                },
                                992: {
                                    slidesPerView: linee.length > 3 ? 3 : linee.length
                                }
                            },
                            children: linee.map(function(linea) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (PreventivatoreLinee_module_default()).sliderItem,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LineaCheckbox_LineaCheckbox, {
                                            linea: linea,
                                            selected: selectedLinee.indexOf(linea.pk) > -1,
                                            setSelected: function(v) {
                                                return setSelectedLinee(v ? selectedLinee.concat(linea.pk) : selectedLinee.filter(function(x) {
                                                    return x !== linea.pk;
                                                }));
                                            },
                                            collapsable: collapsable
                                        })
                                    })
                                }, linea.pk);
                            })
                        })
                    })
                ]
            }),
            errorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (PreventivatoreLinee_module_default()).errorWrap,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* FormError */.Xq, {
                    message: errorMessage,
                    visible: true
                })
            }),
            sconto && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (PreventivatoreLinee_module_default()).discount,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* SimpleMessage */.Cy, {
                    text: sconto
                })
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var PreventivatoreLinee_PreventivatoreLinee = (PreventivatoreLinee);

// EXTERNAL MODULE: ../../libs/shared-ui/src/organisms/PreventivatoreModal/PreventivatoreModal.module.sass
var PreventivatoreModal_module = __webpack_require__(35085);
var PreventivatoreModal_module_default = /*#__PURE__*/__webpack_require__.n(PreventivatoreModal_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/organisms/PreventivatoreModal/PreventivatoreModal.tsx
















function PreventivatoreModal_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function PreventivatoreModal_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function PreventivatoreModal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function PreventivatoreModal_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function PreventivatoreModal_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function PreventivatoreModal_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            PreventivatoreModal_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function PreventivatoreModal_slicedToArray(arr, i) {
    return PreventivatoreModal_arrayWithHoles(arr) || PreventivatoreModal_iterableToArrayLimit(arr, i) || PreventivatoreModal_unsupportedIterableToArray(arr, i) || PreventivatoreModal_nonIterableRest();
}
function PreventivatoreModal_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return PreventivatoreModal_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return PreventivatoreModal_arrayLikeToArray(o, minLen);
}
var PreventivatoreModal = function(props) {
    var _title = props.title, title = _title === void 0 ? '' : _title, _prodotto = props.prodotto, prodotto = _prodotto === void 0 ? undefined : _prodotto, _open = props.open, open = _open === void 0 ? false : _open, _setOpen = props.setOpen, setOpen = _setOpen === void 0 ? function() {
        return undefined;
    } : _setOpen, _selectedLinee = props.selectedLinee, selectedLinee = _selectedLinee === void 0 ? [] : _selectedLinee, _className = props.className, className = _className === void 0 ? '' : _className;
    var t = (0,hooks/* useTrans */.IA)();
    var router = (0,next_router.useRouter)();
    var site = (0,hooks/* useSite */.W4)();
    var executeRecaptcha = (0,react_google_recaptcha_v3_esm/* useGoogleReCaptcha */.xX)().executeRecaptcha;
    var contentRef = (0,react.useRef)(null);
    var createRichiestaPreventivatoreMutation = site === settings/* ASSICURAZIONI */.Cu ? generated_assicurazioni/* useCreateRichiestaPreventivatoreMutation */.A0 : generated_vita/* useCreateRichiestaPreventivatoreMutation */.A0;
    var ref2 = PreventivatoreModal_slicedToArray(createRichiestaPreventivatoreMutation(), 1), createRichiestaPreventivatore = ref2[0];
    var ref1 = (0,react.useState)(null), error = ref1[0], setError = ref1[1];
    (0,react.useEffect)(function() {
        if (!open) setError(null);
    }, [
        open
    ]);
    var validationSchema = es/* object */.Ry().shape({
        nome: es/* string */.Z_().required(t("Campo obbligatorio")),
        cognome: es/* string */.Z_().required(t("Campo obbligatorio")),
        telefono: es/* string */.Z_().required(t("Campo obbligatorio")),
        email: es/* string */.Z_().required(t("Campo obbligatorio")).email(t('Inserire un\'email valida')),
        privacy: es/* bool */.Xg().oneOf([
            true
        ], t("Campo obbligatorio")),
        linee_ids: es/* array */.IX().min(1, t("Seleziona almeno una linea"))
    });
    var initialValues = {
        nome: '',
        cognome: '',
        telefono: '',
        email: '',
        privacy: false,
        linee_ids: selectedLinee
    };
    var getLineeNames = function(linee_ids) {
        return linee_ids.map(function(ids) {
            var ref;
            return (ref = prodotto === null || prodotto === void 0 ? void 0 : prodotto.linee.find(function(l) {
                return l.pk === ids;
            })) === null || ref === void 0 ? void 0 : ref.titolo.toGTMFormat();
        }).join(' | ');
    };
    var setFormError = function(actions) {
        actions.setSubmitting(false);
        setError(t("Errore nell'invio dei dati, riprova pi\xf9 tardi"));
        (contentRef === null || contentRef === void 0 ? void 0 : contentRef.current) && (contentRef.current.scrollTop = 0);
    };
    return prodotto ? /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Modal */.u_, {
        open: open,
        setOpen: setOpen,
        closeButton: true,
        className: "".concat((PreventivatoreModal_module_default()).preventivatoreModal, " ").concat(className ? " ".concat(className) : ''),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (PreventivatoreModal_module_default()).content,
            ref: contentRef,
            children: [
                title && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: (PreventivatoreModal_module_default()).title,
                    dangerouslySetInnerHTML: {
                        __html: title
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                    validationSchema: validationSchema,
                    initialValues: initialValues,
                    onSubmit: function(values, actions) {
                        if (!executeRecaptcha) {
                            setFormError(actions);
                            return;
                        }
                        executeRecaptcha("richiesta_preventivatore_submit").then(function(token) {
                            createRichiestaPreventivatore({
                                variables: {
                                    input: {
                                        nome: values.nome,
                                        cognome: values.cognome,
                                        email: values.email,
                                        telefono: values.telefono,
                                        prodottoId: prodotto.pk,
                                        lineeIds: values.linee_ids,
                                        privacy: values.privacy,
                                        captcha: token
                                    }
                                }
                            }).then(function(res) {
                                var ref;
                                setError(null);
                                (0,gtm/* sendGTMData */.S3)({
                                    event: "GAevent",
                                    eventCategory: 'preventivatore',
                                    eventAction: ((ref = prodotto.titolo) === null || ref === void 0 ? void 0 : ref.toGTMFormat()) || '',
                                    eventLabel: 'ok',
                                    linea_preventivatore: getLineeNames(values.linee_ids)
                                });
                                router.push("".concat(prodotto.url, "thank-you"));
                            }).catch(function(err) {
                                setFormError(actions);
                            });
                        }).catch(function(err) {
                            setFormError(actions);
                        });
                    },
                    children: function(param) {
                        var values = param.values, errors = param.errors, touched = param.touched, setFieldValue = param.setFieldValue, setFieldTouched = param.setFieldTouched, isValid = param.isValid, handleBlur = param.handleBlur, isSubmitting = param.isSubmitting;
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
                            children: [
                                error && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (PreventivatoreModal_module_default()).error,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* NotificationBar */.o4, {
                                        variant: "alert",
                                        label: error,
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.Alert, {})
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (PreventivatoreModal_module_default()).lineeFormField,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PreventivatoreLinee_PreventivatoreLinee, {
                                        linee: prodotto.linee.filter(function(linea) {
                                            return linea.inPreventivatore;
                                        }),
                                        sconto: prodotto.sconto,
                                        className: (PreventivatoreModal_module_default()).linee,
                                        collapsable: true,
                                        errorMessage: touched.linee_ids && errors.linee_ids ? errors.linee_ids : undefined,
                                        selectedLinee: values.linee_ids,
                                        setSelectedLinee: function(v) {
                                            setFieldTouched('linee_ids');
                                            setFieldValue('linee_ids', v);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(atoms/* FormLayout */.lt, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* FormField */.Wi, PreventivatoreModal_objectSpread({
                                            label: t('Nome')
                                        }, (0,safe/* getFormFieldArgs */.MG)('nome', values, errors, touched), {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* FormInput */.yt, {
                                                name: "nome",
                                                placeholder: t("Inserisci il tuo nome"),
                                                value: values.nome,
                                                onChange: function(e) {
                                                    return setFieldValue(e.target.name, e.target.value);
                                                },
                                                onBlur: handleBlur
                                            })
                                        })),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* FormField */.Wi, PreventivatoreModal_objectSpread({
                                            label: t('Cognome')
                                        }, (0,safe/* getFormFieldArgs */.MG)('cognome', values, errors, touched), {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* FormInput */.yt, {
                                                name: "cognome",
                                                placeholder: t("Inserisci il tuo cognome"),
                                                value: values.cognome,
                                                onChange: function(e) {
                                                    return setFieldValue(e.target.name, e.target.value);
                                                },
                                                onBlur: handleBlur
                                            })
                                        })),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* FormField */.Wi, PreventivatoreModal_objectSpread({
                                            label: t('Telefono cellulare')
                                        }, (0,safe/* getFormFieldArgs */.MG)('telefono', values, errors, touched), {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* FormInput */.yt, {
                                                name: "telefono",
                                                placeholder: t("Inserisci il tuo numero"),
                                                value: values.telefono,
                                                onChange: function(e) {
                                                    return setFieldValue(e.target.name, e.target.value);
                                                },
                                                onBlur: handleBlur
                                            })
                                        })),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* FormField */.Wi, PreventivatoreModal_objectSpread({
                                            label: t('La tua e-mail')
                                        }, (0,safe/* getFormFieldArgs */.MG)('email', values, errors, touched), {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* FormInput */.yt, {
                                                name: "email",
                                                placeholder: t("Inserisci la tua e-mail"),
                                                type: "email",
                                                value: values.email,
                                                onChange: function(e) {
                                                    return setFieldValue(e.target.name, e.target.value);
                                                },
                                                onBlur: handleBlur
                                            })
                                        }))
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (PreventivatoreModal_module_default()).bottomDesktop,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(atoms/* FormField */.Wi, PreventivatoreModal_objectSpread({
                                            className: (PreventivatoreModal_module_default()).privacyField
                                        }, (0,safe/* getFormFieldArgs */.MG)('privacy', values, errors, touched), {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* FormCheckbox */.z8, {
                                                    id: "privacy",
                                                    name: "privacy",
                                                    checked: values.privacy,
                                                    label: t("Ho letto e accetto l'informativa {0}Privacy{1}", [
                                                        '<a href="/privacy">',
                                                        '</a>', 
                                                    ]),
                                                    onChange: function(e) {
                                                        return setFieldValue(e.target.name, e.target.checked);
                                                    },
                                                    onBlur: handleBlur
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* ErrorMessage */.Bc, {
                                                    name: "privacy",
                                                    render: function(msg) {
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(atoms/* FormError */.Xq, {
                                                            message: msg
                                                        });
                                                    }
                                                })
                                            ]
                                        })),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (PreventivatoreModal_module_default()).bottomMobile,
                                            children: !Object.keys(touched).length || !isValid ? /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Tooltip */.u, {
                                                id: "preventivatore-tooltip",
                                                label: t("\xc9 necessario selezionare almeno una linea e compilare tutti i campi per richiedere un preventivo"),
                                                className: "preventivatore-tooltip",
                                                size: "md",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                                                    type: "submit",
                                                    label: t('Richiedi un preventivo'),
                                                    className: (PreventivatoreModal_module_default()).submit,
                                                    disabled: !Object.keys(touched).length || !isValid || isSubmitting
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                                                type: "submit",
                                                label: t('Richiedi un preventivo'),
                                                className: (PreventivatoreModal_module_default()).submit,
                                                disabled: !Object.keys(touched).length || !isValid || isSubmitting
                                            })
                                        })
                                    ]
                                })
                            ]
                        });
                    }
                })
            ]
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var PreventivatoreModal_PreventivatoreModal = (PreventivatoreModal);

// EXTERNAL MODULE: ../../libs/shared-ui/src/organisms/ProdottiListing/ProdottiListing.module.sass
var ProdottiListing_module = __webpack_require__(63585);
var ProdottiListing_module_default = /*#__PURE__*/__webpack_require__.n(ProdottiListing_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/organisms/ProdottiListing/ProdottiListing.tsx








var ProdottiListing = function(props) {
    var _prodotti = props.prodotti, prodotti = _prodotti === void 0 ? [] : _prodotti, _className = props.className, className = _className === void 0 ? '' : _className;
    var t = (0,hooks/* useTrans */.IA)();
    var ref1 = (0,react.useState)([]), filtriAttivi = ref1[0], setFiltriAttivi = ref1[1];
    var toggleFiltro = function(id) {
        if (filtriAttivi.indexOf(id) > -1) setFiltriAttivi(filtriAttivi.filter(function(x) {
            return x !== id;
        }));
        else setFiltriAttivi(filtriAttivi.concat([
            id
        ]));
    };
    // FAKE
    var tags = [];
    /* const tags = [
    { pk: 1, titolo: 'Lorem', num: 16 },
    { pk: 2, titolo: 'Ipsum', num: 12 },
  ] */ return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((ProdottiListing_module_default()).root, " ").concat(className ? " ".concat(className) : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: (ProdottiListing_module_default()).title,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: t("Risultati")
                    }),
                    " (",
                    prodotti.length,
                    ")"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ProdottiListing_module_default()).filters,
                children: tags.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper/* Swiper */.t, {
                    spaceBetween: 16,
                    slidesPerView: "auto",
                    watchOverflow: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Chip */.Af, {
                                label: "".concat(t('Tutti'), " (").concat(prodotti.length, ")"),
                                onClick: function() {
                                    setFiltriAttivi([]);
                                    (0,gtm/* sendGTMData */.S3)({
                                        event: "GAevent",
                                        eventCategory: 'filtri',
                                        eventAction: 'tutti',
                                        eventLabel: 'plp'
                                    });
                                },
                                active: filtriAttivi.length === 0
                            })
                        }),
                        tags.map(function(tag) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Chip */.Af, {
                                    label: "".concat(tag.titolo, " (").concat(tag.num, ")"),
                                    onClick: function() {
                                        var ref;
                                        toggleFiltro(tag.pk);
                                        (0,gtm/* sendGTMData */.S3)({
                                            event: "GAevent",
                                            eventCategory: 'filtri',
                                            eventAction: ((ref = tag.titolo) === null || ref === void 0 ? void 0 : ref.toGTMFormat()) || '',
                                            eventLabel: 'plp'
                                        });
                                    },
                                    active: filtriAttivi.indexOf(tag.pk) > -1
                                })
                            }, tag.pk);
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ProdottiListing_module_default()).main,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ProdottiListing_module_default()).list,
                    children: prodotti.map(function(prodotto) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                            className: (ProdottiListing_module_default()).item,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProdottoCard_ProdottoCard, {
                                prodotto: prodotto,
                                onClick: function() {
                                    var ref;
                                    return (0,gtm/* sendGTMData */.S3)({
                                        event: "GAevent",
                                        eventCategory: 'listing_prodotti',
                                        eventAction: ((ref = prodotto.titolo) === null || ref === void 0 ? void 0 : ref.toGTMFormat()) || '',
                                        eventLabel: 'click'
                                    });
                                }
                            })
                        }, prodotto.pk);
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var ProdottiListing_ProdottiListing = (ProdottiListing);

// EXTERNAL MODULE: ../../libs/shared-ui/src/organisms/ProdottiSection/ProdottiSection.module.sass
var ProdottiSection_module = __webpack_require__(10114);
var ProdottiSection_module_default = /*#__PURE__*/__webpack_require__.n(ProdottiSection_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/organisms/ProdottiSection/ProdottiSection.tsx









function ProdottiSection_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ProdottiSection_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ProdottiSection_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
core_class/* default.use */.Z.use([
    pagination/* default */.Z,
    navigation/* default */.Z
]);
var ProdottiSection = function(props) {
    var _item = props.item, item1 = _item === void 0 ? undefined : _item, _prodotti = props.prodotti, prodotti = _prodotti === void 0 ? [] : _prodotti, _className = props.className, className = _className === void 0 ? '' : _className, _prev = props.prev, prev = _prev === void 0 ? undefined : _prev, _next = props.next, next = _next === void 0 ? undefined : _next, _whatIs = props.whatIs, whatIs = _whatIs === void 0 ? '' : _whatIs;
    var swiperSettings = {
        slidesPerView: 1.25,
        spaceBetween: 16,
        pagination: {
            clickable: true
        },
        navigation: {
            nextEl: '.prodotti-button-next',
            prevEl: '.prodotti-button-prev'
        },
        watchOverflow: true,
        centeredSlides: false,
        className: 'swiper-container--pagination',
        breakpoints: {
            1100: {
                slidesPerView: 3,
                spaceBetween: 30
            },
            768: {
                slidesPerView: 2.5,
                centeredSlides: false
            },
            576: {
                slidesPerView: 1.5
            },
            0: {
                centeredSlides: true
            }
        }
    };
    var handleClick = function() {
        var prodotto = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : undefined, item = arguments.length > 1 ? arguments[1] : void 0;
        var ref, ref1, ref2, ref3;
        var ref4, ref5;
        whatIs === 'prodottiMenu' ? (0,gtm/* sendGTMData */.S3)({
            event: "GAevent",
            eventCategory: 'box_info',
            eventAction: 'esplora',
            eventLabel: (ref4 = prodotto === null || prodotto === void 0 ? void 0 : (ref = prodotto.titolo) === null || ref === void 0 ? void 0 : ref.toGTMFormat()) !== null && ref4 !== void 0 ? ref4 : item === null || item === void 0 ? void 0 : (ref1 = item.ctaLabel) === null || ref1 === void 0 ? void 0 : ref1.toGTMFormat()
        }) : whatIs === 'prodottiCorrelati' && (0,gtm/* sendGTMData */.S3)({
            event: "GAevent",
            eventCategory: 'prodotti_correlati',
            eventAction: (ref5 = prodotto === null || prodotto === void 0 ? void 0 : (ref2 = prodotto.titolo) === null || ref2 === void 0 ? void 0 : ref2.toGTMFormat()) !== null && ref5 !== void 0 ? ref5 : item === null || item === void 0 ? void 0 : (ref3 = item.ctaLabel) === null || ref3 === void 0 ? void 0 : ref3.toGTMFormat(),
            eventLabel: 'click'
        });
    };
    return item1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((ProdottiSection_module_default()).prodottiSection, " ").concat(className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(atoms/* WContainer */.$t, {
            variant: "md",
            children: [
                !!item1.name && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* IntroTitle */.Om, {
                    label: item1.name,
                    className: (ProdottiSection_module_default()).intro
                }),
                !!item1.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ProdottiSection_module_default()).title,
                    dangerouslySetInnerHTML: {
                        __html: item1.description
                    }
                }),
                prodotti.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ProdottiSection_module_default()).list,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: "custom-button-prev prodotti-button-prev",
                            onClick: prev ? function() {
                                return (0,gtm/* sendGTMData */.S3)(ProdottiSection_objectSpread({}, prev));
                            } : undefined,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.ArrowLeft, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: "custom-button-next prodotti-button-next",
                            onClick: next ? function() {
                                return (0,gtm/* sendGTMData */.S3)(ProdottiSection_objectSpread({}, next));
                            } : undefined,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.ArrowRight, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper/* Swiper */.t, ProdottiSection_objectSpread({}, swiperSettings, {
                            children: prodotti.map(function(prodotto) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (ProdottiSection_module_default()).item,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProdottoCard_ProdottoCard, {
                                            prodotto: prodotto,
                                            onClick: function() {
                                                return handleClick(prodotto);
                                            }
                                        })
                                    })
                                }, prodotto.pk);
                            })
                        })),
                        !!item1.ctaLabel && !!item1.url && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ProdottiSection_module_default()).ctaBox,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                                label: item1.ctaLabel,
                                rightIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.ArrowRight, {}),
                                href: item1.url,
                                variant: "ghost",
                                onClick: function() {
                                    return handleClick(undefined, item1);
                                }
                            })
                        })
                    ]
                })
            ]
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var ProdottiSection_ProdottiSection = (ProdottiSection);

// EXTERNAL MODULE: ../../libs/shared-ui/src/organisms/ProdottoHead/ProdottoHead.module.sass
var ProdottoHead_module = __webpack_require__(25011);
var ProdottoHead_module_default = /*#__PURE__*/__webpack_require__.n(ProdottoHead_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/organisms/ProdottoHead/ProdottoHead.tsx






var ProdottoHead = function(props) {
    var ref;
    var prodotto = props.prodotto, _setPreventivatoreModalOpen = props.setPreventivatoreModalOpen, setPreventivatoreModalOpen = _setPreventivatoreModalOpen === void 0 ? function() {
        return undefined;
    } : _setPreventivatoreModalOpen, _selectedLineePreventivatore = props.selectedLineePreventivatore, selectedLineePreventivatore = _selectedLineePreventivatore === void 0 ? [] : _selectedLineePreventivatore, _setSelectedLineePreventivatore = props.setSelectedLineePreventivatore, setSelectedLineePreventivatore = _setSelectedLineePreventivatore === void 0 ? function() {
        return undefined;
    } : _setSelectedLineePreventivatore, _className = props.className, className = _className === void 0 ? '' : _className;
    var t = (0,hooks/* useTrans */.IA)();
    var isMobile = (0,hooks/* useIsMobile */.dD)();
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((ProdottoHead_module_default()).prodottoHead, " ").concat(prodotto.preventivatore ? (ProdottoHead_module_default())["prodottoHead--preventivatore"] : '', " ").concat(className ? " ".concat(className) : ''),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ProdottoHead_module_default()).head,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ProdottoHead_module_default()).imageBox,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WImage */.Tg, {
                            src: isMobile ? prodotto.previewImage : prodotto.mainImage,
                            maxWidth: 1920,
                            maxHeight: 340,
                            layout: "intrinsic",
                            objectFit: "cover",
                            priority: true,
                            loading: "eager"
                        }, "main-image-prodotto-".concat(prodotto.pk).concat(isMobile ? '-mobile' : ''))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ProdottoHead_module_default()).heroBox,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: (ProdottoHead_module_default()).heroTitle,
                                children: prodotto.titolo
                            }),
                            prodotto.descrizioneBreve && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ProdottoHead_module_default()).heroDescription,
                                dangerouslySetInnerHTML: {
                                    __html: prodotto.descrizioneBreve
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ProdottoHead_module_default()).main,
                    children: [
                        prodotto.preventivatore && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (ProdottoHead_module_default()).preventivatoreMobile,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: (ProdottoHead_module_default()).preventivatoreMobileTitle,
                                    children: [
                                        t('Consulta il preventivatore'),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ProdottoHead_module_default()).preventivatoreMobileCtaBox,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                                        label: t('Fai un preventivo'),
                                        className: (ProdottoHead_module_default()).preventivatoreMobileCta,
                                        onClick: function() {
                                            return setPreventivatoreModalOpen(true);
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (ProdottoHead_module_default()).content,
                            children: [
                                prodotto.descrizione && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ProdottoHead_module_default()).description,
                                    dangerouslySetInnerHTML: {
                                        __html: prodotto.descrizione
                                    }
                                }),
                                ((ref = prodotto.tags) === null || ref === void 0 ? void 0 : ref.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (ProdottoHead_module_default()).tags,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (ProdottoHead_module_default()).tagsTitle,
                                            children: t('Tag prodotto')
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (ProdottoHead_module_default()).tagsList,
                                            children: prodotto.tags.map(function(tag) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(atoms/* Chip */.Af, {
                                                    variant: "blue",
                                                    size: "sm",
                                                    label: tag.titolo,
                                                    weight: "regular"
                                                }, tag.pk);
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        prodotto.preventivatore && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ProdottoHead_module_default()).preventivatore,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PreventivatoreIntro_PreventivatoreIntro, {
                                title: t('Consulta il <strong>preventivatore</strong> per {0}', [
                                    prodotto.titolo
                                ]),
                                ctaLabel: t('Richiedi un preventivo'),
                                prodotto: prodotto,
                                productPage: true,
                                setFormModalOpen: function(v) {
                                    return setPreventivatoreModalOpen(v);
                                },
                                selectedLinee: selectedLineePreventivatore,
                                setSelectedLinee: function(linee_ids) {
                                    return setSelectedLineePreventivatore(linee_ids);
                                },
                                className: (ProdottoHead_module_default()).tabContent
                            })
                        })
                    ]
                })
            })
        ]
    }));
};
/* harmony default export */ var ProdottoHead_ProdottoHead = (ProdottoHead);

// EXTERNAL MODULE: ../../libs/shared-ui/src/organisms/SearchOverlay/SearchOverlay.module.sass
var SearchOverlay_module = __webpack_require__(72793);
var SearchOverlay_module_default = /*#__PURE__*/__webpack_require__.n(SearchOverlay_module);
// EXTERNAL MODULE: ../../node_modules/@apollo/client/react/hooks/useLazyQuery.js
var useLazyQuery = __webpack_require__(3842);
;// CONCATENATED MODULE: ../../libs/shared-ui/utils/search.ts

function search_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function search_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return search_arrayLikeToArray(arr);
}
function search_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function search_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function search_toConsumableArray(arr) {
    return search_arrayWithoutHoles(arr) || search_iterableToArray(arr) || search_unsupportedIterableToArray(arr) || search_nonIterableSpread();
}
function search_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return search_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return search_arrayLikeToArray(o, minLen);
}
var MODELLI_SEARCH = [
    'prodotto',
    'articolomagazine',
    "categoria",
    "faq",
    "fascicolo",
    "pagina"
];
var mappingRisultatiSearch = function(risultatiSearch) {
    var prodotti = risultatiSearch.search.edges.filter(function(item) {
        var ref;
        return ((ref = item.node) === null || ref === void 0 ? void 0 : ref.modelName) === 'prodotto';
    });
    var documenti = risultatiSearch.search.edges.filter(function(item) {
        var ref;
        return ((ref = item.node) === null || ref === void 0 ? void 0 : ref.modelName) === 'fascicolo';
    });
    var faq = risultatiSearch.search.edges.filter(function(item) {
        var ref;
        return ((ref = item.node) === null || ref === void 0 ? void 0 : ref.modelName) === 'faq';
    });
    var articoli = risultatiSearch.search.edges.filter(function(item) {
        var ref;
        return ((ref = item.node) === null || ref === void 0 ? void 0 : ref.modelName) === 'articolomagazine';
    });
    var categorie = risultatiSearch.search.edges.filter(function(item) {
        var ref;
        return ((ref = item.node) === null || ref === void 0 ? void 0 : ref.modelName) === 'categoria';
    });
    var pagine = risultatiSearch.search.edges.filter(function(item) {
        var ref;
        return ((ref = item.node) === null || ref === void 0 ? void 0 : ref.modelName) === 'pagina';
    });
    return search_toConsumableArray(prodotti.length ? [
        {
            pk: 1,
            name: 'Prodotti',
            items: prodotti.map(function(item) {
                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
                return {
                    pk: (ref = item.node) === null || ref === void 0 ? void 0 : (ref1 = ref.object) === null || ref1 === void 0 ? void 0 : ref1.pk,
                    url: (ref2 = item.node) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.object) === null || ref3 === void 0 ? void 0 : ref3.url,
                    titolo: (ref4 = item.node) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.object) === null || ref5 === void 0 ? void 0 : ref5.titolo,
                    descrizione: (ref6 = item.node) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.object) === null || ref7 === void 0 ? void 0 : ref7.descrizioneBreve,
                    descrizioneBreve: (ref8 = item.node) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.object) === null || ref9 === void 0 ? void 0 : ref9.descrizioneBreve,
                    tags: (ref10 = item.node) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.object) === null || ref11 === void 0 ? void 0 : ref11.tags,
                    previewImage: (ref12 = item.node) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.object) === null || ref13 === void 0 ? void 0 : ref13.previewImage
                };
            })
        }
    ] : []).concat(search_toConsumableArray(documenti.length ? [
        {
            pk: 2,
            name: 'Documenti',
            items: documenti.map(function(item) {
                var ref, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25;
                return {
                    pk: (ref = item.node) === null || ref === void 0 ? void 0 : (ref14 = ref.object) === null || ref14 === void 0 ? void 0 : ref14.pk,
                    url: (ref15 = item.node) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.object) === null || ref16 === void 0 ? void 0 : ref16.url,
                    titolo: ((ref17 = item.node) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.object) === null || ref18 === void 0 ? void 0 : ref18.titolo) + (((ref19 = item.node) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.object) === null || ref20 === void 0 ? void 0 : ref20.edizione) ? " (".concat((ref23 = monthYearFormat((ref21 = item.node) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.object) === null || ref22 === void 0 ? void 0 : ref22.edizione)) === null || ref23 === void 0 ? void 0 : ref23.capitalize(), ")") : ''),
                    descrizione: (ref24 = item.node) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.object) === null || ref25 === void 0 ? void 0 : ref25.descrizione
                };
            })
        }
    ] : []), search_toConsumableArray(articoli.length ? [
        {
            pk: 3,
            name: 'Articoli',
            items: articoli.map(function(item) {
                var ref, ref26, ref27, ref28, ref29, ref30, ref31, ref32;
                return {
                    pk: (ref = item.node) === null || ref === void 0 ? void 0 : (ref26 = ref.object) === null || ref26 === void 0 ? void 0 : ref26.pk,
                    url: (ref27 = item.node) === null || ref27 === void 0 ? void 0 : (ref28 = ref27.object) === null || ref28 === void 0 ? void 0 : ref28.url,
                    titolo: (ref29 = item.node) === null || ref29 === void 0 ? void 0 : (ref30 = ref29.object) === null || ref30 === void 0 ? void 0 : ref30.title,
                    descrizione: (ref31 = item.node) === null || ref31 === void 0 ? void 0 : (ref32 = ref31.object) === null || ref32 === void 0 ? void 0 : ref32.abstract
                };
            })
        }
    ] : []), search_toConsumableArray(categorie.length ? [
        {
            pk: 4,
            name: 'Categorie',
            items: categorie.map(function(item) {
                var ref, ref33, ref34, ref35, ref36, ref37, ref38, ref39;
                return {
                    pk: (ref = item.node) === null || ref === void 0 ? void 0 : (ref33 = ref.object) === null || ref33 === void 0 ? void 0 : ref33.pk,
                    url: (ref34 = item.node) === null || ref34 === void 0 ? void 0 : (ref35 = ref34.object) === null || ref35 === void 0 ? void 0 : ref35.url,
                    titolo: (ref36 = item.node) === null || ref36 === void 0 ? void 0 : (ref37 = ref36.object) === null || ref37 === void 0 ? void 0 : ref37.titolo,
                    descrizione: (ref38 = item.node) === null || ref38 === void 0 ? void 0 : (ref39 = ref38.object) === null || ref39 === void 0 ? void 0 : ref39.descrizione
                };
            })
        }
    ] : []), search_toConsumableArray(faq.length ? [
        {
            pk: 5,
            name: 'Domande e risposte',
            items: faq.map(function(item) {
                var ref, ref40, ref41, ref42, ref43, ref44, ref45, ref46;
                return {
                    pk: (ref = item.node) === null || ref === void 0 ? void 0 : (ref40 = ref.object) === null || ref40 === void 0 ? void 0 : ref40.pk,
                    url: (ref41 = item.node) === null || ref41 === void 0 ? void 0 : (ref42 = ref41.object) === null || ref42 === void 0 ? void 0 : ref42.url,
                    titolo: (ref43 = item.node) === null || ref43 === void 0 ? void 0 : (ref44 = ref43.object) === null || ref44 === void 0 ? void 0 : ref44.domanda,
                    descrizione: (ref45 = item.node) === null || ref45 === void 0 ? void 0 : (ref46 = ref45.object) === null || ref46 === void 0 ? void 0 : ref46.risposta
                };
            })
        }
    ] : []), search_toConsumableArray(pagine.length ? [
        {
            pk: 6,
            name: 'Pagine',
            items: pagine.map(function(item) {
                var ref, ref47, ref48, ref49, ref50, ref51, ref52, ref53;
                return {
                    pk: (ref = item.node) === null || ref === void 0 ? void 0 : (ref47 = ref.object) === null || ref47 === void 0 ? void 0 : ref47.pk,
                    url: (ref48 = item.node) === null || ref48 === void 0 ? void 0 : (ref49 = ref48.object) === null || ref49 === void 0 ? void 0 : ref49.url,
                    titolo: (ref50 = item.node) === null || ref50 === void 0 ? void 0 : (ref51 = ref50.object) === null || ref51 === void 0 ? void 0 : ref51.titolo,
                    descrizione: (ref52 = item.node) === null || ref52 === void 0 ? void 0 : (ref53 = ref52.object) === null || ref53 === void 0 ? void 0 : ref53.descrizione
                };
            })
        }
    ] : []));
};
var mappingRisultatiSearchOverlay = function(searchData) {
    var prodotti = searchData.search.edges.filter(function(item) {
        var ref;
        return ((ref = item.node) === null || ref === void 0 ? void 0 : ref.modelName) === 'prodotto';
    });
    var documenti = searchData.search.edges.filter(function(item) {
        var ref;
        return ((ref = item.node) === null || ref === void 0 ? void 0 : ref.modelName) === 'fascicolo';
    });
    var altro = searchData.search.edges.filter(function(item) {
        var ref, ref54;
        return ((ref = item.node) === null || ref === void 0 ? void 0 : ref.modelName) !== 'prodotto' && ((ref54 = item.node) === null || ref54 === void 0 ? void 0 : ref54.modelName) !== 'fascicolo';
    }).map(function(item) {
        var ref, ref55, ref56, ref57, ref58, ref59, ref60, ref61, ref62, ref63, ref64, ref65, ref66, ref67, ref68, ref69, ref70, ref71, ref72, ref73, ref74, ref75, ref76, ref77, ref78, ref79, ref80, ref81;
        if (((ref = item.node) === null || ref === void 0 ? void 0 : ref.modelName) === 'articolomagazine') return {
            pk: (ref55 = item.node) === null || ref55 === void 0 ? void 0 : (ref56 = ref55.object) === null || ref56 === void 0 ? void 0 : ref56.pk,
            url: (ref57 = item.node) === null || ref57 === void 0 ? void 0 : (ref58 = ref57.object) === null || ref58 === void 0 ? void 0 : ref58.url,
            text: (ref59 = item.node) === null || ref59 === void 0 ? void 0 : (ref60 = ref59.object) === null || ref60 === void 0 ? void 0 : ref60.title
        };
        else if (((ref61 = item.node) === null || ref61 === void 0 ? void 0 : ref61.modelName) === 'categoria') return {
            pk: (ref62 = item.node) === null || ref62 === void 0 ? void 0 : (ref63 = ref62.object) === null || ref63 === void 0 ? void 0 : ref63.pk,
            url: (ref64 = item.node) === null || ref64 === void 0 ? void 0 : (ref65 = ref64.object) === null || ref65 === void 0 ? void 0 : ref65.url,
            text: (ref66 = item.node) === null || ref66 === void 0 ? void 0 : (ref67 = ref66.object) === null || ref67 === void 0 ? void 0 : ref67.titolo
        };
        else if (((ref68 = item.node) === null || ref68 === void 0 ? void 0 : ref68.modelName) === 'faq') return {
            pk: (ref69 = item.node) === null || ref69 === void 0 ? void 0 : (ref70 = ref69.object) === null || ref70 === void 0 ? void 0 : ref70.pk,
            url: (ref71 = item.node) === null || ref71 === void 0 ? void 0 : (ref72 = ref71.object) === null || ref72 === void 0 ? void 0 : ref72.url,
            text: (ref73 = item.node) === null || ref73 === void 0 ? void 0 : (ref74 = ref73.object) === null || ref74 === void 0 ? void 0 : ref74.domanda
        };
        else if (((ref75 = item.node) === null || ref75 === void 0 ? void 0 : ref75.modelName) === 'pagina') return {
            pk: (ref76 = item.node) === null || ref76 === void 0 ? void 0 : (ref77 = ref76.object) === null || ref77 === void 0 ? void 0 : ref77.pk,
            url: (ref78 = item.node) === null || ref78 === void 0 ? void 0 : (ref79 = ref78.object) === null || ref79 === void 0 ? void 0 : ref79.url,
            text: (ref80 = item.node) === null || ref80 === void 0 ? void 0 : (ref81 = ref80.object) === null || ref81 === void 0 ? void 0 : ref81.titolo
        };
        else return {};
    });
    return search_toConsumableArray(prodotti.length ? [
        {
            pk: 1,
            name: 'Prodotti',
            style: 'veicoli',
            items: prodotti.map(function(item) {
                var ref, ref82, ref83, ref84, ref85, ref86;
                return {
                    pk: (ref = item.node) === null || ref === void 0 ? void 0 : (ref82 = ref.object) === null || ref82 === void 0 ? void 0 : ref82.pk,
                    url: (ref83 = item.node) === null || ref83 === void 0 ? void 0 : (ref84 = ref83.object) === null || ref84 === void 0 ? void 0 : ref84.url,
                    text: (ref85 = item.node) === null || ref85 === void 0 ? void 0 : (ref86 = ref85.object) === null || ref86 === void 0 ? void 0 : ref86.titolo
                };
            })
        }
    ] : []).concat(search_toConsumableArray(documenti.length ? [
        {
            pk: 2,
            name: 'Documenti',
            style: 'beni',
            items: documenti.map(function(item) {
                var ref, ref87, ref88, ref89, ref90, ref91, ref92, ref93, ref94, ref95, ref96;
                return {
                    pk: (ref = item.node) === null || ref === void 0 ? void 0 : (ref87 = ref.object) === null || ref87 === void 0 ? void 0 : ref87.pk,
                    url: (ref88 = item.node) === null || ref88 === void 0 ? void 0 : (ref89 = ref88.object) === null || ref89 === void 0 ? void 0 : ref89.url,
                    text: ((ref90 = item.node) === null || ref90 === void 0 ? void 0 : (ref91 = ref90.object) === null || ref91 === void 0 ? void 0 : ref91.titolo) + (((ref92 = item.node) === null || ref92 === void 0 ? void 0 : (ref93 = ref92.object) === null || ref93 === void 0 ? void 0 : ref93.edizione) ? " (".concat((ref96 = (0,safe/* monthYearFormat */.EK)((ref94 = item.node) === null || ref94 === void 0 ? void 0 : (ref95 = ref94.object) === null || ref95 === void 0 ? void 0 : ref95.edizione)) === null || ref96 === void 0 ? void 0 : ref96.capitalize(), ")") : '')
                };
            })
        }
    ] : []), search_toConsumableArray(altro.length ? [
        {
            pk: 3,
            name: 'Altro',
            style: 'beni',
            items: altro.map(function(item) {
                return {
                    pk: item === null || item === void 0 ? void 0 : item.pk,
                    url: item === null || item === void 0 ? void 0 : item.url,
                    text: item === null || item === void 0 ? void 0 : item.text
                };
            })
        }
    ] : []));
};

;// CONCATENATED MODULE: ../../libs/shared-ui/src/organisms/SearchOverlay/SearchOverlay.tsx















function SearchOverlay_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function SearchOverlay_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function SearchOverlay_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function SearchOverlay_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function SearchOverlay_slicedToArray(arr, i) {
    return SearchOverlay_arrayWithHoles(arr) || SearchOverlay_iterableToArrayLimit(arr, i) || SearchOverlay_unsupportedIterableToArray(arr, i) || SearchOverlay_nonIterableRest();
}
function SearchOverlay_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return SearchOverlay_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return SearchOverlay_arrayLikeToArray(o, minLen);
}
var SearchOverlay = function(props) {
    var ref7;
    var _visible = props.visible, visible = _visible === void 0 ? false : _visible, _setVisible = props.setVisible, setVisible = _setVisible === void 0 ? undefined : _setVisible, _className = props.className, className = _className === void 0 ? '' : _className;
    var t = (0,hooks/* useTrans */.IA)();
    var site = (0,hooks/* useSite */.W4)();
    var SearchDocument = site === settings/* ASSICURAZIONI */.Cu ? generated_assicurazioni/* SearchDocument */.t4 : generated_vita/* SearchDocument */.t4;
    var ref1 = SearchOverlay_slicedToArray((0,useLazyQuery/* useLazyQuery */.t)(SearchDocument), 2), getSearch = ref1[0], ref2 = ref1[1], searchData = ref2.data, searchError = ref2.error, searchLoading = ref2.loading;
    var ref3 = (0,react.useState)(false), submitted = ref3[0], setSubmitted = ref3[1];
    var ref4 = (0,react.useState)(""), query = ref4[0], setQuery = ref4[1];
    var resultsPerPage = settings/* SEARCH_OVERLAY_ITEMS_PER_PAGE */.EL;
    var ref5 = (0,react.useState)(false), loading = ref5[0], setLoading = ref5[1];
    var ref6 = (0,react.useState)([]), risultati = ref6[0], setRisultati = ref6[1];
    var error = false;
    var menuTopSearch = (0,hooks/* useFindMenu */.Pb)("top-search");
    var submit = function(e) {
        e.preventDefault();
        var newQuery = e.target.q.value;
        if (newQuery && newQuery.trim() !== "" && newQuery !== query) {
            var ref;
            setSubmitted(true);
            setLoading(true);
            setQuery(newQuery);
            (0,gtm/* sendGTMData */.S3)({
                event: "GAevent",
                eventCategory: "search",
                eventAction: (ref = newQuery === null || newQuery === void 0 ? void 0 : newQuery.toString()) === null || ref === void 0 ? void 0 : ref.toGTMFormat(),
                eventLabel: "free_search"
            });
            getSearch({
                variables: {
                    query: newQuery,
                    models: MODELLI_SEARCH
                }
            });
        }
    };
    (0,react.useEffect)(function() {
        var ref, ref8;
        if ((searchData === null || searchData === void 0 ? void 0 : (ref = searchData.search) === null || ref === void 0 ? void 0 : (ref8 = ref.edges) === null || ref8 === void 0 ? void 0 : ref8.length) && !searchLoading) setRisultati(mappingRisultatiSearchOverlay(searchData));
        else setRisultati([]);
        if (!searchLoading) setLoading(false);
    }, [
        searchData,
        searchLoading
    ]);
    return visible ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((SearchOverlay_module_default()).searchOverlay, " ").concat(className ? " ".concat(className) : ''),
        children: [
            !!setVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                "aria-label": t("Chiudi"),
                onClick: function() {
                    return setVisible(false);
                },
                className: (SearchOverlay_module_default()).close,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.Close, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(atoms/* WContainer */.$t, {
                variant: "sm",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                        className: (SearchOverlay_module_default()).form,
                        onSubmit: submit,
                        autoComplete: "off",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (SearchOverlay_module_default()).inputWrap,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    type: "text",
                                    name: "q",
                                    className: (SearchOverlay_module_default()).input,
                                    placeholder: t("Cerca"),
                                    autoComplete: "off"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "submit",
                                    className: (SearchOverlay_module_default()).submit,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.Search, {})
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (SearchOverlay_module_default()).helpText,
                        children: t("Premi invio per cercare")
                    }),
                    !submitted ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (SearchOverlay_module_default()).suggestions,
                        children: menuTopSearch && ((ref7 = menuTopSearch.children) === null || ref7 === void 0 ? void 0 : ref7.edges) && menuTopSearch.children.edges.slice(0, 4).map(function(item) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(next_link["default"], {
                                href: item.node.url ? item.node.url : "/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    className: (SearchOverlay_module_default()).suggestionItem,
                                    onClick: function() {
                                        var ref;
                                        return (0,gtm/* sendGTMData */.S3)({
                                            event: "GAevent",
                                            eventCategory: "search",
                                            eventAction: (ref = item.node.name) === null || ref === void 0 ? void 0 : ref.toGTMFormat(),
                                            eventLabel: "suggested"
                                        });
                                    },
                                    children: [
                                        !!item.node.style && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (SearchOverlay_module_default()).suggestionItemIcon,
                                            children: getIcon(item.node.style)
                                        }),
                                        !!item.node.name && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (SearchOverlay_module_default()).suggestionItemTitle,
                                            children: item.node.name
                                        })
                                    ]
                                })
                            }, item.node.pk);
                        })
                    }) : loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Loader */.aN, {}) : error ? /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* NotificationBar */.o4, {
                        variant: "alert",
                        label: error
                    }) : risultati.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (SearchOverlay_module_default()).results,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* TabGroup */.v0, {
                            triggerSize: "lg",
                            tabs: risultati.map(function(resultType) {
                                return {
                                    key: resultType.pk.toString(),
                                    label: resultType.name,
                                    icon: getIcon(resultType.style),
                                    content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (SearchOverlay_module_default()).tabContent,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (SearchOverlay_module_default()).page,
                                                children: resultType.items.slice(0, resultsPerPage).map(function(item) {
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(next_link["default"], {
                                                        href: item.url,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: (SearchOverlay_module_default()).pageItem,
                                                            dangerouslySetInnerHTML: {
                                                                __html: "<span>".concat(item.text, "</span>")
                                                            }
                                                        })
                                                    }, item.pk);
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (SearchOverlay_module_default()).pageActions,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: (SearchOverlay_module_default()).pageIndicator,
                                                        dangerouslySetInnerHTML: {
                                                            __html: t("{0} di {1}", [
                                                                "<strong>".concat(resultType.items.length > resultsPerPage ? resultsPerPage : resultType.items.length, "</strong>"),
                                                                resultType.items.length.toString()
                                                            ])
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                                                        label: t("Vedi tutti i risultati"),
                                                        rightIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.ArrowRight, {}),
                                                        variant: "ghost",
                                                        external: true,
                                                        href: "/ricerca?q=" + query,
                                                        onClick: function() {
                                                            return (0,gtm/* sendGTMData */.S3)({
                                                                event: "GAevent",
                                                                eventCategory: 'search',
                                                                eventAction: 'ricerca_suggerita',
                                                                eventLabel: 'vedi_tutti_risultati'
                                                            });
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                };
                            })
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (SearchOverlay_module_default()).noResults,
                        children: t("Non ci sono risultati per questa ricerca")
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var SearchOverlay_SearchOverlay = (SearchOverlay);

// EXTERNAL MODULE: ../../libs/shared-ui/src/organisms/TestimonianzeSection/TestimonianzeSection.module.sass
var TestimonianzeSection_module = __webpack_require__(39280);
var TestimonianzeSection_module_default = /*#__PURE__*/__webpack_require__.n(TestimonianzeSection_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/organisms/TestimonianzeSection/TestimonianzeSection.tsx








function TestimonianzeSection_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function TestimonianzeSection_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            TestimonianzeSection_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var TestimonianzeSection = function(props) {
    var ref2;
    var _item = props.item, item = _item === void 0 ? undefined : _item, _className = props.className, className = _className === void 0 ? '' : _className;
    var swiperSettings = {
        slidesPerView: 1.25,
        spaceBetween: 16,
        pagination: {
            clickable: true
        },
        navigation: {
            nextEl: '.testimonianze-button-next',
            prevEl: '.testimonianze-button-prev'
        },
        watchOverflow: true,
        className: 'swiper-container--pagination',
        breakpoints: {
            1100: {
                slidesPerView: 3,
                spaceBetween: 30
            },
            768: {
                slidesPerView: 2.5,
                centeredSlides: false
            },
            576: {
                slidesPerView: 1.5
            },
            0: {
                centeredSlides: true
            }
        }
    };
    return item ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((TestimonianzeSection_module_default()).testimonianzeSection, " ").concat(className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(atoms/* WContainer */.$t, {
            variant: "md",
            children: [
                !!item.name && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* IntroTitle */.Om, {
                    label: item.name,
                    className: (TestimonianzeSection_module_default()).intro
                }),
                !!item.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (TestimonianzeSection_module_default()).title,
                    dangerouslySetInnerHTML: {
                        __html: item.description
                    }
                }),
                !!((ref2 = item.children) === null || ref2 === void 0 ? void 0 : ref2.edges.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (TestimonianzeSection_module_default()).list,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: "custom-button-prev testimonianze-button-prev",
                            onClick: function() {
                                return (0,gtm/* sendGTMData */.S3)({
                                    event: "GAevent",
                                    eventCategory: "box_info",
                                    eventAction: "approfondisci",
                                    eventLabel: "prev"
                                });
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.ArrowLeft, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: "custom-button-next testimonianze-button-next",
                            onClick: function() {
                                return (0,gtm/* sendGTMData */.S3)({
                                    event: "GAevent",
                                    eventCategory: "box_info",
                                    eventAction: "approfondisci",
                                    eventLabel: "next"
                                });
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.ArrowRight, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper/* Swiper */.t, TestimonianzeSection_objectSpread({}, swiperSettings, {
                            children: item.children.edges.slice(0, 3).map(function(child) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (TestimonianzeSection_module_default()).item,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UseCaseCard_UseCaseCard, {
                                            item: child.node,
                                            onClick: function() {
                                                var ref, ref1;
                                                return (0,gtm/* sendGTMData */.S3)({
                                                    event: "GAevent",
                                                    eventCategory: 'box_info',
                                                    eventAction: 'approfondisci',
                                                    eventLabel: (child === null || child === void 0 ? void 0 : (ref = child.node) === null || ref === void 0 ? void 0 : (ref1 = ref.name) === null || ref1 === void 0 ? void 0 : ref1.toGTMFormat()) || ''
                                                });
                                            }
                                        })
                                    })
                                }, child.node.pk);
                            })
                        }))
                    ]
                })
            ]
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var TestimonianzeSection_TestimonianzeSection = (TestimonianzeSection);

// EXTERNAL MODULE: ../../libs/shared-ui/src/organisms/Toolbar/Toolbar.module.sass
var Toolbar_module = __webpack_require__(43529);
var Toolbar_module_default = /*#__PURE__*/__webpack_require__.n(Toolbar_module);
// EXTERNAL MODULE: ../../libs/shared-ui/utils/index.ts
var utils = __webpack_require__(20741);
// EXTERNAL MODULE: ../../libs/shared-ui/utils/endpoints.ts
var endpoints = __webpack_require__(9861);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/organisms/Toolbar/Toolbar.tsx








utils/* api.defaults.xsrfCookieName */.hi.defaults.xsrfCookieName = 'csrftoken';
utils/* api.defaults.xsrfHeaderName */.hi.defaults.xsrfHeaderName = 'X-CSRFTOKEN';
var Toolbar = function(props) {
    var _page = props.page, page = _page === void 0 ? null : _page, _item = props.item, item = _item === void 0 ? null : _item;
    var router = (0,next_router.useRouter)();
    var ref = (0,hooks/* useUtente */.yl)(), utente = ref.utente, loading = ref.loading;
    if (!utente) return null;
    if (!(utente.isStaff || utente.isImpersonate)) return null;
    var handleSwitchMode = function(edit) {
        utils/* api.post */.hi.post(endpoints/* TOOLBAR */.t5 + 'set_edit/', {
            edit: edit
        }).then(function() {
            router.reload();
        }).catch(function(error) {
            return console.log(error);
        });
    };
    var paginaContienePagebuilder = document.getElementsByClassName("pb-content").length ? true : false;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((Toolbar_module_default()).toolbar, " toolbar"),
        children: utente.isImpersonate ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((Toolbar_module_default()).user, " ").concat((Toolbar_module_default())["user--impersonate"]),
            children: [
                "Stai impersonando",
                ' ',
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        utente.nome,
                        " ",
                        utente.cognome
                    ]
                }),
                ' ',
                "- ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: utente.stopImpersonateUrl,
                    children: "Smetti di impersonare"
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                    label: "Admin",
                    size: "sm",
                    href: "/d/admin",
                    newPage: true,
                    className: (Toolbar_module_default()).adminLink
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Toolbar_module_default()).user,
                    children: [
                        utente.nome,
                        " ",
                        utente.cognome
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    className: (Toolbar_module_default()).left
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: (Toolbar_module_default()).right,
                    children: [
                        item && item.adminUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                            label: "Modifica ".concat(item.modelClass),
                            size: "sm",
                            variant: "ghost",
                            href: item.adminUrl,
                            newPage: true
                        }),
                        page && page.adminUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                            label: "Admin Pagina",
                            size: "sm",
                            variant: "ghost",
                            href: page.adminUrl,
                            newPage: true
                        }),
                        paginaContienePagebuilder && (utente.edit ? /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                            label: "VEDI PUBBLICATA",
                            size: "sm",
                            onClick: function() {
                                return handleSwitchMode(false);
                            }
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                            label: "MODIFICA",
                            size: "sm",
                            onClick: function() {
                                return handleSwitchMode(true);
                            }
                        }))
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ var Toolbar_Toolbar = (Toolbar);

// EXTERNAL MODULE: ../../libs/shared-ui/src/organisms/TrovaSubitoSection/TrovaSubitoSection.module.sass
var TrovaSubitoSection_module = __webpack_require__(80483);
var TrovaSubitoSection_module_default = /*#__PURE__*/__webpack_require__.n(TrovaSubitoSection_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/organisms/TrovaSubitoSection/TrovaSubitoSection.tsx







var TrovaSubitoSection = function(props) {
    var ref1;
    var _item = props.item, item = _item === void 0 ? undefined : _item, _className = props.className, className = _className === void 0 ? '' : _className;
    var chatbotCtx = (0,react.useContext)(chatBotContext/* ChatBotContext */.i);
    return item ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((TrovaSubitoSection_module_default()).trovaSubitoSection, " ").concat(className ? " ".concat(className) : ''),
        children: [
            !!item.name && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* IntroTitle */.Om, {
                label: item.name,
                className: (TrovaSubitoSection_module_default()).intro
            }),
            !!item.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (TrovaSubitoSection_module_default()).title,
                dangerouslySetInnerHTML: {
                    __html: item.description
                }
            }),
            !!((ref1 = item.children) === null || ref1 === void 0 ? void 0 : ref1.edges.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (TrovaSubitoSection_module_default()).list,
                children: item.children.edges.map(function(child) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(atoms/* Chip */.Af, {
                        label: child.node.name,
                        size: "xl",
                        href: child.node.url,
                        onClick: function() {
                            var ref;
                            chatbotCtx.openChatBot(child.node);
                            (0,gtm/* sendGTMData */.S3)({
                                event: "GAevent",
                                eventCategory: "box_info",
                                eventAction: "trova_subito",
                                eventLabel: ((ref = child.node.name) === null || ref === void 0 ? void 0 : ref.toGTMFormat()) || ''
                            });
                        }
                    }, child.node.pk);
                })
            }),
            !!item.ctaLabel && !!item.chatbotUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (TrovaSubitoSection_module_default()).ctaBox,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                    label: item.ctaLabel,
                    rightIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.ArrowRight, {}),
                    variant: "ghost",
                    onClick: function() {
                        chatbotCtx.openChatBot(item);
                        (0,gtm/* sendGTMData */.S3)({
                            event: "GAevent",
                            eventCategory: "box_info",
                            eventAction: "trova_subito",
                            eventLabel: "non \xe8 quello che stavi cercando"
                        });
                    }
                })
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var TrovaSubitoSection_TrovaSubitoSection = (TrovaSubitoSection);

// EXTERNAL MODULE: ../../libs/shared-ui/src/organisms/ValorizzazioniListing/ValorizzazioniListing.module.sass
var ValorizzazioniListing_module = __webpack_require__(89317);
var ValorizzazioniListing_module_default = /*#__PURE__*/__webpack_require__.n(ValorizzazioniListing_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/organisms/ValorizzazioniListing/ValorizzazioniListing.tsx













var ValorizzazioniListing = function(props) {
    var ref12, ref1, ref2;
    var _slugCategoria = props.slugCategoria, slugCategoria = _slugCategoria === void 0 ? null : _slugCategoria, _className = props.className, className = _className === void 0 ? '' : _className;
    var t = (0,hooks/* useTrans */.IA)();
    var router = (0,next_router.useRouter)();
    var ref3 = (0,react.useState)(slugCategoria), categoriaAttiva = ref3[0], setCategoriaAttiva = ref3[1];
    var ref4 = (0,react.useState)(), searchInput = ref4[0], setSearchInput = ref4[1];
    var ref5 = (0,react.useState)(), searchedInput = ref5[0], setSearchedInput = ref5[1];
    var ref6 = (0,react.useState)(1), page1 = ref6[0], setPage = ref6[1];
    var ref7 = (0,react.useState)(null), tipologiaSelezionata = ref7[0], setTipologiaSelezionata = ref7[1];
    var ref8 = (0,generated_vita/* useCategorieFondoQuery */.j0)(), categorieFondoData = ref8.data;
    var ref9 = (0,generated_vita/* useFondiQuery */.m_)({
        variables: {
            offset: 0,
            first: settings/* FONDI_LISTING_ITEMS_PER_PAGE */.bC,
            categorie_Slug_Equals: categoriaAttiva,
            descrizioneCompleta_Icontains: searchedInput ? searchedInput : undefined,
            tipologia: tipologiaSelezionata
        }
    }), dataFondi = ref9.data, loadingFondi = ref9.loading, error = ref9.error, refetchFondi = ref9.refetch;
    var totaleValorizzazioni = dataFondi === null || dataFondi === void 0 ? void 0 : (ref12 = dataFondi.fondi) === null || ref12 === void 0 ? void 0 : ref12.totalCount;
    var selectCategoria = function(slug) {
        if (categoriaAttiva === slug) {
            setCategoriaAttiva(null);
            setPage(1);
            router.push('/portale-valorizzazioni');
        } else {
            setCategoriaAttiva(slug);
            setPage(1);
            router.push('/portale-valorizzazioni/' + slug);
        }
    };
    var handleChangePage = function(value) {
        setPage(value);
        refetchFondi({
            offset: (value - 1) * settings/* FONDI_LISTING_ITEMS_PER_PAGE */.bC,
            first: settings/* FONDI_LISTING_ITEMS_PER_PAGE */.bC,
            categorie_Slug_Equals: categoriaAttiva,
            descrizioneCompleta_Icontains: searchedInput ? searchedInput : undefined,
            tipologia: tipologiaSelezionata
        });
    };
    var handleSearchSubmit = function(value) {
        setPage(1);
        setSearchedInput(value);
        (0,gtm/* sendGTMData */.S3)({
            event: "GAevent",
            eventCategory: "search_portale_valorizzazioni",
            eventAction: value === null || value === void 0 ? void 0 : value.toGTMFormat(),
            eventLabel: "portale_valorizzazioni"
        });
        refetchFondi({
            offset: 0,
            first: settings/* FONDI_LISTING_ITEMS_PER_PAGE */.bC,
            categorie_Slug_Equals: categoriaAttiva,
            descrizioneCompleta_Icontains: value ? value : undefined,
            tipologia: tipologiaSelezionata
        });
    };
    var handleTipologiaFilter = function(value) {
        setPage(1);
        setTipologiaSelezionata(value);
        (0,gtm/* sendGTMData */.S3)({
            event: "GAevent",
            eventCategory: "filtri_avanzati",
            eventAction: value === null || value === void 0 ? void 0 : value.toGTMFormat(),
            eventLabel: "portale_valorizzazioni"
        });
        refetchFondi({
            offset: 0,
            first: settings/* FONDI_LISTING_ITEMS_PER_PAGE */.bC,
            categorie_Slug_Equals: categoriaAttiva,
            descrizioneCompleta_Icontains: searchedInput ? searchedInput : undefined,
            tipologia: value
        });
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((ValorizzazioniListing_module_default()).magazineListing, " ").concat(className ? " ".concat(className) : ''),
        children: [
            !!(categorieFondoData === null || categorieFondoData === void 0 ? void 0 : (ref1 = categorieFondoData.categorieFondo) === null || ref1 === void 0 ? void 0 : ref1.edges.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ValorizzazioniListing_module_default()).filtersList,
                        children: categorieFondoData.categorieFondo.edges.map(function(filtro) {
                            return (filtro === null || filtro === void 0 ? void 0 : filtro.node) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Chip */.Af, {
                                label: filtro.node.nome,
                                onClick: function() {
                                    var ref, ref10, ref11;
                                    selectCategoria((ref = filtro.node) === null || ref === void 0 ? void 0 : ref.slug);
                                    (0,gtm/* sendGTMData */.S3)({
                                        event: "GAevent",
                                        eventCategory: 'filtri',
                                        eventAction: (filtro === null || filtro === void 0 ? void 0 : (ref10 = filtro.node) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.nome) === null || ref11 === void 0 ? void 0 : ref11.toGTMFormat()) || '',
                                        eventLabel: 'portale_valorizzazioni'
                                    });
                                },
                                active: categoriaAttiva === filtro.node.slug
                            }, filtro.node.pk) : null;
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ValorizzazioniListing_module_default()).filtersSlider,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper/* Swiper */.t, {
                            spaceBetween: 16,
                            slidesPerView: "auto",
                            watchOverflow: true,
                            children: categorieFondoData.categorieFondo.edges.map(function(filtro) {
                                return (filtro === null || filtro === void 0 ? void 0 : filtro.node) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Chip */.Af, {
                                        label: filtro.node.nome,
                                        onClick: function() {
                                            var ref, ref13, ref14;
                                            selectCategoria((ref = filtro.node) === null || ref === void 0 ? void 0 : ref.slug);
                                            (0,gtm/* sendGTMData */.S3)({
                                                event: "GAevent",
                                                eventCategory: 'filtri',
                                                eventAction: (filtro === null || filtro === void 0 ? void 0 : (ref13 = filtro.node) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.nome) === null || ref14 === void 0 ? void 0 : ref14.toGTMFormat()) || '',
                                                eventLabel: 'portale_valorizzazioni'
                                            });
                                        },
                                        active: categoriaAttiva === filtro.node.slug
                                    })
                                }, filtro.node.pk) : null;
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ValorizzazioniListing_module_default()).advanced,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: (ValorizzazioniListing_module_default()).title,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: t("Risultati")
                            }),
                            " (",
                            totaleValorizzazioni,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ValorizzazioniListing_module_default()).search,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "text",
                                placeholder: t("Cerca un fondo..."),
                                onChange: function(e) {
                                    var value = e.target.value;
                                    setSearchInput(value);
                                    if (!value) {
                                        handleSearchSubmit(value);
                                    }
                                },
                                className: (ValorizzazioniListing_module_default()).input,
                                autoComplete: "off"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "submit",
                                className: (ValorizzazioniListing_module_default()).submit,
                                onClick: function() {
                                    return handleSearchSubmit(searchInput);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.Search, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ValorizzazioniListing_module_default()).advancedFilters,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Dropdown */.Lt, {
                                triggerProps: {
                                    label: t("Filtri avanzati"),
                                    labelMobile: t("Filtri"),
                                    rightIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.Filters, {})
                                },
                                contentPos: "right",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (ValorizzazioniListing_module_default()).advancedFiltersDropdown,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* FiltroValorizzazioni */.pK, {
                                            label: "Interno",
                                            value: "interno",
                                            selection: tipologiaSelezionata,
                                            handleTipologiaFilter: handleTipologiaFilter
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* FiltroValorizzazioni */.pK, {
                                            label: "Esterno",
                                            value: "esterno",
                                            selection: tipologiaSelezionata,
                                            handleTipologiaFilter: handleTipologiaFilter
                                        })
                                    ]
                                })
                            }),
                            tipologiaSelezionata && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ValorizzazioniListing_module_default()).advancedFiltersBadge,
                                children: "1"
                            })
                        ]
                    })
                ]
            }),
            loadingFondi && !dataFondi ? /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Loader */.aN, {
                className: (ValorizzazioniListing_module_default()).loader
            }) : error ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ValorizzazioniListing_module_default()).error,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* NotificationBar */.o4, {
                    variant: "alert",
                    label: error.message,
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.Alert, {})
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ValorizzazioniListing_module_default()).list,
                        children: dataFondi === null || dataFondi === void 0 ? void 0 : (ref2 = dataFondi.fondi) === null || ref2 === void 0 ? void 0 : ref2.edges.map(function(valorizzazione) {
                            return (valorizzazione === null || valorizzazione === void 0 ? void 0 : valorizzazione.node) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ValorizzazioniListing_module_default()).item,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ValorizzazioneCard_ValorizzazioneCard, {
                                    valorizzazione: valorizzazione.node
                                })
                            }, valorizzazione.node.pk);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Pagination */.tl, {
                        currentPage: page1,
                        totalCount: totaleValorizzazioni ? totaleValorizzazioni : 0,
                        pageSize: settings/* FONDI_LISTING_ITEMS_PER_PAGE */.bC,
                        onPageChange: function(page) {
                            return handleChangePage(page);
                        },
                        className: (ValorizzazioniListing_module_default()).pagination
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var ValorizzazioniListing_ValorizzazioniListing = (ValorizzazioniListing);

;// CONCATENATED MODULE: ../../libs/shared-ui/src/organisms/index.ts



































// EXTERNAL MODULE: ../../libs/shared-ui/src/templates/ArchivioFascicoliTemplate/ArchivioFascicoliTemplate.module.sass
var ArchivioFascicoliTemplate_module = __webpack_require__(77339);
var ArchivioFascicoliTemplate_module_default = /*#__PURE__*/__webpack_require__.n(ArchivioFascicoliTemplate_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/templates/ArchivioFascicoliTemplate/ArchivioFascicoliTemplate.tsx





var ArchivioFascicoliTemplate = function(props) {
    var _pagina = props.pagina, pagina = _pagina === void 0 ? null : _pagina, _isCatalogoFondi = props.isCatalogoFondi, isCatalogoFondi = _isCatalogoFondi === void 0 ? false : _isCatalogoFondi;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(organisms_Page_Page, {
        pagina: pagina,
        item: {},
        contentClassName: (ArchivioFascicoliTemplate_module_default()).archivioFascicoliContent,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((ArchivioFascicoliTemplate_module_default()).headBg, " bg-grey"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(atoms/* WContainer */.$t, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Breadcrumbs */.Oo, {
                            breadcrumbs: pagina === null || pagina === void 0 ? void 0 : pagina.breadcrumbs
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* MainTitle */.U3, {
                            label: pagina === null || pagina === void 0 ? void 0 : pagina.nome,
                            variant: "light",
                            className: (ArchivioFascicoliTemplate_module_default()).title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* MainDescription */.WC, {
                            html: pagina === null || pagina === void 0 ? void 0 : pagina.descrizione
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArchivioFascicoliListing_ArchivioFascicoliListing, {
                        isCatalogoFondi: isCatalogoFondi
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var ArchivioFascicoliTemplate_ArchivioFascicoliTemplate = (ArchivioFascicoliTemplate);

// EXTERNAL MODULE: ../../libs/shared-ui/src/templates/AreaClientiTemplate/AreaClientiTemplate.module.sass
var AreaClientiTemplate_module = __webpack_require__(34451);
var AreaClientiTemplate_module_default = /*#__PURE__*/__webpack_require__.n(AreaClientiTemplate_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/templates/AreaClientiTemplate/AreaClientiTemplate.tsx








function AreaClientiTemplate_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function AreaClientiTemplate_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            AreaClientiTemplate_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var AreaClientiTemplate = function(props) {
    var ref1;
    var _pagina = props.pagina, pagina = _pagina === void 0 ? {} : _pagina;
    var isMobile = (0,hooks/* useIsMobile */.dD)();
    var chatbotCtx = (0,react.useContext)(chatBotContext/* ChatBotContext */.i);
    var menuAreaClienti = (0,hooks/* useFindMenu */.Pb)('pagina_area_clienti');
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(organisms_Page_Page, {
        pagina: pagina,
        item: {},
        contentClassName: (AreaClientiTemplate_module_default()).areaClientiContent,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((AreaClientiTemplate_module_default()).headBg, " bg-grey"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(atoms/* WContainer */.$t, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Breadcrumbs */.Oo, {
                            breadcrumbs: pagina === null || pagina === void 0 ? void 0 : pagina.breadcrumbs
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (AreaClientiTemplate_module_default()).headLayout,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((AreaClientiTemplate_module_default()).headContent, " ").concat(!(pagina === null || pagina === void 0 ? void 0 : pagina.mainImage) ? (AreaClientiTemplate_module_default())["headContent--full"] : ''),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* MainTitle */.U3, {
                                            label: pagina === null || pagina === void 0 ? void 0 : pagina.nome,
                                            variant: "light",
                                            className: (AreaClientiTemplate_module_default()).title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* MainDescription */.WC, {
                                            html: pagina === null || pagina === void 0 ? void 0 : pagina.descrizione,
                                            className: (AreaClientiTemplate_module_default()).description
                                        })
                                    ]
                                }),
                                (pagina === null || pagina === void 0 ? void 0 : pagina.mainImage) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (AreaClientiTemplate_module_default()).headImage,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WImage */.Tg, {
                                        src: isMobile ? pagina === null || pagina === void 0 ? void 0 : pagina.previewImage : pagina === null || pagina === void 0 ? void 0 : pagina.mainImage,
                                        maxWidth: 536,
                                        maxHeight: 350,
                                        layout: "intrinsic",
                                        objectFit: "cover",
                                        priority: true,
                                        loading: "eager"
                                    }, "area-clienti-main-image".concat(isMobile ? '-mobile' : ''))
                                })
                            ]
                        })
                    ]
                })
            }),
            menuAreaClienti && ((ref1 = menuAreaClienti.children) === null || ref1 === void 0 ? void 0 : ref1.edges) && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (AreaClientiTemplate_module_default()).sectionContainer,
                    children: menuAreaClienti.children.edges.map(function(child) {
                        var ref;
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                            className: (AreaClientiTemplate_module_default()).section,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (AreaClientiTemplate_module_default()).sectionTitle,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: child.node.name
                                    })
                                }),
                                !!child.node.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (AreaClientiTemplate_module_default()).sectionDescription,
                                    dangerouslySetInnerHTML: {
                                        __html: child.node.description || ''
                                    }
                                }),
                                ((ref = child.node.children) === null || ref === void 0 ? void 0 : ref.edges) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (AreaClientiTemplate_module_default()).list,
                                    children: child.node.children.edges.map(function(item) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(atoms/* AssistenzaButton */.zm, AreaClientiTemplate_objectSpread({
                                            label: item.node.name || '',
                                            icon: getIcon(child.node.style),
                                            newPage: child.node.blank
                                        }, item.node.url ? {
                                            url: item.node.url
                                        } : {
                                            onClick: function() {
                                                chatbotCtx.openChatBot(item.node);
                                            }
                                        }), item.node.pk);
                                    })
                                })
                            ]
                        }, "menu-area-clienti-".concat(child.node.pk));
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var AreaClientiTemplate_AreaClientiTemplate = (AreaClientiTemplate);

// EXTERNAL MODULE: ../../libs/shared-ui/src/templates/ArticoloTemplate/ArticoloTemplate.module.sass
var ArticoloTemplate_module = __webpack_require__(46501);
var ArticoloTemplate_module_default = /*#__PURE__*/__webpack_require__.n(ArticoloTemplate_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/templates/ArticoloTemplate/ArticoloTemplate.tsx








var ArticoloTemplate = function(props) {
    var ref;
    var _pagina = props.pagina, pagina = _pagina === void 0 ? null : _pagina, _articolo = props.articolo, articolo = _articolo === void 0 ? null : _articolo;
    var t = (0,hooks/* useTrans */.IA)();
    return articolo ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(organisms_Page_Page, {
        pagina: pagina,
        item: articolo,
        contentClassName: (ArticoloTemplate_module_default()).articoloContent,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                children: (pagina === null || pagina === void 0 ? void 0 : pagina.breadcrumbs) && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Breadcrumbs */.Oo, {
                    breadcrumbs: pagina.breadcrumbs,
                    mobileHideLast: true
                })
            }),
            !!articolo.title && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                variant: "sm",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* MainTitle */.U3, {
                    label: articolo.title,
                    className: (ArticoloTemplate_module_default()).title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(atoms/* WContainer */.$t, {
                variant: "xs",
                children: [
                    !!(articolo === null || articolo === void 0 ? void 0 : articolo.mainImage) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ArticoloTemplate_module_default()).imageBox,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WImage */.Tg, {
                            src: articolo === null || articolo === void 0 ? void 0 : articolo.mainImage,
                            maxWidth: 730,
                            maxHeight: 261,
                            layout: "intrinsic",
                            objectFit: "cover",
                            priority: true,
                            loading: "eager"
                        })
                    }),
                    !!(articolo === null || articolo === void 0 ? void 0 : articolo.publicationDate) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (ArticoloTemplate_module_default()).date,
                        children: articolo.publicationDate
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ArticoloTemplate_module_default()).content,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* PlaceholderReact */.b, {
                            contentTypeId: articolo.contentTypeId,
                            objectId: articolo.pk,
                            pkey: "content"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ArticoloTemplate_module_default()).actions,
                    children: [
                        (pagina === null || pagina === void 0 ? void 0 : pagina.breadcrumbs) && pagina.breadcrumbs.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                            label: t("Torna alla lista"),
                            variant: "ghost",
                            leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.ArrowLeft, {}),
                            href: pagina.breadcrumbs[1].url
                        }),
                        !!((ref = articolo.next) === null || ref === void 0 ? void 0 : ref.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                            label: t("Articolo successivo"),
                            variant: "ghost",
                            rightIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons.ArrowRight, {}),
                            href: articolo.next.url
                        })
                    ]
                })
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var ArticoloTemplate_ArticoloTemplate = (ArticoloTemplate);

// EXTERNAL MODULE: ../../libs/shared-ui/src/templates/CategoriaProdottoTemplate/CategoriaProdottoTemplate.module.sass
var CategoriaProdottoTemplate_module = __webpack_require__(93210);
var CategoriaProdottoTemplate_module_default = /*#__PURE__*/__webpack_require__.n(CategoriaProdottoTemplate_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/templates/CategoriaProdottoTemplate/CategoriaProdottoTemplate.tsx







var CategoriaProdottoTemplate = function(props) {
    var _categoria = props.categoria, categoria = _categoria === void 0 ? null : _categoria, _pagina = props.pagina, pagina = _pagina === void 0 ? null : _pagina;
    var ref;
    return categoria ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(organisms_Page_Page, {
        pagina: pagina,
        item: categoria,
        contentClassName: (CategoriaProdottoTemplate_module_default()).categoriaProdottoContent,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((CategoriaProdottoTemplate_module_default()).headBg, " ").concat(categoria.box ? "bg-grey-white" : "bg-grey"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(atoms/* WContainer */.$t, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Breadcrumbs */.Oo, {
                            breadcrumbs: pagina.breadcrumbs
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (CategoriaProdottoTemplate_module_default()).head,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (CategoriaProdottoTemplate_module_default()).headContent,
                                    children: [
                                        !!categoria.nome && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* MainTitle */.U3, {
                                            label: categoria.nome,
                                            variant: "light",
                                            className: (CategoriaProdottoTemplate_module_default()).title
                                        }),
                                        !!categoria.descrizione && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (CategoriaProdottoTemplate_module_default()).description,
                                            dangerouslySetInnerHTML: {
                                                __html: categoria.descrizione
                                            }
                                        })
                                    ]
                                }),
                                !!categoria.box && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (CategoriaProdottoTemplate_module_default()).promo,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextCtaBox_TextCtaBox, {
                                        item: categoria.box,
                                        size: "lg-narrow",
                                        onClick: function() {
                                            var ref1;
                                            return (0,gtm/* sendGTMData */.S3)({
                                                event: "GAevent",
                                                eventCategory: 'banner_promo',
                                                eventAction: (ref = (ref1 = categoria.box.name) === null || ref1 === void 0 ? void 0 : ref1.toGTMFormat()) !== null && ref !== void 0 ? ref : '',
                                                eventLabel: 'plp'
                                            });
                                        }
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            categoria.prodotti && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProdottiListing_ProdottiListing, {
                    prodotti: categoria.prodotti
                })
            }),
            !!categoria.descrizioneAggiuntiva && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (CategoriaProdottoTemplate_module_default()).description,
                    dangerouslySetInnerHTML: {
                        __html: categoria.descrizioneAggiuntiva
                    }
                })
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var CategoriaProdottoTemplate_CategoriaProdottoTemplate = (CategoriaProdottoTemplate);

// EXTERNAL MODULE: ../../libs/shared-ui/src/templates/ChiSiamoTemplate/ChiSiamoTemplate.module.sass
var ChiSiamoTemplate_module = __webpack_require__(44590);
var ChiSiamoTemplate_module_default = /*#__PURE__*/__webpack_require__.n(ChiSiamoTemplate_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/templates/ChiSiamoTemplate/ChiSiamoTemplate.tsx










var ChiSiamoTemplate = function(props) {
    var ref2;
    var _pagina = props.pagina, pagina = _pagina === void 0 ? {} : _pagina;
    var isMobile = (0,hooks/* useIsMobile */.dD)();
    var utente = (0,hooks/* useUtente */.yl)().utente;
    var toolbarPresente = utente && (utente.isStaff || utente.isImpersonate);
    var ref1 = (0,react.useState)(''), menuActive = ref1[0], setMenuActive = ref1[1];
    var menuRef = (0,react.useRef)(null);
    var sectionRefs = (0,react.useRef)([]);
    var addSectionRef = function(ref) {
        if (ref) {
            if (sectionRefs.current.filter(function(x) {
                return x.id === ref.id;
            }).length > 0) sectionRefs.current = sectionRefs.current.map(function(x) {
                return x.id === ref.id ? ref : x;
            });
            else sectionRefs.current.push(ref);
        }
    };
    var handleScroll = function() {
        var ref;
        if (menuRef.current) {
            if (window.scrollY >= menuRef.current.offsetTop - (toolbarPresente ? 40 : 0) - 80) document.body.classList.add('chi-siamo-menu-sticky');
            else document.body.classList.remove('chi-siamo-menu-sticky');
        }
        // Calcolo se sono all'altezza di un box del menu
        var scrollOffset = window.scrollY + (toolbarPresente ? 40 : 0) + 80 + 80 + 20 + 10 // + header + menu + margine + correzzione
        ;
        var match = sectionRefs.current.filter(function(x) {
            return scrollOffset >= x.offsetTop && scrollOffset <= x.offsetTop + x.clientHeight;
        });
        // Potrebbero esserci box sovrapposti, prendo l'ultimo match
        setMenuActive(match.length > 0 ? (ref = match[match.length - 1].id) === null || ref === void 0 ? void 0 : ref.replace('menu_', '') : null);
    };
    (0,react.useEffect)(function() {
        window.addEventListener('scroll', handleScroll, {
            passive: true
        });
        return function() {
            return window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    var menuChiSiamo = (0,hooks/* useFindMenu */.Pb)("chi-siamo");
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(organisms_Page_Page, {
        pagina: pagina,
        item: {},
        contentClassName: (ChiSiamoTemplate_module_default()).chiSiamoContent,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((ChiSiamoTemplate_module_default()).headBg, " bg-grey"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(atoms/* WContainer */.$t, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Breadcrumbs */.Oo, {
                            breadcrumbs: pagina === null || pagina === void 0 ? void 0 : pagina.breadcrumbs
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (ChiSiamoTemplate_module_default()).headLayout,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (ChiSiamoTemplate_module_default()).headContent,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* MainTitle */.U3, {
                                            label: pagina === null || pagina === void 0 ? void 0 : pagina.nome,
                                            variant: "light",
                                            className: (ChiSiamoTemplate_module_default()).title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* MainDescription */.WC, {
                                            html: pagina === null || pagina === void 0 ? void 0 : pagina.descrizione,
                                            className: (ChiSiamoTemplate_module_default()).description
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ChiSiamoTemplate_module_default()).headImage,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WImage */.Tg, {
                                        src: isMobile ? pagina === null || pagina === void 0 ? void 0 : pagina.previewImage : pagina === null || pagina === void 0 ? void 0 : pagina.mainImage,
                                        maxWidth: 536,
                                        maxHeight: 350,
                                        layout: "intrinsic",
                                        objectFit: "cover",
                                        priority: true,
                                        loading: "eager"
                                    }, "chi-siamo-main-image".concat(isMobile ? '-mobile' : ''))
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ChiSiamoTemplate_module_default()).contentSection,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                    variant: "xs",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ChiSiamoTemplate_module_default()).customContent,
                        dangerouslySetInnerHTML: {
                            __html: (menuChiSiamo === null || menuChiSiamo === void 0 ? void 0 : menuChiSiamo.description) || ''
                        }
                    })
                })
            }),
            menuChiSiamo && ((ref2 = menuChiSiamo.children) === null || ref2 === void 0 ? void 0 : ref2.edges) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ChiSiamoTemplate_module_default()).menuSectionRef,
                        ref: menuRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ChiSiamoTemplate_module_default()).menuSection,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ChiSiamoTemplate_module_default()).menu,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper/* Swiper */.t, {
                                        spaceBetween: 0,
                                        slidesPerView: "auto",
                                        children: menuChiSiamo.children.edges.map(function(child, index) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "#menu_".concat(child.node.pk),
                                                    className: "".concat((ChiSiamoTemplate_module_default()).menuItem, " ").concat(menuActive === "".concat(child.node.pk) ? (ChiSiamoTemplate_module_default())["menuItem--active"] : ''),
                                                    onClick: function(e) {
                                                        var ref;
                                                        e.preventDefault();
                                                        (0,safe/* scrollTo */.X5)(sectionRefs.current[index], toolbarPresente, 100) // Offset: 80 di menu + 20 di margine
                                                        ;
                                                        (0,gtm/* sendGTMData */.S3)({
                                                            event: "GAevent",
                                                            eventCategory: "sotto_menu",
                                                            eventAction: (ref = child.node.name) === null || ref === void 0 ? void 0 : ref.toGTMFormat(),
                                                            eventLabel: "chi_siamo"
                                                        });
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        dangerouslySetInnerHTML: {
                                                            __html: child.node.name || ''
                                                        }
                                                    })
                                                })
                                            }, child.node.pk);
                                        })
                                    })
                                })
                            })
                        })
                    }),
                    menuChiSiamo.children.edges.map(function(child) {
                        return child.node.style ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (ChiSiamoTemplate_module_default()).section,
                            id: "menu_".concat(child.node.pk),
                            ref: addSectionRef,
                            children: [
                                child.node.style.startsWith('image_text_box_') && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageTextBox_ImageTextBox, {
                                        item: child.node,
                                        textPos: child.node.style === 'image_text_box_right' ? 'right' : 'left'
                                    })
                                }),
                                child.node.style.startsWith('content_box_') && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentBox_ContentBox, {
                                    item: child.node,
                                    titlePos: child.node.style === 'content_box_right' ? 'right' : 'left'
                                }),
                                child.node.style === 'allegati' && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AllegatiBox_AllegatiBox, {
                                        item: child.node
                                    })
                                })
                            ]
                        }, "menu_".concat(child.node.pk)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var ChiSiamoTemplate_ChiSiamoTemplate = (ChiSiamoTemplate);

// EXTERNAL MODULE: ../../libs/shared-ui/src/templates/ContattaciTemplate/ContattaciTemplate.module.sass
var ContattaciTemplate_module = __webpack_require__(34927);
var ContattaciTemplate_module_default = /*#__PURE__*/__webpack_require__.n(ContattaciTemplate_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/templates/ContattaciTemplate/ContattaciTemplate.tsx










var ContattaciTemplate = function(props) {
    var ref3;
    var _pagina = props.pagina, pagina = _pagina === void 0 ? {} : _pagina;
    var site = (0,hooks/* useSite */.W4)();
    var t = (0,hooks/* useTrans */.IA)();
    var isMobile = (0,hooks/* useIsMobile */.dD)();
    var utente = (0,hooks/* useUtente */.yl)().utente;
    var toolbarPresente = utente && (utente.isStaff || utente.isImpersonate);
    var ref1 = (0,react.useState)(false), mobileModalOpen = ref1[0], setMobileModalOpen = ref1[1];
    var formContattiRef = (0,react.useRef)(null);
    var ref2 = (0,react.useState)(''), menuActive = ref2[0], setMenuActive = ref2[1];
    var menuRef = (0,react.useRef)(null);
    var sectionRefs = (0,react.useRef)([]);
    var addSectionRef = function(ref) {
        if (ref) {
            if (sectionRefs.current.filter(function(x) {
                return x.id === ref.id;
            }).length > 0) sectionRefs.current = sectionRefs.current.map(function(x) {
                return x.id === ref.id ? ref : x;
            });
            else sectionRefs.current.push(ref);
        }
    };
    var handleScroll = function() {
        var ref;
        if (menuRef.current) {
            if (window.scrollY >= menuRef.current.offsetTop - (toolbarPresente ? 40 : 0) - 80) document.body.classList.add('contattaci-menu-sticky');
            else document.body.classList.remove('contattaci-menu-sticky');
        }
        // Calcolo se sono all'altezza di un box del menu
        var scrollOffset = window.scrollY + (toolbarPresente ? 40 : 0) + 80 + 80 + 20 + 10 // + header + menu + margine + correzzione
        ;
        var match = sectionRefs.current.filter(function(x) {
            return scrollOffset >= x.offsetTop && scrollOffset <= x.offsetTop + x.clientHeight;
        });
        // Potrebbero esserci box sovrapposti, prendo l'ultimo match
        setMenuActive(match.length > 0 ? (ref = match[match.length - 1].id) === null || ref === void 0 ? void 0 : ref.replace('menu_', '') : null);
    };
    (0,react.useEffect)(function() {
        window.addEventListener('scroll', handleScroll, {
            passive: true
        });
        return function() {
            return window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    var menuContattaci = (0,hooks/* useFindMenu */.Pb)("contattaci");
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(organisms_Page_Page, {
        pagina: pagina,
        item: {},
        contentClassName: (ContattaciTemplate_module_default()).chiSiamoContent,
        recaptchaRequired: true,
        children: [
            (pagina === null || pagina === void 0 ? void 0 : pagina.breadcrumbs) && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Breadcrumbs */.Oo, {
                    breadcrumbs: pagina === null || pagina === void 0 ? void 0 : pagina.breadcrumbs,
                    className: (ContattaciTemplate_module_default()).contattaciBreadcrumbs
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (ContattaciTemplate_module_default()).head,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ContattaciTemplate_module_default()).imageBox,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WImage */.Tg, {
                            src: isMobile ? pagina.previewImage : pagina.mainImage,
                            maxWidth: 1920,
                            maxHeight: 340,
                            layout: "intrinsic",
                            objectFit: "cover",
                            priority: true,
                            loading: "eager"
                        }, "contattaci-main-image".concat(isMobile ? '-mobile' : ''))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ContattaciTemplate_module_default()).heroBox,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (ContattaciTemplate_module_default()).heroTitle,
                                children: pagina.nome
                            }),
                            pagina.descrizione && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ContattaciTemplate_module_default()).heroDescription,
                                dangerouslySetInnerHTML: {
                                    __html: pagina.descrizione
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ContattaciTemplate_module_default()).mainSection,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ContattaciTemplate_module_default()).main,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (ContattaciTemplate_module_default()).formMobile,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (ContattaciTemplate_module_default()).formMobileTitle,
                                        children: t("Hai bisogno di assistenza?")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (ContattaciTemplate_module_default()).formMobileCtaBox,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                                            label: t("Invia messaggio"),
                                            className: (ContattaciTemplate_module_default()).formMobileCta,
                                            onClick: function() {
                                                return setMobileModalOpen(true);
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ContattaciTemplate_module_default()).formBox,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContattaciForm_ContattaciForm, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat((ContattaciTemplate_module_default()).content, " custom-content"),
                                dangerouslySetInnerHTML: {
                                    __html: (menuContattaci === null || menuContattaci === void 0 ? void 0 : menuContattaci.description) || ''
                                }
                            })
                        ]
                    })
                })
            }),
            menuContattaci && ((ref3 = menuContattaci.children) === null || ref3 === void 0 ? void 0 : ref3.edges) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    site === settings/* ASSICURAZIONI */.Cu && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ContattaciTemplate_module_default()).menuSectionRef,
                        ref: menuRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ContattaciTemplate_module_default()).menuSection,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ContattaciTemplate_module_default()).menu,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper/* Swiper */.t, {
                                        spaceBetween: 0,
                                        slidesPerView: "auto",
                                        children: menuContattaci.children.edges.map(function(child, index) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "#menu_".concat(child.node.pk),
                                                    className: "".concat((ContattaciTemplate_module_default()).menuItem, " ").concat(menuActive === "".concat(child.node.pk) ? (ContattaciTemplate_module_default())["menuItem--active"] : ''),
                                                    onClick: function(e) {
                                                        e.preventDefault();
                                                        (0,safe/* scrollTo */.X5)(sectionRefs.current[index], toolbarPresente, 100) // Offset: 80 di menu + 20 di margine
                                                        ;
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        dangerouslySetInnerHTML: {
                                                            __html: child.node.name || ''
                                                        }
                                                    })
                                                })
                                            }, child.node.pk);
                                        })
                                    })
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                        variant: "xs",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ContattaciTemplate_module_default()).list,
                            children: menuContattaci.children.edges.filter(function(child) {
                                return child.node.style !== 'allegati';
                            }).map(function(child) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                    id: "menu_".concat(child.node.pk),
                                    className: "".concat((ContattaciTemplate_module_default()).item, " custom-content"),
                                    dangerouslySetInnerHTML: {
                                        __html: child.node.description || ''
                                    },
                                    ref: addSectionRef
                                }, child.node.pk);
                            })
                        })
                    }),
                    menuContattaci.children.edges.filter(function(child) {
                        return child.node.style === 'allegati';
                    }).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ContattaciTemplate_module_default()).allegati,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                            children: menuContattaci.children.edges.filter(function(child) {
                                return child.node.style === 'allegati';
                            }).map(function(child) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                    id: "menu_".concat(child.node.pk),
                                    ref: addSectionRef,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AllegatiBox_AllegatiBox, {
                                        item: child.node
                                    })
                                }, child.node.pk);
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ContattaciTemplate_module_default()).formMobile,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Modal */.u_, {
                    open: mobileModalOpen,
                    setOpen: setMobileModalOpen,
                    closeButton: true,
                    className: (ContattaciTemplate_module_default()).formModal,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (ContattaciTemplate_module_default()).formModalContent,
                        ref: formContattiRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContattaciForm_ContattaciForm, {
                            id: "mobile",
                            formContattiRef: formContattiRef
                        })
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var ContattaciTemplate_ContattaciTemplate = (ContattaciTemplate);

// EXTERNAL MODULE: ../../libs/shared-ui/src/templates/ContattaciThankYouTemplate/ContattaciThankYouTemplate.module.sass
var ContattaciThankYouTemplate_module = __webpack_require__(75218);
var ContattaciThankYouTemplate_module_default = /*#__PURE__*/__webpack_require__.n(ContattaciThankYouTemplate_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/templates/ContattaciThankYouTemplate/ContattaciThankYouTemplate.tsx






var ContattaciThankYouTemplate = function(props) {
    var _pagina = props.pagina, pagina = _pagina === void 0 ? null : _pagina;
    var t = (0,hooks/* useTrans */.IA)();
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(organisms_Page_Page, {
        pagina: pagina,
        item: {},
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((ContattaciThankYouTemplate_module_default()).headBg),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Breadcrumbs */.Oo, {
                        breadcrumbs: pagina === null || pagina === void 0 ? void 0 : pagina.breadcrumbs
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(atoms/* WContainer */.$t, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ContattaciThankYouTemplate_module_default()).title,
                            dangerouslySetInnerHTML: {
                                __html: (pagina === null || pagina === void 0 ? void 0 : pagina.nome) || ''
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ContattaciThankYouTemplate_module_default()).descrizione,
                            dangerouslySetInnerHTML: {
                                __html: (pagina === null || pagina === void 0 ? void 0 : pagina.descrizione) || ''
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((ContattaciThankYouTemplate_module_default()).homeBtnContainer, " bg-grey"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                    label: t("Torna alla home"),
                    href: "/"
                })
            })
        ]
    }));
};
/* harmony default export */ var ContattaciThankYouTemplate_ContattaciThankYouTemplate = (ContattaciThankYouTemplate);

// EXTERNAL MODULE: ../../libs/shared-ui/src/templates/Custom404Template/Custom404Template.module.sass
var Custom404Template_module = __webpack_require__(62385);
var Custom404Template_module_default = /*#__PURE__*/__webpack_require__.n(Custom404Template_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/templates/Custom404Template/Custom404Template.tsx






var Custom404Template = function() {
    var t = (0,hooks/* useTrans */.IA)();
    var pagina = {
        titolo: "page404__titolo",
        descrizione: "page404__descrizione",
        breadcrumbs: [
            {
                titolo: 'Homepage',
                url: '/'
            },
            {
                titolo: '404'
            }
        ]
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(organisms_Page_Page, {
        pagina: pagina,
        item: {},
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((Custom404Template_module_default()).headBg),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Breadcrumbs */.Oo, {
                        breadcrumbs: pagina === null || pagina === void 0 ? void 0 : pagina.breadcrumbs
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(atoms/* WContainer */.$t, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Custom404Template_module_default()).title,
                            dangerouslySetInnerHTML: {
                                __html: t(pagina === null || pagina === void 0 ? void 0 : pagina.titolo) || ''
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Custom404Template_module_default()).descrizione,
                            dangerouslySetInnerHTML: {
                                __html: t(pagina === null || pagina === void 0 ? void 0 : pagina.descrizione) || ''
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((Custom404Template_module_default()).homeBtnContainer, " bg-grey"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                    label: t("Torna alla home"),
                    href: "/"
                })
            })
        ]
    }));
};
/* harmony default export */ var Custom404Template_Custom404Template = (Custom404Template);

// EXTERNAL MODULE: ../../libs/shared-ui/src/templates/FaqDetailTemplate/FaqDetailTemplate.module.sass
var FaqDetailTemplate_module = __webpack_require__(5343);
var FaqDetailTemplate_module_default = /*#__PURE__*/__webpack_require__.n(FaqDetailTemplate_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/templates/FaqDetailTemplate/FaqDetailTemplate.tsx








function FaqDetailTemplate_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function FaqDetailTemplate_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            FaqDetailTemplate_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var FaqDetailTemplate = function(props) {
    var _pagina = props.pagina, pagina = _pagina === void 0 ? undefined : _pagina, _categorieFaq = props.categorieFaq, categorieFaq = _categorieFaq === void 0 ? [] : _categorieFaq, _categoria = props.categoria, categoria = _categoria === void 0 ? null : _categoria, _domanda = props.domanda, domanda = _domanda === void 0 ? null : _domanda, _query = props.query, query = _query === void 0 ? null : _query, _risultati = props.risultati, risultati = _risultati === void 0 ? [] : _risultati;
    var t = (0,hooks/* useTrans */.IA)();
    var ref1 = (0,react.useState)(null), categoriaSelected1 = ref1[0], setCategoriaSelected = ref1[1];
    var handleSelectCategory = function(pk) {
        var ref;
        var categoriaSelected = categorieFaq.find(function(cat) {
            return cat.pk === pk;
        });
        setCategoriaSelected(FaqDetailTemplate_objectSpread({}, categoriaSelected, {
            faq: risultati.filter(function(item) {
                return item.categoriaFaq.pk === pk;
            })
        }));
        (0,gtm/* sendGTMData */.S3)({
            event: "GAevent",
            eventCategory: 'faq_category',
            eventAction: categoriaSelected === null || categoriaSelected === void 0 ? void 0 : (ref = categoriaSelected.titolo) === null || ref === void 0 ? void 0 : ref.toGTMFormat()
        });
    };
    (0,react.useEffect)(function() {
        if (query && categorieFaq.length > 0) {
            setCategoriaSelected(FaqDetailTemplate_objectSpread({}, categorieFaq[0], {
                faq: risultati.filter(function(item) {
                    return item.categoriaFaq.pk === categorieFaq[0].pk;
                })
            }));
        } else setCategoriaSelected(null);
    }, [
        risultati
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(organisms_Page_Page, {
        pagina: pagina,
        item: {},
        contentClassName: (FaqDetailTemplate_module_default()).faqListingContent,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((FaqDetailTemplate_module_default()).headBg, " bg-grey"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(atoms/* WContainer */.$t, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Breadcrumbs */.Oo, {
                                breadcrumbs: pagina === null || pagina === void 0 ? void 0 : pagina.breadcrumbs.slice(0, -1)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* MainTitle */.U3, {
                                label: t("Hai bisogno di <strong>aiuto</strong>?"),
                                variant: "light",
                                className: (FaqDetailTemplate_module_default()).title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                        variant: "xs",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FaqSearchForm_FaqSearchForm, {})
                    })
                ]
            }),
            query && query.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (FaqDetailTemplate_module_default()).listing,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (FaqDetailTemplate_module_default()).layout,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (FaqDetailTemplate_module_default()).sidebar,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FaqSidebarMenu_FaqSidebarMenu, {
                                    items: categorieFaq,
                                    isSearchFaq: true,
                                    handleSelectCategory: handleSelectCategory,
                                    pkCategoriaSelected: categoriaSelected1 === null || categoriaSelected1 === void 0 ? void 0 : categoriaSelected1.pk
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (FaqDetailTemplate_module_default()).main,
                                children: [
                                    !!(categoriaSelected1 === null || categoriaSelected1 === void 0 ? void 0 : categoriaSelected1.titolo) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (FaqDetailTemplate_module_default()).title,
                                        children: categoriaSelected1.titolo
                                    }),
                                    !!(categoriaSelected1 === null || categoriaSelected1 === void 0 ? void 0 : categoriaSelected1.descrizione) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (FaqDetailTemplate_module_default()).description,
                                        dangerouslySetInnerHTML: {
                                            __html: categoriaSelected1.descrizione
                                        }
                                    }),
                                    (categoriaSelected1 === null || categoriaSelected1 === void 0 ? void 0 : categoriaSelected1.faq.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (FaqDetailTemplate_module_default()).listing,
                                        children: categoriaSelected1.faq.map(function(faq) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(atoms/* Accordion */.UQ, {
                                                label: faq.domanda,
                                                content: faq.risposta,
                                                isOpen: faq.slug === domanda,
                                                onClick: function() {
                                                    var ref;
                                                    return (0,gtm/* sendGTMData */.S3)({
                                                        event: "GAevent",
                                                        eventCategory: "faq",
                                                        eventAction: (ref = faq.domanda) === null || ref === void 0 ? void 0 : ref.toGTMFormat(),
                                                        eventLabel: "faq_page"
                                                    });
                                                }
                                            }, faq.pk);
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (FaqDetailTemplate_module_default()).listing,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (FaqDetailTemplate_module_default()).layout,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (FaqDetailTemplate_module_default()).sidebar,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FaqSidebarMenu_FaqSidebarMenu, {
                                    items: categorieFaq,
                                    handleSelectCategory: handleSelectCategory
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (FaqDetailTemplate_module_default()).main,
                                children: [
                                    !!(categoria === null || categoria === void 0 ? void 0 : categoria.titolo) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (FaqDetailTemplate_module_default()).title,
                                        children: categoria.titolo
                                    }),
                                    !!(categoria === null || categoria === void 0 ? void 0 : categoria.descrizione) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (FaqDetailTemplate_module_default()).description,
                                        dangerouslySetInnerHTML: {
                                            __html: categoria.descrizione
                                        }
                                    }),
                                    (categoria === null || categoria === void 0 ? void 0 : categoria.faq.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (FaqDetailTemplate_module_default()).listing,
                                        children: categoria.faq.map(function(faq) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(atoms/* Accordion */.UQ, {
                                                label: faq.domanda,
                                                content: faq.risposta,
                                                isOpen: faq.slug === domanda,
                                                onClick: function() {
                                                    var ref;
                                                    return (0,gtm/* sendGTMData */.S3)({
                                                        event: "GAevent",
                                                        eventCategory: "faq",
                                                        eventAction: (ref = faq.domanda) === null || ref === void 0 ? void 0 : ref.toGTMFormat(),
                                                        eventLabel: "faq_page"
                                                    });
                                                }
                                            }, faq.pk);
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var FaqDetailTemplate_FaqDetailTemplate = (FaqDetailTemplate);

// EXTERNAL MODULE: ../../libs/shared-ui/src/templates/FaqListingTemplate/FaqListingTemplate.module.sass
var FaqListingTemplate_module = __webpack_require__(77502);
var FaqListingTemplate_module_default = /*#__PURE__*/__webpack_require__.n(FaqListingTemplate_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/templates/FaqListingTemplate/FaqListingTemplate.tsx





var FaqListingTemplate = function(props) {
    var _pagina = props.pagina, pagina = _pagina === void 0 ? undefined : _pagina, _categorieFaq = props.categorieFaq, categorieFaq = _categorieFaq === void 0 ? [] : _categorieFaq;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(organisms_Page_Page, {
        pagina: pagina,
        item: {},
        contentClassName: (FaqListingTemplate_module_default()).faqListingContent,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((FaqListingTemplate_module_default()).headBg, " bg-grey"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(atoms/* WContainer */.$t, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Breadcrumbs */.Oo, {
                                breadcrumbs: pagina === null || pagina === void 0 ? void 0 : pagina.breadcrumbs
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* MainTitle */.U3, {
                                label: pagina === null || pagina === void 0 ? void 0 : pagina.nome,
                                variant: "light",
                                className: (FaqListingTemplate_module_default()).title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                        variant: "xs",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FaqSearchForm_FaqSearchForm, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (FaqListingTemplate_module_default()).listing,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FaqCategoriesListing_FaqCategoriesListing, {
                        categorieFaq: categorieFaq
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var FaqListingTemplate_FaqListingTemplate = (FaqListingTemplate);

// EXTERNAL MODULE: ../../libs/shared-ui/src/templates/HomeTemplate/HomeTemplate.module.sass
var HomeTemplate_module = __webpack_require__(43171);
var HomeTemplate_module_default = /*#__PURE__*/__webpack_require__.n(HomeTemplate_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/templates/HomeTemplate/HomeTemplate.tsx











var HomeTemplate = function(props) {
    var ref, ref1, ref2, ref3, ref4;
    var _pagina = props.pagina, pagina = _pagina === void 0 ? null : _pagina, _className = props.className, className = _className === void 0 ? '' : _className;
    var site = (0,hooks/* useSite */.W4)();
    var useArticoliMagazineQuery = site === settings/* ASSICURAZIONI */.Cu ? generated_assicurazioni/* useArticoliMagazineQuery */.kM : generated_vita/* useArticoliMagazineQuery */.kM;
    var t = (0,hooks/* useTrans */.IA)();
    var ref5 = (0,react.useState)(false), preventivatoreModalOpen = ref5[0], setPreventivatoreModalOpen = ref5[1];
    var ref6 = (0,react.useState)(undefined), prodottoPreventivatoreModal = ref6[0], setProdottoPreventivatoreModal = ref6[1];
    var ref7 = (0,react.useState)([]), selectedLineePreventivatore = ref7[0], setSelectedLineePreventivatore = ref7[1];
    (0,react.useEffect)(function() {
        if (prodottoPreventivatoreModal) {
            setPreventivatoreModalOpen(true);
        }
    }, [
        prodottoPreventivatoreModal
    ]);
    (0,react.useEffect)(function() {
        if (!preventivatoreModalOpen) {
            setProdottoPreventivatoreModal(undefined);
        }
    }, [
        preventivatoreModalOpen
    ]);
    var hpMenu = (0,hooks/* useFindMenu */.Pb)("hp");
    var heroSliderMenu = (0,hooks/* useFindMenu */.Pb)("hero", hpMenu);
    var trovaSubitoMenu = (0,hooks/* useFindMenu */.Pb)("trova-subito", hpMenu);
    var assistenzaMenu = (0,hooks/* useFindMenu */.Pb)("assistenza", hpMenu);
    var areaClienteBoxMenu = (0,hooks/* useFindMenu */.Pb)("area-cliente", hpMenu);
    // SOLO ASSICURAZIONI
    var prodottiMenu = site === settings/* VITA */.HX ? null : (0,hooks/* useFindMenu */.Pb)("prodotti", hpMenu);
    // SOLO ASSICURAZIONI
    var appMenu = site === settings/* VITA */.HX ? null : (0,hooks/* useFindMenu */.Pb)("app", hpMenu);
    // SOLO ASSICURAZIONI
    var testimonianzeMenu = site === settings/* VITA */.HX ? null : (0,hooks/* useFindMenu */.Pb)("testimonianze", hpMenu);
    // SOLO VITA
    var vitaRendimentiMenu = site === settings/* VITA */.HX ? (0,hooks/* useFindMenu */.Pb)("rendimenti", hpMenu) : null;
    // SOLO VITA
    var vitaModulisticaMenu = site === settings/* VITA */.HX ? (0,hooks/* useFindMenu */.Pb)("modulistica", hpMenu) : null;
    var newsMenu = (0,hooks/* useFindMenu */.Pb)("news", hpMenu);
    var articoliMagazineQuery = useArticoliMagazineQuery({
        variables: {
            first: 5
        }
    });
    var prodottiPreventivatoreQuery = site === settings/* ASSICURAZIONI */.Cu ? generated_assicurazioni/* useProdottiPreventivatoreQuery */.s_ : generated_vita/* useProdottiPreventivatoreQuery */.s_;
    var ref8 = prodottiPreventivatoreQuery(), prodottiPreventivatoreData = ref8.data;
    var prodottiPreventivatore = prodottiPreventivatoreData === null || prodottiPreventivatoreData === void 0 ? void 0 : prodottiPreventivatoreData.prodottiPreventivatore;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(organisms_Page_Page, {
        pagina: pagina,
        item: {},
        contentClassName: (HomeTemplate_module_default()).homeContent,
        recaptchaRequired: site === settings/* ASSICURAZIONI */.Cu && prodottiPreventivatore ? true : false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bg-grey",
                children: [
                    !!heroSliderMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroSlider_HeroSlider, {
                        item: heroSliderMenu
                    }),
                    site === settings/* ASSICURAZIONI */.Cu && prodottiPreventivatore && (prodottiPreventivatore === null || prodottiPreventivatore === void 0 ? void 0 : (ref = prodottiPreventivatore.edges) === null || ref === void 0 ? void 0 : ref.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (HomeTemplate_module_default()).preventivatore,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                            variant: "sm",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PreventivatoreHomeSection_PreventivatoreHomeSection, {
                                prodotti: prodottiPreventivatore.edges.map(function(item) {
                                    return item === null || item === void 0 ? void 0 : item.node;
                                }),
                                setProdottoPreventivatoreModal: function(prodotto) {
                                    return setProdottoPreventivatoreModal(prodotto);
                                },
                                selectedLineePreventivatore: selectedLineePreventivatore,
                                setSelectedLineePreventivatore: function(linee_ids) {
                                    return setSelectedLineePreventivatore(linee_ids);
                                }
                            })
                        })
                    }),
                    !!trovaSubitoMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (HomeTemplate_module_default()).trovaSubito,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                            variant: "sm",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TrovaSubitoSection_TrovaSubitoSection, {
                                item: trovaSubitoMenu
                            })
                        })
                    })
                ]
            }),
            !!assistenzaMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((HomeTemplate_module_default()).assistenza, " bg-grey-white--30"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                    variant: "lg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AssistenzaSection_AssistenzaSection, {
                        item: assistenzaMenu
                    })
                })
            }),
            !!areaClienteBoxMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((HomeTemplate_module_default()).areaCliente, " ").concat(site === settings/* ASSICURAZIONI */.Cu ? "bg-white-grey" : "bg-grey"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextCtaBox_TextCtaBox, {
                        item: areaClienteBoxMenu,
                        onClick: function() {
                            return (0,gtm/* sendGTMData */.S3)({
                                event: "GAevent",
                                eventCategory: "login",
                                eventAction: "accedi | registrati",
                                eventLabel: "step1"
                            });
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bg-grey",
                children: [
                    !!prodottiMenu && ((ref1 = prodottiMenu.children) === null || ref1 === void 0 ? void 0 : ref1.edges) && prodottiMenu.children.edges.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (HomeTemplate_module_default()).prodotti,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProdottiSection_ProdottiSection, {
                            item: prodottiMenu,
                            prodotti: prodottiMenu && ((ref2 = prodottiMenu.children) === null || ref2 === void 0 ? void 0 : ref2.edges.length) ? (ref3 = prodottiMenu.children) === null || ref3 === void 0 ? void 0 : ref3.edges.map(function(child) {
                                return child.node.prodottoCollegato;
                            }) : [],
                            prev: {
                                event: "GAevent",
                                eventCategory: 'box_info',
                                eventAction: 'esplora',
                                eventLabel: 'pre'
                            },
                            next: {
                                event: "GAevent",
                                eventCategory: 'box_info',
                                eventAction: 'esplora',
                                eventLabel: 'next'
                            },
                            whatIs: "prodottiMenu"
                        })
                    }),
                    !!appMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (HomeTemplate_module_default()).app,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                            variant: "lg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBox_AppBox, {
                                item: appMenu
                            })
                        })
                    }),
                    !!testimonianzeMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (HomeTemplate_module_default()).testimonianze,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonianzeSection_TestimonianzeSection, {
                            item: testimonianzeMenu
                        })
                    }),
                    !!vitaRendimentiMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (HomeTemplate_module_default()).rendimenti,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageTextBox_ImageTextBox, {
                                item: vitaRendimentiMenu
                            })
                        })
                    })
                ]
            }),
            !!vitaModulisticaMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-grey-white--70",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (HomeTemplate_module_default()).modulistica,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageTextBox_ImageTextBox, {
                            item: vitaModulisticaMenu,
                            textPos: "left"
                        })
                    })
                })
            }),
            !!newsMenu && !!(articoliMagazineQuery === null || articoliMagazineQuery === void 0 ? void 0 : (ref4 = articoliMagazineQuery.data) === null || ref4 === void 0 ? void 0 : ref4.articoliMagazine) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((HomeTemplate_module_default()).news, " bg-white"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsSection_NewsSection, {
                    news: articoliMagazineQuery.data.articoliMagazine.edges,
                    intro: newsMenu.name,
                    title: newsMenu.description,
                    ctaLabel: newsMenu.ctaLabel,
                    url: newsMenu.url
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PreventivatoreModal_PreventivatoreModal, {
                title: t("Consulta il nostro <strong>preventivatore</strong>"),
                prodotto: prodottoPreventivatoreModal,
                open: preventivatoreModalOpen,
                setOpen: setPreventivatoreModalOpen,
                selectedLinee: selectedLineePreventivatore
            })
        ]
    }));
};
/* harmony default export */ var HomeTemplate_HomeTemplate = (HomeTemplate);

;// CONCATENATED MODULE: ../../libs/shared-ui/src/templates/LayoutEmpty/LayoutEmpty.js


// import "react-pagebuilder/styles/sass/base/base.sass"
var LayoutEmpty = function(props) {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: props.children
    }));
};
/* harmony default export */ var LayoutEmpty_LayoutEmpty = (LayoutEmpty);

// EXTERNAL MODULE: ../../libs/shared-ui/src/templates/MagazineTemplate/MagazineTemplate.module.sass
var MagazineTemplate_module = __webpack_require__(81792);
var MagazineTemplate_module_default = /*#__PURE__*/__webpack_require__.n(MagazineTemplate_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/templates/MagazineTemplate/MagazineTemplate.tsx









var MagazineTemplate = function(param) {
    var _pagina = param.pagina, pagina = _pagina === void 0 ? null : _pagina, _className = param.className, className = _className === void 0 ? '' : _className;
    var site = (0,hooks/* useSite */.W4)();
    var useArticoliMagazineQuery = site === settings/* ASSICURAZIONI */.Cu ? generated_assicurazioni/* useArticoliMagazineQuery */.kM : generated_vita/* useArticoliMagazineQuery */.kM;
    var data = useArticoliMagazineQuery({
        variables: {
            first: 1
        }
    }).data;
    // FAKE
    /* const primoPiano = {
    publicationDate: '01/07/2021',
    title: 'Ottieni fino a 50 euro di cashback con la nuova polizza Protezione Casa Più',
    abstract: '<p>Se deciderai di sottoscrivere la nuova polizza Protezione Casa Più tra il 1 e il 31 Luglio, \
    includendo almeno una delle garanzie a scelta tra:</p><ul>\
    <li>Eventi catastrofali</li>\
    <li>Furto...</li>\
    </ul>',
    url: '#'
  } */ var ref2 = (0,react.useState)(), primoPiano = ref2[0], setPrimoPiano = ref2[1];
    (0,react.useEffect)(function() {
        var ref;
        if (data === null || data === void 0 ? void 0 : (ref = data.articoliMagazine) === null || ref === void 0 ? void 0 : ref.edges) {
            if (data.articoliMagazine.edges.length > 0) {
                var ref1;
                setPrimoPiano((ref1 = data.articoliMagazine.edges[0]) === null || ref1 === void 0 ? void 0 : ref1.node);
            }
        }
    }, [
        data
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(organisms_Page_Page, {
        pagina: pagina,
        item: {},
        contentClassName: (MagazineTemplate_module_default()).magazineContent,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-grey",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(atoms/* WContainer */.$t, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Breadcrumbs */.Oo, {
                            breadcrumbs: pagina === null || pagina === void 0 ? void 0 : pagina.breadcrumbs
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* MainTitle */.U3, {
                            label: pagina === null || pagina === void 0 ? void 0 : pagina.nome,
                            variant: "light",
                            className: (MagazineTemplate_module_default()).title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticoloPrimoPiano_ArticoloPrimoPiano, {
                            title: "In <strong>primo piano</strong>",
                            articolo: primoPiano
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MagazineListing_MagazineListing, {})
                })
            })
        ]
    }));
};
/* harmony default export */ var MagazineTemplate_MagazineTemplate = (MagazineTemplate);

// EXTERNAL MODULE: ../../libs/shared-ui/src/templates/PortaleValorizzazioniTemplate/PortaleValorizzazioniTemplate.module.sass
var PortaleValorizzazioniTemplate_module = __webpack_require__(48260);
var PortaleValorizzazioniTemplate_module_default = /*#__PURE__*/__webpack_require__.n(PortaleValorizzazioniTemplate_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/templates/PortaleValorizzazioniTemplate/PortaleValorizzazioniTemplate.tsx





var PortaleValorizzazioniTemplate = function(props) {
    var _pagina = props.pagina, pagina = _pagina === void 0 ? null : _pagina, _slugCategoria = props.slugCategoria, slugCategoria = _slugCategoria === void 0 ? null : _slugCategoria;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(organisms_Page_Page, {
        pagina: pagina,
        item: {},
        contentClassName: (PortaleValorizzazioniTemplate_module_default()).portaleValorizzazioniContent,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((PortaleValorizzazioniTemplate_module_default()).headBg, " bg-grey"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(atoms/* WContainer */.$t, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Breadcrumbs */.Oo, {
                            breadcrumbs: pagina === null || pagina === void 0 ? void 0 : pagina.breadcrumbs
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* MainTitle */.U3, {
                            label: pagina === null || pagina === void 0 ? void 0 : pagina.nome,
                            variant: "light",
                            className: (PortaleValorizzazioniTemplate_module_default()).title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* MainDescription */.WC, {
                            html: pagina === null || pagina === void 0 ? void 0 : pagina.descrizione
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ValorizzazioniListing_ValorizzazioniListing, {
                        slugCategoria: slugCategoria
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var PortaleValorizzazioniTemplate_PortaleValorizzazioniTemplate = (PortaleValorizzazioniTemplate);

// EXTERNAL MODULE: ../../libs/shared-ui/src/templates/PreventivatoreThankYouTemplate/PreventivatoreThankYouTemplate.module.sass
var PreventivatoreThankYouTemplate_module = __webpack_require__(24636);
var PreventivatoreThankYouTemplate_module_default = /*#__PURE__*/__webpack_require__.n(PreventivatoreThankYouTemplate_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/templates/PreventivatoreThankYouTemplate/PreventivatoreThankYouTemplate.tsx






var PreventivatoreThankYouTemplate = function(props) {
    var _pagina = props.pagina, pagina = _pagina === void 0 ? null : _pagina, _prodotto = props.prodotto, prodotto = _prodotto === void 0 ? null : _prodotto;
    var t = (0,hooks/* useTrans */.IA)();
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(organisms_Page_Page, {
        pagina: pagina,
        item: {},
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((PreventivatoreThankYouTemplate_module_default()).headBg),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Breadcrumbs */.Oo, {
                        breadcrumbs: pagina === null || pagina === void 0 ? void 0 : pagina.breadcrumbs
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(atoms/* WContainer */.$t, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (PreventivatoreThankYouTemplate_module_default()).title,
                            dangerouslySetInnerHTML: {
                                __html: (pagina === null || pagina === void 0 ? void 0 : pagina.nome) || ''
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (PreventivatoreThankYouTemplate_module_default()).descrizione,
                            dangerouslySetInnerHTML: {
                                __html: (pagina === null || pagina === void 0 ? void 0 : pagina.descrizione) || ''
                            }
                        })
                    ]
                })
            }),
            !!prodotto.prodottiCorrelati && prodotto.prodottiCorrelati.edges.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((PreventivatoreThankYouTemplate_module_default()).correlati, " bg-grey"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProdottiSection_ProdottiSection, {
                        item: {
                            description: t('Scopri gli altri <strong>nostri prodotti</strong>')
                        },
                        prodotti: prodotto.prodottiCorrelati && prodotto.prodottiCorrelati.edges.length ? prodotto.prodottiCorrelati.edges.map(function(p) {
                            return p.node;
                        }) : []
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((PreventivatoreThankYouTemplate_module_default()).homeBtnContainer, " bg-grey"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Button */.zx, {
                    label: t("Torna alla home"),
                    href: "/"
                })
            })
        ]
    }));
};
/* harmony default export */ var PreventivatoreThankYouTemplate_PreventivatoreThankYouTemplate = (PreventivatoreThankYouTemplate);

// EXTERNAL MODULE: ../../libs/shared-ui/src/templates/ProdottoTemplate/ProdottoTemplate.module.sass
var ProdottoTemplate_module = __webpack_require__(83966);
var ProdottoTemplate_module_default = /*#__PURE__*/__webpack_require__.n(ProdottoTemplate_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/templates/ProdottoTemplate/ProdottoTemplate.tsx














var ProdottoTemplate = function(props) {
    var ref13, ref1, ref2, ref3, ref4, ref5;
    var prodotto = props.prodotto, _pagina = props.pagina, pagina = _pagina === void 0 ? undefined : _pagina;
    var t = (0,hooks/* useTrans */.IA)();
    var utente = (0,hooks/* useUtente */.yl)().utente;
    var toolbarPresente = utente && (utente.isStaff || utente.isImpersonate);
    var menuRef = (0,react.useRef)(null);
    var sectionRefs = (0,react.useRef)([]);
    var ref6 = (0,react.useState)('descrizione'), menuActive = ref6[0], setMenuActive = ref6[1];
    var ref7 = (0,react.useState)(false), appModalOpen = ref7[0], setAppModalOpen = ref7[1];
    var ref8 = (0,react.useState)(undefined), appModal = ref8[0], setAppModal = ref8[1];
    var ref9 = (0,react.useState)(false), preventivatoreModalOpen = ref9[0], setPreventivatoreModalOpen = ref9[1];
    var ref10 = (0,react.useState)([]), selectedLineePreventivatore = ref10[0], setSelectedLineePreventivatore = ref10[1];
    var addSectionRef = function(ref) {
        if (ref) {
            if (sectionRefs.current.filter(function(x) {
                return x.id === ref.id;
            }).length > 0) sectionRefs.current = sectionRefs.current.map(function(x) {
                return x.id === ref.id ? ref : x;
            });
            else sectionRefs.current.push(ref);
        }
    };
    var site = (0,hooks/* useSite */.W4)();
    var prodottoSharedMenu = (0,hooks/* useFindMenu */.Pb)("prodotto");
    var topBoxesProdottoMenu = (0,hooks/* useFindMenu */.Pb)("top-boxes", prodotto.menuItems);
    var topBoxesSharedMenu = (0,hooks/* useFindMenu */.Pb)("top-boxes", prodottoSharedMenu);
    var topBoxesMenu = topBoxesProdottoMenu || topBoxesSharedMenu;
    var descrizioneBoxesMenu = (0,hooks/* useFindMenu */.Pb)("card_descrizione", prodotto.menuItems);
    var offertaMenu = (0,hooks/* useFindMenu */.Pb)("offerta", prodotto.menuItems);
    var motiviMenu = (0,hooks/* useFindMenu */.Pb)("motivi", prodotto.menuItems);
    var vantaggiMenu = (0,hooks/* useFindMenu */.Pb)("vantaggi", prodotto.menuItems);
    var lineeMenu = (0,hooks/* useFindMenu */.Pb)("linee", prodotto.menuItems);
    var faqProdottoMenu = (0,hooks/* useFindMenu */.Pb)("faq", prodotto.menuItems);
    var faqSharedMenu = (0,hooks/* useFindMenu */.Pb)("faq", prodottoSharedMenu);
    var faqMenu = faqProdottoMenu || faqSharedMenu;
    var areaClientiProdottoMenu = (0,hooks/* useFindMenu */.Pb)("area_clienti", prodotto.menuItems);
    var areaClientiSharedMenu = (0,hooks/* useFindMenu */.Pb)("area_clienti", prodottoSharedMenu);
    var areaClientiMenu = areaClientiProdottoMenu || areaClientiSharedMenu;
    var fondiMenu = site === settings/* VITA */.HX ? (0,hooks/* useFindMenu */.Pb)("fondi", prodotto.menuItems) : null;
    var allegatiMenu = (0,hooks/* useFindMenu */.Pb)("allegati", prodotto.menuItems);
    var appProdottoMenu = (0,hooks/* useFindMenu */.Pb)("app", prodotto.menuItems);
    var appSharedMenu = (0,hooks/* useFindMenu */.Pb)("app", prodottoSharedMenu);
    var appMenu = appProdottoMenu || appSharedMenu;
    var disclaimerMenu = (0,hooks/* useFindMenu */.Pb)("disclaimer", prodotto.menuItems);
    var ref11 = (0,react.useState)(), menuSwiper = ref11[0], setMenuSwiper = ref11[1];
    var ref12 = (0,react.useState)(false), scrolling = ref12[0], setScrolling = ref12[1];
    var menuItems = [].concat(descrizioneBoxesMenu ? [
        {
            pk: 'descrizione',
            name: 'Descrizione'
        }
    ] : []).concat(offertaMenu ? [
        {
            pk: 'offerta',
            name: 'Che cosa offre'
        }
    ] : []).concat(vantaggiMenu ? [
        {
            pk: 'vantaggi',
            name: 'I Vantaggi'
        }
    ] : []).concat(lineeMenu && ((ref13 = prodotto.linee) === null || ref13 === void 0 ? void 0 : ref13.length) > 0 ? [
        {
            pk: 'linee',
            name: 'Linee'
        }
    ] : [])//.concat([{ pk: 'garanzie', name: 'Garanzie' }])
    //.concat([{ pk: 'condizioni', name: 'Condizioni' }])
    .concat(faqMenu && ((ref1 = prodotto.faqs) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 ? [
        {
            pk: 'faqs',
            name: 'Domande e Risposte'
        }
    ] : []).concat(fondiMenu ? [
        {
            pk: 'fondi',
            name: 'Andamento fondi'
        }
    ] : []).concat(allegatiMenu ? [
        {
            pk: 'allegati',
            name: 'Allegati'
        }
    ] : []).concat(appMenu ? [
        {
            pk: 'app',
            name: 'App'
        }
    ] : []);
    var handleScroll = function() {
        var ref;
        if (menuRef.current) {
            if (window.scrollY >= menuRef.current.offsetTop - (toolbarPresente ? 80 : 0) - 80) document.body.classList.add('prodotto-menu-sticky');
            else document.body.classList.remove('prodotto-menu-sticky');
        }
        // Calcolo se sono all'altezza di un box del menu
        var scrollOffset = window.scrollY + (toolbarPresente ? 80 : 0) + 80 + 80 + 10 // + header + menu + correzzione
        ;
        var match = sectionRefs.current.filter(function(x) {
            return scrollOffset >= x.offsetTop && scrollOffset <= x.offsetTop + x.clientHeight;
        });
        // Potrebbero esserci box sovrapposti (es. linee che va sopra a vantaggi), prendo l'ultimo match
        setMenuActive(match.length > 0 ? (ref = match[match.length - 1].id) === null || ref === void 0 ? void 0 : ref.replace('menu_', '') : null);
    };
    (0,react.useEffect)(function() {
        if (menuActive && !scrolling) {
            var index = menuItems.findIndex(function(item) {
                return item.pk === menuActive;
            });
            if (index !== -1) menuSwiper === null || menuSwiper === void 0 ? void 0 : menuSwiper.slideTo(index);
        }
    }, [
        menuActive
    ]);
    (0,react.useEffect)(function() {
        window.addEventListener('scroll', handleScroll, {
            passive: true
        });
        return function() {
            return window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return prodotto ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(organisms_Page_Page, {
        pagina: pagina,
        item: prodotto,
        contentClassName: (ProdottoTemplate_module_default()).prodottoContent,
        recaptchaRequired: prodotto.preventivatore,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                children: (pagina === null || pagina === void 0 ? void 0 : pagina.breadcrumbs) && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Breadcrumbs */.Oo, {
                    breadcrumbs: pagina.breadcrumbs,
                    className: (ProdottoTemplate_module_default()).prodottoBreadcrumbs
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProdottoHead_ProdottoHead, {
                prodotto: prodotto,
                selectedLineePreventivatore: selectedLineePreventivatore,
                setSelectedLineePreventivatore: setSelectedLineePreventivatore,
                setPreventivatoreModalOpen: setPreventivatoreModalOpen,
                className: (ProdottoTemplate_module_default()).head
            }),
            topBoxesMenu && ((ref2 = topBoxesMenu.children) === null || ref2 === void 0 ? void 0 : ref2.edges.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                variant: "sm",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ProdottoTemplate_module_default()).topBoxes,
                    children: topBoxesMenu.children.edges.map(function(child) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(OutlineTextCtaBox_OutlineTextCtaBox, {
                            item: child.node,
                            onClick: function() {
                                var ref, ref14;
                                return (0,gtm/* sendGTMData */.S3)({
                                    event: "GAevent",
                                    eventCategory: 'cta',
                                    eventAction: (ref = child.node) === null || ref === void 0 ? void 0 : (ref14 = ref.ctaLabel) === null || ref14 === void 0 ? void 0 : ref14.toGTMFormat()
                                });
                            }
                        }, child.node.pk);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ProdottoTemplate_module_default()).menuSectionRef,
                ref: menuRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (ProdottoTemplate_module_default()).menuSection,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ProdottoTemplate_module_default()).menu,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper/* Swiper */.t, {
                                slidesPerView: "auto",
                                onSwiper: function(swiper) {
                                    return setMenuSwiper(swiper);
                                },
                                children: menuItems.map(function(child, index) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "#menu_".concat(child.pk),
                                            className: "".concat((ProdottoTemplate_module_default()).menuItem, " ").concat(menuActive === child.pk ? (ProdottoTemplate_module_default())["menuItem--active"] : ''),
                                            onClick: function(e) {
                                                var ref;
                                                e.preventDefault();
                                                setScrolling(true);
                                                (0,safe/* scrollTo */.X5)(sectionRefs.current[index], toolbarPresente, 80) // Offset: 80 di menu
                                                ;
                                                setTimeout(function() {
                                                    return setScrolling(false);
                                                }, 1000);
                                                (0,gtm/* sendGTMData */.S3)({
                                                    event: "GAevent",
                                                    eventCategory: "sotto_menu",
                                                    eventAction: ((ref = child.name) === null || ref === void 0 ? void 0 : ref.toGTMFormat()) || ''
                                                });
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                dangerouslySetInnerHTML: {
                                                    __html: child.name || ''
                                                }
                                            })
                                        }, child.pk)
                                    }, child.pk);
                                })
                            })
                        })
                    })
                })
            }),
            descrizioneBoxesMenu && ((ref3 = descrizioneBoxesMenu.children) === null || ref3 === void 0 ? void 0 : ref3.edges.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "menu_descrizione",
                ref: addSectionRef,
                className: (ProdottoTemplate_module_default()).descrizione,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                    variant: "sm",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ProdottoTemplate_module_default()).descrizioneBoxes,
                        children: [
                            descrizioneBoxesMenu.name && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                dangerouslySetInnerHTML: {
                                    __html: descrizioneBoxesMenu.name
                                },
                                className: (ProdottoTemplate_module_default()).descrizioneTitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ProdottoTemplate_module_default()).descrizioneBoxesLayout,
                                children: descrizioneBoxesMenu.children.edges.map(function(item) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(FilledTextBox_FilledTextBox, {
                                        item: item.node
                                    }, item.node.pk);
                                })
                            })
                        ]
                    })
                })
            }),
            offertaMenu && ((ref4 = offertaMenu.children) === null || ref4 === void 0 ? void 0 : ref4.edges.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "menu_offerta",
                ref: addSectionRef,
                className: "bg-grey",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ProdottoTemplate_module_default()).offerta,
                        children: [
                            offertaMenu.name && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                dangerouslySetInnerHTML: {
                                    __html: offertaMenu.name
                                },
                                className: (ProdottoTemplate_module_default()).offertaTitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ProdottoTemplate_module_default()).offertaLayout,
                                children: offertaMenu.children.edges.map(function(item) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                        className: (ProdottoTemplate_module_default()).offertaItem,
                                        children: [
                                            getIcon(item.node.style) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (ProdottoTemplate_module_default()).offertaItemIcon,
                                                children: getIcon(item.node.style)
                                            }),
                                            item.node.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (ProdottoTemplate_module_default()).offertaItemContent,
                                                dangerouslySetInnerHTML: {
                                                    __html: item.node.description
                                                }
                                            })
                                        ]
                                    }, item.node.pk);
                                })
                            })
                        ]
                    })
                })
            }),
            motiviMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "menu_motivi",
                className: "bg-grey-white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MotiviSection_MotiviSection, {
                    item: motiviMenu
                })
            }),
            vantaggiMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "menu_vantaggi",
                ref: addSectionRef,
                className: (ProdottoTemplate_module_default()).vantaggi,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentBox_ContentBox, {
                    item: vantaggiMenu
                })
            }),
            !!prodotto.linee && !!lineeMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "menu_linee",
                ref: addSectionRef,
                className: "".concat((ProdottoTemplate_module_default()).linee, " bg-grey"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LineeSection_LineeSection, {
                    title: lineeMenu.name,
                    linee: prodotto.linee,
                    note: lineeMenu.description
                })
            }),
            !!prodotto.faqs && !!faqMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "menu_faqs",
                ref: addSectionRef,
                className: (ProdottoTemplate_module_default()).faqs,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FaqSection_FaqSection, {
                        faqMenu: faqMenu,
                        faqs: prodotto.faqs
                    })
                })
            }),
            !!areaClientiMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ProdottoTemplate_module_default()).areaClienti,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextCtaBox_TextCtaBox, {
                        item: areaClientiMenu
                    })
                })
            }),
            fondiMenu && ((ref5 = fondiMenu.children) === null || ref5 === void 0 ? void 0 : ref5.edges.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "menu_fondi",
                ref: addSectionRef,
                className: (ProdottoTemplate_module_default()).fondi,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(atoms/* WContainer */.$t, {
                    children: [
                        fondiMenu.name && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (ProdottoTemplate_module_default()).fondiTitle,
                            dangerouslySetInnerHTML: {
                                __html: fondiMenu.name
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (ProdottoTemplate_module_default()).fondiList,
                            children: fondiMenu.children.edges.map(function(child1) {
                                var ref16;
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(OutlineTextCtaBox_OutlineTextCtaBox, {
                                    item: child1.node,
                                    onClick: function() {
                                        var ref, ref15;
                                        return (0,gtm/* sendGTMData */.S3)({
                                            event: "GAevent",
                                            eventCategory: 'andamento_fondi',
                                            eventAction: 'scopri_andamento_dei_tuoi_fondi',
                                            eventLabel: (ref = child1.node) === null || ref === void 0 ? void 0 : (ref15 = ref.url) === null || ref15 === void 0 ? void 0 : ref15.toGTMFormat()
                                        });
                                    },
                                    onChildrenClick: (ref16 = child1.node.children) === null || ref16 === void 0 ? void 0 : ref16.edges.map(function(child) {
                                        return {
                                            pk: child.node.pk,
                                            onClick: function() {
                                                var ref, ref17;
                                                return (0,gtm/* sendGTMData */.S3)({
                                                    event: "GAevent",
                                                    eventCategory: 'andamento_fondi',
                                                    eventAction: 'scopri_andamento_dei_tuoi_fondi',
                                                    eventLabel: (ref = child.node) === null || ref === void 0 ? void 0 : (ref17 = ref.url) === null || ref17 === void 0 ? void 0 : ref17.toGTMFormat()
                                                });
                                            }
                                        };
                                    })
                                }, child1.node.pk);
                            })
                        })
                    ]
                })
            }),
            !!allegatiMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "menu_allegati",
                ref: addSectionRef,
                className: (ProdottoTemplate_module_default()).allegati,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AllegatiBox_AllegatiBox, {
                        item: allegatiMenu
                    })
                })
            }),
            !!appMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "menu_app",
                ref: addSectionRef,
                className: "".concat((ProdottoTemplate_module_default()).app, " bg-white-grey"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                    variant: "lg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBox_AppBox, {
                        item: appMenu,
                        controlled: true,
                        defaultAppModal: appModal,
                        setDefaultAppModal: setAppModal,
                        defaultOpenAppModal: appModalOpen,
                        setDefaultOpenAppModal: setAppModalOpen
                    })
                })
            }),
            !!prodotto.prodottiCorrelati && prodotto.prodottiCorrelati.edges.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((ProdottoTemplate_module_default()).correlati, " bg-grey"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProdottiSection_ProdottiSection, {
                        item: {
                            description: t('Prodotti <strong>correlati</strong>')
                        },
                        prodotti: prodotto.prodottiCorrelati && prodotto.prodottiCorrelati.edges.length ? prodotto.prodottiCorrelati.edges.map(function(p) {
                            return p.node;
                        }) : [],
                        whatIs: "prodottiCorrelati"
                    })
                })
            }),
            !!disclaimerMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ProdottoTemplate_module_default()).disclaimer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                    variant: "sm",
                    children: disclaimerMenu.description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((ProdottoTemplate_module_default()).disclaimerContent, " custom-content"),
                        dangerouslySetInnerHTML: {
                            __html: disclaimerMenu.description
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PreventivatoreModal_PreventivatoreModal, {
                title: t("Consulta il nostro <strong>preventivatore</strong>"),
                prodotto: prodotto,
                open: preventivatoreModalOpen,
                setOpen: setPreventivatoreModalOpen,
                selectedLinee: selectedLineePreventivatore
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppModal_AppModal, {
                app: appModal,
                open: appModalOpen,
                setOpen: setAppModalOpen
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var ProdottoTemplate_ProdottoTemplate = (ProdottoTemplate);

// EXTERNAL MODULE: ../../libs/shared-ui/src/templates/ReclamiTemplate/ReclamiTemplate.module.sass
var ReclamiTemplate_module = __webpack_require__(81605);
var ReclamiTemplate_module_default = /*#__PURE__*/__webpack_require__.n(ReclamiTemplate_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/templates/ReclamiTemplate/ReclamiTemplate.tsx









var ReclamiTemplate = function(props) {
    var _pagina = props.pagina, pagina = _pagina === void 0 ? null : _pagina;
    var isMobile = (0,hooks/* useIsMobile */.dD)();
    var menuReclami = (0,hooks/* useFindMenu */.Pb)("reclami");
    var menuAllegati = (0,hooks/* useFindMenu */.Pb)("allegati", menuReclami);
    var menuHelp = (0,hooks/* useFindMenu */.Pb)("help", menuReclami);
    var menuBottom = (0,hooks/* useFindMenu */.Pb)("bottom", menuReclami);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(organisms_Page_Page, {
        pagina: pagina,
        item: {},
        contentClassName: (ReclamiTemplate_module_default()).reclamiContent,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((ReclamiTemplate_module_default()).headBg, " bg-grey"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(atoms/* WContainer */.$t, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Breadcrumbs */.Oo, {
                            breadcrumbs: pagina === null || pagina === void 0 ? void 0 : pagina.breadcrumbs
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (ReclamiTemplate_module_default()).headLayout,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (ReclamiTemplate_module_default()).headContent,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* MainTitle */.U3, {
                                            label: pagina === null || pagina === void 0 ? void 0 : pagina.nome,
                                            variant: "light",
                                            className: (ReclamiTemplate_module_default()).title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* MainDescription */.WC, {
                                            html: pagina === null || pagina === void 0 ? void 0 : pagina.descrizione,
                                            className: (ReclamiTemplate_module_default()).description
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (ReclamiTemplate_module_default()).headImage,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WImage */.Tg, {
                                        src: isMobile ? pagina === null || pagina === void 0 ? void 0 : pagina.previewImage : pagina === null || pagina === void 0 ? void 0 : pagina.mainImage,
                                        maxWidth: 536,
                                        maxHeight: 350,
                                        layout: "intrinsic",
                                        objectFit: "cover",
                                        priority: true,
                                        loading: "eager"
                                    }, "reclami-main-image".concat(isMobile ? '-mobile' : ''))
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (ReclamiTemplate_module_default()).layout,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ReclamiTemplate_module_default()).main,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* PlaceholderReact */.b, {
                                    pkey: "content",
                                    contentTypeId: pagina.contentTypeId,
                                    objectId: pagina.pk
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (ReclamiTemplate_module_default()).bottom,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageTextBox_ImageTextBox, {
                                    item: menuBottom
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (ReclamiTemplate_module_default()).sidebar,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AllegatiBox_AllegatiBox, {
                                        item: menuAllegati,
                                        sidebar: true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OutlineTextCtaBox_OutlineTextCtaBox, {
                                        item: menuHelp,
                                        onClick: function() {
                                            var ref;
                                            return (0,gtm/* sendGTMData */.S3)({
                                                event: "GAevent",
                                                eventCategory: 'contattaci',
                                                eventAction: 'click',
                                                eventLabel: (menuHelp === null || menuHelp === void 0 ? void 0 : (ref = menuHelp.url) === null || ref === void 0 ? void 0 : ref.toGTMFormat()) || ''
                                            });
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var ReclamiTemplate_ReclamiTemplate = (ReclamiTemplate);

// EXTERNAL MODULE: ../../libs/shared-ui/src/templates/SearchResultsTemplate/SearchResultsTemplate.module.sass
var SearchResultsTemplate_module = __webpack_require__(88364);
var SearchResultsTemplate_module_default = /*#__PURE__*/__webpack_require__.n(SearchResultsTemplate_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/templates/SearchResultsTemplate/SearchResultsTemplate.tsx










function SearchResultsTemplate_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SearchResultsTemplate_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SearchResultsTemplate_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var SearchResultsTemplate = function(props) {
    var _risultati = props.risultati, risultati = _risultati === void 0 ? [] : _risultati, _pagina = props.pagina, pagina = _pagina === void 0 ? null : _pagina, _query = props.query, query = _query === void 0 ? '' : _query, _totalCount = props.totalCount, totalCount = _totalCount === void 0 ? 0 : _totalCount;
    var t = (0,hooks/* useTrans */.IA)();
    var ref5 = (0,react.useState)(null), selectedType = ref5[0], setSelectedType = ref5[1];
    var ref1 = (0,react.useState)(0), countSelectedType = ref1[0], setCountSelectedType = ref1[1];
    var ref2 // risultati visualizzati nella pagina correntemente visualizzata (sezione altri)
     = (0,react.useState)([]), results = ref2[0], setResults = ref2[1];
    var ref3 = (0,react.useState)([]), prodottiTop = ref3[0], setProdottiTop = ref3[1];
    var ref4 = (0,react.useState)(1), selectedPage = ref4[0], setSelectedPage = ref4[1];
    var resultTypes = risultati.reduce(function(res, item) {
        var key = item.pk.toString();
        return SearchResultsTemplate_objectSpread({}, res, SearchResultsTemplate_defineProperty({}, key, {
            name: item.name,
            num: item.items.length
        }));
    }, {});
    var handleChangePage = function(value) {
        setSelectedPage(value);
    };
    var handleSelectType = function(pk) {
        setSelectedType(pk);
        setSelectedPage(1);
    };
    (0,react.useEffect)(function() {
        var filteredResults = risultati.find(function(categoria) {
            return categoria.pk.toString() === selectedType;
        });
        if (filteredResults && (filteredResults === null || filteredResults === void 0 ? void 0 : filteredResults.items.length)) {
            var ref;
            if ((filteredResults === null || filteredResults === void 0 ? void 0 : filteredResults.name) === "Prodotti" && selectedPage === 1) {
                setResults(filteredResults.items.slice(4, settings/* SEARCH_LISTING_ITEMS_PER_PAGE */.sW));
                setProdottiTop(filteredResults.items.slice(0, 4));
            } else {
                setResults(filteredResults.items.slice(settings/* SEARCH_LISTING_ITEMS_PER_PAGE */.sW * (selectedPage - 1), settings/* SEARCH_LISTING_ITEMS_PER_PAGE */.sW * selectedPage));
                setProdottiTop([]);
            }
            setCountSelectedType((ref = filteredResults.items) === null || ref === void 0 ? void 0 : ref.length);
        }
    }, [
        selectedType,
        selectedPage
    ]);
    (0,react.useEffect)(function() {
        var ref;
        setSelectedType((ref = risultati[0]) === null || ref === void 0 ? void 0 : ref.pk.toString());
    }, []);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(organisms_Page_Page, {
        pagina: pagina,
        item: {},
        contentClassName: (SearchResultsTemplate_module_default()).searchResultsContent,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-grey",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(atoms/* WContainer */.$t, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Breadcrumbs */.Oo, {
                            breadcrumbs: pagina.breadcrumbs
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                            className: (SearchResultsTemplate_module_default()).mainTitle,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: totalCount.toString()
                                }),
                                " ",
                                totalCount === 1 ? t("Risultato per:") : t("Risultati per:"),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: query
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (SearchResultsTemplate_module_default()).filters,
                            children: Object.keys(resultTypes).map(function(pk) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(atoms/* Chip */.Af, {
                                    label: "".concat(resultTypes[pk].name, " (").concat(resultTypes[pk].num, ")"),
                                    active: selectedType === pk,
                                    onClick: function() {
                                        return handleSelectType(pk);
                                    }
                                }, pk);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(atoms/* WContainer */.$t, {
                children: [
                    prodottiTop.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (SearchResultsTemplate_module_default()).primoPiano,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (SearchResultsTemplate_module_default()).primoPianoTitle,
                                dangerouslySetInnerHTML: {
                                    __html: t("Prodotti in <strong>primo piano</strong>")
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (SearchResultsTemplate_module_default()).primoPianoList,
                                children: prodottiTop.map(function(prodotto) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(ProdottoCard_ProdottoCard, {
                                        prodotto: prodotto,
                                        variant: "horizontal"
                                    }, prodotto.pk);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (SearchResultsTemplate_module_default()).primoPianoSlider,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper/* Swiper */.t, {
                                    pagination: {
                                        clickable: true
                                    },
                                    slidesPerView: 1.2,
                                    spaceBetween: 16,
                                    centeredSlides: true,
                                    className: "swiper-container--pagination",
                                    children: prodottiTop.map(function(prodotto) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProdottoCard_ProdottoCard, {
                                                prodotto: prodotto,
                                                className: (SearchResultsTemplate_module_default()).primoPianoSlideCard
                                            })
                                        }, prodotto.pk);
                                    })
                                })
                            })
                        ]
                    }),
                    results.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (SearchResultsTemplate_module_default()).results,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (SearchResultsTemplate_module_default()).resultsTitle,
                                dangerouslySetInnerHTML: {
                                    __html: prodottiTop.length > 0 ? t("Altri <strong>risultati</strong> ({0})", [
                                        countSelectedType ? (countSelectedType - 4).toString() : "0", 
                                    ]) : t("<strong>Risultati</strong> ({0})", [
                                        countSelectedType ? countSelectedType.toString() : "0", 
                                    ])
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (SearchResultsTemplate_module_default()).resultsList,
                                children: results.map(function(item) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                        className: (SearchResultsTemplate_module_default()).resultsItem,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                href: item.url,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: (SearchResultsTemplate_module_default()).resultsItemTitle,
                                                    children: item.titolo
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (SearchResultsTemplate_module_default()).resultsItemDescription,
                                                dangerouslySetInnerHTML: {
                                                    __html: item.descrizione
                                                }
                                            })
                                        ]
                                    }, item.pk);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Pagination */.tl, {
                                currentPage: selectedPage,
                                totalCount: countSelectedType ? countSelectedType : 0,
                                pageSize: settings/* SEARCH_LISTING_ITEMS_PER_PAGE */.sW,
                                onPageChange: function(page) {
                                    return handleChangePage(page);
                                }
                            })
                        ]
                    }) : countSelectedType ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (SearchResultsTemplate_module_default()).noResults,
                        children: t("Non ci sono risultati")
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var SearchResultsTemplate_SearchResultsTemplate = (SearchResultsTemplate);

;// CONCATENATED MODULE: ../../libs/shared-ui/src/templates/SinistroTemplate/SinistroTemplate.tsx







var SinistroTemplate = function(props) {
    var _pagina = props.pagina, pagina = _pagina === void 0 ? null : _pagina;
    var isMobile = useIsMobile();
    return(/*#__PURE__*/ _jsxs(Page, {
        pagina: pagina,
        item: {},
        contentClassName: styles.sinistroContent,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "".concat(styles.headBg, " bg-grey"),
                children: /*#__PURE__*/ _jsxs(WContainer, {
                    children: [
                        /*#__PURE__*/ _jsx(Breadcrumbs, {
                            breadcrumbs: pagina === null || pagina === void 0 ? void 0 : pagina.breadcrumbs
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: styles.headLayout,
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: styles.headContent,
                                    children: [
                                        /*#__PURE__*/ _jsx(MainTitle, {
                                            label: pagina === null || pagina === void 0 ? void 0 : pagina.nome,
                                            variant: "light",
                                            className: styles.title
                                        }),
                                        /*#__PURE__*/ _jsx(MainDescription, {
                                            html: pagina === null || pagina === void 0 ? void 0 : pagina.descrizione,
                                            className: styles.description
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: styles.headImage,
                                    children: /*#__PURE__*/ _jsx(WImage, {
                                        src: isMobile ? pagina === null || pagina === void 0 ? void 0 : pagina.previewImage : pagina === null || pagina === void 0 ? void 0 : pagina.mainImage,
                                        maxWidth: 536,
                                        maxHeight: 350,
                                        layout: "intrinsic",
                                        objectFit: "cover",
                                        priority: true,
                                        loading: "eager"
                                    }, "sinistro-main-image".concat(isMobile ? '-mobile' : ''))
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "bg-white",
                children: /*#__PURE__*/ _jsx(WContainer, {
                    variant: "xs",
                    children: /*#__PURE__*/ _jsx(PlaceholderReact, {
                        pkey: "content",
                        contentTypeId: pagina.contentTypeId,
                        objectId: pagina.pk
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var SinistroTemplate_SinistroTemplate = ((/* unused pure expression or super */ null && (SinistroTemplate)));

// EXTERNAL MODULE: ../../libs/shared-ui/src/templates/CatchAllTemplate/CatchAllTemplate.module.sass
var CatchAllTemplate_module = __webpack_require__(48469);
var CatchAllTemplate_module_default = /*#__PURE__*/__webpack_require__.n(CatchAllTemplate_module);
;// CONCATENATED MODULE: ../../libs/shared-ui/src/templates/CatchAllTemplate/CatchAllTemplate.tsx







var CatchAllTemplate = function(props) {
    var _pagina = props.pagina, pagina = _pagina === void 0 ? null : _pagina;
    var isMobile = (0,hooks/* useIsMobile */.dD)();
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(organisms_Page_Page, {
        pagina: pagina,
        item: {},
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((CatchAllTemplate_module_default()).headBg, " bg-grey"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(atoms/* WContainer */.$t, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* Breadcrumbs */.Oo, {
                            breadcrumbs: pagina === null || pagina === void 0 ? void 0 : pagina.breadcrumbs
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (CatchAllTemplate_module_default()).headLayout,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "".concat((CatchAllTemplate_module_default()).headContent, " ").concat(!(pagina === null || pagina === void 0 ? void 0 : pagina.mainImage) ? (CatchAllTemplate_module_default())["headContent--full"] : ""),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* MainTitle */.U3, {
                                            label: pagina === null || pagina === void 0 ? void 0 : pagina.nome,
                                            variant: "light",
                                            className: (CatchAllTemplate_module_default()).title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* MainDescription */.WC, {
                                            html: pagina === null || pagina === void 0 ? void 0 : pagina.descrizione,
                                            className: (CatchAllTemplate_module_default()).description
                                        })
                                    ]
                                }),
                                (pagina === null || pagina === void 0 ? void 0 : pagina.mainImage) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (CatchAllTemplate_module_default()).headImage,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WImage */.Tg, {
                                        src: isMobile ? pagina === null || pagina === void 0 ? void 0 : pagina.previewImage : pagina === null || pagina === void 0 ? void 0 : pagina.mainImage,
                                        maxWidth: 536,
                                        maxHeight: 350,
                                        layout: "intrinsic",
                                        objectFit: "cover",
                                        priority: true,
                                        loading: "eager"
                                    }, "".concat(pagina === null || pagina === void 0 ? void 0 : pagina.pk, "-main-image").concat(isMobile ? '-mobile' : ''))
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (CatchAllTemplate_module_default()).contentSection,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* WContainer */.$t, {
                    variant: "xs",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src/* PlaceholderReact */.b, {
                        contentTypeId: pagina.contentTypeId,
                        objectId: pagina.pk,
                        pkey: "content"
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var CatchAllTemplate_CatchAllTemplate = (CatchAllTemplate);

;// CONCATENATED MODULE: ../../libs/shared-ui/src/templates/index.ts























/***/ }),

/***/ 19663:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"description":"AllegatiBox_description__XPHNs","allegatiBox":"AllegatiBox_allegatiBox__3eAdK","allegatiBox--sidebar":"AllegatiBox_allegatiBox--sidebar__qlwgl","titleBox":"AllegatiBox_titleBox__p4p_d","title":"AllegatiBox_title__9dLrT","content":"AllegatiBox_content__oSZl8"};

/***/ }),

/***/ 89808:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"appBox":"AppBox_appBox__zoqPN","imageBox":"AppBox_imageBox__gmi8M","image":"AppBox_image__OYNFz","main":"AppBox_main__UkJua","baffo":"AppBox_baffo__VFUZ3","title":"AppBox_title__xtKEs","description":"AppBox_description__NSxFR","list":"AppBox_list__15eEG"};

/***/ }),

/***/ 8573:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imageBox":"ArticoloCard_imageBox__QWYpu","chips":"ArticoloCard_chips__25gFE","date":"ArticoloCard_date__Sv97a","title":"ArticoloCard_title__xpIYY","articoloCard":"ArticoloCard_articoloCard__zOSlA"};

/***/ }),

/***/ 38570:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contentBox":"ContentBox_contentBox__dKAy0","layout":"ContentBox_layout__T_1sA","titleBox":"ContentBox_titleBox__qd3nr","titleBox--image":"ContentBox_titleBox--image__McEfZ","main":"ContentBox_main__TDnGN","content":"ContentBox_content__iQ9qv","links":"ContentBox_links__c2EKz","title":"ContentBox_title__kC61H","imageCompositionBox":"ContentBox_imageCompositionBox__AUKGN","imageBox":"ContentBox_imageBox__eEN9U","baffo":"ContentBox_baffo__QhK58","contentBox--title-right":"ContentBox_contentBox--title-right__MNbXT","contentBox--title-left":"ContentBox_contentBox--title-left__arYBW"};

/***/ }),

/***/ 66497:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"faqCategoryCard":"FaqCategoryCard_faqCategoryCard__RSVx_","icon":"FaqCategoryCard_icon__eYdWc","title":"FaqCategoryCard_title__9lxPB","description":"FaqCategoryCard_description__zn5fc"};

/***/ }),

/***/ 14456:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"listing":"FaqSidebarMenu_listing__1Ehx9","innerListing":"FaqSidebarMenu_innerListing__bI7gG","item":"FaqSidebarMenu_item__hFu0E","item--active":"FaqSidebarMenu_item--active__5WFzQ","itemTitle":"FaqSidebarMenu_itemTitle__bajJ8","itemIcon":"FaqSidebarMenu_itemIcon__Bmha0","mobileAction":"FaqSidebarMenu_mobileAction__67MdJ","actionLabel":"FaqSidebarMenu_actionLabel__8G8LX","actionIcon":"FaqSidebarMenu_actionIcon__b5NTF"};

/***/ }),

/***/ 6654:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"fascicoloCard":"FascicoloCard_fascicoloCard__y9XXA","edizione":"FascicoloCard_edizione__yLEBj","value":"FascicoloCard_value__76OHM","chips":"FascicoloCard_chips__Ybfsp","title":"FascicoloCard_title__Nbfwj","description":"FascicoloCard_description__5vX5K","ctaBox":"FascicoloCard_ctaBox__N3V_O"};

/***/ }),

/***/ 54150:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"filledTextBox":"FilledTextBox_filledTextBox__0_Xjz","title":"FilledTextBox_title__88TS0","icon":"FilledTextBox_icon___6_gq","description":"FilledTextBox_description__TUDps","ctaBox":"FilledTextBox_ctaBox__jekPF"};

/***/ }),

/***/ 25009:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imageTextBox":"ImageTextBox_imageTextBox__h_1cL","imageTextBox--text-left":"ImageTextBox_imageTextBox--text-left__yJ8or","imageTextBox--text-right":"ImageTextBox_imageTextBox--text-right__i7pKU","imageBox":"ImageTextBox_imageBox__Krm1u","content":"ImageTextBox_content__swECl","title":"ImageTextBox_title__AnEBv","description":"ImageTextBox_description__jCN8m","ctaBox":"ImageTextBox_ctaBox__8XdJM"};

/***/ }),

/***/ 83254:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"lineaBox":"LineaBox_lineaBox__2eyfs","lineaBox--footer":"LineaBox_lineaBox--footer__3pgsJ","head":"LineaBox_head__fsHEZ","title":"LineaBox_title__U6rpv","title--green":"LineaBox_title--green__VrVC6","title--gold":"LineaBox_title--gold__yXuTE","chip":"LineaBox_chip__bZR_I","description":"LineaBox_description__WFmzS","description--mobile-full":"LineaBox_description--mobile-full__aBZjE","readMore":"LineaBox_readMore__lxxgl","footer":"LineaBox_footer__PspdD","priceLabel":"LineaBox_priceLabel__nBAI9","priceValue":"LineaBox_priceValue__MJSOr","garanzieBlock":"LineaBox_garanzieBlock__MWwEa","garanzieBlock--collapsable":"LineaBox_garanzieBlock--collapsable__hqdva","garanzieList":"LineaBox_garanzieList__db1fD","garanzieButton":"LineaBox_garanzieButton__6YVak","garanzieArrow":"LineaBox_garanzieArrow__iC7yy","garanzieTitle":"LineaBox_garanzieTitle__xlwhI","garanzieItem":"LineaBox_garanzieItem__HKmxL","garanzieItemIcon":"LineaBox_garanzieItemIcon__2Wi6y","garanzieItemTitle":"LineaBox_garanzieItemTitle__cFV8b","garanzieItemLabel":"LineaBox_garanzieItemLabel__xqx61","garanzieItemInfo":"LineaBox_garanzieItemInfo__aGNwv"};

/***/ }),

/***/ 10585:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"lineaCheckbox":"LineaCheckbox_lineaCheckbox___97HS","lineaCheckbox--selected":"LineaCheckbox_lineaCheckbox--selected__HvuYT","lineaCheckbox--hovered":"LineaCheckbox_lineaCheckbox--hovered__d71_m","head":"LineaCheckbox_head__KxhLo","checkbox":"LineaCheckbox_checkbox__pdnUk","checkbox--hovered":"LineaCheckbox_checkbox--hovered__MsF1p","icon":"LineaCheckbox_icon__IzrhQ","title":"LineaCheckbox_title__1fIGM","price":"LineaCheckbox_price__rsGlk","accordion":"LineaCheckbox_accordion__MoktB","accordionTrigger":"LineaCheckbox_accordionTrigger__4fSct","accordionArrow":"LineaCheckbox_accordionArrow__v1fOy","description":"LineaCheckbox_description__3wZUp","lineaCheckbox--collapsable":"LineaCheckbox_lineaCheckbox--collapsable__0qjcz","descriptionWrap":"LineaCheckbox_descriptionWrap__puupu"};

/***/ }),

/***/ 23320:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"outlineTextCtaBox":"OutlineTextCtaBox_outlineTextCtaBox__h9ySg","title":"OutlineTextCtaBox_title__beY_u","description":"OutlineTextCtaBox_description__iA33k","ctaBox":"OutlineTextCtaBox_ctaBox__mcFX8"};

/***/ }),

/***/ 60397:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imageBox":"ProdottoCard_imageBox__RSQCm","chips":"ProdottoCard_chips__02Rad","title":"ProdottoCard_title__6I1kW","description":"ProdottoCard_description__lVeZW","prodottoCard":"ProdottoCard_prodottoCard__PM3ee","prodottoCard--horizontal":"ProdottoCard_prodottoCard--horizontal__C3aP9","content":"ProdottoCard_content__y8ByI"};

/***/ }),

/***/ 11010:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tabTriggerCard":"TabTriggerCard_tabTriggerCard__7eJWX","icon":"TabTriggerCard_icon__B_odE","label":"TabTriggerCard_label__7DSlw"};

/***/ }),

/***/ 67055:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"TextCtaBox_title__Yv4WF","textCtaBox":"TextCtaBox_textCtaBox__nkmJI","textCtaBox--lg":"TextCtaBox_textCtaBox--lg__SwJUu","content":"TextCtaBox_content__4r_du","description":"TextCtaBox_description__ZtnXj","ctaBox":"TextCtaBox_ctaBox___VoyY","textCtaBox--lg-narrow":"TextCtaBox_textCtaBox--lg-narrow__yz_64","textCtaBox--sm":"TextCtaBox_textCtaBox--sm__53VOx"};

/***/ }),

/***/ 84605:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imageBox":"UseCaseCard_imageBox___5iJq","content":"UseCaseCard_content__ovxXQ","baffo":"UseCaseCard_baffo__EjZiy","title":"UseCaseCard_title__YHB3x","description":"UseCaseCard_description__iIPu_","ctaBox":"UseCaseCard_ctaBox__PhwXl","useCaseCard":"UseCaseCard_useCaseCard__Q21XB"};

/***/ }),

/***/ 18057:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"valorizzazioneCard":"ValorizzazioneCard_valorizzazioneCard__sJ3SL","data":"ValorizzazioneCard_data__ob4y0","value":"ValorizzazioneCard_value__egKKg","title":"ValorizzazioneCard_title__T9n3P","attrs":"ValorizzazioneCard_attrs__4Uqa7","attr":"ValorizzazioneCard_attr__NF2OB","valore":"ValorizzazioneCard_valore__Dnl8f","ctaBox":"ValorizzazioneCard_ctaBox__wPyud"};

/***/ }),

/***/ 43204:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"appModal":"AppModal_appModal__glnTF","content":"AppModal_content__6kMzw","title":"AppModal_title__uGvJb","description":"AppModal_description__t3Nuh","links":"AppModal_links___mo53","logo":"AppModal_logo__lJcqh"};

/***/ }),

/***/ 46101:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"filtersList":"ArchivioFascicoliListing_filtersList__tLwtE","filtersSlider":"ArchivioFascicoliListing_filtersSlider__ChZtN","advanced":"ArchivioFascicoliListing_advanced__fVFm1","title":"ArchivioFascicoliListing_title__vFJx0","search":"ArchivioFascicoliListing_search__JaFdU","input":"ArchivioFascicoliListing_input__2LaT6","submit":"ArchivioFascicoliListing_submit__QhC5K","advancedFiltersTrigger":"ArchivioFascicoliListing_advancedFiltersTrigger__C9LYX","list":"ArchivioFascicoliListing_list__GZfv_","item":"ArchivioFascicoliListing_item__CufBF"};

/***/ }),

/***/ 86309:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"articoloPrimoPiano":"ArticoloPrimoPiano_articoloPrimoPiano__vgosS","mainTitle":"ArticoloPrimoPiano_mainTitle___xarQ","layout":"ArticoloPrimoPiano_layout__AQsf2","imageBox":"ArticoloPrimoPiano_imageBox__3SPIT","content":"ArticoloPrimoPiano_content__1UHAB","date":"ArticoloPrimoPiano_date__iHrx1","title":"ArticoloPrimoPiano_title__SfC9B","abstract":"ArticoloPrimoPiano_abstract__JVsg6","cta":"ArticoloPrimoPiano_cta__QE_Ex"};

/***/ }),

/***/ 18859:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"assistenzaSection":"AssistenzaSection_assistenzaSection__YUPWd","intro":"AssistenzaSection_intro__UTS0m","title":"AssistenzaSection_title__FsaQ6","images":"AssistenzaSection_images__Zvmsa","imageBox":"AssistenzaSection_imageBox__qtseu","baffo":"AssistenzaSection_baffo__2OTiG","list":"AssistenzaSection_list__NVa_3","ctaBox":"AssistenzaSection_ctaBox__OHYDH"};

/***/ }),

/***/ 8753:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"chatBotOverlay":"ChatBotOverlay_chatBotOverlay__MiLUW","chatBotOverlay--visible":"ChatBotOverlay_chatBotOverlay--visible__1dbL_","head":"ChatBotOverlay_head__hOAFQ","headContent":"ChatBotOverlay_headContent__RwTNT","logo":"ChatBotOverlay_logo__cOhXF","close":"ChatBotOverlay_close__qvRFJ","content":"ChatBotOverlay_content__HHbBT"};

/***/ }),

/***/ 29718:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"ContattaciForm_title__ZXzuG","submitBox":"ContattaciForm_submitBox__tFCTK","submit":"ContattaciForm_submit__c_0CM","error":"ContattaciForm_error__Cjet8","privacyDisclaimer":"ContattaciForm_privacyDisclaimer__wwsrs"};

/***/ }),

/***/ 66612:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"faqCategoriesListing":"FaqCategoriesListing_faqCategoriesListing__9YE99"};

/***/ }),

/***/ 17845:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"faqSearchForm":"FaqSearchForm_faqSearchForm__eg1cD","inputWrap":"FaqSearchForm_inputWrap__x3Sqa","input":"FaqSearchForm_input__axTPZ","submit":"FaqSearchForm_submit__qD811"};

/***/ }),

/***/ 22017:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"faqSection":"FaqSection_faqSection__jK_Ba","title":"FaqSection_title__6IJWi","actions":"FaqSection_actions__wkcTr","allLink":"FaqSection_allLink__31Md_","contacts":"FaqSection_contacts__6PKWa","list":"FaqSection_list__EYbvT","showAll":"FaqSection_showAll__WEj_Z"};

/***/ }),

/***/ 79962:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__Vpzzp","head":"Footer_head__JiG3B","logo":"Footer_logo__m0ZJD","menuTitle":"Footer_menuTitle__JE1fY","menuChildren":"Footer_menuChildren__88JAc","menuItem":"Footer_menuItem__JnxFy","menus":"Footer_menus__tjhtT","col":"Footer_col__zIrDP","col--big":"Footer_col--big__48N8V","col--big-mobile":"Footer_col--big-mobile___vy2S","socials":"Footer_socials__d4hwv","socialItem":"Footer_socialItem__tXBt_","apps":"Footer_apps__IgW_Q","copyright":"Footer_copyright__2ByyX"};

/***/ }),

/***/ 56177:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__DrwL8","top":"Header_top__JEV1Y","topMenu":"Header_topMenu__aXqlk","main":"Header_main__HmL0q","mainContent":"Header_mainContent__Xn21C","logo":"Header_logo__N6PAA","navigation":"Header_navigation__zzp1h","search":"Header_search__fdatv","areaClienti":"Header_areaClienti__UaAiW","mobileButtons":"Header_mobileButtons__UXKe8","mobileButton":"Header_mobileButton___Vfdg"};

/***/ }),

/***/ 22722:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"heroSlider":"HeroSlider_heroSlider__U2GID","imagesSlider":"HeroSlider_imagesSlider__hc9kV","imageBox":"HeroSlider_imageBox__C8png","contentSlider":"HeroSlider_contentSlider__WMbI2","content":"HeroSlider_content__dOq9G","title":"HeroSlider_title__D8mbt","description":"HeroSlider_description__0OJC6","ctaBox":"HeroSlider_ctaBox__PmdHr"};

/***/ }),

/***/ 77362:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"LineeSection_title___3dVk","slider":"LineeSection_slider__rkjBZ","lineaSingola":"LineeSection_lineaSingola__G3yJJ","note":"LineeSection_note__lN4tj","note--lineaSingola":"LineeSection_note--lineaSingola__35C0T"};

/***/ }),

/***/ 23468:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"magazineListing":"MagazineListing_magazineListing__o_LeK","title":"MagazineListing_title__tZRCR","options":"MagazineListing_options__qtNf7","filters":"MagazineListing_filters__FzzAy","order":"MagazineListing_order__FRFPw","orderLabel":"MagazineListing_orderLabel__HQ7xo","orderField":"MagazineListing_orderField__XPzcs","list":"MagazineListing_list__8QxYx","item":"MagazineListing_item__ZS6FU","pagination":"MagazineListing_pagination__acDia"};

/***/ }),

/***/ 45870:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"motiviSection":"MotiviSection_motiviSection__Y7STU","main":"MotiviSection_main__aKkOv","baffo":"MotiviSection_baffo__7EKbD","content":"MotiviSection_content__LLP_2","title":"MotiviSection_title__rpkuo","description":"MotiviSection_description__R0C97","slider":"MotiviSection_slider__5ihS_","item":"MotiviSection_item__b8CsC","itemIcon":"MotiviSection_itemIcon__rSMOs","itemTitle":"MotiviSection_itemTitle__lynJp","itemDescription":"MotiviSection_itemDescription__fkGzD"};

/***/ }),

/***/ 63499:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"Nav_main__8zfAG","mainItemLabel":"Nav_mainItemLabel__ksAZ7","noLink":"Nav_noLink__FQX4Z","mainItemLabel--open":"Nav_mainItemLabel--open__TIEFy","dropdown":"Nav_dropdown__s_kWl","dropdown--open":"Nav_dropdown--open__MLOm1","dropdownContent":"Nav_dropdownContent__tDD2I","dropdownCol":"Nav_dropdownCol__ny9Ue","dropdownCol--auto":"Nav_dropdownCol--auto__vQ_lL","dropdownCol--2-cols":"Nav_dropdownCol--2-cols__Zr10u","dropdownCol--3-cols":"Nav_dropdownCol--3-cols__p7wuw","dropdownItemLabel":"Nav_dropdownItemLabel__pI3DV","dropdownItemChildren":"Nav_dropdownItemChildren__7PHmQ","dropdownItemChildren--2-cols":"Nav_dropdownItemChildren--2-cols__Uj6qq","dropdownItemChildren--3-cols":"Nav_dropdownItemChildren--3-cols___6bV5","dropdownItemChildren--4-cols":"Nav_dropdownItemChildren--4-cols__HJmVp","dropdownItemChild":"Nav_dropdownItemChild__Vjl0x"};

/***/ }),

/***/ 85185:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"navMobile":"NavMobile_navMobile___wPTa","navMobile--open":"NavMobile_navMobile--open__i9Khl","menu":"NavMobile_menu__fSWpi","menu--openChild":"NavMobile_menu--openChild__vDi3b","actions":"NavMobile_actions__DCneu","action":"NavMobile_action__gwRLL","item":"NavMobile_item__irO0l","item--primary":"NavMobile_item--primary__MqI9V","itemLabel":"NavMobile_itemLabel__nOAMj","itemHead":"NavMobile_itemHead__LZ6Kw","itemLink":"NavMobile_itemLink__4_m50","itemIcon":"NavMobile_itemIcon__9onQs","itemArrow":"NavMobile_itemArrow__rJnGp","panel":"NavMobile_panel__68Lz_","panel--open":"NavMobile_panel--open__Oq5ZK","back":"NavMobile_back__e7mIf","backArrow":"NavMobile_backArrow__z4rZy","backIcon":"NavMobile_backIcon__hdaJN","backLabel":"NavMobile_backLabel__6SqI8","panelMenu":"NavMobile_panelMenu__pITZT"};

/***/ }),

/***/ 51850:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"intro":"NewsSection_intro__7n_rD","title":"NewsSection_title__mBFvL","list":"NewsSection_list__kQJEp","item":"NewsSection_item__BFtDr","ctaBox":"NewsSection_ctaBox__QVJlM"};

/***/ }),

/***/ 47330:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pageWrap":"Page_pageWrap__dKOZK"};

/***/ }),

/***/ 84449:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tabs":"PreventivatoreHomeSection_tabs__GFODr","tabContent":"PreventivatoreHomeSection_tabContent__Fgtln","slider":"PreventivatoreHomeSection_slider__NjAgl","sliderItem":"PreventivatoreHomeSection_sliderItem___2gkm","titleMobile":"PreventivatoreHomeSection_titleMobile__Uucve"};

/***/ }),

/***/ 38352:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"PreventivatoreIntro_title__Ytqlk","ctaBox":"PreventivatoreIntro_ctaBox__HJumH","modalContent":"PreventivatoreIntro_modalContent__Go5_p","preventivatoreIntro--productPage":"PreventivatoreIntro_preventivatoreIntro--productPage__K61gT","cta":"PreventivatoreIntro_cta__XZE1u","preventivatore-tooltip":"PreventivatoreIntro_preventivatore-tooltip__T_9Vc","tooltip-inner":"PreventivatoreIntro_tooltip-inner__lLO38"};

/***/ }),

/***/ 56915:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"preventivatoreLinee":"PreventivatoreLinee_preventivatoreLinee__9ldh5","title":"PreventivatoreLinee_title__70niT","slider":"PreventivatoreLinee_slider__3EPZw","list":"PreventivatoreLinee_list__Nbwd0","listItem":"PreventivatoreLinee_listItem__gDH9d","linee":"PreventivatoreLinee_linee__1Ajom","linee--collapsable":"PreventivatoreLinee_linee--collapsable__uniEc","sliderItem":"PreventivatoreLinee_sliderItem__in19_","errorWrap":"PreventivatoreLinee_errorWrap__5l3tq","discount":"PreventivatoreLinee_discount__BhA35","preventivatoreLinee--productPage":"PreventivatoreLinee_preventivatoreLinee--productPage__0Vuer"};

/***/ }),

/***/ 35085:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"preventivatoreModal":"PreventivatoreModal_preventivatoreModal__pvGGe","content":"PreventivatoreModal_content__Pccgc","title":"PreventivatoreModal_title__vKZu8","linee":"PreventivatoreModal_linee__erAW5","privacyField":"PreventivatoreModal_privacyField__9oqO3","bottomDesktop":"PreventivatoreModal_bottomDesktop__AH6wh","bottomMobile":"PreventivatoreModal_bottomMobile__Cd1Zd","submit":"PreventivatoreModal_submit__cyCXh","error":"PreventivatoreModal_error__Zq9NI"};

/***/ }),

/***/ 63585:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"filters":"ProdottiListing_filters__aFT9A","title":"ProdottiListing_title__eVBNx","main":"ProdottiListing_main___mtkl","list":"ProdottiListing_list__rETLI","item":"ProdottiListing_item__4dYC7"};

/***/ }),

/***/ 10114:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"intro":"ProdottiSection_intro__y9z_Q","title":"ProdottiSection_title__CTKdI","list":"ProdottiSection_list__4Tja6","item":"ProdottiSection_item__aX2Cl","ctaBox":"ProdottiSection_ctaBox__3OO7S"};

/***/ }),

/***/ 25011:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"prodottoHead":"ProdottoHead_prodottoHead__wLhjO","prodottoHead--preventivatore":"ProdottoHead_prodottoHead--preventivatore__6LLO6","head":"ProdottoHead_head__ABoWc","baffo":"ProdottoHead_baffo__0TxBJ","heroBox":"ProdottoHead_heroBox__Uxp2_","main":"ProdottoHead_main__df8Eg","content":"ProdottoHead_content__2It6T","tags":"ProdottoHead_tags__7oNyB","imageBox":"ProdottoHead_imageBox__Vn7k_","heroTitle":"ProdottoHead_heroTitle__9rmIS","heroDescription":"ProdottoHead_heroDescription__I0_iu","description":"ProdottoHead_description__iS0E7","tagsTitle":"ProdottoHead_tagsTitle__hYd1r","tagsList":"ProdottoHead_tagsList__LC00Y","preventivatore":"ProdottoHead_preventivatore__euCmh","preventivatoreTitle":"ProdottoHead_preventivatoreTitle__VmEwF","preventivatoreMobile":"ProdottoHead_preventivatoreMobile__5mTzI","preventivatoreMobileTitle":"ProdottoHead_preventivatoreMobileTitle__fap69","preventivatoreCtaBox":"ProdottoHead_preventivatoreCtaBox__rskhU","preventivatoreMobileCtaBox":"ProdottoHead_preventivatoreMobileCtaBox__OTHXx","preventivatoreCta":"ProdottoHead_preventivatoreCta__bBDIu","preventivatoreMobileCta":"ProdottoHead_preventivatoreMobileCta__qEizo"};

/***/ }),

/***/ 72793:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"searchOverlay":"SearchOverlay_searchOverlay__ppBH_","close":"SearchOverlay_close__W_zGS","inputWrap":"SearchOverlay_inputWrap__hazG8","submit":"SearchOverlay_submit__cVuW8","input":"SearchOverlay_input__CKSuz","helpText":"SearchOverlay_helpText__ku4gv","suggestions":"SearchOverlay_suggestions__gtCkj","suggestionItem":"SearchOverlay_suggestionItem__a3KXA","suggestionItemIcon":"SearchOverlay_suggestionItemIcon__J6Oo4","suggestionItemTitle":"SearchOverlay_suggestionItemTitle__ShWLD","results":"SearchOverlay_results__MB3oG","tabsHeaders":"SearchOverlay_tabsHeaders__Bt052","pageItem":"SearchOverlay_pageItem__fdnvy","pageActions":"SearchOverlay_pageActions__WhD7C","pageIndicator":"SearchOverlay_pageIndicator__sL_TB"};

/***/ }),

/***/ 39280:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"intro":"TestimonianzeSection_intro__MywOI","title":"TestimonianzeSection_title__tObZe","list":"TestimonianzeSection_list__KNlW4","item":"TestimonianzeSection_item__l46TA"};

/***/ }),

/***/ 43529:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"Toolbar_toolbar__wXTGX","adminLink":"Toolbar_adminLink__vEtFf","user":"Toolbar_user__wfWWZ","user--impersonate":"Toolbar_user--impersonate__8dMWD","right":"Toolbar_right__ym2p8"};

/***/ }),

/***/ 80483:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"intro":"TrovaSubitoSection_intro__qK_iH","title":"TrovaSubitoSection_title__w21St","list":"TrovaSubitoSection_list__hAx8f","ctaBox":"TrovaSubitoSection_ctaBox__WGM9L"};

/***/ }),

/***/ 89317:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"filtersList":"ValorizzazioniListing_filtersList__OdO9t","filtersSlider":"ValorizzazioniListing_filtersSlider__F9NFN","advanced":"ValorizzazioniListing_advanced__sqXqG","title":"ValorizzazioniListing_title__3Mt9e","search":"ValorizzazioniListing_search__60CUp","input":"ValorizzazioniListing_input__IzkjO","submit":"ValorizzazioniListing_submit__Ud7ZW","advancedFilters":"ValorizzazioniListing_advancedFilters__sYI9X","advancedFiltersDropdown":"ValorizzazioniListing_advancedFiltersDropdown__mzuBd","advancedFiltersBadge":"ValorizzazioniListing_advancedFiltersBadge__Q8lbR","list":"ValorizzazioniListing_list__oPtB_","item":"ValorizzazioniListing_item__ALVyj"};

/***/ }),

/***/ 77339:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"headBg":"ArchivioFascicoliTemplate_headBg__YsY_o","archivioFascicoliContent":"ArchivioFascicoliTemplate_archivioFascicoliContent__n0nfx"};

/***/ }),

/***/ 34451:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"headBg":"AreaClientiTemplate_headBg__N1MrJ","headLayout":"AreaClientiTemplate_headLayout__YQ4Ec","headContent":"AreaClientiTemplate_headContent__NYJZJ","headContent--full":"AreaClientiTemplate_headContent--full__lAi6_","headImage":"AreaClientiTemplate_headImage__FWVH4","sectionContainer":"AreaClientiTemplate_sectionContainer__LG1BX","section":"AreaClientiTemplate_section__YzrsG","sectionTitle":"AreaClientiTemplate_sectionTitle__0IEc3","sectionDescription":"AreaClientiTemplate_sectionDescription__JP2q_","list":"AreaClientiTemplate_list__aiqC2"};

/***/ }),

/***/ 46501:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"ArticoloTemplate_title__BDrRp","imageBox":"ArticoloTemplate_imageBox__udxbK","date":"ArticoloTemplate_date__sQnqQ","actions":"ArticoloTemplate_actions__Fnuh2"};

/***/ }),

/***/ 48469:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"headBg":"CatchAllTemplate_headBg__jI_5E","headLayout":"CatchAllTemplate_headLayout__NJeQ_","headContent":"CatchAllTemplate_headContent__Vvhwn","headContent--full":"CatchAllTemplate_headContent--full__qh9I6","headImage":"CatchAllTemplate_headImage__j5Mhm","contentSection":"CatchAllTemplate_contentSection__KMAX0"};

/***/ }),

/***/ 93210:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"headBg":"CategoriaProdottoTemplate_headBg__YM7P6","head":"CategoriaProdottoTemplate_head__pbA0D","headContent":"CategoriaProdottoTemplate_headContent__qYUgm","promo":"CategoriaProdottoTemplate_promo__nFQgD","title":"CategoriaProdottoTemplate_title__vlH6M","description":"CategoriaProdottoTemplate_description__N0QHN"};

/***/ }),

/***/ 44590:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"headBg":"ChiSiamoTemplate_headBg__NlSH0","headLayout":"ChiSiamoTemplate_headLayout__hLBIO","headContent":"ChiSiamoTemplate_headContent__OmtW7","headImage":"ChiSiamoTemplate_headImage__w0k2D","section":"ChiSiamoTemplate_section__iuzY6","contentSection":"ChiSiamoTemplate_contentSection__2RKfL","menuSectionRef":"ChiSiamoTemplate_menuSectionRef__XWiH9","menuSection":"ChiSiamoTemplate_menuSection__0KA2Q","menu":"ChiSiamoTemplate_menu__qdH0W","menuItem":"ChiSiamoTemplate_menuItem__C1qWs","menuItem--active":"ChiSiamoTemplate_menuItem--active__IvRNI"};

/***/ }),

/***/ 34927:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contattaciBreadcrumbs":"ContattaciTemplate_contattaciBreadcrumbs__omFpi","head":"ContattaciTemplate_head__vVSOf","imageBox":"ContattaciTemplate_imageBox__yb9Eo","baffo":"ContattaciTemplate_baffo__cVmG4","heroBox":"ContattaciTemplate_heroBox__qbDJs","heroTitle":"ContattaciTemplate_heroTitle___uQov","heroDescription":"ContattaciTemplate_heroDescription__qkdKA","main":"ContattaciTemplate_main__sRpPO","formBox":"ContattaciTemplate_formBox__kCmAD","formMobile":"ContattaciTemplate_formMobile__8izcm","formMobileTitle":"ContattaciTemplate_formMobileTitle__UjUj_","formMobileCtaBox":"ContattaciTemplate_formMobileCtaBox__EtC93","formMobileCta":"ContattaciTemplate_formMobileCta__PtDXd","content":"ContattaciTemplate_content__hCjPl","menuSectionRef":"ContattaciTemplate_menuSectionRef__eBpwh","menuSection":"ContattaciTemplate_menuSection__b3RGo","menu":"ContattaciTemplate_menu__cvBq2","menuItem":"ContattaciTemplate_menuItem__AlzyO","menuItem--active":"ContattaciTemplate_menuItem--active__ikXaj","list":"ContattaciTemplate_list__MWhjr","item":"ContattaciTemplate_item__OuYWe","formModal":"ContattaciTemplate_formModal__tOPuT","formModalContent":"ContattaciTemplate_formModalContent__4TJCd","allegati":"ContattaciTemplate_allegati__eUZMA"};

/***/ }),

/***/ 75218:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"ContattaciThankYouTemplate_title__VR7Gm","descrizione":"ContattaciThankYouTemplate_descrizione__vutCr","homeBtnContainer":"ContattaciThankYouTemplate_homeBtnContainer__ureu5"};

/***/ }),

/***/ 62385:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"Custom404Template_title__NiwTp","descrizione":"Custom404Template_descrizione__fmAf_","homeBtnContainer":"Custom404Template_homeBtnContainer__SUekZ"};

/***/ }),

/***/ 5343:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"headBg":"FaqDetailTemplate_headBg__YH_aJ","layout":"FaqDetailTemplate_layout__UFHKY","main":"FaqDetailTemplate_main__V_l_p","sidebar":"FaqDetailTemplate_sidebar__DZWT_","title":"FaqDetailTemplate_title__iIoyk","description":"FaqDetailTemplate_description__UfaVM","listing":"FaqDetailTemplate_listing__KhQgG"};

/***/ }),

/***/ 77502:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"headBg":"FaqListingTemplate_headBg__7RKew","listing":"FaqListingTemplate_listing__yAP3k"};

/***/ }),

/***/ 43171:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"preventivatore":"HomeTemplate_preventivatore__x5UOP","trovaSubito":"HomeTemplate_trovaSubito__H3VPe","assistenza":"HomeTemplate_assistenza__q_w2f","prodotti":"HomeTemplate_prodotti__dkmwe","testimonianze":"HomeTemplate_testimonianze__dPcC0","rendimenti":"HomeTemplate_rendimenti__gtA1s","modulistica":"HomeTemplate_modulistica__EFIR6","news":"HomeTemplate_news__irVKC"};

/***/ }),

/***/ 81792:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"MagazineTemplate_title__m5lgG"};

/***/ }),

/***/ 48260:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"headBg":"PortaleValorizzazioniTemplate_headBg__7YqdL","portaleValorizzazioniContent":"PortaleValorizzazioniTemplate_portaleValorizzazioniContent__yZmQg"};

/***/ }),

/***/ 24636:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"PreventivatoreThankYouTemplate_title__AucBj","descrizione":"PreventivatoreThankYouTemplate_descrizione__PMUoZ","correlati":"PreventivatoreThankYouTemplate_correlati__8O0Vy","homeBtnContainer":"PreventivatoreThankYouTemplate_homeBtnContainer__gKGa6"};

/***/ }),

/***/ 83966:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"prodottoBreadcrumbs":"ProdottoTemplate_prodottoBreadcrumbs__fzBQH","head":"ProdottoTemplate_head__5dRik","topBoxes":"ProdottoTemplate_topBoxes__y6ak_","descrizioneBoxesLayout":"ProdottoTemplate_descrizioneBoxesLayout__xJt_T","descrizioneBoxes":"ProdottoTemplate_descrizioneBoxes__CuxRs","descrizioneTitle":"ProdottoTemplate_descrizioneTitle__pw9qh","offertaTitle":"ProdottoTemplate_offertaTitle__gxTMO","fondiTitle":"ProdottoTemplate_fondiTitle__mmvbw","offerta":"ProdottoTemplate_offerta__v8B6O","offertaLayout":"ProdottoTemplate_offertaLayout__Ji_TX","offertaItem":"ProdottoTemplate_offertaItem__Ves_b","offertaItemIcon":"ProdottoTemplate_offertaItemIcon__z4PrG","offertaItemContent":"ProdottoTemplate_offertaItemContent__XVLSP","descrizione":"ProdottoTemplate_descrizione__EWwMI","vantaggi":"ProdottoTemplate_vantaggi__JcokH","linee":"ProdottoTemplate_linee__llfta","faqs":"ProdottoTemplate_faqs__Zne_y","areaClienti":"ProdottoTemplate_areaClienti__fPqgG","allegati":"ProdottoTemplate_allegati__BjesH","fondi":"ProdottoTemplate_fondi__sgW9n","fondiList":"ProdottoTemplate_fondiList___Boec","correlati":"ProdottoTemplate_correlati__kMZHq","disclaimer":"ProdottoTemplate_disclaimer__Xou_b","disclaimerContent":"ProdottoTemplate_disclaimerContent__3BWKD","menuSectionRef":"ProdottoTemplate_menuSectionRef__wMZBL","menuSection":"ProdottoTemplate_menuSection__2qiFC","menu":"ProdottoTemplate_menu__mnXVA","menuItem":"ProdottoTemplate_menuItem__28_y3","menuItem--active":"ProdottoTemplate_menuItem--active__n1LRP"};

/***/ }),

/***/ 81605:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"headBg":"ReclamiTemplate_headBg__FbE8o","headLayout":"ReclamiTemplate_headLayout___yW2n","headContent":"ReclamiTemplate_headContent___TirD","headImage":"ReclamiTemplate_headImage__80DGD","layout":"ReclamiTemplate_layout__4jfty","main":"ReclamiTemplate_main__SXb7Z","sidebar":"ReclamiTemplate_sidebar__m4S1j","bottom":"ReclamiTemplate_bottom__a_laR"};

/***/ }),

/***/ 88364:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"SearchResultsTemplate_title__lSTJj","filters":"SearchResultsTemplate_filters__iMxh_","primoPiano":"SearchResultsTemplate_primoPiano__XJica","primoPianoTitle":"SearchResultsTemplate_primoPianoTitle__J9AAQ","primoPianoList":"SearchResultsTemplate_primoPianoList__fnqYE","primoPianoSlider":"SearchResultsTemplate_primoPianoSlider__LSJFN","primoPianoSlideCard":"SearchResultsTemplate_primoPianoSlideCard__MLDB1","results":"SearchResultsTemplate_results__ui2Xm","resultsTitle":"SearchResultsTemplate_resultsTitle__BgYL4","resultsItem":"SearchResultsTemplate_resultsItem__Zhbe4","resultsItemTitle":"SearchResultsTemplate_resultsItemTitle__rN_Wi","resultsItemDescription":"SearchResultsTemplate_resultsItemDescription__nAk1x","noResults":"SearchResultsTemplate_noResults__W3Wj4","mainTitle":"SearchResultsTemplate_mainTitle__hBmId","mainTitle--light":"SearchResultsTemplate_mainTitle--light__shuKm"};

/***/ })

}]);